webpackJsonp([2,0],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(842);
	module.exports = __webpack_require__(870);


/***/ },

/***/ 32:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.putJson = exports.postJson = exports.post = exports.fetchJson = exports.handleFetchError = undefined;
	exports.default = fetchUrl;
	
	var _json = __webpack_require__(506);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FetchError = function (_Error) {
	  _inherits(FetchError, _Error);
	
	  function FetchError(url, res) {
	    _classCallCheck(this, FetchError);
	
	    var _this = _possibleConstructorReturn(this, (FetchError.__proto__ || Object.getPrototypeOf(FetchError)).call(this, 'Error fetching url ' + url));
	
	    _this.url = url;
	    _this.res = res;
	    _this.name = 'FetchError';
	    return _this;
	  }
	
	  return FetchError;
	}(Error);
	
	var handleFetchError = exports.handleFetchError = function handleFetchError(error) {
	  // Checking error content type before rejecting
	  var contentType = error.res.headers.get('content-type');
	  if (contentType && contentType.indexOf('application/json') !== -1) {
	    return error.res.json().then(function (jsError) {
	      return new Promise(function (_, reject) {
	        reject(jsError);
	      });
	    });
	  } else {
	    return new Promise(function (_, reject) {
	      reject(error);
	    });
	  }
	};
	
	function fetchUrl(url) {
	  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  return fetch(url, Object.assign({
	    credentials: 'same-origin'
	  }, params)).then(function (res) {
	    if (res.status < 400) {
	      return res;
	    } else {
	      throw new FetchError(url, res);
	    }
	  });
	}
	
	var fetchJson = exports.fetchJson = function fetchJson(url) {
	  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return fetchUrl(url, Object.assign({}, params, {
	    headers: {
	      Accept: 'application/json',
	      'Content-Type': 'application/json'
	    }
	  })).then(function (res) {
	    return res.json();
	  }, handleFetchError);
	};
	
	var post = exports.post = function post(url, data) {
	  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  return fetchUrl(url, Object.assign({}, params, {
	    method: 'POST',
	    body: data
	  }));
	};
	
	var postJson = exports.postJson = function postJson(url, data) {
	  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  return fetchJson(url, Object.assign({}, params, {
	    method: 'POST',
	    body: JSON.stringify(data, _json.purify)
	  }));
	};
	
	var putJson = exports.putJson = function putJson(url, data) {
	  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  return fetchJson(url, Object.assign({}, params, {
	    method: 'PUT',
	    body: JSON.stringify(data, _json.purify)
	  }));
	};

/***/ },

/***/ 46:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SAVE_PAGE = exports.SAVE_PAGE = 'SAVE_PAGE';
	var SAVE_PAGE_SUBMIT = exports.SAVE_PAGE_SUBMIT = 'SAVE_PAGE_SUBMIT';
	var SAVE_PAGE_SUCCESS = exports.SAVE_PAGE_SUCCESS = 'SAVE_PAGE_SUCCESS';
	var SAVE_PAGE_FAILURE = exports.SAVE_PAGE_FAILURE = 'SAVE_PAGE_FAILURE';
	var FETCH_PAGES = exports.FETCH_PAGES = 'FETCH_PAGES';
	var FETCH_PAGES_SUCCESS = exports.FETCH_PAGES_SUCCESS = 'FETCH_PAGES_SUCCESS';
	var FETCH_PAGES_FAILURE = exports.FETCH_PAGES_FAILURE = 'FETCH_PAGES_FAILURE';
	var FILTER_PAGES = exports.FILTER_PAGES = 'FILTER_PAGES';
	var UPDATE_PAGE = exports.UPDATE_PAGE = 'UPDATE_PAGE';
	var UPDATE_PAGE_SUCCESS = exports.UPDATE_PAGE_SUCCESS = 'UPDATE_PAGE_SUCCESS';
	var UPDATE_PAGE_FAILURE = exports.UPDATE_PAGE_FAILURE = 'UPDATE_PAGE_FAILURE';
	var SERIALIZE_PAGE = exports.SERIALIZE_PAGE = 'SERIALIZE_PAGE';
	var CANCEL_PENDING = exports.CANCEL_PENDING = 'CANCEL_PENDING';
	var ARCHIVE_PAGE = exports.ARCHIVE_PAGE = 'ARCHIVE_PAGE';
	var UNARCHIVE_PAGE = exports.UNARCHIVE_PAGE = 'UNARCHIVE_PAGE';
	
	var fetchPages = exports.fetchPages = function fetchPages() {
	  return {
	    type: FETCH_PAGES
	  };
	};
	
	var filterPages = exports.filterPages = function filterPages(filter) {
	  return {
	    type: FILTER_PAGES,
	    filter: filter
	  };
	};
	
	var serializePage = exports.serializePage = function serializePage(page) {
	  return {
	    type: SERIALIZE_PAGE,
	    page: page
	  };
	};
	
	var cancelPending = exports.cancelPending = function cancelPending(page, content) {
	  return {
	    type: CANCEL_PENDING,
	    page: page,
	    content: content
	  };
	};
	
	var updatePage = exports.updatePage = function updatePage(page) {
	  return {
	    type: UPDATE_PAGE,
	    page: page
	  };
	};
	
	var archivePage = exports.archivePage = function archivePage(page) {
	  return {
	    type: ARCHIVE_PAGE,
	    page: page
	  };
	};
	
	var unarchivePage = exports.unarchivePage = function unarchivePage(page) {
	  return {
	    type: UNARCHIVE_PAGE,
	    page: page
	  };
	};

/***/ },

/***/ 72:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getIsUpdating = exports.hasContentUpdate = exports.getRootPage = exports.getPendingPageById = exports.getPageById = exports.getArchivedPages = exports.getAllPages = exports.getFilter = exports.getError = exports.getIsFetching = undefined;
	
	var _redux = __webpack_require__(33);
	
	var _immutable = __webpack_require__(10);
	
	var _page = __webpack_require__(305);
	
	var _contents = __webpack_require__(173);
	
	var _pages = __webpack_require__(46);
	
	var pages = function pages() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.Map)();
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _pages.FETCH_PAGES_SUCCESS:
	      return (0, _immutable.Map)(action.response.entities.pages);
	    case _pages.SAVE_PAGE_SUCCESS:
	    case _pages.UPDATE_PAGE_SUCCESS:
	      return state.merge((0, _immutable.Map)(action.response.entities.pages));
	    default:
	      return state;
	  }
	};
	
	var pending = function pending() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.Map)();
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _pages.FETCH_PAGES_SUCCESS:
	      return (0, _immutable.Map)(action.response.entities.pages);
	    case _pages.SAVE_PAGE_SUCCESS:
	    case _pages.UPDATE_PAGE_SUCCESS:
	      return state.merge((0, _immutable.Map)(action.response.entities.pages));
	    case _pages.SERIALIZE_PAGE:
	    case _pages.CANCEL_PENDING:
	      return state.set(action.page.id.toString(), action.page);
	    default:
	      return state;
	  }
	};
	
	var isFetching = function isFetching() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _pages.FETCH_PAGES:
	      return true;
	    case _pages.FETCH_PAGES_SUCCESS:
	    case _pages.FETCH_PAGES_FAILURE:
	      return false;
	    default:
	      return state;
	  }
	};
	
	var error = function error() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _pages.FETCH_PAGES_FAILURE:
	      return action.error;
	    default:
	      return state;
	  }
	};
	
	var filter = function filter() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _pages.FILTER_PAGES:
	      return action.filter;
	    default:
	      return state;
	  }
	};
	
	var isUpdating = function isUpdating() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _pages.UPDATE_PAGE:
	      return true;
	    case _pages.UPDATE_PAGE_SUCCESS:
	    case _pages.UPDATE_PAGE_FAILURE:
	      return false;
	    default:
	      return state;
	  }
	};
	
	exports.default = (0, _redux.combineReducers)({
	  items: pages,
	  pending: pending,
	  isFetching: isFetching,
	  error: error,
	  filter: filter,
	  isUpdating: isUpdating
	});
	var getIsFetching = exports.getIsFetching = function getIsFetching(state) {
	  return state.pages.isFetching;
	};
	var getError = exports.getError = function getError(state) {
	  return state.pages.error;
	};
	
	var getSortedPages = function getSortedPages(state) {
	  return state.pages.items.sort(_page.pageComparator);
	};
	
	var getFilter = exports.getFilter = function getFilter(state) {
	  return state.pages.filter;
	};
	
	var getAllPages = exports.getAllPages = function getAllPages(state) {
	  var filter = getFilter(state);
	  var allPages = getSortedPages(state);
	
	  var filterPage = function filterPage(page) {
	    return !page.isArchived && (filter.length > 0 ? page.name.toLowerCase().indexOf(filter.toLowerCase()) > -1 : true);
	  };
	
	  return allPages.filter(filterPage).toList();
	};
	
	var getArchivedPages = exports.getArchivedPages = function getArchivedPages(state) {
	  return getSortedPages(state).filter(function (p) {
	    return p.isArchived;
	  }).toList();
	};
	
	var getPageById = exports.getPageById = function getPageById(state, id) {
	  return state.pages.items.get(id.toString());
	};
	var getPendingPageById = exports.getPendingPageById = function getPendingPageById(state, id) {
	  return state.pages.pending.get(id.toString());
	};
	
	var getRootPage = exports.getRootPage = function getRootPage(state) {
	  var allPages = getAllPages(state);
	  return allPages.find(function (p) {
	    return p.isRoot;
	  });
	};
	
	var hasContentUpdate = exports.hasContentUpdate = function hasContentUpdate(state, id) {
	  var pending = state.pages.pending.get(id.toString());
	  var existing = getPageById(state, id);
	
	  return pending !== existing || (0, _contents.hasUpdate)(state, id);
	};
	
	var getIsUpdating = exports.getIsUpdating = function getIsUpdating(state) {
	  return state.pages.isUpdating;
	};

/***/ },

/***/ 81:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.storeSuccess = storeSuccess;
	exports.success = success;
	exports.error = error;
	
	var _jquery = __webpack_require__(16);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _toastr = __webpack_require__(2043);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var _storage = __webpack_require__(1078);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FLASH_SUCCESS_STORAGE_KEY = 'capmobil@@flash-success';
	
	exports.default = function () {
	  var notification = (0, _jquery2.default)('#notifications').html().trim();
	  if (notification && notification.length) {
	    success(notification);
	  }
	
	  var errorNotification = (0, _jquery2.default)('#error-notifications').html().trim();
	  if (errorNotification && errorNotification.length) {
	    error(errorNotification);
	  }
	
	  // Bind from session storage flash
	  (0, _storage.scopeWithKey)(FLASH_SUCCESS_STORAGE_KEY, function (value) {
	    return success(value);
	  });
	};
	
	function storeSuccess(content) {
	  (0, _storage.storeInSession)(FLASH_SUCCESS_STORAGE_KEY, content);
	}
	
	function success(content) {
	  _toastr2.default.success(content);
	}
	
	function error(content) {
	  _toastr2.default.error(content);
	}

/***/ },

/***/ 99:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _imageLoader = __webpack_require__(379);
	
	var _imageLoader2 = _interopRequireDefault(_imageLoader);
	
	var _ProgressiveImage = __webpack_require__(316);
	
	var _ProgressiveImage2 = _interopRequireDefault(_ProgressiveImage);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _resources = __webpack_require__(114);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var resourceAlt = function resourceAlt(resource) {
	  return resource ? resource.name : 'Ressource';
	};
	
	var ResourceImage = function ResourceImage(_ref) {
	  var resource = _ref.resource,
	      className = _ref.className,
	      dimmer = _ref.dimmer,
	      dimmerProps = _ref.dimmerProps,
	      rest = _objectWithoutProperties(_ref, ['resource', 'className', 'dimmer', 'dimmerProps']);
	
	  var url = (0, _resources.getImageOrPlaceholder)(resource);
	  var imageClass = (0, _classnames2.default)('ui image', className);
	
	  var innerDimmer = dimmer && _react2.default.cloneElement(_semanticUiReact.Dimmer.create(dimmer), Object.assign({}, dimmerProps));
	
	  return _react2.default.createElement(
	    'div',
	    Object.assign({ className: imageClass, style: { overflow: 'visible' } }, rest),
	    innerDimmer,
	    _react2.default.createElement(
	      _ProgressiveImage2.default,
	      { placeholder: _imageLoader2.default, src: url },
	      function (src) {
	        return _react2.default.createElement('img', { src: src, crossOrigin: 'Anonymous', alt: resourceAlt(resource) });
	      }
	    )
	  );
	};
	
	ResourceImage.propTypes = {
	  resource: __webpack_require__(1).PropTypes.any,
	  className: __webpack_require__(1).PropTypes.string,
	  dimmer: __webpack_require__(1).PropTypes.object,
	  dimmerProps: __webpack_require__(1).PropTypes.object
	};
	exports.default = ResourceImage;

/***/ },

/***/ 113:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isPageSecured = exports.getSecurityComponent = exports.getViewComponent = exports.getEditComponent = exports.getContentWarnings = exports.writeContent = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DiffusionSecurity = __webpack_require__(937);
	
	var _DiffusionSecurity2 = _interopRequireDefault(_DiffusionSecurity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var replaceDotBySlash = function replaceDotBySlash(template) {
	  return template.replace('.', '/');
	};
	
	var usingPlugin = function usingPlugin(template) {
	  return function (execute) {
	    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	    try {
	      var plugin = __webpack_require__(2054)("./" + replaceDotBySlash(template) + '/index.js');
	      return execute(plugin);
	    } catch (error) {
	      console.warn('No plugin found for template ' + template, error);
	      return defaultValue;
	    }
	  };
	};
	
	var writeContent = exports.writeContent = function writeContent(template, content) {
	  return usingPlugin(template)(function (plugin) {
	    if (plugin.writeContent) {
	      return plugin.writeContent(content);
	    }
	
	    return content;
	  }, content);
	};
	
	var getContentWarnings = exports.getContentWarnings = function getContentWarnings(template, content) {
	  return usingPlugin(template)(function (plugin) {
	    if (content && plugin.getContentWarnings) {
	      return plugin.getContentWarnings(content);
	    }
	
	    return [];
	  }, []);
	};
	
	var getEditComponent = exports.getEditComponent = function getEditComponent(template, content) {
	  return usingPlugin(template)(function (plugin) {
	    var component = plugin.getEditComponent();
	    return _react2.default.createElement(component, {
	      content: content
	    });
	  });
	};
	
	var getViewComponent = exports.getViewComponent = function getViewComponent(template, content) {
	  return usingPlugin(template)(function (plugin) {
	    var component = plugin.getViewComponent();
	    return _react2.default.createElement(component, {
	      content: content
	    });
	  });
	};
	
	var getSecurityComponent = exports.getSecurityComponent = function getSecurityComponent(page) {
	  return _react2.default.createElement(_DiffusionSecurity2.default, { security: page.security });
	};
	
	var isPageSecured = exports.isPageSecured = function isPageSecured(page) {
	  return page.security.targets && page.security.targets.length > 0;
	};

/***/ },

/***/ 114:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getVideoPlaceholder = exports.getImageOrPlaceholder = exports.getImage = undefined;
	
	var _placeholder = __webpack_require__(2046);
	
	var _placeholder2 = _interopRequireDefault(_placeholder);
	
	var _videoPlaceholder = __webpack_require__(2047);
	
	var _videoPlaceholder2 = _interopRequireDefault(_videoPlaceholder);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getImage = exports.getImage = function getImage(resource) {
	  var variant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'web';
	
	  if (resource) {
	    switch (resource.type.category) {
	      case 'image':
	        return resource.url[variant];
	      case 'pdf':
	        return resource.url.thumbnail;
	      default:
	        return null;
	    }
	  }
	
	  return null;
	};
	
	var getImageOrPlaceholder = exports.getImageOrPlaceholder = function getImageOrPlaceholder(resource) {
	  var variant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'web';
	  return getImage(resource, variant) || _placeholder2.default;
	};
	
	var getVideoPlaceholder = exports.getVideoPlaceholder = _videoPlaceholder2.default;

/***/ },

/***/ 115:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.INLINE_STYLES = exports.ALIGN_TYPES = exports.HEADER_TYPES = exports.BLOCK_TYPES = exports.getBlockAlignment = exports.getBlockColor = exports.htmlToState = exports.stateToHTML = exports.linkDecorator = exports.Link = exports.findLinkEntities = exports.getWordCount = exports.getLineCount = exports.getCharCount = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _draftJs = __webpack_require__(86);
	
	var _draftConvert = __webpack_require__(1328);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/////////
	// Text counters for rich text editor
	/////////
	
	var getCharCount = exports.getCharCount = function getCharCount(editorState) {
	  var plainText = editorState.getCurrentContent().getPlainText('');
	  var regex = /(?:\r\n|\r|\n)/g;
	  return plainText.replace(regex, '').trim().length;
	};
	
	var getLineCount = exports.getLineCount = function getLineCount(editorState) {
	  var blockArray = editorState.getCurrentContent().getBlocksAsArray();
	  return blockArray && blockArray.length;
	};
	
	var getWordCount = exports.getWordCount = function getWordCount(editorState) {
	  var plainText = editorState.getCurrentContent().getPlainText('');
	  var wordArray = plainText.replace(/(?:\r\n|\r|\n)/g, ' ').trim().match(/\S+/g);
	  return wordArray ? wordArray.length : 0;
	};
	
	/////////
	// Link rendering in rich text editor
	/////////
	
	var findLinkEntities = exports.findLinkEntities = function findLinkEntities(contentBlock, callback) {
	  contentBlock.findEntityRanges(function (character) {
	    var entityKey = character.getEntity();
	
	    return entityKey !== null && _draftJs.Entity.get(entityKey).getType() === 'LINK';
	  }, callback);
	};
	
	var Link = exports.Link = function Link(_ref) {
	  var entityKey = _ref.entityKey,
	      children = _ref.children;
	
	  var _Entity$get$getData = _draftJs.Entity.get(entityKey).getData(),
	      url = _Entity$get$getData.url;
	
	  return _react2.default.createElement(
	    'a',
	    { href: url, target: '_blank' },
	    children
	  );
	};
	
	Link.propTypes = {
	  entityKey: __webpack_require__(1).PropTypes.string.isRequired,
	  children: __webpack_require__(1).PropTypes.any.isRequired
	};
	var linkDecorator = exports.linkDecorator = new _draftJs.CompositeDecorator([{
	  strategy: findLinkEntities,
	  component: Link
	}]);
	
	/////////
	// html parsing/rendering from/to draft js editor state
	////////
	
	var stateToHTML = exports.stateToHTML = function stateToHTML(editoContent) {
	  return (0, _draftConvert.convertToHTML)({
	    styleToHTML: function styleToHTML(style) {
	      if (style && style.substring(0, 3) === 'rgb') {
	        return _react2.default.createElement('span', { style: { color: style } });
	      }
	    },
	    blockToHTML: function blockToHTML(block) {
	      var blockStyles = block.inlineStyleRanges;
	
	      var alignment = blockStyles.find(function (style) {
	        return style.style === 'left' || style.style === 'center' || style.style === 'right';
	      });
	
	      switch (block.type) {
	        case 'unstyled':
	          return _react2.default.createElement('p', { style: { textAlign: alignment && alignment.style } });
	        case 'blockquote':
	          return _react2.default.createElement('blockquote', { style: { textAlign: alignment && alignment.style } });
	        case 'code-block':
	          return _react2.default.createElement('pre', { style: { textAlign: alignment && alignment.style } });
	        default:
	          return null;
	      }
	    },
	    entityToHTML: function entityToHTML(entity, originalText) {
	      if (entity.type === 'LINK') {
	        return _react2.default.createElement(
	          'a',
	          { href: entity.data.url },
	          originalText
	        );
	      }
	      return originalText;
	    }
	  })(editoContent);
	};
	
	var htmlToState = exports.htmlToState = function htmlToState(html) {
	  var decorator = new _draftJs.CompositeDecorator([{ strategy: findLinkEntities, component: Link }]);
	
	  var state = (0, _draftConvert.convertFromHTML)({
	    htmlToStyle: function htmlToStyle(nodeName, node, currentStyle) {
	      var patchedStyle = currentStyle;
	
	      if (node.style.color) {
	        var existingColor = patchedStyle.find(function (style) {
	          return style && style.substring(0, 3) === 'rgb';
	        });
	        if (existingColor) {
	          patchedStyle = patchedStyle.delete(existingColor);
	        }
	        patchedStyle = patchedStyle.add(node.style.color);
	      }
	
	      if (node.style.textAlign) {
	        patchedStyle = patchedStyle.add(node.style.textAlign);
	      }
	
	      return patchedStyle;
	    },
	    htmlToEntity: function htmlToEntity(nodeName, node) {
	      if (nodeName === 'a') {
	        return _draftJs.Entity.create('LINK', 'MUTABLE', { url: node.href });
	      }
	    },
	    htmlToBlock: function htmlToBlock(nodeName, node) {
	      if (nodeName === 'blockquote') {
	        return {
	          type: 'blockquote',
	          data: {}
	        };
	      }
	    }
	  })(html);
	
	  var applyAlignmentStyles = function applyAlignmentStyles(contentBlock) {
	    return contentBlock.getCharacterList().map(function (c) {
	      return _draftJs.CharacterMetadata.applyStyle(c, contentBlock.data.get('textAlign'));
	    });
	  };
	
	  var applyColorStyles = function applyColorStyles(contentBlock) {
	    return contentBlock.getCharacterList().map(function (c) {
	      return _draftJs.CharacterMetadata.applyStyle(c, contentBlock.data.get('color'));
	    });
	  };
	
	  // TODO: Could proably use reduce here to chain state mutations and style applications
	  var newBlockMap = state.getBlockMap().map(function (contentBlock) {
	    return contentBlock.set('characterList', applyAlignmentStyles(contentBlock));
	  });
	
	  var alignedState = state.set('blockMap', newBlockMap);
	  var coloredState = state.set('blockMap', alignedState.getBlockMap().map(function (contentBlock) {
	    return contentBlock.set('characterList', applyColorStyles(contentBlock));
	  }));
	
	  return _draftJs.EditorState.createWithContent(coloredState, decorator);
	};
	
	/////////
	// Special Block rendering and className application on custom blocks of text
	/////////
	
	var getBlockColor = exports.getBlockColor = function getBlockColor(block) {
	  var color = '';
	
	  block.findStyleRanges(function (e) {
	    color = e.getStyle().find(function (style) {
	      return style && style.substring(0, 3) === 'rgb';
	    });
	  });
	
	  return color;
	};
	
	var getBlockAlignment = exports.getBlockAlignment = function getBlockAlignment(block) {
	  var style = 'left';
	  block.findStyleRanges(function (e) {
	    if (e.hasStyle('center')) style = 'center';
	    if (e.hasStyle('right')) style = 'right';
	  });
	  return style;
	};
	
	/////////
	// Controls rendering in rich text edito
	/////////
	
	var BLOCK_TYPES = exports.BLOCK_TYPES = [
	// {label: 'Blockquote', style: 'blockquote', display_style: 'quote right'},
	{ label: 'UL', style: 'unordered-list-item', display_style: 'list' }, { label: 'OL', style: 'ordered-list-item', display_style: 'ordered list' }];
	
	var HEADER_TYPES = exports.HEADER_TYPES = [{ label: 'Titre 1', style: 'header-one' }, { label: 'Titre 2', style: 'header-two' }, { label: 'Titre 3', style: 'header-three' }, { label: 'Titre 4', style: 'header-four' }, { label: 'Titre 5', style: 'header-five' }, { label: 'Titre 6', style: 'header-six' }];
	
	var ALIGN_TYPES = exports.ALIGN_TYPES = [{
	  label: 'Align left',
	  className: '.alignment--left',
	  style: 'align left',
	  display_style: 'align left'
	}, {
	  label: 'Align center',
	  className: '.alignment--center',
	  style: 'align center',
	  display_style: 'align center'
	}, {
	  label: 'Align right',
	  className: '.alignment--right',
	  style: 'align right',
	  display_style: 'align right'
	}];
	
	var INLINE_STYLES = exports.INLINE_STYLES = [{ label: 'Bold', style: 'BOLD', display_style: 'bold' }, { label: 'Italic', style: 'ITALIC', display_style: 'italic' }, { label: 'Underline', style: 'UNDERLINE', display_style: 'underline' }];

/***/ },

/***/ 140:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getCatalogPlatform = exports.getEditionPlatform = exports.getDefaultPlatform = exports.getPlatforms = undefined;
	
	var _redux = __webpack_require__(33);
	
	var _pages = __webpack_require__(46);
	
	var _platforms = __webpack_require__(212);
	
	var items = function items() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _pages.FETCH_PAGES_SUCCESS:
	      return action.platforms;
	    default:
	      return state;
	  }
	};
	
	var edit = function edit() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _platforms.CHANGE_EDITION_PLATFORM:
	      return action.platform;
	    default:
	      return state;
	  }
	};
	
	var catalog = function catalog() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _platforms.CHANGE_CATALOG_PLATFORM:
	      return action.platform;
	    default:
	      return state;
	  }
	};
	
	exports.default = (0, _redux.combineReducers)({
	  items: items,
	  edit: edit,
	  catalog: catalog
	});
	var getPlatforms = exports.getPlatforms = function getPlatforms(state) {
	  return state.platforms.items;
	};
	
	var getDefaultPlatform = exports.getDefaultPlatform = function getDefaultPlatform(state) {
	  var platforms = getPlatforms(state);
	  return platforms.find(function (p) {
	    return p.isDefault;
	  });
	};
	
	var getEditionPlatform = exports.getEditionPlatform = function getEditionPlatform(state) {
	  var edit = state.platforms.edit;
	
	  return edit || getDefaultPlatform(state);
	};
	
	var getCatalogPlatform = exports.getCatalogPlatform = function getCatalogPlatform(state) {
	  var catalog = state.platforms.catalog;
	
	  return catalog || getDefaultPlatform(state);
	};

/***/ },

/***/ 141:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var TEXT_CHARACTER_LIMIT = exports.TEXT_CHARACTER_LIMIT = 3000;
	var CONTACT_CHARACTER_LIMIT = exports.CONTACT_CHARACTER_LIMIT = 500;
	var ADDRESS_CHARACTER_LIMIT = exports.ADDRESS_CHARACTER_LIMIT = 500;
	var DEFAULT_BLOCK_ICON = exports.DEFAULT_BLOCK_ICON = 'stop';

/***/ },

/***/ 142:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var INITIAL_DATA_LOAD = exports.INITIAL_DATA_LOAD = 'news:INITIAL_DATA_LOAD';
	var INITIAL_DATA_LOAD_SUCCESS = exports.INITIAL_DATA_LOAD_SUCCESS = 'news:INITIAL_DATA_LOAD_SUCCESS';
	
	var loadInitialDatas = exports.loadInitialDatas = function loadInitialDatas() {
	  return {
	    type: INITIAL_DATA_LOAD
	  };
	};

/***/ },

/***/ 171:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.cancelPending = exports.cropResource = exports.uploadFileFailure = exports.uploadFileSuccess = exports.uploadingFile = exports.uploadFile = exports.CANCEL_PENDING = exports.CROP_RESOURCE = exports.UPLOAD_FILE_FAILURE = exports.UPLOAD_FILE_SUCCESS = exports.PROCESSING_FILE = exports.UPLOADING_FILE = exports.UPLOAD_FILE = undefined;
	
	var _uuid = __webpack_require__(296);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UPLOAD_FILE = exports.UPLOAD_FILE = 'UPLOAD_FILE';
	var UPLOADING_FILE = exports.UPLOADING_FILE = 'UPLOADING_FILE';
	var PROCESSING_FILE = exports.PROCESSING_FILE = 'PROCESSING_FILE';
	var UPLOAD_FILE_SUCCESS = exports.UPLOAD_FILE_SUCCESS = 'UPLOAD_FILE_SUCCESS';
	var UPLOAD_FILE_FAILURE = exports.UPLOAD_FILE_FAILURE = 'UPLOAD_FILE_FAILURE';
	var CROP_RESOURCE = exports.CROP_RESOURCE = 'CROP_RESOURCE';
	var CANCEL_PENDING = exports.CANCEL_PENDING = 'CANCEL_PENDING';
	
	var pendingUpload = function pendingUpload(file) {
	  return {
	    token: (0, _uuid2.default)(),
	    name: file.name,
	    file: file
	  };
	};
	
	var runningUpload = function runningUpload(upload) {
	  return Object.assign({}, upload, {
	    state: 'uploading',
	    file: undefined
	  });
	};
	
	var uploadFile = exports.uploadFile = function uploadFile(folder, file) {
	  return {
	    type: UPLOAD_FILE,
	    folder: folder,
	    upload: pendingUpload(file)
	  };
	};
	
	var uploadingFile = exports.uploadingFile = function uploadingFile(folder, upload) {
	  return {
	    type: UPLOADING_FILE,
	    folder: folder,
	    upload: runningUpload(upload)
	  };
	};
	
	var uploadFileSuccess = exports.uploadFileSuccess = function uploadFileSuccess(folder, upload, response) {
	  return {
	    type: UPLOAD_FILE_SUCCESS,
	    folder: folder,
	    upload: upload,
	    response: response
	  };
	};
	
	var uploadFileFailure = exports.uploadFileFailure = function uploadFileFailure(folder, upload, error) {
	  return {
	    type: UPLOAD_FILE_FAILURE,
	    folder: folder,
	    upload: upload,
	    error: error
	  };
	};
	
	var cropResource = exports.cropResource = function cropResource(folder, resource, crop) {
	  return {
	    type: CROP_RESOURCE,
	    folder: folder,
	    resource: resource,
	    crop: crop,
	    upload: {
	      token: (0, _uuid2.default)(),
	      name: resource.name
	    }
	  };
	};
	
	var cancelPending = exports.cancelPending = function cancelPending() {
	  return {
	    type: CANCEL_PENDING
	  };
	};

/***/ },

/***/ 172:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getIsRemoving = exports.getIsUpdating = exports.getIsSaving = exports.getIsFetching = exports.getFolderById = exports.getAllFolders = undefined;
	
	var _redux = __webpack_require__(33);
	
	var _immutable = __webpack_require__(10);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_State = __webpack_require__(477).babelPluginFlowReactPropTypes_proptype_State || __webpack_require__(1).PropTypes.any;
	
	if (true) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_FoldersState', {
	  value: __webpack_require__(1).PropTypes.shape({
	    items: __webpack_require__(1).PropTypes.any.isRequired,
	    isFetching: __webpack_require__(1).PropTypes.bool.isRequired,
	    isSaving: __webpack_require__(1).PropTypes.bool.isRequired,
	    isUpdating: __webpack_require__(1).PropTypes.bool.isRequired,
	    isRemoving: __webpack_require__(1).PropTypes.bool.isRequired
	  })
	});
	
	
	var folders = function folders() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _immutable2.default.Map();
	  var action = arguments[1];
	
	  switch (action.type) {
	    case 'FETCH_FOLDERS_SUCCESS':
	    case 'SAVE_FOLDER_SUCCESS':
	    case 'UPDATE_FOLDER_SUCCESS':
	      return state.merge(_immutable2.default.Map(action.response.entities.folders));
	    case 'REMOVE_FOLDER_SUCCESS':
	      return state.remove(action.folderId.toString());
	    default:
	      return state;
	  }
	};
	
	var isFetching = function isFetching() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case 'FETCH_FOLDERS':
	      return true;
	    case 'FETCH_FOLDERS_FAILURE':
	    case 'FETCH_FOLDERS_SUCCESS':
	      return false;
	    default:
	      return state;
	  }
	};
	
	var isSaving = function isSaving() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case 'SAVE_FOLDER':
	      return true;
	    case 'SAVE_FOLDER_SUCCESS':
	      return false;
	    default:
	      return state;
	  }
	};
	
	var isUpdating = function isUpdating() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case 'UPDATE_FOLDER':
	      return true;
	    case 'UPDATE_FOLDER_SUCCESS':
	      return false;
	    default:
	      return state;
	  }
	};
	
	var isRemoving = function isRemoving() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case 'REMOVE_FOLDER':
	      return true;
	    case 'REMOVE_FOLDER_SUCCESS':
	      return false;
	    default:
	      return state;
	  }
	};
	
	exports.default = (0, _redux.combineReducers)({
	  items: folders,
	  isFetching: isFetching,
	  isSaving: isSaving,
	  isUpdating: isUpdating,
	  isRemoving: isRemoving
	});
	var getAllFolders = exports.getAllFolders = function getAllFolders(state) {
	  return state.folders.items.toList().sortBy(function (f) {
	    return f.name;
	  });
	};
	var getFolderById = exports.getFolderById = function getFolderById(state, id) {
	  return state.folders.items.get(id);
	};
	
	var getIsFetching = exports.getIsFetching = function getIsFetching(state) {
	  return state.folders.isFetching;
	};
	var getIsSaving = exports.getIsSaving = function getIsSaving(state) {
	  return state.folders.isSaving;
	};
	var getIsUpdating = exports.getIsUpdating = function getIsUpdating(state) {
	  return state.folders.isUpdating;
	};
	var getIsRemoving = exports.getIsRemoving = function getIsRemoving(state) {
	  return state.folders.isRemoving;
	};

/***/ },

/***/ 173:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getIsCreating = exports.hasUpdate = exports.getPendingContent = exports.getPendingContents = exports.getCurrentContent = exports.getContent = exports.getPageContents = undefined;
	
	var _redux = __webpack_require__(33);
	
	var _immutable = __webpack_require__(10);
	
	var _pages = __webpack_require__(46);
	
	var _contents = __webpack_require__(210);
	
	var _platforms = __webpack_require__(140);
	
	var items = function items() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.Map)();
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _pages.FETCH_PAGES_SUCCESS:
	      return (0, _immutable.Map)(action.response.entities.contents);
	    case _pages.SAVE_PAGE_SUCCESS:
	    case _pages.UPDATE_PAGE_SUCCESS:
	      return state.merge((0, _immutable.Map)(action.response.entities.contents));
	    case _contents.CREATE_CONTENT_SUCCESS:
	      return state.set(action.content.id, action.content);
	    default:
	      return state;
	  }
	};
	
	var pending = function pending() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.Map)();
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _pages.FETCH_PAGES_SUCCESS:
	      return (0, _immutable.Map)(action.response.entities.contents);
	    case _pages.SAVE_PAGE_SUCCESS:
	    case _pages.UPDATE_PAGE_SUCCESS:
	      return state.merge((0, _immutable.Map)(action.response.entities.contents));
	    case _contents.CREATE_CONTENT_SUCCESS:
	    case _contents.SERIALIZE_CONTENT:
	    case _pages.CANCEL_PENDING:
	      {
	        if (action.content) {
	          return state.set(action.content.id, action.content);
	        } else {
	          return state;
	        }
	      }
	    default:
	      return state;
	  }
	};
	
	var creating = function creating() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _contents.CREATE_CONTENT:
	      return true;
	    case _contents.CREATE_CONTENT_SUCCESS:
	      return false;
	    default:
	      return state;
	  }
	};
	
	exports.default = (0, _redux.combineReducers)({
	  items: items,
	  pending: pending,
	  creating: creating
	});
	
	
	var getAllContents = function getAllContents(state) {
	  return state.contents.items;
	};
	
	var getPageContents = exports.getPageContents = function getPageContents(state, pageId) {
	  var contents = getAllContents(state);
	  return contents.filter(function (c) {
	    return c.pageId.toString() === pageId.toString();
	  }).toList();
	};
	
	var getContent = exports.getContent = function getContent(state, pageId, platform) {
	  var contents = getPageContents(state, pageId);
	  var platformContent = contents.find(function (c) {
	    return c.platform === platform.code;
	  });
	
	  var fallbackToDefaultContent = function fallbackToDefaultContent() {
	    var defaultPlatform = (0, _platforms.getDefaultPlatform)(state);
	    return contents.find(function (c) {
	      return c.platform === defaultPlatform.code;
	    });
	  };
	
	  // Fallback to default content if not found
	  return platformContent || fallbackToDefaultContent();
	};
	
	var getCurrentContent = exports.getCurrentContent = function getCurrentContent(state, pageId) {
	  var platform = (0, _platforms.getEditionPlatform)(state);
	  return getContent(state, pageId, platform);
	};
	
	var getPendingContents = exports.getPendingContents = function getPendingContents(state, pageId) {
	  var pending = state.contents.pending;
	  return pending.filter(function (c) {
	    return c.pageId.toString() === pageId.toString();
	  }).toList();
	};
	
	var getPendingContent = exports.getPendingContent = function getPendingContent(state, pageId) {
	  var platform = (0, _platforms.getEditionPlatform)(state);
	  var pending = getPendingContents(state, pageId);
	
	  return pending.find(function (c) {
	    return c.platform === platform.code;
	  });
	};
	
	var hasUpdate = exports.hasUpdate = function hasUpdate(state, pageId) {
	  var pending = getPendingContents(state, pageId);
	  var existing = getPageContents(state, pageId);
	
	  return !pending.equals(existing);
	};
	
	var getIsCreating = exports.getIsCreating = function getIsCreating(state) {
	  return state.contents.creating;
	};

/***/ },

/***/ 174:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _reactImageCrop = __webpack_require__(1760);
	
	var _reactImageCrop2 = _interopRequireDefault(_reactImageCrop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	if (true) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_CropConfig', {
	  value: __webpack_require__(1).PropTypes.shape({
	    width: __webpack_require__(1).PropTypes.number,
	    height: __webpack_require__(1).PropTypes.number,
	    x: __webpack_require__(1).PropTypes.number,
	    y: __webpack_require__(1).PropTypes.number,
	    aspect: __webpack_require__(1).PropTypes.number
	  })
	});
	
	// TODO: display loader while loading image (see onImageLoaded props from ReactCrop)
	var ImageCrop = function (_Component) {
	  _inherits(ImageCrop, _Component);
	
	  function ImageCrop(props) {
	    _classCallCheck(this, ImageCrop);
	
	    var _this = _possibleConstructorReturn(this, (ImageCrop.__proto__ || Object.getPrototypeOf(ImageCrop)).call(this, props));
	
	    _this.onCropComplete = function (crop) {
	      return _this.setState({
	        crop: Object.assign({}, crop, {
	          aspect: crop.aspect || undefined
	        })
	      });
	    };
	
	    _this.onConfirm = function () {
	      var crop = _this.state.crop;
	
	      if (crop) {
	        _this.props.onComplete(crop);
	      }
	    };
	
	    _this.state = {
	      crop: props.config
	    };
	    return _this;
	  }
	
	  _createClass(ImageCrop, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.config !== this.props.config) {
	        this.setState({
	          crop: nextProps.config
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          open = _props.open,
	          image = _props.image,
	          fullWidth = _props.fullWidth,
	          fullHeight = _props.fullHeight,
	          onClose = _props.onClose;
	      var crop = this.state.crop;
	
	
	      var minWidth = void 0,
	          minHeight = void 0;
	      if (fullWidth) {
	        minWidth = 100;
	      } else if (fullHeight) {
	        minHeight = 100;
	      }
	
	      return _react2.default.createElement(
	        _semanticUiReact.Modal,
	        {
	          closeIcon: true,
	          open: open,
	          onClose: onClose,
	          closeOnRootNodeClick: false
	        },
	        _react2.default.createElement(
	          _semanticUiReact.Modal.Header,
	          null,
	          'Redimensionnement de l\'image'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Modal.Content,
	          { image: true },
	          _react2.default.createElement(_reactImageCrop2.default, {
	            src: image,
	            crop: crop,
	            crossorigin: 'Anonymous',
	            minWidth: minWidth,
	            minHeight: minHeight,
	            onComplete: this.onCropComplete
	          })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Modal.Actions,
	          null,
	          _react2.default.createElement(_semanticUiReact.Button, {
	            type: 'button',
	            onClick: this.onConfirm,
	            positive: true,
	            icon: 'checkmark',
	            labelPosition: 'right',
	            content: 'Valider'
	          })
	        )
	      );
	    }
	  }]);
	
	  return ImageCrop;
	}(_react.Component);
	
	ImageCrop.propTypes = {
	  open: __webpack_require__(1).PropTypes.bool.isRequired,
	  image: __webpack_require__(1).PropTypes.string.isRequired,
	  fullWidth: __webpack_require__(1).PropTypes.bool,
	  fullHeight: __webpack_require__(1).PropTypes.bool,
	  config: __webpack_require__(1).PropTypes.shape({
	    width: __webpack_require__(1).PropTypes.number,
	    height: __webpack_require__(1).PropTypes.number,
	    x: __webpack_require__(1).PropTypes.number,
	    y: __webpack_require__(1).PropTypes.number,
	    aspect: __webpack_require__(1).PropTypes.number
	  }),
	  onComplete: __webpack_require__(1).PropTypes.func.isRequired,
	  onClose: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = ImageCrop;

/***/ },

/***/ 175:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _ResourceImage = __webpack_require__(99);
	
	var _ResourceImage2 = _interopRequireDefault(_ResourceImage);
	
	var _index = __webpack_require__(318);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResourceCard = function (_Component) {
	  _inherits(ResourceCard, _Component);
	
	  function ResourceCard(props) {
	    _classCallCheck(this, ResourceCard);
	
	    var _this = _possibleConstructorReturn(this, (ResourceCard.__proto__ || Object.getPrototypeOf(ResourceCard)).call(this, props));
	
	    _this.onShowSelector = function () {
	      return _this.setState({ selectorOpen: true });
	    };
	
	    _this.onHideSelector = function () {
	      return _this.setState({ selectorOpen: false });
	    };
	
	    _this.onResourceSelected = function (resource) {
	      // Updating current image
	      _this.setState({
	        selectorOpen: false
	      });
	
	      _this.props.onSelected(resource);
	    };
	
	    _this.onResourceDeleted = function () {
	      _this.props.onDeleted();
	    };
	
	    _this.state = {
	      selectorOpen: false
	    };
	    return _this;
	  }
	
	  _createClass(ResourceCard, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          resource = _props.resource,
	          resourceType = _props.resourceType,
	          onDeleted = _props.onDeleted;
	      var selectorOpen = this.state.selectorOpen;
	
	
	      var image = children || _react2.default.createElement(_ResourceImage2.default, { resource: resource });
	
	      return _react2.default.createElement(
	        _semanticUiReact.Card,
	        { centered: true },
	        image,
	        _react2.default.createElement(
	          _semanticUiReact.Card.Content,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'ui two buttons' },
	            _react2.default.createElement(
	              _semanticUiReact.Button,
	              {
	                type: 'button',
	                basic: true,
	                color: 'green',
	                onClick: this.onShowSelector
	              },
	              'Modifier'
	            ),
	            resource && _react2.default.createElement(
	              _semanticUiReact.Button,
	              { type: 'button', basic: true, color: 'red', onClick: onDeleted },
	              'Supprimer'
	            )
	          )
	        ),
	        _react2.default.createElement(_index2.default, {
	          open: selectorOpen,
	          resourceType: resourceType,
	          onResourceSelected: this.onResourceSelected,
	          onClose: this.onHideSelector
	        })
	      );
	    }
	  }]);
	
	  return ResourceCard;
	}(_react.Component);
	
	ResourceCard.propTypes = {
	  children: __webpack_require__(1).PropTypes.any,
	  resource: __webpack_require__(1).PropTypes.any,
	  resourceType: __webpack_require__(1).PropTypes.any.isRequired,
	  onSelected: __webpack_require__(1).PropTypes.func.isRequired,
	  onDeleted: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = ResourceCard;

/***/ },

/***/ 176:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _ResourceImage = __webpack_require__(99);
	
	var _ResourceImage2 = _interopRequireDefault(_ResourceImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResourceDimmer = function (_Component) {
	  _inherits(ResourceDimmer, _Component);
	
	  function ResourceDimmer(props) {
	    _classCallCheck(this, ResourceDimmer);
	
	    var _this = _possibleConstructorReturn(this, (ResourceDimmer.__proto__ || Object.getPrototypeOf(ResourceDimmer)).call(this, props));
	
	    _this.handleShow = function () {
	      return _this.setState({ active: true });
	    };
	
	    _this.handleHide = function () {
	      return _this.setState({ active: false });
	    };
	
	    _this.state = {
	      active: false
	    };
	    return _this;
	  }
	
	  _createClass(ResourceDimmer, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          resource = _props.resource,
	          children = _props.children;
	      var active = this.state.active;
	
	
	      var dimmerActive = resource && active;
	
	      return _react2.default.createElement(_semanticUiReact.Dimmer.Dimmable, {
	        as: _ResourceImage2.default,
	        resource: resource,
	        dimmed: dimmerActive,
	        dimmer: { active: dimmerActive, content: children },
	        onMouseEnter: this.handleShow,
	        onMouseLeave: this.handleHide
	      });
	    }
	  }]);
	
	  return ResourceDimmer;
	}(_react.Component);
	
	ResourceDimmer.propTypes = {
	  resource: __webpack_require__(1).PropTypes.any,
	  children: __webpack_require__(1).PropTypes.any
	};
	exports.default = ResourceDimmer;

/***/ },

/***/ 177:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(16);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _draftJs = __webpack_require__(86);
	
	var _reactColor = __webpack_require__(409);
	
	var _RichTextMenuButton = __webpack_require__(1075);
	
	var _RichTextMenuButton2 = _interopRequireDefault(_RichTextMenuButton);
	
	var _richtext = __webpack_require__(115);
	
	var _reactAddonsShallowCompare = __webpack_require__(273);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _semanticUiReact = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// TODO: Only used for sticky menu, to remove when sticky appears in semantic ui react
	
	
	// eslint-disable-next-line no-unused-vars
	
	
	//TODO: Add maxWidth equal to width on Segment encaplusating the editor
	var RichTextItem = function (_Component) {
	  _inherits(RichTextItem, _Component);
	
	  function RichTextItem(props) {
	    _classCallCheck(this, RichTextItem);
	
	    var _this = _possibleConstructorReturn(this, (RichTextItem.__proto__ || Object.getPrototypeOf(RichTextItem)).call(this, props));
	
	    _this._focusNow = function () {
	      setTimeout(function () {
	        return _this.textEdito.focus();
	      }, 0);
	    };
	
	    _this._onColorChange = function (newColor) {
	      _this.setState({
	        currentColor: 'rgb(' + newColor.rgb.r + ',' + newColor.rgb.g + ',' + newColor.rgb.b + ')'
	      });
	    };
	
	    _this._applyColor = function (evt) {
	      var color = _this.state.currentColor;
	
	      var parentState = _this.props.parentState;
	
	      var selection = parentState.getSelection();
	
	      var appliedColors = parentState.getCurrentInlineStyle().filter(function (style) {
	        return style && style.substring(0, 3) === 'rgb';
	      });
	
	      var nextEditorState = parentState;
	
	      // TODO: reduce instead of map
	      appliedColors.map(function (appliedColor) {
	        nextEditorState = _draftJs.EditorState.push(nextEditorState, _draftJs.Modifier.removeInlineStyle(parentState.getCurrentContent(), selection, appliedColor), 'change-inline-style');
	
	        // anti-warning ugly thingy
	        return {};
	      });
	
	      nextEditorState = _draftJs.RichUtils.toggleInlineStyle(nextEditorState, color);
	
	      _this.onChange(nextEditorState);
	      _this.setState({
	        showColorPicker: false
	      }, _this._focusNow);
	    };
	
	    _this._applyAlignment = function (editorState, style) {
	      var removeStyles = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	      var currentContent = editorState.getCurrentContent();
	      var selection = editorState.getSelection();
	      var selectionIsBackward = selection.getIsBackward();
	
	      var changes = {
	        anchorOffset: 0,
	        focusOffset: currentContent.getBlockForKey(selection.getFocusKey()).getLength()
	      };
	
	      if (selectionIsBackward) {
	        changes = {
	          focusOffset: 0,
	          anchorOffset: currentContent.getBlockForKey(selection.getAnchorKey()).getLength()
	        };
	      }
	
	      var selectWholeBlocks = selection.merge(changes);
	      var modifiedContent = _draftJs.Modifier.applyInlineStyle(currentContent, selectWholeBlocks, style);
	      var finalContent = removeStyles.reduce(function (content, style) {
	        return _draftJs.Modifier.removeInlineStyle(content, selectWholeBlocks, style);
	      }, modifiedContent);
	      return _draftJs.EditorState.push(editorState, finalContent, 'change-inline-style');
	    };
	
	    _this._toggleAlignment = function (selection) {
	      var classN = selection.replace('align ', '');
	
	      var getOppositeAlignments = function getOppositeAlignments(alignmentClass) {
	        switch (alignmentClass) {
	          case 'right':
	            return ['left', 'center'];
	          case 'center':
	            return ['left', 'right'];
	          case 'left':
	            return ['center', 'right'];
	          default:
	            return [];
	        }
	      };
	
	      _this.onChange(_this._applyAlignment(_this.props.parentState, classN, getOppositeAlignments(classN)));
	    };
	
	    _this._toggleColorPicker = function (blockType) {
	      _this.setState({ showColorPicker: !_this.state.showColorPicker });
	    };
	
	    _this._toggleBlockType = function (blockType) {
	      _this.onChange(_draftJs.RichUtils.toggleBlockType(_this.props.parentState, blockType));
	    };
	
	    _this._toggleInlineStyle = function (inlineStyle) {
	      _this.onChange(_draftJs.RichUtils.toggleInlineStyle(_this.props.parentState, inlineStyle));
	    };
	
	    _this._promptForLink = function (e) {
	      e.preventDefault();
	      var parentState = _this.props.parentState;
	
	      var selection = parentState.getSelection();
	      if (!selection.isCollapsed()) {
	        var contentState = parentState.getCurrentContent();
	        var startKey = parentState.getSelection().getStartKey();
	        var startOffset = parentState.getSelection().getStartOffset();
	        var blockWithLinkAtBeginning = contentState.getBlockForKey(startKey);
	        var linkKey = blockWithLinkAtBeginning.getEntityAt(startOffset);
	
	        var url = '';
	        if (linkKey) {
	          var linkInstance = contentState.getEntity(linkKey);
	          url = linkInstance.getData().url;
	        }
	
	        _this.setState({
	          showURLInput: true,
	          urlValue: url
	        }, function () {
	          setTimeout(function () {
	            return _this.textEditoUrl.focus();
	          }, 0);
	        });
	      }
	    };
	
	    _this._confirmLink = function (e) {
	      e.preventDefault();
	      var urlValue = _this.state.urlValue;
	
	
	      var validatedUrl = !urlValue.match(/^[a-zA-Z]+:\/\//) ? 'http://' + urlValue : urlValue;
	      var parentState = _this.props.parentState;
	
	      // Can be IMMUTABLE, if so, whole link( and its characters) will be removed if one of its characters is removed
	
	      var entityKey = _draftJs.Entity.create('LINK', 'MUTABLE', { url: validatedUrl });
	      _this.onChange(_draftJs.RichUtils.toggleLink(parentState, parentState.getSelection(), entityKey));
	      _this.setState({
	        showURLInput: false,
	        urlValue: ''
	      }, _this._focusNow);
	    };
	
	    _this._cancelLink = function (e) {
	      e.preventDefault();
	
	      _this.setState({
	        showURLInput: false,
	        urlValue: ''
	      }, _this._focusNow);
	    };
	
	    _this._onLinkInputKeyDown = function (e) {
	      if (e.which === 13) {
	        _this._confirmLink(e);
	      }
	    };
	
	    _this._removeLink = function (e) {
	      e.preventDefault();
	      var parentState = _this.props.parentState;
	
	      var selection = parentState.getSelection();
	      if (!selection.isCollapsed()) {
	        _this.onChange(_draftJs.RichUtils.toggleLink(parentState, selection, null));
	      }
	    };
	
	    _this._handleKeyCommand = function (command) {
	      var newState = _draftJs.RichUtils.handleKeyCommand(_this.props.parentState, command);
	      if (newState) {
	        _this.onChange(newState);
	        return 'handled';
	      }
	      return 'not-handled';
	    };
	
	    _this._blockStyler = function (block) {
	      var alignment = (0, _richtext.getBlockAlignment)(block);
	      if (!block.getText()) {
	        var previousBlock = _this.props.parentState.getCurrentContent().getBlockBefore(block.getKey());
	        if (previousBlock) {
	          alignment = (0, _richtext.getBlockAlignment)(previousBlock);
	        }
	      }
	      return 'alignment--' + alignment;
	    };
	
	    _this.state = {
	      showURLInput: false,
	      showColorPicker: false,
	      urlValue: '',
	      currentColor: ''
	    };
	
	    _this.focus = function () {
	      return _this.textEdito.focus();
	    };
	
	    _this.onChange = function (editorState) {
	      var onChange = _this.props.onChange;
	
	
	      onChange && onChange(editorState);
	    };
	
	    _this._onURLChange = function (evt) {
	      _this.setState({ urlValue: evt.target.value });
	    };
	    return _this;
	  }
	
	  _createClass(RichTextItem, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.parentState.getCurrentContent().getBlockMap().size > 5) {
	        var _itemId = this.props.itemId;
	
	
	        if (_itemId) {
	          var selector = '#editoMenu' + _itemId;
	          (0, _jquery2.default)(selector).sticky({
	            offset: 50,
	            bottomOffset: 50,
	            observeChanges: true,
	            context: '#edito' + _itemId,
	            jitter: 50000
	          });
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var parentState = this.props.parentState;
	      var _handleKeyCommand = this._handleKeyCommand,
	          onChange = this.onChange,
	          _blockStyler = this._blockStyler;
	      var _props = this.props,
	          readOnly = _props.readOnly,
	          withHeaders = _props.withHeaders,
	          withTextBlocks = _props.withTextBlocks,
	          withAlignment = _props.withAlignment,
	          withInlineBasics = _props.withInlineBasics,
	          withLinks = _props.withLinks,
	          withColors = _props.withColors;
	
	
	      var BlockStyleControls = function BlockStyleControls(props) {
	        var selection = props.editorState.getSelection();
	        var blockType = props.editorState.getCurrentContent().getBlockForKey(selection.getStartKey()).getType();
	
	        return _react2.default.createElement(
	          _semanticUiReact.Button.Group,
	          null,
	          withHeaders && _richtext.HEADER_TYPES.map(function (type) {
	            return _react2.default.createElement(_RichTextMenuButton2.default, {
	              key: type.label,
	              active: type.style === blockType,
	              label: type.label,
	              onToggle: props.onToggle,
	              styleEffect: type.style
	            });
	          }),
	          withTextBlocks && _richtext.BLOCK_TYPES.map(function (type) {
	            return _react2.default.createElement(_RichTextMenuButton2.default, {
	              key: type.label,
	              active: type.style === blockType,
	              label: type.label,
	              onToggle: props.onToggle,
	              styleEffect: type.style,
	              displayStyle: type.display_style
	            });
	          })
	        );
	      };
	
	      var InlineStyleControls = function InlineStyleControls(props) {
	        var currentStyle = props.editorState.getCurrentInlineStyle();
	        return _react2.default.createElement(
	          _semanticUiReact.Button.Group,
	          { style: { marginLeft: '5px' } },
	          _richtext.INLINE_STYLES.map(function (type) {
	            return _react2.default.createElement(_RichTextMenuButton2.default, {
	              key: type.label,
	              active: currentStyle.has(type.style),
	              label: type.label,
	              onToggle: props.onToggle,
	              styleEffect: type.style,
	              displayStyle: type.display_style
	            });
	          })
	        );
	      };
	
	      var AlignmentControls = function AlignmentControls(props) {
	        var currentStyle = props.editorState.getCurrentInlineStyle();
	        return _react2.default.createElement(
	          _semanticUiReact.Button.Group,
	          { style: { marginTop: '5px', marginLeft: '5px' } },
	          _richtext.ALIGN_TYPES.map(function (type) {
	            return _react2.default.createElement(_RichTextMenuButton2.default, {
	              key: type.label,
	              label: type.label,
	              active: currentStyle.has(type.style.replace('align ', '')),
	              onToggle: props.onToggle,
	              styleEffect: type.style,
	              displayStyle: type.display_style
	            });
	          })
	        );
	      };
	
	      var LinkControls = function LinkControls(props) {
	        var current = props.editorState.getSelection();
	        var noSelection = current.getStartKey() === current.getEndKey() && current.getStartOffset() === current.getEndOffset();
	        return _react2.default.createElement(
	          _semanticUiReact.Button.Group,
	          { style: { marginLeft: '5px' } },
	          _react2.default.createElement(_semanticUiReact.Button, {
	            type: 'button',
	            icon: 'linkify',
	            onMouseDown: _this2._promptForLink,
	            disabled: noSelection
	          }),
	          _react2.default.createElement(_semanticUiReact.Button, {
	            type: 'button',
	            icon: 'unlinkify',
	            onMouseDown: _this2._removeLink,
	            disabled: noSelection
	          })
	        );
	      };
	
	      var ColorControls = function ColorControls(props) {
	        return _react2.default.createElement(
	          _semanticUiReact.Button.Group,
	          { style: { marginLeft: '5px' } },
	          _react2.default.createElement(_RichTextMenuButton2.default, {
	            label: 'Couleur',
	            active: _this2.state.showColorPicker,
	            onToggle: props.onToggle,
	            styleEffect: 'color'
	          })
	        );
	      };
	
	      var getBlockStyle = function getBlockStyle(block) {
	        switch (block.getType()) {
	          case 'blockquote':
	            return 'RichEditor-blockquote';
	          default:
	            return _blockStyler(block);
	        }
	      };
	
	      var getCurrentColor = function getCurrentColor() {
	        var appliedColor = _this2.props.parentState.getCurrentInlineStyle().findLast(function (style) {
	          return style && style.substring(0, 3) === 'rgb';
	        });
	
	        if (_this2.state.currentColor) {
	          return _this2.state.currentColor;
	        } else if (appliedColor) {
	          return appliedColor;
	        } else {
	          return '';
	        }
	      };
	
	      var applyColorStyles = function applyColorStyles(style, block) {
	        var output = {};
	
	        var colorExists = style.findLast(function (styleUnit) {
	          return styleUnit && styleUnit.substring(0, 3) === 'rgb';
	        });
	        if (colorExists) {
	          return {
	            color: colorExists
	          };
	        }
	        return output;
	      };
	
	      var displayControls = !readOnly && _react2.default.createElement(
	        'div',
	        null,
	        (withHeaders || withTextBlocks) && _react2.default.createElement(BlockStyleControls, {
	          editorState: parentState,
	          onToggle: this._toggleBlockType
	        }),
	        withInlineBasics && _react2.default.createElement(InlineStyleControls, {
	          editorState: parentState,
	          onToggle: this._toggleInlineStyle
	        }),
	        withLinks && _react2.default.createElement(LinkControls, { editorState: parentState }),
	        withAlignment && _react2.default.createElement(AlignmentControls, {
	          editorState: parentState,
	          onToggle: this._toggleAlignment
	        }),
	        withColors && _react2.default.createElement(ColorControls, { onToggle: this._toggleColorPicker })
	      );
	
	      var displayLinkHandler = this.state.showURLInput && _react2.default.createElement(
	        'div',
	        { className: 'ui action input', style: { marginTop: '10px' } },
	        _react2.default.createElement('input', {
	          onChange: this._onURLChange,
	          type: 'text',
	          ref: function ref(_ref) {
	            _this2.textEditoUrl = _ref;
	          },
	          value: this.state.urlValue,
	          onKeyDown: this._onLinkInputKeyDown,
	          placeholder: 'Lien hypertexte'
	        }),
	        _react2.default.createElement(_semanticUiReact.Button, {
	          type: 'button',
	          icon: 'checkmark',
	          onMouseDown: this._confirmLink
	        }),
	        _react2.default.createElement(_semanticUiReact.Button, {
	          type: 'button',
	          color: 'red',
	          icon: 'remove',
	          onMouseDown: this._cancelLink
	        })
	      );
	
	      var displayColorPicker = this.state.showColorPicker && _react2.default.createElement(
	        'div',
	        { style: { marginTop: '10px' } },
	        _react2.default.createElement(_reactColor.ChromePicker, {
	          color: getCurrentColor(),
	          onChangeComplete: this._onColorChange,
	          disableAlpha: true
	        }),
	        _react2.default.createElement(
	          'div',
	          { style: { marginTop: '10px' } },
	          _react2.default.createElement(
	            _semanticUiReact.Button,
	            { type: 'button', primary: true, onMouseDown: this._applyColor },
	            'Appliquer'
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Button,
	            { type: 'button', onMouseDown: this._toggleColorPicker },
	            'Annuler'
	          )
	        )
	      );
	
	      var menuClassname = (0, _classnames2.default)({
	        'ui sticky': parentState.getCurrentContent().getBlockMap().size > 5
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'RichEditor-root', style: { marginRight: '10px' } },
	        _react2.default.createElement(
	          'div',
	          { id: 'editoMenu' + this.props.itemId, className: menuClassname },
	          displayControls,
	          displayLinkHandler,
	          displayColorPicker
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Segment,
	          { id: 'edito' + this.props.itemId, onClick: this.focus },
	          _react2.default.createElement(_draftJs.Editor, {
	            blockStyleFn: getBlockStyle,
	            customStyleFn: applyColorStyles,
	            editorState: parentState,
	            handleKeyCommand: _handleKeyCommand,
	            onChange: onChange,
	            ref: function ref(_ref2) {
	              _this2.textEdito = _ref2;
	            },
	            readOnly: this.props.readOnly
	          })
	        )
	      );
	    }
	  }]);
	
	  return RichTextItem;
	}(_react.Component);
	
	RichTextItem.propTypes = {
	  parentState: __webpack_require__(1).PropTypes.any.isRequired,
	  onChange: __webpack_require__(1).PropTypes.func,
	  readOnly: __webpack_require__(1).PropTypes.bool,
	  withHeaders: __webpack_require__(1).PropTypes.bool,
	  withTextBlocks: __webpack_require__(1).PropTypes.bool,
	  withAlignment: __webpack_require__(1).PropTypes.bool,
	  withInlineBasics: __webpack_require__(1).PropTypes.bool,
	  withLinks: __webpack_require__(1).PropTypes.bool,
	  withColors: __webpack_require__(1).PropTypes.bool,
	  itemId: __webpack_require__(1).PropTypes.any
	};
	exports.default = RichTextItem;

/***/ },

/***/ 178:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var displayJsonError = exports.displayJsonError = function displayJsonError(json) {
	  if (json && json.message) {
	    return json.message;
	  }
	
	  return 'Une erreur technique est survenue';
	};
	
	var displayError = exports.displayError = function displayError(error) {
	  if (error.json) return displayJsonError(error.json);else {
	    return 'Une erreur technique est survenue';
	  }
	};

/***/ },

/***/ 208:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var fetchFolders = exports.fetchFolders = function fetchFolders() {
	  return {
	    type: 'FETCH_FOLDERS'
	  };
	};
	
	var fetchFoldersSuccess = exports.fetchFoldersSuccess = function fetchFoldersSuccess(response) {
	  return {
	    type: 'FETCH_FOLDERS_SUCCESS',
	    response: response
	  };
	};
	
	var fetchFoldersFailure = exports.fetchFoldersFailure = function fetchFoldersFailure(error) {
	  return {
	    type: 'FETCH_FOLDERS_FAILURE',
	    error: error
	  };
	};
	
	var saveFolder = exports.saveFolder = function saveFolder(name) {
	  return {
	    type: 'SAVE_FOLDER',
	    name: name
	  };
	};
	
	var saveFolderSuccess = exports.saveFolderSuccess = function saveFolderSuccess(response) {
	  return {
	    type: 'SAVE_FOLDER_SUCCESS',
	    response: response
	  };
	};
	
	var updateFolder = exports.updateFolder = function updateFolder(folder) {
	  return {
	    type: 'UPDATE_FOLDER',
	    folder: folder
	  };
	};
	
	var updateFolderSuccess = exports.updateFolderSuccess = function updateFolderSuccess(response) {
	  return {
	    type: 'UPDATE_FOLDER_SUCCESS',
	    response: response
	  };
	};
	
	var removeFolder = exports.removeFolder = function removeFolder(folder) {
	  return {
	    type: 'REMOVE_FOLDER',
	    folder: folder
	  };
	};
	
	var removeFolderSuccess = exports.removeFolderSuccess = function removeFolderSuccess(folderId) {
	  return {
	    type: 'REMOVE_FOLDER_SUCCESS',
	    folderId: folderId
	  };
	};

/***/ },

/***/ 209:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var INITIAL_DATA_LOAD = exports.INITIAL_DATA_LOAD = 'campaign:INITIAL_DATA_LOAD';
	var INITIAL_DATA_LOAD_SUCCESS = exports.INITIAL_DATA_LOAD_SUCCESS = 'campaign:INITIAL_DATA_LOAD_SUCCESS';
	
	var loadInitialDatas = exports.loadInitialDatas = function loadInitialDatas() {
	  return {
	    type: INITIAL_DATA_LOAD
	  };
	};

/***/ },

/***/ 210:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SERIALIZE_CONTENT = exports.SERIALIZE_CONTENT = 'SERIALIZE_CONTENT';
	var CREATE_CONTENT = exports.CREATE_CONTENT = 'CREATE_CONTENT';
	var CREATE_CONTENT_SUCCESS = exports.CREATE_CONTENT_SUCCESS = 'CREATE_CONTENT_SUCCESS';
	
	var serializeContent = exports.serializeContent = function serializeContent(content) {
	  return {
	    type: SERIALIZE_CONTENT,
	    content: content
	  };
	};
	
	var createContent = exports.createContent = function createContent(page, platform) {
	  return {
	    type: CREATE_CONTENT,
	    page: page,
	    platform: platform
	  };
	};

/***/ },

/***/ 211:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var FETCH_DEPLOYMENTS = exports.FETCH_DEPLOYMENTS = 'FETCH_DEPLOYMENTS';
	var FETCH_DEPLOYMENTS_SUCCESS = exports.FETCH_DEPLOYMENTS_SUCCESS = 'FETCH_DEPLOYMENTS_SUCCESS';
	var FETCH_DEPLOYMENTS_FAILURE = exports.FETCH_DEPLOYMENTS_FAILURE = 'FETCH_DEPLOYMENTS_FAILURE';
	var DEPLOY = exports.DEPLOY = 'DEPLOY';
	var DEPLOY_SUCCESS = exports.DEPLOY_SUCCESS = 'DEPLOY_SUCCESS';
	var DEPLOY_FAILURE = exports.DEPLOY_FAILURE = 'DEPLOY_FAILURE';
	
	var fetchDeployments = exports.fetchDeployments = function fetchDeployments() {
	  return {
	    type: FETCH_DEPLOYMENTS
	  };
	};
	
	var deploy = exports.deploy = function deploy() {
	  return {
	    type: DEPLOY
	  };
	};

/***/ },

/***/ 212:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CHANGE_EDITION_PLATFORM = exports.CHANGE_EDITION_PLATFORM = 'CHANGE_EDITION_PLATFORM';
	var CHANGE_CATALOG_PLATFORM = exports.CHANGE_CATALOG_PLATFORM = 'CHANGE_CATALOG_PLATFORM';
	
	var changeEditionPlatform = exports.changeEditionPlatform = function changeEditionPlatform(platform) {
	  return {
	    type: CHANGE_EDITION_PLATFORM,
	    platform: platform
	  };
	};
	
	var changeCatalogPlatform = exports.changeCatalogPlatform = function changeCatalogPlatform(platform) {
	  return {
	    type: CHANGE_CATALOG_PLATFORM,
	    platform: platform
	  };
	};

/***/ },

/***/ 213:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getUnlockedTemplates = exports.getTemplates = exports.getRoles = exports.getSettings = undefined;
	
	var _redux = __webpack_require__(33);
	
	var _pages = __webpack_require__(46);
	
	var settings = function settings() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _pages.FETCH_PAGES_SUCCESS:
	      return action.settings;
	    default:
	      return state;
	  }
	};
	
	var roles = function roles() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _pages.FETCH_PAGES_SUCCESS:
	      return action.roles;
	    default:
	      return state;
	  }
	};
	
	var templates = function templates() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _pages.FETCH_PAGES_SUCCESS:
	      return action.templates;
	    default:
	      return state;
	  }
	};
	
	exports.default = (0, _redux.combineReducers)({
	  settings: settings,
	  roles: roles,
	  templates: templates
	});
	var getSettings = exports.getSettings = function getSettings(state) {
	  return state.catalog.settings;
	};
	var getRoles = exports.getRoles = function getRoles(state) {
	  return state.catalog.roles;
	};
	
	var getTemplates = exports.getTemplates = function getTemplates(state) {
	  return state.catalog.templates;
	};
	var getUnlockedTemplates = exports.getUnlockedTemplates = function getUnlockedTemplates(state) {
	  return getTemplates(state).filter(function (t) {
	    return !t.isLocked;
	  });
	};

/***/ },

/***/ 214:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getDeploymentError = exports.getIsDeploying = exports.getIsFetched = exports.getIsFetching = exports.getDeployments = undefined;
	
	var _redux = __webpack_require__(33);
	
	var _immutable = __webpack_require__(10);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _deployments = __webpack_require__(211);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var items = function items() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _immutable2.default.Map();
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _deployments.FETCH_DEPLOYMENTS_SUCCESS:
	      return state.merge(_immutable2.default.Map(action.response.entities.deployments));
	    case _deployments.DEPLOY_SUCCESS:
	      var removeProduction = function removeProduction(d) {
	        return Object.assign({}, d, {
	          inProduction: false
	        });
	      };
	
	      // Cleaning production state then merge
	      return state.map(removeProduction).merge(_immutable2.default.Map(action.response.entities.deployments));
	    default:
	      return state;
	  }
	};
	
	var isFetching = function isFetching() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _deployments.FETCH_DEPLOYMENTS:
	      return true;
	    case _deployments.FETCH_DEPLOYMENTS_SUCCESS:
	    case _deployments.FETCH_DEPLOYMENTS_FAILURE:
	      return false;
	    default:
	      return state;
	  }
	};
	
	var isFetched = function isFetched() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _deployments.FETCH_DEPLOYMENTS_SUCCESS:
	    case _deployments.FETCH_DEPLOYMENTS_FAILURE:
	      return true;
	    default:
	      return state;
	  }
	};
	
	var isDeploying = function isDeploying() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _deployments.DEPLOY:
	      return true;
	    case _deployments.DEPLOY_SUCCESS:
	    case _deployments.DEPLOY_FAILURE:
	      return false;
	    default:
	      return state;
	  }
	};
	
	var deploymentError = function deploymentError() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _deployments.DEPLOY_FAILURE:
	      return action.error;
	    default:
	      return state;
	  }
	};
	
	exports.default = (0, _redux.combineReducers)({
	  items: items,
	  isFetching: isFetching,
	  isFetched: isFetched,
	  isDeploying: isDeploying,
	  deploymentError: deploymentError
	});
	var getDeployments = exports.getDeployments = function getDeployments(state) {
	  return state.deployments.items.sortBy(function (d) {
	    return d.deployedAt;
	  }).reverse().toArray();
	};
	
	var getIsFetching = exports.getIsFetching = function getIsFetching(state) {
	  return state.deployments.isFetching;
	};
	var getIsFetched = exports.getIsFetched = function getIsFetched(state) {
	  return state.deployments.isFetched;
	};
	var getIsDeploying = exports.getIsDeploying = function getIsDeploying(state) {
	  return state.deployments.isDeploying;
	};
	var getDeploymentError = exports.getDeploymentError = function getDeploymentError(state) {
	  return state.deployments.deploymentError;
	};

/***/ },

/***/ 215:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ResourceCard = __webpack_require__(175);
	
	var _ResourceCard2 = _interopRequireDefault(_ResourceCard);
	
	var _ServerDrivenResourceCard = __webpack_require__(1076);
	
	var _ServerDrivenResourceCard2 = _interopRequireDefault(_ServerDrivenResourceCard);
	
	var _ClientDrivenResourceCard = __webpack_require__(1062);
	
	var _ClientDrivenResourceCard2 = _interopRequireDefault(_ClientDrivenResourceCard);
	
	var _FixedDimensionResourceCard = __webpack_require__(501);
	
	var _FixedDimensionResourceCard2 = _interopRequireDefault(_FixedDimensionResourceCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_CropConfig = __webpack_require__(174).babelPluginFlowReactPropTypes_proptype_CropConfig || __webpack_require__(1).PropTypes.any;
	
	var babelPluginFlowReactPropTypes_proptype_FixedDimensionConfig = __webpack_require__(501).babelPluginFlowReactPropTypes_proptype_FixedDimensionConfig || __webpack_require__(1).PropTypes.any;
	
	var OctoResourceCard = function OctoResourceCard(_ref) {
	  var strategy = _ref.strategy,
	      resource = _ref.resource,
	      onUpdated = _ref.onUpdated,
	      onProcessed = _ref.onProcessed,
	      onDeleted = _ref.onDeleted;
	
	  var type = strategy ? strategy.type : 'template';
	
	  var selected = function selected(resource) {
	    return onUpdated({
	      strategy: Object.assign({
	        type: type
	      }, strategy, {
	        source: resource.id
	      }),
	      source: resource
	    });
	  };
	
	  switch (type) {
	    case 'server':
	      {
	        var configChanged = function configChanged(config) {
	          return onUpdated(Object.assign({}, resource, {
	            strategy: Object.assign({}, resource.strategy, config)
	          }));
	        };
	
	        var config = resource ? resource.strategy : strategy;
	
	        return _react2.default.createElement(_ServerDrivenResourceCard2.default, {
	          resource: resource && resource.source,
	          raw: resource && resource.raw,
	          config: config,
	          output: resource && resource.resource,
	          onSelected: selected,
	          onConfigChanged: configChanged,
	          onImageProcessed: onProcessed,
	          onDeleted: onDeleted
	        });
	      }
	    case 'client':
	      {
	        var changed = function changed(horizontalAlign, verticalAlign, parallaxEnabled) {
	          return onUpdated(Object.assign({}, resource, {
	            strategy: Object.assign({}, resource.strategy, {
	              horizontalAlign: horizontalAlign,
	              verticalAlign: verticalAlign,
	              parallaxEnabled: parallaxEnabled
	            })
	          }));
	        };
	
	        var _config = resource ? resource.strategy : strategy;
	
	        return _react2.default.createElement(_ClientDrivenResourceCard2.default, Object.assign({
	          resource: resource && resource.source,
	          onSelected: selected,
	          onChanged: changed,
	          onDeleted: onDeleted
	        }, _config));
	      }
	    case 'fixed':
	      {
	        var _config2 = resource ? resource.strategy : strategy;
	
	        var _configChanged = function _configChanged(config) {
	          return onUpdated(Object.assign({}, resource, {
	            strategy: Object.assign({}, resource.strategy, config)
	          }));
	        };
	
	        return _react2.default.createElement(_FixedDimensionResourceCard2.default, {
	          resource: resource && resource.source,
	          config: _config2,
	          onSelected: selected,
	          onConfigChanged: _configChanged,
	          onDeleted: onDeleted
	        });
	      }
	    case 'template':
	      {
	        return _react2.default.createElement(_ResourceCard2.default, {
	          resourceType: 'image',
	          resource: resource && resource.source,
	          onSelected: selected,
	          onDeleted: onDeleted
	        });
	      }
	    default:
	      console.warn('Unknwon resource strategy ' + strategy.type + '. Cannot render');
	      return null;
	  }
	};
	
	OctoResourceCard.propTypes = {
	  strategy: __webpack_require__(1).PropTypes.any,
	  resource: __webpack_require__(1).PropTypes.any,
	  onUpdated: __webpack_require__(1).PropTypes.func.isRequired,
	  onProcessed: __webpack_require__(1).PropTypes.func,
	  onDeleted: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = OctoResourceCard;

/***/ },

/***/ 216:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ResourceImage = __webpack_require__(99);
	
	var _ResourceImage2 = _interopRequireDefault(_ResourceImage);
	
	var _RawImage = __webpack_require__(1066);
	
	var _RawImage2 = _interopRequireDefault(_RawImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getImageByStrategy = function getImageByStrategy(type, resource) {
	  switch (type) {
	    case 'template':
	      return resource && resource.source;
	    case 'server':
	    case 'client':
	      return resource && (resource.resource || resource.source);
	    default:
	      return null;
	  }
	};
	
	var OctoResourceImage = function OctoResourceImage(_ref) {
	  var strategy = _ref.strategy,
	      resource = _ref.resource;
	
	  var type = resource ? resource.strategy.type : strategy ? strategy.type : 'template';
	
	  if (resource && resource.raw) {
	    return _react2.default.createElement(_RawImage2.default, { raw: resource.raw });
	  }
	
	  return _react2.default.createElement(_ResourceImage2.default, { resource: getImageByStrategy(type, resource) });
	};
	
	OctoResourceImage.propTypes = {
	  strategy: __webpack_require__(1).PropTypes.any,
	  resource: __webpack_require__(1).PropTypes.any
	};
	exports.default = OctoResourceImage;

/***/ },

/***/ 217:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unmountCurrentComponent = exports.mountComponent = undefined;
	
	var _reactDom = __webpack_require__(38);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mountComponent = exports.mountComponent = function mountComponent(component) {
	  var root = document.getElementById('modal-root');
	  if (root) {
	    _reactDom2.default.unmountComponentAtNode(root);
	    _reactDom2.default.render(component, root);
	  }
	};
	
	var unmountCurrentComponent = exports.unmountCurrentComponent = function unmountCurrentComponent() {
	  var root = document.getElementById('modal-root');
	  _reactDom2.default.unmountComponentAtNode(root);
	};

/***/ },

/***/ 301:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var MAX_CONCURRENT_UPLOADS = exports.MAX_CONCURRENT_UPLOADS = 5;
	
	var ResourceTypes = exports.ResourceTypes = {
	  IMAGE: 'image',
	  PDF: 'pdf',
	  VIDEO: 'video'
	};
	
	var getResourceTypeLabelPlural = exports.getResourceTypeLabelPlural = function getResourceTypeLabelPlural(type) {
	  switch (type) {
	    case ResourceTypes.IMAGE:
	      return 'Images';
	    case ResourceTypes.PDF:
	      return 'PDF';
	    case ResourceTypes.VIDEO:
	      return 'Vidéos';
	    default:
	      console.warn('Unknown resource type ' + type);
	      return 'Autres';
	  }
	};

/***/ },

/***/ 302:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getIsRemoving = exports.getResourcesByFolder = exports.getCountByFolder = undefined;
	
	var _redux = __webpack_require__(33);
	
	var _immutable = __webpack_require__(10);
	
	var items = function items() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.Map)();
	  var action = arguments[1];
	
	  switch (action.type) {
	    case 'FETCH_FOLDERS_SUCCESS':
	      return (0, _immutable.Map)(action.response.entities.resources);
	    case 'UPLOAD_FILE_SUCCESS':
	      return state.set(action.response.id, action.response);
	    case 'UPDATE_RESOURCE':
	      return state.set(action.resource.id, action.resource);
	    case 'REMOVE_FOLDER_SUCCESS':
	      return state.filter(function (r) {
	        return r.folderId.toString() !== action.folderId.toString();
	      });
	    case 'REMOVE_RESOURCE_SUCCESS':
	      return state.remove(action.resourceId);
	    default:
	      return state;
	  }
	};
	
	var filter = function filter() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  var action = arguments[1];
	
	  switch (action.type) {
	    case 'FILTER_RESOURCES':
	      return action.value;
	    default:
	      return state;
	  }
	};
	
	var isRemoving = function isRemoving() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case 'REMOVE_RESOURCE':
	      return true;
	    case 'REMOVE_RESOURCE_SUCCESS':
	      return false;
	    default:
	      return state;
	  }
	};
	
	exports.default = (0, _redux.combineReducers)({
	  items: items,
	  filter: filter,
	  isRemoving: isRemoving
	});
	
	
	var getFilter = function getFilter(state) {
	  return state.resources.filter;
	};
	
	var getCountByFolder = exports.getCountByFolder = function getCountByFolder(state) {
	  return state.resources.items.groupBy(function (r) {
	    return r.folderId;
	  }).map(function (rs, _) {
	    return rs.size;
	  });
	};
	
	var getResourcesByFolder = exports.getResourcesByFolder = function getResourcesByFolder(state, folderId) {
	  var filter = getFilter(state);
	
	  var resources = state.resources.items.filter(function (r) {
	    return r.folderId.toString() === folderId.toString();
	  }).toList();
	
	  // Apply filtering
	  return filter && filter.length ? resources.filter(function (r) {
	    return r.name.toLowerCase().indexOf(filter.toLowerCase()) > -1;
	  }) : resources;
	};
	
	var getIsRemoving = exports.getIsRemoving = function getIsRemoving(state) {
	  return state.resources.isRemoving;
	};

/***/ },

/***/ 303:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTargets = undefined;
	
	var _redux = __webpack_require__(33);
	
	var _diffusion = __webpack_require__(479);
	
	var _actions = __webpack_require__(209);
	
	var targets = function targets() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _diffusion.NEWS_TARGETS_UPDATED:
	    case _actions.INITIAL_DATA_LOAD_SUCCESS:
	      return action.targets;
	    case _diffusion.NEWS_TARGET_CLEARED:
	      return [];
	    default:
	      return state;
	  }
	};
	
	exports.default = (0, _redux.combineReducers)({
	  targets: targets
	});
	var getTargets = exports.getTargets = function getTargets(state) {
	  return state.diffusion.targets;
	};

/***/ },

/***/ 304:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var NETWORK_MODES = exports.NETWORK_MODES = [{
	  value: 'online',
	  text: 'Connexion réseau requise'
	}, {
	  value: 'offline',
	  text: 'Hors ligne'
	}];
	
	var SECURITY_CONTEXTS = exports.SECURITY_CONTEXTS = [{
	  value: 'none',
	  text: 'Aucun'
	}, {
	  value: 'use',
	  text: 'Contient du contenu personnalisé si authentifié'
	}, {
	  value: 'require',
	  text: 'N\xE9cessite d\'\xEAtre authentifi\xE9'
	}];

/***/ },

/***/ 305:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getPageWarnings = exports.isPageLocked = exports.pageComparator = undefined;
	
	var _plugin = __webpack_require__(113);
	
	var pageComparator = exports.pageComparator = function pageComparator(p1, p2) {
	  if (p1.isRoot) return -1;
	  if (p2.isRoot) return 1;
	
	  if (p1.isLocked || p1.template.isLocked) return -1;
	  if (p2.isLocked || p2.template.isLocked) return 1;
	
	  var p1Name = p1.name.toLowerCase();
	  var p2Name = p2.name.toLowerCase();
	
	  return p1Name < p2Name ? -1 : +(p1Name > p2Name);
	};
	
	var isPageLocked = exports.isPageLocked = function isPageLocked(page) {
	  return page.isRoot || page.isLocked || page.template.isLocked;
	};
	
	/**
	 * Accumulates warning relative to this page
	 */
	var getPageWarnings = exports.getPageWarnings = function getPageWarnings(page, content) {
	  return (0, _plugin.getContentWarnings)(page.template.code, content);
	};

/***/ },

/***/ 306:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PageTemplateLabel = function PageTemplateLabel(_ref) {
	  var page = _ref.page;
	
	  var isLocked = page.isLocked || page.template.isLocked;
	  var label = isLocked ? 'Embarqué' : page.template.label;
	  var color = isLocked ? 'grey' : 'green';
	
	  return _react2.default.createElement(
	    _semanticUiReact.Label,
	    { color: color },
	    label
	  );
	};
	
	PageTemplateLabel.propTypes = {
	  page: __webpack_require__(1).PropTypes.any.isRequired
	};
	exports.default = PageTemplateLabel;

/***/ },

/***/ 307:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutable = __webpack_require__(10);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _api = __webpack_require__(499);
	
	var UserApi = _interopRequireWildcard(_api);
	
	var _DiffusionHeader = __webpack_require__(991);
	
	var _DiffusionHeader2 = _interopRequireDefault(_DiffusionHeader);
	
	var _DiffusionTargets = __webpack_require__(994);
	
	var _DiffusionTargets2 = _interopRequireDefault(_DiffusionTargets);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DiffusionList = function (_React$Component) {
	  _inherits(DiffusionList, _React$Component);
	
	  function DiffusionList(props) {
	    _classCallCheck(this, DiffusionList);
	
	    var _this = _possibleConstructorReturn(this, (DiffusionList.__proto__ || Object.getPrototypeOf(DiffusionList)).call(this, props));
	
	    _this.onAddTarget = function (target) {
	      var _this$props = _this.props,
	          targets = _this$props.targets,
	          onUpdate = _this$props.onUpdate;
	
	      onUpdate([].concat(_toConsumableArray(targets), [target]));
	    };
	
	    _this.onDeleteTarget = function (target) {
	      var _this$props2 = _this.props,
	          targets = _this$props2.targets,
	          onUpdate = _this$props2.onUpdate;
	
	      onUpdate(_immutable2.default.Set(targets).remove(target).toArray());
	    };
	
	    _this.onClearTargets = function () {
	      return _this.props.onUpdate([]);
	    };
	
	    _this.state = {
	      isFetching: false,
	      roles: []
	    };
	    return _this;
	  }
	
	  _createClass(DiffusionList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.setState({ isFetching: true });
	
	      // Fetching roles
	      UserApi.fetchRoles().then(function (roles) {
	        return _this2.setState({
	          isFetching: false,
	          roles: roles
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          targets = _props.targets,
	          isEditable = _props.isEditable,
	          attached = _props.attached;
	      var _state = this.state,
	          isFetching = _state.isFetching,
	          roles = _state.roles;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_DiffusionHeader2.default, {
	          isFetching: isFetching,
	          isEditable: isEditable,
	          roles: roles,
	          attached: attached,
	          onAdd: this.onAddTarget,
	          onClear: this.onClearTargets
	        }),
	        _react2.default.createElement(_DiffusionTargets2.default, {
	          isFetching: isFetching,
	          isEditable: isEditable,
	          targets: targets,
	          roles: roles,
	          attached: attached,
	          onDelete: this.onDeleteTarget
	        })
	      );
	    }
	  }]);
	
	  return DiffusionList;
	}(_react2.default.Component);
	
	DiffusionList.propTypes = {
	  targets: __webpack_require__(1).PropTypes.arrayOf(__webpack_require__(1).PropTypes.any).isRequired,
	  isEditable: __webpack_require__(1).PropTypes.bool.isRequired,
	  onUpdate: __webpack_require__(1).PropTypes.func.isRequired,
	  attached: __webpack_require__(1).PropTypes.bool
	};
	exports.default = DiffusionList;

/***/ },

/***/ 308:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutable = __webpack_require__(10);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _uuid = __webpack_require__(296);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var _api = __webpack_require__(490);
	
	var Api = _interopRequireWildcard(_api);
	
	var _EditorBlocks = __webpack_require__(1003);
	
	var _EditorBlocks2 = _interopRequireDefault(_EditorBlocks);
	
	var _semanticUiReact = __webpack_require__(5);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapBlocksToState = function mapBlocksToState(blocks) {
	  return _immutable2.default.Map(blocks.map(function (b) {
	    return [b.order, b];
	  })).sortBy(function (b) {
	    return b.order;
	  }).toList();
	};
	
	var addBlock = function addBlock(template, blocks) {
	  var block = {
	    id: (0, _uuid2.default)(),
	    template: template,
	    order: blocks.size,
	    isNew: true
	  };
	
	  return blocks.push(block);
	};
	
	var App = function (_Component) {
	  _inherits(App, _Component);
	
	  function App(props) {
	    _classCallCheck(this, App);
	
	    var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));
	
	    _this.addBlock = function (contentType) {
	      _this.setState(function (prevState) {
	        return {
	          diff: addBlock(contentType, prevState.diff)
	        };
	      }, _this.notifyUpdate);
	    };
	
	    _this.updateBlocks = function (blocks) {
	      _this.setState({
	        diff: blocks
	      }, _this.notifyUpdate);
	    };
	
	    _this.notifyUpdate = function () {
	      var diff = _this.state.diff;
	
	
	      _this.props.onUpdate(diff.toArray());
	    };
	
	    _this.state = {
	      isFetching: false,
	      templates: [],
	      diff: mapBlocksToState(props.blocks)
	    };
	    return _this;
	  }
	
	  _createClass(App, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.setState({
	        isFetching: true
	      });
	
	      Api.fetchTemplates().then(function (templates) {
	        return _this2.setState({
	          isFetching: false,
	          templates: templates
	        });
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.blocks !== this.props.blocks) {
	        this.setState({
	          diff: mapBlocksToState(nextProps.blocks)
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          mode = _props.mode,
	          attached = _props.attached,
	          locked = _props.locked;
	      var _state = this.state,
	          isFetching = _state.isFetching,
	          templates = _state.templates,
	          diff = _state.diff;
	
	
	      if (isFetching) {
	        return _react2.default.createElement(_semanticUiReact.Segment, { loading: true, style: { minHeight: '180px' } });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_EditorBlocks2.default, {
	          mode: mode,
	          templates: templates,
	          blocks: diff,
	          onAdd: this.addBlock,
	          onUpdate: this.updateBlocks,
	          attached: attached,
	          locked: locked
	        })
	      );
	    }
	  }]);
	
	  return App;
	}(_react.Component);
	
	App.propTypes = {
	  mode: __webpack_require__(1).PropTypes.any.isRequired,
	  blocks: __webpack_require__(1).PropTypes.arrayOf(__webpack_require__(1).PropTypes.any).isRequired,
	  onUpdate: __webpack_require__(1).PropTypes.func.isRequired,
	  attached: __webpack_require__(1).PropTypes.bool,
	  locked: __webpack_require__(1).PropTypes.bool
	};
	exports.default = App;

/***/ },

/***/ 309:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getRenderComponent = exports.getViewComponent = exports.getEditComponent = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var replaceDotBySlash = function replaceDotBySlash(template) {
	  return template.replace('.', '/');
	};
	
	var usingPlugin = function usingPlugin(template) {
	  return function (execute) {
	    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	    try {
	      var plugin = __webpack_require__(2055)("./" + replaceDotBySlash(template) + '/index.js');
	      return execute(plugin);
	    } catch (error) {
	      console.warn('No plugin found for template ' + template, error);
	      return defaultValue;
	    }
	  };
	};
	
	var getEditComponent = exports.getEditComponent = function getEditComponent(block) {
	  return usingPlugin(block.template)(function (plugin) {
	    var component = plugin.getEditComponent();
	    return _react2.default.createElement(component, {
	      block: block
	    });
	  });
	};
	
	var getViewComponent = exports.getViewComponent = function getViewComponent(block) {
	  return usingPlugin(block.template)(function (plugin) {
	    var component = plugin.getViewComponent();
	    return _react2.default.createElement(component, {
	      block: block
	    });
	  });
	};
	
	var getRenderComponent = exports.getRenderComponent = function getRenderComponent(block) {
	  return usingPlugin(block.template)(function (plugin) {
	    var component = plugin.getRenderComponent();
	    return _react2.default.createElement(component, {
	      block: block
	    });
	  });
	};

/***/ },

/***/ 310:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTargets = undefined;
	
	var _redux = __webpack_require__(33);
	
	var _diffusion = __webpack_require__(494);
	
	var _actions = __webpack_require__(142);
	
	var targets = function targets() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _diffusion.NEWS_TARGETS_UPDATED:
	    case _actions.INITIAL_DATA_LOAD_SUCCESS:
	      return action.targets;
	    case _diffusion.NEWS_TARGET_CLEARED:
	      return [];
	    default:
	      return state;
	  }
	};
	
	exports.default = (0, _redux.combineReducers)({
	  targets: targets
	});
	var getTargets = exports.getTargets = function getTargets(state) {
	  return state.diffusion.targets;
	};

/***/ },

/***/ 311:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getBlocks = undefined;
	
	var _redux = __webpack_require__(33);
	
	var _edito = __webpack_require__(495);
	
	var _actions = __webpack_require__(142);
	
	var blocks = function blocks() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _actions.INITIAL_DATA_LOAD_SUCCESS:
	    case _edito.BLOCKS_UPDATED:
	      return action.blocks;
	    default:
	      return state;
	  }
	};
	
	exports.default = (0, _redux.combineReducers)({
	  blocks: blocks
	});
	var getBlocks = exports.getBlocks = function getBlocks(state) {
	  return state.edito.blocks;
	};

/***/ },

/***/ 312:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getCatchImage = exports.getCatchImageStrategy = exports.getImage = exports.getImageStrategy = undefined;
	
	var _redux = __webpack_require__(33);
	
	var _images = __webpack_require__(496);
	
	var _actions = __webpack_require__(142);
	
	var strategies = function strategies() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _actions.INITIAL_DATA_LOAD_SUCCESS:
	      return {
	        image: action.strategy,
	        catchImage: action.catchStrategy
	      };
	    default:
	      return state;
	  }
	};
	
	var resources = function resources() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _actions.INITIAL_DATA_LOAD_SUCCESS:
	      return {
	        image: action.image,
	        catchImage: action.catchImage
	      };
	    case _images.IMAGE_UPDATED:
	      return Object.assign({}, state, {
	        image: action.image
	      });
	    case _images.CATCH_IMAGE_UPDATED:
	      return Object.assign({}, state, {
	        catchImage: action.image
	      });
	    case _images.IMAGE_DELETED:
	      return Object.assign({}, state, {
	        image: undefined
	      });
	    case _images.CATCH_IMAGE_DELETED:
	      return Object.assign({}, state, {
	        catchImage: undefined
	      });
	    default:
	      return state;
	  }
	};
	
	exports.default = (0, _redux.combineReducers)({
	  strategies: strategies,
	  resources: resources
	});
	var getImageStrategy = exports.getImageStrategy = function getImageStrategy(state) {
	  return state.images.strategies.image;
	};
	var getImage = exports.getImage = function getImage(state) {
	  return state.images.resources.image;
	};
	var getCatchImageStrategy = exports.getCatchImageStrategy = function getCatchImageStrategy(state) {
	  return state.images.strategies.catchImage;
	};
	var getCatchImage = exports.getCatchImage = function getCatchImage(state) {
	  return state.images.resources.catchImage;
	};

/***/ },

/***/ 313:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hideFormLoader = undefined;
	
	var _jquery = __webpack_require__(16);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  // TODO: Add support for nav animations
	
	  // Add support for loading indicator on submit button
	  (0, _jquery2.default)('form').on('submit', displayFormLoader);
	};
	
	function displayFormLoader(event) {
	  var $button = (0, _jquery2.default)(document.activeElement);
	  if (!$button.hasClass('no-loader')) {
	    $button.addClass('loading');
	  }
	
	  return true;
	}
	
	var hideFormLoader = exports.hideFormLoader = function hideFormLoader($form) {
	  $form.find('button.loading').removeClass('loading');
	};

/***/ },

/***/ 314:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createMiddleware;
	
	var _ravenJs = __webpack_require__(669);
	
	var _ravenJs2 = _interopRequireDefault(_ravenJs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMiddleware() {
	  if (typeof _ravenJs2.default !== 'undefined' && typeof _ravenJs2.default.captureException === 'function' && _ravenJs2.default.isSetup()) {
	    return function (store) {
	      return function (next) {
	        return function (action) {
	          var logger = console.error.bind(console, '[redux-raven-middleware] Reporting error to Sentry:');
	
	          try {
	            _ravenJs2.default.captureBreadcrumb({
	              category: 'redux',
	              message: action.type
	            });
	
	            return next(action);
	          } catch (err) {
	            logger(err);
	
	            // Send the report.
	            _ravenJs2.default.captureException(err, {
	              extra: {
	                action: typeof action === 'function' ? action.toString() : action,
	                state: store.getState()
	              }
	            });
	          }
	        };
	      };
	    };
	  } else {
	    return function (store) {
	      return function (next) {
	        return function (action) {
	          next(action);
	        };
	      };
	    };
	  }
	}

/***/ },

/***/ 315:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _DeleteModal = __webpack_require__(500);
	
	var _DeleteModal2 = _interopRequireDefault(_DeleteModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ConfirmDeleteButton = function (_Component) {
	  _inherits(ConfirmDeleteButton, _Component);
	
	  function ConfirmDeleteButton(props) {
	    _classCallCheck(this, ConfirmDeleteButton);
	
	    var _this = _possibleConstructorReturn(this, (ConfirmDeleteButton.__proto__ || Object.getPrototypeOf(ConfirmDeleteButton)).call(this, props));
	
	    _this.showModal = function (evt) {
	      evt.preventDefault();
	      evt.stopPropagation();
	
	      _this.setState({ modalOpen: true });
	    };
	
	    _this.closeModal = function () {
	      return _this.setState({ modalOpen: false });
	    };
	
	    _this.state = {
	      modalOpen: false
	    };
	    return _this;
	  }
	
	  _createClass(ConfirmDeleteButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          content = _props.content,
	          modalTitle = _props.modalTitle,
	          modalContent = _props.modalContent,
	          className = _props.className,
	          isLoading = _props.isLoading,
	          icon = _props.icon,
	          onConfirm = _props.onConfirm;
	      var modalOpen = this.state.modalOpen;
	
	
	      var buttonClass = (0, _classnames2.default)('ui button', className);
	      var open = modalOpen || !!isLoading;
	
	      return _react2.default.createElement(
	        'button',
	        { className: buttonClass, onClick: this.showModal },
	        content,
	        icon,
	        _react2.default.createElement(_DeleteModal2.default, {
	          open: open,
	          loading: isLoading,
	          title: modalTitle,
	          content: modalContent,
	          onConfirm: onConfirm,
	          onClose: this.closeModal
	        })
	      );
	    }
	  }]);
	
	  return ConfirmDeleteButton;
	}(_react.Component);
	
	ConfirmDeleteButton.defaultProps = {
	  isLoading: false
	};
	ConfirmDeleteButton.propTypes = {
	  content: __webpack_require__(1).PropTypes.oneOfType([__webpack_require__(1).PropTypes.string, __webpack_require__(1).PropTypes.any]).isRequired,
	  modalTitle: __webpack_require__(1).PropTypes.string,
	  modalContent: __webpack_require__(1).PropTypes.string.isRequired,
	  className: __webpack_require__(1).PropTypes.string,
	  isLoading: __webpack_require__(1).PropTypes.bool,
	  icon: __webpack_require__(1).PropTypes.any,
	  onConfirm: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = ConfirmDeleteButton;

/***/ },

/***/ 316:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProgressiveImage = function (_React$Component) {
	  _inherits(ProgressiveImage, _React$Component);
	
	  function ProgressiveImage(props) {
	    _classCallCheck(this, ProgressiveImage);
	
	    var _this = _possibleConstructorReturn(this, (ProgressiveImage.__proto__ || Object.getPrototypeOf(ProgressiveImage)).call(this, props));
	
	    _this.loadImage = function (src) {
	      // If there is already an image we nullify the onload
	      // and onerror props so it does not incorrectly set state
	      // when it resolves
	      if (_this.image) {
	        _this.image.onload = null;
	        _this.image.onerror = null;
	      }
	      var image = new Image();
	      _this.image = image;
	      image.crossOrigin = _this.props.crossOrigin;
	      image.onload = _this.onLoad;
	      image.onerror = _this.onError;
	      image.src = src;
	    };
	
	    _this.onLoad = function () {
	      // use this.image.src instead of this.props.src to
	      // avoid the possibility of props being updated and the
	      // new image loading before the new props are available as
	      // this.props.
	      _this.setState({
	        image: _this.image.src
	      });
	    };
	
	    _this.onError = function (errorEvent) {
	      var onError = _this.props.onError;
	
	      if (onError) {
	        onError(errorEvent);
	      }
	    };
	
	    _this.state = {
	      image: props.placeholder
	    };
	    return _this;
	  }
	
	  _createClass(ProgressiveImage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var src = this.props.src;
	
	      this.loadImage(src);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      var src = nextProps.src,
	          placeholder = nextProps.placeholder;
	      // We only invalidate the current image if the src has changed.
	
	      if (src !== this.props.src) {
	        this.setState({ image: placeholder }, function () {
	          _this2.loadImage(src);
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.image) {
	        this.image.onload = null;
	        this.image.onerror = null;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var image = this.state.image;
	      var children = this.props.children;
	
	      if (!children || typeof children !== 'function') {
	        throw new Error('ProgressiveImage requires a function as its only child');
	      }
	      return children(image);
	    }
	  }]);
	
	  return ProgressiveImage;
	}(_react2.default.Component);
	
	ProgressiveImage.defaultProps = {
	  crossOrigin: 'Anonymous'
	};
	ProgressiveImage.propTypes = {
	  children: __webpack_require__(1).PropTypes.func,
	  onError: __webpack_require__(1).PropTypes.func,
	  placeholder: __webpack_require__(1).PropTypes.string.isRequired,
	  src: __webpack_require__(1).PropTypes.string.isRequired,
	  crossOrigin: __webpack_require__(1).PropTypes.string
	};
	exports.default = ProgressiveImage;

/***/ },

/***/ 317:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RadioMenu = function RadioMenu(_ref) {
	  var label = _ref.label,
	      currentValue = _ref.currentValue,
	      menuDesc = _ref.menuDesc;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'ui form' },
	      _react2.default.createElement(
	        'div',
	        { className: 'ui field' },
	        _react2.default.createElement(
	          'label',
	          { className: 'ui form field' },
	          label
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Button.Group,
	          null,
	          menuDesc && menuDesc.map(function (item) {
	            return _react2.default.createElement(
	              _semanticUiReact.Button,
	              {
	                key: item.value,
	                type: 'button',
	                active: item.value === currentValue,
	                secondary: item.value === currentValue,
	                onClick: item.handler
	              },
	              item.label
	            );
	          })
	        )
	      )
	    )
	  );
	};
	
	exports.default = RadioMenu;

/***/ },

/***/ 318:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutable = __webpack_require__(10);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _api = __webpack_require__(1067);
	
	var Api = _interopRequireWildcard(_api);
	
	var _ResourcesHeader = __webpack_require__(1070);
	
	var _ResourcesHeader2 = _interopRequireDefault(_ResourcesHeader);
	
	var _ResourcesPage = __webpack_require__(1071);
	
	var _ResourcesPage2 = _interopRequireDefault(_ResourcesPage);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResourceSelector = function (_Component) {
	  _inherits(ResourceSelector, _Component);
	
	  function ResourceSelector(props) {
	    _classCallCheck(this, ResourceSelector);
	
	    var _this = _possibleConstructorReturn(this, (ResourceSelector.__proto__ || Object.getPrototypeOf(ResourceSelector)).call(this, props));
	
	    _this.onModalMount = function () {
	      var _this$state = _this.state,
	          isFetchingFolders = _this$state.isFetchingFolders,
	          isFetchingResources = _this$state.isFetchingResources;
	
	
	      if (isFetchingFolders || isFetchingResources) {
	        return;
	      }
	
	      _this.setState({
	        isFetchingFolders: true
	      });
	
	      // Loading folders and first resources page
	      Api.fetchFolders().then(function (folders) {
	        _this.setState({
	          isFetchingFolders: false,
	          folders: (0, _immutable.List)(folders)
	        }, _this.fetchResources);
	      });
	    };
	
	    _this.onPreviousPage = function () {
	      _this.setState({
	        currentPage: _this.state.currentPage - 1
	      }, _this.fetchResources);
	    };
	
	    _this.onNextPage = function () {
	      _this.setState({
	        currentPage: _this.state.currentPage + 1
	      }, _this.fetchResources);
	    };
	
	    _this.onFolderChange = function (folder) {
	      _this.setState({
	        currentFolder: folder
	      }, _this.fetchResources);
	    };
	
	    _this.onFilterChange = function (value) {
	      _this.setState({
	        currentFilter: value
	      }, _this.fetchResources);
	    };
	
	    _this.state = {
	      currentPage: 1,
	      currentFilter: '',
	      isFetchingFolders: false,
	      isFetchingResources: false,
	      isError: false,
	      folders: (0, _immutable.List)(),
	      resources: (0, _immutable.List)(),
	      hasNextPage: false,
	      hasPreviousPage: false
	    };
	    return _this;
	  }
	
	  _createClass(ResourceSelector, [{
	    key: 'fetchResources',
	    value: function fetchResources() {
	      var _this2 = this;
	
	      var _state = this.state,
	          isFetchingResources = _state.isFetchingResources,
	          currentPage = _state.currentPage,
	          currentFolder = _state.currentFolder,
	          currentFilter = _state.currentFilter;
	      var resourceType = this.props.resourceType;
	
	
	      if (isFetchingResources) return;
	
	      this.setState({
	        isFetchingResources: true
	      });
	
	      Api.fetchResources(currentPage, resourceType, currentFolder, currentFilter).then(function (_ref) {
	        var total = _ref.total,
	            limit = _ref.limit,
	            resources = _ref.resources;
	        return _this2.setState({
	          isFetchingResources: false,
	          resources: (0, _immutable.List)(resources),
	          hasPreviousPage: currentPage > 1,
	          hasNextPage: limit < total
	        });
	      }, function (error) {
	        return _this2.setState({
	          isFetchingResources: false,
	          isError: true
	        });
	      });
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      var _state2 = this.state,
	          isFetchingFolders = _state2.isFetchingFolders,
	          isFetchingResources = _state2.isFetchingResources,
	          isError = _state2.isError,
	          folders = _state2.folders,
	          resources = _state2.resources,
	          hasPreviousPage = _state2.hasPreviousPage,
	          hasNextPage = _state2.hasNextPage,
	          currentFolder = _state2.currentFolder,
	          currentFilter = _state2.currentFilter;
	      var onResourceSelected = this.props.onResourceSelected;
	
	
	      if (isFetchingFolders || isFetchingResources) {
	        return _react2.default.createElement(
	          _semanticUiReact.Segment,
	          { style: { minHeight: '640px' } },
	          _react2.default.createElement(
	            _semanticUiReact.Dimmer,
	            { active: true },
	            _react2.default.createElement(_semanticUiReact.Loader, { content: 'Chargement des ressources...' })
	          )
	        );
	      }
	
	      if (isError) {
	        return _react2.default.createElement(
	          _semanticUiReact.Message,
	          { error: true, icon: true },
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'frown' }),
	          'Une erreur est survenue. Impossible de charger les ressources graphiques.'
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_ResourcesHeader2.default, {
	          folders: folders,
	          hasPreviousPage: hasPreviousPage,
	          hasNextPage: hasNextPage,
	          onPreviousPage: this.onPreviousPage,
	          onNextPage: this.onNextPage,
	          currentFolder: currentFolder,
	          onFolderChange: this.onFolderChange,
	          currentFilter: currentFilter,
	          onFilterChange: this.onFilterChange
	        }),
	        _react2.default.createElement(_ResourcesPage2.default, { resources: resources, onSelect: onResourceSelected })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          open = _props.open,
	          onClose = _props.onClose;
	
	
	      return _react2.default.createElement(
	        _semanticUiReact.Modal,
	        {
	          open: open,
	          closeIcon: true,
	          size: 'fullscreen',
	          onMount: this.onModalMount,
	          onClose: onClose
	        },
	        _react2.default.createElement(
	          _semanticUiReact.Modal.Header,
	          null,
	          'S\xE9lectionnez une ressource graphique'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Modal.Content,
	          null,
	          this.renderContent()
	        )
	      );
	    }
	  }]);
	
	  return ResourceSelector;
	}(_react.Component);
	
	ResourceSelector.propTypes = {
	  open: __webpack_require__(1).PropTypes.bool.isRequired,
	  resourceType: __webpack_require__(1).PropTypes.any.isRequired,
	  onResourceSelected: __webpack_require__(1).PropTypes.func.isRequired,
	  onClose: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = ResourceSelector;

/***/ },

/***/ 319:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(141);
	
	var _richtext = __webpack_require__(115);
	
	var _semanticUiReact = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CharacterCount = function CharacterCount(_ref) {
	  var editorState = _ref.editorState,
	      charLimit = _ref.charLimit,
	      chars = _ref.chars,
	      lines = _ref.lines,
	      words = _ref.words;
	
	  var count = (0, _richtext.getCharCount)(editorState);
	  var charCountClassname = count > (charLimit || _index.TEXT_CHARACTER_LIMIT) ? { color: 'rgb(255, 0, 0)' } : { color: 'inherit' };
	
	  var renderChars = chars && _react2.default.createElement(
	    'div',
	    null,
	    'Nombre de caract\xE8res: ',
	    _react2.default.createElement(
	      'span',
	      { style: charCountClassname },
	      count
	    )
	  );
	  var renderLines = lines && _react2.default.createElement(
	    'div',
	    null,
	    'Nombre de lignes: ',
	    _react2.default.createElement(
	      'span',
	      null,
	      (0, _richtext.getLineCount)(editorState)
	    )
	  );
	  var renderWords = words && _react2.default.createElement(
	    'div',
	    null,
	    'Nombre de mots: ',
	    _react2.default.createElement(
	      'span',
	      null,
	      (0, _richtext.getWordCount)(editorState)
	    )
	  );
	
	  return _react2.default.createElement(
	    _semanticUiReact.Segment,
	    { compact: true },
	    renderLines,
	    renderWords,
	    renderChars
	  );
	};
	
	CharacterCount.propTypes = {
	  editorState: __webpack_require__(1).PropTypes.any.isRequired,
	  charLimit: __webpack_require__(1).PropTypes.number,
	  chars: __webpack_require__(1).PropTypes.bool,
	  lines: __webpack_require__(1).PropTypes.bool,
	  words: __webpack_require__(1).PropTypes.bool
	};
	exports.default = CharacterCount;

/***/ },

/***/ 320:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.reorderElements = exports.enforceElementsOrder = undefined;
	
	var _immutable = __webpack_require__(10);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var enforceElementsOrder = exports.enforceElementsOrder = function enforceElementsOrder(source) {
	  return _immutable2.default.Seq(source).sortBy(function (e) {
	    return e.order;
	  }).map(function (element, index) {
	    return Object.assign({}, element, {
	      order: index
	    });
	  }).toList();
	};
	
	var reorderElements = exports.reorderElements = function reorderElements(source, element, newOrder) {
	  var currentOrder = element.order;
	
	  var reordered = source.map(function (element) {
	    if (element.order === currentOrder) {
	      return Object.assign({}, element, {
	        order: newOrder
	      });
	    } else if (element.order >= newOrder && element.order < currentOrder) {
	      return Object.assign({}, element, {
	        order: element.order + 1
	      });
	    } else if (element.order <= newOrder && element.order > currentOrder) {
	      return Object.assign({}, element, {
	        order: element.order - 1
	      });
	    } else {
	      return element;
	    }
	  });
	
	  return enforceElementsOrder(reordered);
	};

/***/ },

/***/ 321:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var redirectToResponse = exports.redirectToResponse = function redirectToResponse(response) {
	  var headers = response.headers;
	
	
	  var getFromHeader = function getFromHeader(header) {
	    return headers.has(header) ? headers.get(header) : null;
	  };
	
	  var location = getFromHeader('location') || getFromHeader('Location');
	  if (location) {
	    window.location.replace(location);
	  } else {
	    window.location.reload(true);
	  }
	};

/***/ },

/***/ 322:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.appendLoggerMiddlewareInDev = undefined;
	
	var _reduxLogger = __webpack_require__(1948);
	
	var _reduxLogger2 = _interopRequireDefault(_reduxLogger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var appendLoggerMiddlewareInDev = exports.appendLoggerMiddlewareInDev = function appendLoggerMiddlewareInDev(middlewares) {
	  if (false) {
	    var loggerMiddleware = (0, _reduxLogger2.default)({
	      collapsed: function collapsed(getState, action) {
	        return action.type.indexOf('redux-form/') > -1;
	      }
	    });
	
	    middlewares.push(loggerMiddleware);
	  }
	};

/***/ },

/***/ 379:
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/image-loader.86612673.svg";

/***/ },

/***/ 475:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var filterResources = exports.filterResources = function filterResources(value) {
	  return {
	    type: 'FILTER_RESOURCES',
	    value: value
	  };
	};
	
	var updateResource = exports.updateResource = function updateResource(resource) {
	  return {
	    type: 'UPDATE_RESOURCE',
	    resource: resource
	  };
	};
	
	var removeResource = exports.removeResource = function removeResource(resource) {
	  return {
	    type: 'REMOVE_RESOURCE',
	    resource: resource
	  };
	};
	
	var removeResourceSuccess = exports.removeResourceSuccess = function removeResourceSuccess(resourceId) {
	  return {
	    type: 'REMOVE_RESOURCE_SUCCESS',
	    resourceId: resourceId
	  };
	};

/***/ },

/***/ 476:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.remove = exports.expand = exports.crop = exports.update = undefined;
	
	var _fetch = __webpack_require__(32);
	
	var _fetch2 = _interopRequireDefault(_fetch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var update = exports.update = function update(resource) {
	  return (0, _fetch2.default)('/bucket/resources.json/' + resource.id, {
	    method: 'POST',
	    headers: {
	      'Content-Type': 'application/json'
	    },
	    body: JSON.stringify(resource)
	  });
	};
	
	var crop = exports.crop = function crop(resourceId, config) {
	  return (0, _fetch2.default)('/bucket/resources.json/' + resourceId + '/crop', {
	    method: 'POST',
	    headers: {
	      'Content-Type': 'application/json'
	    },
	    body: JSON.stringify(config)
	  }).then(function (res) {
	    return res.blob();
	  });
	};
	
	var expand = exports.expand = function expand(resourceId, config) {
	  return (0, _fetch2.default)('/bucket/resources.json/' + resourceId + '/expand', {
	    method: 'POST',
	    headers: {
	      'Content-Type': 'application/json'
	    },
	    body: JSON.stringify(config)
	  }).then(function (res) {
	    return res.blob();
	  });
	};
	
	var remove = exports.remove = function remove(resourceId) {
	  return (0, _fetch2.default)('/bucket/resources.json/' + resourceId, {
	    method: 'DELETE'
	  });
	};

/***/ },

/***/ 477:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(33);
	
	var _folders = __webpack_require__(172);
	
	var _folders2 = _interopRequireDefault(_folders);
	
	var _uploads = __webpack_require__(478);
	
	var _uploads2 = _interopRequireDefault(_uploads);
	
	var _resources = __webpack_require__(302);
	
	var _resources2 = _interopRequireDefault(_resources);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_FoldersState = __webpack_require__(172).babelPluginFlowReactPropTypes_proptype_FoldersState || __webpack_require__(1).PropTypes.any;
	
	if (true) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_State', {
	  value: __webpack_require__(1).PropTypes.shape({
	    folders: babelPluginFlowReactPropTypes_proptype_FoldersState
	  })
	});
	exports.default = (0, _redux.combineReducers)({
	  folders: _folders2.default,
	  uploads: _uploads2.default,
	  resources: _resources2.default
	});

/***/ },

/***/ 478:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getRunningCount = exports.getRunningUploads = exports.getPendingUploads = undefined;
	
	var _redux = __webpack_require__(33);
	
	var _immutable = __webpack_require__(10);
	
	var _uploads = __webpack_require__(171);
	
	var _upload = __webpack_require__(877);
	
	var pending = function pending() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.Stack)();
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _uploads.UPLOAD_FILE:
	      return state.unshift(action.upload);
	    case _uploads.UPLOADING_FILE:
	      return state.shift();
	    case _uploads.CANCEL_PENDING:
	      return state.clear();
	    default:
	      return state;
	  }
	};
	
	var running = function running() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.Map)();
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _uploads.UPLOADING_FILE:
	      return state.set(action.upload.token, action.upload);
	    case _uploads.UPLOAD_FILE_FAILURE:
	      return state.update(action.upload.token, function (upload) {
	        return Object.assign({}, upload, {
	          state: 'error',
	          error: action.error
	        });
	      });
	    case _uploads.UPLOAD_FILE_SUCCESS:
	      return state.delete(action.upload.token);
	    default:
	      return state;
	  }
	};
	
	exports.default = (0, _redux.combineReducers)({
	  pending: pending,
	  running: running
	});
	var getPendingUploads = exports.getPendingUploads = function getPendingUploads(state) {
	  return state.uploads.pending;
	};
	var getRunningUploads = exports.getRunningUploads = function getRunningUploads(state) {
	  return state.uploads.running.toList();
	};
	var getRunningCount = exports.getRunningCount = function getRunningCount(state) {
	  return state.uploads.running.count(_upload.isRunning);
	};

/***/ },

/***/ 479:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var NEWS_TARGET_CLEARED = exports.NEWS_TARGET_CLEARED = 'campaign@diffusion:NEWS_TARGET_CLEAR';
	var NEWS_TARGETS_UPDATED = exports.NEWS_TARGETS_UPDATED = 'campaign@diffusion:NEWS_TARGETS_UPDATED';
	
	var updateTargets = exports.updateTargets = function updateTargets(targets) {
	  return {
	    type: NEWS_TARGETS_UPDATED,
	    targets: targets
	  };
	};
	
	var clearTarget = exports.clearTarget = function clearTarget() {
	  return {
	    type: NEWS_TARGET_CLEARED
	  };
	};

/***/ },

/***/ 480:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.bindInteractions = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(16);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _fetch = __webpack_require__(32);
	
	var _fetch2 = _interopRequireDefault(_fetch);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(134);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _redirect = __webpack_require__(321);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _toastr = __webpack_require__(81);
	
	var _api = __webpack_require__(905);
	
	var Api = _interopRequireWildcard(_api);
	
	var _modals = __webpack_require__(217);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	exports.default = function (onSubmit) {
	  (0, _modals.mountComponent)(_react2.default.createElement(PostponeModal, { onConfirm: onSubmit, onClose: _modals.unmountCurrentComponent }));
	};
	
	var bindInteractions = exports.bindInteractions = function bindInteractions(id) {
	  (0, _jquery2.default)('#bt-update-postpone').on('click', function (event) {
	    return bindUpdate(id, event);
	  });
	  (0, _jquery2.default)('#bt-cancel-postpone').on('click', function (event) {
	    return bindCancel(id, event);
	  });
	};
	
	function bindUpdate(id, event) {
	  var confirm = function confirm(date) {
	    return Api.updatePostpone(id, date).then(function (res) {
	      (0, _toastr.storeSuccess)('Programmation reprogrammée avec succès');
	      return res;
	    }).then(_redirect.redirectToResponse);
	  };
	
	  (0, _modals.mountComponent)(_react2.default.createElement(PostponeModal, { onConfirm: confirm, onClose: _modals.unmountCurrentComponent }));
	}
	
	function bindCancel(id, event) {
	  var $button = (0, _jquery2.default)(event.currentTarget);
	  var url = $button.attr('data-url');
	
	  if (url && url.length) {
	    $button.addClass('loading');
	
	    (0, _fetch2.default)(url, { method: 'DELETE' }).then(function (res) {
	      (0, _toastr.storeSuccess)('Programmation annulée avec succès');
	      return res;
	    }).then(_redirect.redirectToResponse);
	  }
	}
	
	var minPostponeDate = function minPostponeDate() {
	  return (0, _moment2.default)().add(1, 'hours').toDate();
	};
	
	var formatPostponeDate = function formatPostponeDate(date) {
	  return (0, _moment2.default)(date).format('DD/MM/YYYY HH:mm');
	};
	
	//TODO: move to shared (same component as in news)
	
	var PostponeModal = function (_Component) {
	  _inherits(PostponeModal, _Component);
	
	  function PostponeModal(props) {
	    _classCallCheck(this, PostponeModal);
	
	    var _this = _possibleConstructorReturn(this, (PostponeModal.__proto__ || Object.getPrototypeOf(PostponeModal)).call(this, props));
	
	    _this.onDateChange = function (value) {
	      return _this.setState({ value: value });
	    };
	
	    _this.onConfirm = function () {
	      var value = _this.state.value;
	
	      if (value) {
	        var handleConfirm = function handleConfirm() {
	          return _this.props.onConfirm(formatPostponeDate(value)).then(function (_) {
	            return _this.setState({
	              loading: false
	            });
	          });
	        };
	
	        _this.setState({
	          loading: true
	        }, handleConfirm);
	      }
	    };
	
	    _this.state = {
	      loading: false
	    };
	    return _this;
	  }
	
	  _createClass(PostponeModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _jquery2.default)(this.calendar).calendarFr({
	        minDate: minPostponeDate(),
	        disableMinute: true,
	        onChange: this.onDateChange
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var onClose = this.props.onClose;
	      var _state = this.state,
	          value = _state.value,
	          loading = _state.loading;
	
	
	      return _react2.default.createElement(
	        _semanticUiReact.Modal,
	        { size: 'small', closeIcon: true, open: true, onClose: onClose },
	        _react2.default.createElement(
	          _semanticUiReact.Modal.Header,
	          null,
	          'Publication ult\xE9rieure'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Modal.Content,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Form,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Form.Field,
	              null,
	              _react2.default.createElement(
	                'label',
	                null,
	                'Date de publication'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ui calendar', ref: function ref(_ref) {
	                    return _this2.calendar = _ref;
	                  } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'ui input left icon' },
	                  _react2.default.createElement('i', { className: 'calendar icon' }),
	                  _react2.default.createElement('input', {
	                    type: 'text',
	                    name: 'postpone',
	                    placeholder: 'Date',
	                    readOnly: true
	                  })
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Modal.Actions,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Button,
	            { onClick: onClose },
	            'Annuler'
	          ),
	          _react2.default.createElement(_semanticUiReact.Button, {
	            onClick: this.onConfirm,
	            disabled: value === undefined,
	            loading: loading,
	            positive: true,
	            icon: 'play',
	            labelPosition: 'right',
	            content: 'Programmer'
	          })
	        )
	      );
	    }
	  }]);

	  return PostponeModal;
	}(_react.Component);

	PostponeModal.propTypes = {
	  onConfirm: __webpack_require__(1).PropTypes.func.isRequired,
	  onClose: __webpack_require__(1).PropTypes.func.isRequired
	};

/***/ },

/***/ 481:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getIsFetched = undefined;
	
	var _redux = __webpack_require__(33);
	
	var _diffusion = __webpack_require__(303);
	
	var _diffusion2 = _interopRequireDefault(_diffusion);
	
	var _actions = __webpack_require__(209);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isFetched = function isFetched() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _actions.INITIAL_DATA_LOAD_SUCCESS:
	      return true;
	    default:
	      return state;
	  }
	};
	
	exports.default = (0, _redux.combineReducers)({
	  isFetched: isFetched,
	  diffusion: _diffusion2.default
	});
	var getIsFetched = exports.getIsFetched = function getIsFetched(state) {
	  return state.isFetched;
	};

/***/ },

/***/ 482:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unarchive = exports.archive = exports.update = exports.save = exports.fetchLight = exports.fetch = undefined;
	
	var _fetch = __webpack_require__(32);
	
	var _fetch2 = _interopRequireDefault(_fetch);
	
	var _plugin = __webpack_require__(113);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fetch = exports.fetch = function fetch() {
	  return (0, _fetch.fetchJson)('/catalog/pages.json');
	};
	
	var fetchLight = exports.fetchLight = function fetchLight(mode) {
	  return (0, _fetch.fetchJson)('/catalog/pages/light.json?mode=' + mode);
	};
	
	var save = exports.save = function save(data) {
	  return (0, _fetch.postJson)('/catalog/pages.json', data);
	};
	
	var update = exports.update = function update(page, contents) {
	  var data = Object.assign({}, page, {
	    contents: contents.map(function (c) {
	      return Object.assign({}, c, {
	        template: page.template.code
	      });
	    }).map(function (c) {
	      return (0, _plugin.writeContent)(page.template.code, c);
	    })
	  });
	
	  return (0, _fetch.postJson)('/catalog/pages.json/' + page.id, data);
	};
	
	var archive = exports.archive = function archive(pageId) {
	  return (0, _fetch2.default)('/catalog/pages.json/' + pageId + '/archive', {
	    method: 'PUT'
	  });
	};
	
	var unarchive = exports.unarchive = function unarchive(pageId) {
	  return (0, _fetch2.default)('/catalog/pages.json/' + pageId + '/unarchive', {
	    method: 'PUT'
	  });
	};

/***/ },

/***/ 483:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.deployments = exports.pages = exports.deployment = exports.content = exports.page = undefined;
	
	var _normalizr = __webpack_require__(201);
	
	var _moment = __webpack_require__(134);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var page = exports.page = new _normalizr.Schema('pages');
	var content = exports.content = new _normalizr.Schema('contents');
	
	var deployment = exports.deployment = new _normalizr.Schema('deployments', {
	  idAttribute: 'version',
	  assignEntity: function assignEntity(output, key, value, input) {
	    // Update date to moment
	    if (key === 'deployedAt') {
	      output.deployedAt = (0, _moment2.default)(value).locale('fr');
	    } else {
	      output[key] = value;
	    }
	  }
	});
	
	page.define({
	  contents: (0, _normalizr.arrayOf)(content)
	});
	
	var pages = exports.pages = (0, _normalizr.arrayOf)(page);
	var deployments = exports.deployments = (0, _normalizr.arrayOf)(deployment);

/***/ },

/***/ 484:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DeployButton = function (_Component) {
	  _inherits(DeployButton, _Component);
	
	  function DeployButton(props) {
	    _classCallCheck(this, DeployButton);
	
	    var _this = _possibleConstructorReturn(this, (DeployButton.__proto__ || Object.getPrototypeOf(DeployButton)).call(this, props));
	
	    _this.onCancel = function () {
	      return _this.setState({ modalOpened: false });
	    };
	
	    _this.onShow = function () {
	      return _this.setState({ modalOpened: true });
	    };
	
	    _this.onConfirm = function () {
	      var onDeployed = _this.props.onDeployed;
	
	
	      _this.setState({ modalOpened: false }, onDeployed);
	    };
	
	    _this.state = {
	      modalOpened: false
	    };
	    return _this;
	  }
	
	  _createClass(DeployButton, [{
	    key: 'render',
	    value: function render() {
	      var children = this.props.children;
	      var modalOpened = this.state.modalOpened;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Modal,
	          { open: modalOpened, onClose: this.onCancel, closeIcon: true },
	          _react2.default.createElement(_semanticUiReact.Header, { content: 'D\xE9ploiement en production' }),
	          _react2.default.createElement(
	            _semanticUiReact.Modal.Content,
	            null,
	            _react2.default.createElement(_semanticUiReact.Message, {
	              icon: 'info circle',
	              header: '\n                Vous-\xEAtes sur le point de mettre la version courante de l\'application en production.\n                \xCAtes-vous s\xFBr(e) ?\n              '
	            })
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Modal.Actions,
	            null,
	            _react2.default.createElement(_semanticUiReact.Button, {
	              onClick: this.onCancel,
	              labelPosition: 'left',
	              icon: 'close',
	              content: 'Annuler'
	            }),
	            _react2.default.createElement(_semanticUiReact.Button, {
	              onClick: this.onConfirm,
	              color: 'red',
	              labelPosition: 'right',
	              icon: 'upload',
	              content: 'Deployer'
	            })
	          )
	        ),
	        children && children(this.onShow)
	      );
	    }
	  }]);
	
	  return DeployButton;
	}(_react.Component);
	
	DeployButton.propTypes = {
	  children: __webpack_require__(1).PropTypes.func,
	  onDeployed: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = DeployButton;

/***/ },

/***/ 485:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _compose = __webpack_require__(436);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _reactRedux = __webpack_require__(14);
	
	var _reactRouterDom = __webpack_require__(31);
	
	var _reduxForm = __webpack_require__(440);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _catalog = __webpack_require__(213);
	
	var _TemplateSelector = __webpack_require__(986);
	
	var _TemplateSelector2 = _interopRequireDefault(_TemplateSelector);
	
	var _NetworkModeSelector = __webpack_require__(982);
	
	var _NetworkModeSelector2 = _interopRequireDefault(_NetworkModeSelector);
	
	var _SecurityContextSelector = __webpack_require__(984);
	
	var _SecurityContextSelector2 = _interopRequireDefault(_SecurityContextSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  form: {
	    marginTop: '1rem'
	  }
	};
	
	var isRootLocation = function isRootLocation(location) {
	  return location.query && location.query.root;
	};
	var defaultNameIfRoot = function defaultNameIfRoot(location) {
	  return isRootLocation(location) ? 'Accueil' : '';
	};
	
	var mapStateToProps = function mapStateToProps(state, _ref) {
	  var location = _ref.location;
	
	  var settings = (0, _catalog.getSettings)(state);
	
	  return {
	    initialValues: {
	      root: isRootLocation(location),
	      name: defaultNameIfRoot(location),
	      networkMode: settings.defaultNetworkMode,
	      securityContext: settings.defaultSecurityContext || 'none'
	    },
	    settings: settings,
	    templates: (0, _catalog.getUnlockedTemplates)(state)
	  };
	};
	
	var validate = function validate(values) {
	  var errors = {};
	  if (!values.name) {
	    errors.name = 'Le nom est requis';
	  }
	  if (!values.template) {
	    errors.template = 'Le type est requis';
	  }
	
	  return errors;
	};
	
	var renderField = function renderField(_ref2) {
	  var input = _ref2.input,
	      label = _ref2.label,
	      type = _ref2.type,
	      _ref2$meta = _ref2.meta,
	      touched = _ref2$meta.touched,
	      error = _ref2$meta.error;
	  return _react2.default.createElement(
	    _semanticUiReact.Form.Field,
	    { error: touched && !!error },
	    _react2.default.createElement(
	      'label',
	      null,
	      label
	    ),
	    _react2.default.createElement('input', Object.assign({}, input, { placeholder: label, type: type }))
	  );
	};
	
	var Create = function Create(_ref3) {
	  var children = _ref3.children,
	      settings = _ref3.settings,
	      templates = _ref3.templates,
	      pristine = _ref3.pristine,
	      submitting = _ref3.submitting,
	      error = _ref3.error,
	      history = _ref3.history,
	      location = _ref3.location,
	      handleSubmit = _ref3.handleSubmit,
	      onSubmit = _ref3.onSubmit;
	
	  var renderFields = function renderFields() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_semanticUiReact.Message, { error: true, content: error }),
	      _react2.default.createElement(_reduxForm.Field, { name: 'root', type: 'hidden', component: 'input' }),
	      _react2.default.createElement(_reduxForm.Field, {
	        name: 'name',
	        type: 'text',
	        component: renderField,
	        label: 'Nom de la page'
	      }),
	      _react2.default.createElement(_reduxForm.Field, {
	        name: 'template',
	        component: _TemplateSelector2.default,
	        label: 'Type',
	        templates: templates
	      }),
	      _react2.default.createElement(_reduxForm.Field, {
	        name: 'networkMode',
	        component: _NetworkModeSelector2.default,
	        label: 'Mode de connectivit\xE9',
	        canOverride: settings.canOverrideNetworkMode
	      }),
	      _react2.default.createElement(_reduxForm.Field, {
	        name: 'securityContext',
	        component: _SecurityContextSelector2.default,
	        label: 'Contexte d\'authentification',
	        canOverride: settings.canOverrideSecurityContext
	      })
	    );
	  };
	
	  return _react2.default.createElement(
	    _semanticUiReact.Form,
	    { error: !!error, onSubmit: handleSubmit, style: styles.form },
	    children({
	      fields: renderFields(),
	      pristine: pristine,
	      submitting: submitting
	    })
	  );
	};
	
	Create.propTypes = {
	  children: __webpack_require__(1).PropTypes.func.isRequired,
	  submitting: __webpack_require__(1).PropTypes.bool.isRequired,
	  error: __webpack_require__(1).PropTypes.string,
	  pristine: __webpack_require__(1).PropTypes.bool,
	  history: __webpack_require__(1).PropTypes.object.isRequired,
	  location: __webpack_require__(1).PropTypes.object.isRequired,
	  settings: __webpack_require__(1).PropTypes.any.isRequired,
	  templates: __webpack_require__(1).PropTypes.arrayOf(__webpack_require__(1).PropTypes.any).isRequired,
	  handleSubmit: __webpack_require__(1).PropTypes.func.isRequired,
	  onSubmit: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = (0, _compose2.default)(_reactRouterDom.withRouter, (0, _reactRedux.connect)(mapStateToProps), (0, _reduxForm.reduxForm)({
	  form: 'createPage',
	  validate: validate
	}))(Create);

/***/ },

/***/ 486:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PendingChangesPrompt = function PendingChangesPrompt(_ref) {
	  var visible = _ref.visible;
	  return _react2.default.createElement(_reactRouterDom.Prompt, {
	    when: visible,
	    message: '\n    Vous avez des modifications non enregistr\xE9es.\n    \xCAtes-vous s\xFBr(e) de vouloir quitter ?\n    '
	  });
	};
	
	PendingChangesPrompt.propTypes = {
	  visible: __webpack_require__(1).PropTypes.bool.isRequired
	};
	exports.default = PendingChangesPrompt;

/***/ },

/***/ 487:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var platformValues = function platformValues(platforms) {
	  return platforms.map(function (p) {
	    return {
	      value: p.code,
	      text: p.label
	    };
	  });
	};
	
	var PlatformSelector = function PlatformSelector(_ref) {
	  var value = _ref.value,
	      platforms = _ref.platforms,
	      onChange = _ref.onChange;
	
	  var change = function change(_, _ref2) {
	    var value = _ref2.value;
	
	    var target = platforms.find(function (p) {
	      return p.code === value;
	    });
	    if (target) {
	      onChange(target);
	    }
	  };
	
	  return _react2.default.createElement(_semanticUiReact.Dropdown, {
	    value: value.code,
	    selection: true,
	    options: platformValues(platforms),
	    onChange: change
	  });
	};
	
	PlatformSelector.propTypes = {
	  value: __webpack_require__(1).PropTypes.any.isRequired,
	  platforms: __webpack_require__(1).PropTypes.arrayOf(__webpack_require__(1).PropTypes.any).isRequired,
	  onChange: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = PlatformSelector;

/***/ },

/***/ 488:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createTemplateResource = exports.createTemplateResource = function createTemplateResource(resource) {
	  return {
	    strategy: {
	      type: 'template',
	      source: resource.id
	    },
	    source: resource
	  };
	};
	
	var createTemplateDrivenStrategy = exports.createTemplateDrivenStrategy = function createTemplateDrivenStrategy() {
	  return {
	    type: 'template'
	  };
	};
	
	var createServerDrivenStrategy = exports.createServerDrivenStrategy = function createServerDrivenStrategy(config) {
	  return Object.assign({
	    type: 'server'
	  }, config);
	};
	
	var createClientDrivenStrategy = exports.createClientDrivenStrategy = function createClientDrivenStrategy() {
	  var horizontalAlign = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'center';
	  var verticalAlign = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'center';
	  var parallaxEnabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	  return {
	    type: 'client',
	    horizontalAlign: horizontalAlign,
	    verticalAlign: verticalAlign,
	    parallaxEnabled: parallaxEnabled
	  };
	};
	
	var createFixedWidthStrategy = exports.createFixedWidthStrategy = function createFixedWidthStrategy() {
	  var align = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'center';
	  return {
	    type: 'fixed',
	    fullWidth: true,
	    fullHeight: false,
	    align: align,
	    color: '#FFFFFF'
	  };
	};
	
	var createFixedHeightStrategy = exports.createFixedHeightStrategy = function createFixedHeightStrategy() {
	  var align = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'center';
	  return {
	    type: 'fixed',
	    fullWidth: false,
	    fullHeight: true,
	    align: align,
	    color: '#FFFFFF'
	  };
	};

/***/ },

/***/ 489:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _api = __webpack_require__(490);
	
	var Api = _interopRequireWildcard(_api);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _BlockListRender = __webpack_require__(998);
	
	var _BlockListRender2 = _interopRequireDefault(_BlockListRender);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Render = function (_Component) {
	  _inherits(Render, _Component);
	
	  function Render(props) {
	    _classCallCheck(this, Render);
	
	    var _this = _possibleConstructorReturn(this, (Render.__proto__ || Object.getPrototypeOf(Render)).call(this, props));
	
	    _this.state = {
	      isFetching: false,
	      templates: []
	    };
	    return _this;
	  }
	
	  _createClass(Render, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.setState({
	        isFetching: true
	      });
	
	      Api.fetchTemplates().then(function (templates) {
	        return _this2.setState({
	          isFetching: false,
	          templates: templates
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var blocks = this.props.blocks;
	      var _state = this.state,
	          isFetching = _state.isFetching,
	          templates = _state.templates;
	
	
	      if (isFetching) {
	        return _react2.default.createElement(_semanticUiReact.Segment, { loading: true, style: { minHeight: '180px' } });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_BlockListRender2.default, { blocks: blocks, templates: templates })
	      );
	    }
	  }]);
	
	  return Render;
	}(_react.Component);
	
	Render.propTypes = {
	  blocks: __webpack_require__(1).PropTypes.arrayOf(__webpack_require__(1).PropTypes.any).isRequired
	};
	exports.default = Render;

/***/ },

/***/ 490:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchTemplates = undefined;
	
	var _fetch = __webpack_require__(32);
	
	var fetchTemplates = exports.fetchTemplates = function fetchTemplates() {
	  return (0, _fetch.fetchJson)('/flow/templates.json');
	};

/***/ },

/***/ 491:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _constants = __webpack_require__(141);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  image: {
	    minHeight: '100px',
	    display: 'flex',
	    background: '#e0e1e2'
	  },
	  icon: {
	    margin: 'auto',
	    fontSize: '4em',
	    color: '#fff',
	    lineHeight: '1em'
	  }
	};
	
	var BlockTemplateImage = function BlockTemplateImage(_ref) {
	  var templates = _ref.templates,
	      block = _ref.block;
	
	  var template = templates.find(function (t) {
	    return t.code === block.template;
	  });
	  var icon = template ? template.icon : _constants.DEFAULT_BLOCK_ICON;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'ui small image', style: styles.image },
	    _react2.default.createElement(_semanticUiReact.Icon, { name: icon, style: styles.icon })
	  );
	};
	
	BlockTemplateImage.propTypes = {
	  templates: __webpack_require__(1).PropTypes.arrayOf(__webpack_require__(1).PropTypes.any).isRequired,
	  block: __webpack_require__(1).PropTypes.any.isRequired
	};
	exports.default = BlockTemplateImage;

/***/ },

/***/ 492:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ADDRESS_MAP_BLOCKTYPE = exports.ADDRESS_MAP_BLOCKTYPE = 'address';
	var DESTINATION_MAP_BLOCKTYPE = exports.DESTINATION_MAP_BLOCKTYPE = 'destination';
	var DEFAULT_MAP_BLOCKTYPE = exports.DEFAULT_MAP_BLOCKTYPE = DESTINATION_MAP_BLOCKTYPE;

/***/ },

/***/ 493:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var DEFAULT_CONTACT_BLOCKTYPE = exports.DEFAULT_CONTACT_BLOCKTYPE = 'mail_contact';
	var MAIL_CONTACT_BLOCKTYPE = exports.MAIL_CONTACT_BLOCKTYPE = 'mail_contact';
	var PHONE_CONTACT_BLOCKTYPE = exports.PHONE_CONTACT_BLOCKTYPE = 'phone_contact';
	
	var MAIL_VALIDATION = exports.MAIL_VALIDATION = /\S+@\S+\.\S+/;

/***/ },

/***/ 494:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var NEWS_TARGET_CLEARED = exports.NEWS_TARGET_CLEARED = 'news@diffusion:NEWS_TARGET_CLEAR';
	var NEWS_TARGETS_UPDATED = exports.NEWS_TARGETS_UPDATED = 'news@diffusion:NEWS_TARGETS_UPDATED';
	
	var updateTargets = exports.updateTargets = function updateTargets(targets) {
	  return {
	    type: NEWS_TARGETS_UPDATED,
	    targets: targets
	  };
	};
	
	var clearTarget = exports.clearTarget = function clearTarget() {
	  return {
	    type: NEWS_TARGET_CLEARED
	  };
	};

/***/ },

/***/ 495:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var BLOCKS_UPDATED = exports.BLOCKS_UPDATED = 'news@edito:BLOCKS_UPDATED';
	
	var updateBlocks = exports.updateBlocks = function updateBlocks(blocks) {
	  return {
	    type: BLOCKS_UPDATED,
	    blocks: blocks
	  };
	};

/***/ },

/***/ 496:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var IMAGE_UPDATED = exports.IMAGE_UPDATED = 'news@images:IMAGE_UPDATED';
	var IMAGE_DELETED = exports.IMAGE_DELETED = 'news@images:IMAGE_DELETED';
	var CATCH_IMAGE_UPDATED = exports.CATCH_IMAGE_UPDATED = 'news@images:CATCH_IMAGE_UPDATED';
	var CATCH_IMAGE_DELETED = exports.CATCH_IMAGE_DELETED = 'news@images:CATCH_IMAGE_DELETED';
	
	var updateImage = exports.updateImage = function updateImage(image) {
	  return {
	    type: IMAGE_UPDATED,
	    image: image
	  };
	};
	
	var deleteImage = exports.deleteImage = function deleteImage() {
	  return {
	    type: IMAGE_DELETED
	  };
	};
	
	var updateCatchImage = exports.updateCatchImage = function updateCatchImage(image) {
	  return {
	    type: CATCH_IMAGE_UPDATED,
	    image: image
	  };
	};
	
	var deleteCatchImage = exports.deleteCatchImage = function deleteCatchImage() {
	  return {
	    type: CATCH_IMAGE_DELETED
	  };
	};

/***/ },

/***/ 497:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.bindInteractions = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(16);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _fetch = __webpack_require__(32);
	
	var _fetch2 = _interopRequireDefault(_fetch);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(134);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _redirect = __webpack_require__(321);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _toastr = __webpack_require__(81);
	
	var _api = __webpack_require__(1038);
	
	var NewsApi = _interopRequireWildcard(_api);
	
	var _modals = __webpack_require__(217);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	exports.default = function (onSubmit) {
	  (0, _modals.mountComponent)(_react2.default.createElement(PostponeModal, { onConfirm: onSubmit, onClose: _modals.unmountCurrentComponent }));
	};
	
	var bindInteractions = exports.bindInteractions = function bindInteractions(id) {
	  (0, _jquery2.default)('#bt-update-postpone').on('click', function (event) {
	    return bindUpdate(id, event);
	  });
	  (0, _jquery2.default)('#bt-cancel-postpone').on('click', function (event) {
	    return bindCancel(id, event);
	  });
	};
	
	function bindUpdate(id, event) {
	  var confirm = function confirm(date) {
	    return NewsApi.updatePostpone(id, date).then(function (res) {
	      (0, _toastr.storeSuccess)('Programmation reprogrammée avec succès');
	      return res;
	    }).then(_redirect.redirectToResponse);
	  };
	
	  (0, _modals.mountComponent)(_react2.default.createElement(PostponeModal, { onConfirm: confirm, onClose: _modals.unmountCurrentComponent }));
	}
	
	function bindCancel(id, event) {
	  var $button = (0, _jquery2.default)(event.currentTarget);
	  var url = $button.attr('data-url');
	
	  if (url && url.length) {
	    $button.addClass('loading');
	
	    (0, _fetch2.default)(url, { method: 'DELETE' }).then(function (res) {
	      (0, _toastr.storeSuccess)('Programmation annulée avec succès');
	      return res;
	    }).then(_redirect.redirectToResponse);
	  }
	}
	
	var minPostponeDate = function minPostponeDate() {
	  return (0, _moment2.default)().add(1, 'hours').toDate();
	};
	
	var formatPostponeDate = function formatPostponeDate(date) {
	  return (0, _moment2.default)(date).format('DD/MM/YYYY HH:mm');
	};
	
	var PostponeModal = function (_Component) {
	  _inherits(PostponeModal, _Component);
	
	  function PostponeModal(props) {
	    _classCallCheck(this, PostponeModal);
	
	    var _this = _possibleConstructorReturn(this, (PostponeModal.__proto__ || Object.getPrototypeOf(PostponeModal)).call(this, props));
	
	    _this.onDateChange = function (value) {
	      return _this.setState({ value: value });
	    };
	
	    _this.onConfirm = function () {
	      var value = _this.state.value;
	
	      if (value) {
	        var handleConfirm = function handleConfirm() {
	          return _this.props.onConfirm(formatPostponeDate(value)).then(function (_) {
	            return _this.setState({
	              loading: false
	            });
	          });
	        };
	
	        _this.setState({
	          loading: true
	        }, handleConfirm);
	      }
	    };
	
	    _this.state = {
	      loading: false
	    };
	    return _this;
	  }
	
	  _createClass(PostponeModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _jquery2.default)(this.calendar).calendarFr({
	        minDate: minPostponeDate(),
	        disableMinute: true,
	        onChange: this.onDateChange
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var onClose = this.props.onClose;
	      var _state = this.state,
	          value = _state.value,
	          loading = _state.loading;
	
	
	      return _react2.default.createElement(
	        _semanticUiReact.Modal,
	        { size: 'small', closeIcon: true, open: true, onClose: onClose },
	        _react2.default.createElement(
	          _semanticUiReact.Modal.Header,
	          null,
	          'Publication ult\xE9rieure'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Modal.Content,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Form,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Form.Field,
	              null,
	              _react2.default.createElement(
	                'label',
	                null,
	                'Date de publication'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ui calendar', ref: function ref(_ref) {
	                    return _this2.calendar = _ref;
	                  } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'ui input left icon' },
	                  _react2.default.createElement('i', { className: 'calendar icon' }),
	                  _react2.default.createElement('input', {
	                    type: 'text',
	                    name: 'postpone',
	                    placeholder: 'Date',
	                    readOnly: true
	                  })
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Modal.Actions,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Button,
	            { onClick: onClose },
	            'Annuler'
	          ),
	          _react2.default.createElement(_semanticUiReact.Button, {
	            onClick: this.onConfirm,
	            disabled: value === undefined,
	            loading: loading,
	            positive: true,
	            icon: 'play',
	            labelPosition: 'right',
	            content: 'Programmer'
	          })
	        )
	      );
	    }
	  }]);

	  return PostponeModal;
	}(_react.Component);

	PostponeModal.propTypes = {
	  onConfirm: __webpack_require__(1).PropTypes.func.isRequired,
	  onClose: __webpack_require__(1).PropTypes.func.isRequired
	};

/***/ },

/***/ 498:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getIsFetched = undefined;
	
	var _redux = __webpack_require__(33);
	
	var _diffusion = __webpack_require__(310);
	
	var _diffusion2 = _interopRequireDefault(_diffusion);
	
	var _edito = __webpack_require__(311);
	
	var _edito2 = _interopRequireDefault(_edito);
	
	var _images = __webpack_require__(312);
	
	var _images2 = _interopRequireDefault(_images);
	
	var _actions = __webpack_require__(142);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isFetched = function isFetched() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _actions.INITIAL_DATA_LOAD_SUCCESS:
	      return true;
	    default:
	      return state;
	  }
	};
	
	exports.default = (0, _redux.combineReducers)({
	  isFetched: isFetched,
	  diffusion: _diffusion2.default,
	  edito: _edito2.default,
	  images: _images2.default
	});
	var getIsFetched = exports.getIsFetched = function getIsFetched(state) {
	  return state.isFetched;
	};

/***/ },

/***/ 499:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchRoles = undefined;
	
	var _fetch = __webpack_require__(32);
	
	var fetchRoles = exports.fetchRoles = function fetchRoles() {
	  return (0, _fetch.fetchJson)('/users/roles.json');
	};

/***/ },

/***/ 500:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeleteModal = function DeleteModal(_ref) {
	  var open = _ref.open,
	      loading = _ref.loading,
	      _ref$title = _ref.title,
	      title = _ref$title === undefined ? 'Suppression' : _ref$title,
	      content = _ref.content,
	      error = _ref.error,
	      onConfirm = _ref.onConfirm,
	      onClose = _ref.onClose;
	  return _react2.default.createElement(
	    _semanticUiReact.Modal,
	    { closeIcon: true, size: 'small', open: open, onClose: onClose },
	    _react2.default.createElement(
	      _semanticUiReact.Modal.Header,
	      null,
	      title
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Modal.Content,
	      null,
	      error && _react2.default.createElement(_semanticUiReact.Message, { error: true, content: error }),
	      _react2.default.createElement(
	        'p',
	        null,
	        content
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Modal.Actions,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Button,
	        { onClick: onClose },
	        'Non'
	      ),
	      _react2.default.createElement(_semanticUiReact.Button, {
	        disabled: !!error,
	        onClick: onConfirm,
	        loading: loading,
	        negative: true,
	        icon: 'close',
	        labelPosition: 'right',
	        content: 'Oui'
	      })
	    )
	  );
	};
	
	DeleteModal.propTypes = {
	  open: __webpack_require__(1).PropTypes.bool.isRequired,
	  loading: __webpack_require__(1).PropTypes.bool,
	  title: __webpack_require__(1).PropTypes.string,
	  content: __webpack_require__(1).PropTypes.string.isRequired,
	  error: __webpack_require__(1).PropTypes.string,
	  onConfirm: __webpack_require__(1).PropTypes.func.isRequired,
	  onClose: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = DeleteModal;

/***/ },

/***/ 501:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _ResourceCard = __webpack_require__(175);
	
	var _ResourceCard2 = _interopRequireDefault(_ResourceCard);
	
	var _ResourceDimmer = __webpack_require__(176);
	
	var _ResourceDimmer2 = _interopRequireDefault(_ResourceDimmer);
	
	var _ImageCrop = __webpack_require__(174);
	
	var _ImageCrop2 = _interopRequireDefault(_ImageCrop);
	
	var _reactColor = __webpack_require__(409);
	
	var _resources = __webpack_require__(504);
	
	var _resources2 = __webpack_require__(114);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	if (true) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_FixedDimensionConfig', {
	  value: __webpack_require__(1).PropTypes.shape({
	    fullWidth: __webpack_require__(1).PropTypes.bool,
	    fullHeight: __webpack_require__(1).PropTypes.bool,
	    align: __webpack_require__(1).PropTypes.string.isRequired,
	    color: __webpack_require__(1).PropTypes.string.isRequired,
	    x: __webpack_require__(1).PropTypes.number,
	    y: __webpack_require__(1).PropTypes.number,
	    width: __webpack_require__(1).PropTypes.number,
	    height: __webpack_require__(1).PropTypes.number
	  })
	});
	
	var FixedDimensionResourceCard = function (_Component) {
	  _inherits(FixedDimensionResourceCard, _Component);
	
	  function FixedDimensionResourceCard(props) {
	    _classCallCheck(this, FixedDimensionResourceCard);
	
	    var _this = _possibleConstructorReturn(this, (FixedDimensionResourceCard.__proto__ || Object.getPrototypeOf(FixedDimensionResourceCard)).call(this, props));
	
	    _this.onShowCrop = function () {
	      return _this.setState({ cropOpen: true });
	    };
	
	    _this.onHideCrop = function () {
	      return _this.setState({ cropOpen: false });
	    };
	
	    _this.onResourceCrop = function (crop) {
	      var _this$props = _this.props,
	          resource = _this$props.resource,
	          config = _this$props.config;
	
	      if (!resource) {
	        console.warn('Trying to crop image without source');
	        return;
	      }
	
	      _this.setState({
	        cropOpen: false
	      }, function () {
	        return _this.props.onConfigChanged(Object.assign({}, config, crop));
	      });
	    };
	
	    _this.onAlignChanged = function (_, _ref) {
	      var align = _ref.value;
	      return _this.props.onConfigChanged(Object.assign({}, _this.props.config, {
	        align: align
	      }));
	    };
	
	    _this.onColorChanged = function (value) {
	      return _this.props.onConfigChanged(Object.assign({}, _this.props.config, {
	        color: value.hex
	      }));
	    };
	
	    _this.state = {
	      cropOpen: false
	    };
	    return _this;
	  }
	
	  _createClass(FixedDimensionResourceCard, [{
	    key: 'renderDimmer',
	    value: function renderDimmer() {
	      var resource = this.props.resource;
	
	
	      return _react2.default.createElement(
	        _ResourceDimmer2.default,
	        { resource: resource },
	        _react2.default.createElement(
	          _semanticUiReact.Button,
	          {
	            type: 'button',
	            primary: true,
	            icon: true,
	            labelPosition: 'right',
	            onClick: this.onShowCrop
	          },
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'crop' }),
	          'Redimensionner'
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          resource = _props.resource,
	          config = _props.config,
	          onSelected = _props.onSelected,
	          onDeleted = _props.onDeleted;
	      var cropOpen = this.state.cropOpen;
	
	
	      var fieldDisabled = !resource;
	
	      return _react2.default.createElement(
	        _semanticUiReact.Grid,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Row,
	          { columns: 2, divided: true },
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Header,
	              { as: 'h3', textAlign: 'center' },
	              'Image Cible'
	            ),
	            _react2.default.createElement(
	              _ResourceCard2.default,
	              {
	                resourceType: 'image',
	                resource: resource,
	                onSelected: onSelected,
	                onDeleted: onDeleted
	              },
	              this.renderDimmer()
	            ),
	            resource && _react2.default.createElement(_ImageCrop2.default, {
	              open: cropOpen,
	              fullWidth: config.fullWidth,
	              fullHeight: config.fullHeight,
	              onClose: this.onHideCrop,
	              config: config,
	              image: (0, _resources2.getImage)(resource, 'xhdpi_2x'),
	              onComplete: this.onResourceCrop
	            })
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Header,
	              { as: 'h3', textAlign: 'center' },
	              'Configuration'
	            ),
	            _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	            _react2.default.createElement(
	              _semanticUiReact.Form,
	              null,
	              config.fullWidth && _react2.default.createElement(_semanticUiReact.Form.Select, {
	                value: config.align,
	                onChange: this.onAlignChanged,
	                disabled: fieldDisabled,
	                label: 'Alignement horizontal',
	                name: 'horizontalAlign',
	                options: _resources.HORIZONTAL_ALIGNS
	              }),
	              config.fullHeight && _react2.default.createElement(_semanticUiReact.Form.Select, {
	                value: config.align,
	                onChange: this.onAlignChanged,
	                disabled: fieldDisabled,
	                label: 'Alignement vertical',
	                name: 'verticalAlign',
	                options: _resources.VERTICAL_ALIGNS
	              }),
	              _react2.default.createElement(
	                _semanticUiReact.Form.Field,
	                { disabled: fieldDisabled },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  'Couleur de remplissage'
	                ),
	                _react2.default.createElement(_reactColor.ChromePicker, {
	                  color: config.color,
	                  onChangeComplete: this.onColorChanged,
	                  disableAlpha: true
	                })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return FixedDimensionResourceCard;
	}(_react.Component);
	
	FixedDimensionResourceCard.propTypes = {
	  resource: __webpack_require__(1).PropTypes.any,
	  config: __webpack_require__(1).PropTypes.shape({
	    fullWidth: __webpack_require__(1).PropTypes.bool,
	    fullHeight: __webpack_require__(1).PropTypes.bool,
	    align: __webpack_require__(1).PropTypes.string.isRequired,
	    color: __webpack_require__(1).PropTypes.string.isRequired,
	    x: __webpack_require__(1).PropTypes.number,
	    y: __webpack_require__(1).PropTypes.number,
	    width: __webpack_require__(1).PropTypes.number,
	    height: __webpack_require__(1).PropTypes.number
	  }),
	  onSelected: __webpack_require__(1).PropTypes.func.isRequired,
	  onConfigChanged: __webpack_require__(1).PropTypes.func.isRequired,
	  onDeleted: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = FixedDimensionResourceCard;

/***/ },

/***/ 502:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IconHeader = function IconHeader(_ref) {
	  var icon = _ref.icon,
	      title = _ref.title,
	      _ref$circular = _ref.circular,
	      circular = _ref$circular === undefined ? false : _ref$circular;
	  return _react2.default.createElement(
	    'h4',
	    { className: 'ui center aligned icon header' },
	    _react2.default.createElement(_semanticUiReact.Icon, { name: icon, circular: true }),
	    title
	  );
	};
	
	IconHeader.propTypes = {
	  icon: __webpack_require__(1).PropTypes.string.isRequired,
	  circular: __webpack_require__(1).PropTypes.bool,
	  title: __webpack_require__(1).PropTypes.string.isRequired
	};
	exports.default = IconHeader;

/***/ },

/***/ 503:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PageLoader = function PageLoader(_ref) {
	  var _ref$message = _ref.message,
	      message = _ref$message === undefined ? 'Chargement...' : _ref$message;
	  return _react2.default.createElement(
	    'div',
	    { className: 'ui active page dimmer' },
	    _react2.default.createElement(
	      'div',
	      { className: 'content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'ui large text loader' },
	        message
	      )
	    )
	  );
	};
	
	PageLoader.propTypes = {
	  message: __webpack_require__(1).PropTypes.string
	};
	exports.default = PageLoader;

/***/ },

/***/ 504:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var HORIZONTAL_ALIGNS = exports.HORIZONTAL_ALIGNS = [{
	  text: 'Gauche',
	  value: 'left'
	}, {
	  text: 'Centre',
	  value: 'center'
	}, {
	  text: 'Droit',
	  value: 'right'
	}];
	
	var VERTICAL_ALIGNS = exports.VERTICAL_ALIGNS = [{
	  text: 'Haut',
	  value: 'top'
	}, {
	  text: 'Centre',
	  value: 'center'
	}, {
	  text: 'Bas',
	  value: 'bottom'
	}];

/***/ },

/***/ 505:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getFromInitialData = exports.getFromInitialData = function getFromInitialData(key, orElse) {
	  var data = __INITIAL_DATA__;
	  if (data && data[key]) return data[key];else return orElse;
	};

/***/ },

/***/ 506:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var DATA_URL_REGEX = /^\s*data:([a-z]+\/[a-z0-9-+.]+(;[a-z-]+=[a-z0-9-]+)?)?(;base64)?,([a-z0-9!$&',()*+;=\-._~:@/?%\s]*)\s*$/i;
	
	// Remove data URLs
	var purify = exports.purify = function purify(name, val) {
	  if (typeof val === 'string' && val.match(DATA_URL_REGEX)) {
	    // Filtering out data urls
	    return undefined;
	  }
	
	  return val;
	};

/***/ },

/***/ 507:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = configureStore;
	
	var _redux = __webpack_require__(33);
	
	var _reduxSaga = __webpack_require__(138);
	
	var _reduxSaga2 = _interopRequireDefault(_reduxSaga);
	
	var _middleware = __webpack_require__(314);
	
	var _middleware2 = _interopRequireDefault(_middleware);
	
	var _redux2 = __webpack_require__(322);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var sagaMiddleware = (0, _reduxSaga2.default)();
	var ravenMiddleware = (0, _middleware2.default)();
	
	function configureStore(rootReducer, rootSaga) {
	  var otherMiddlewares = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	  var middlewares = [sagaMiddleware].concat(_toConsumableArray(otherMiddlewares), [ravenMiddleware]);
	
	  (0, _redux2.appendLoggerMiddlewareInDev)(middlewares);
	
	  var enhancers = [_redux.applyMiddleware.apply(undefined, _toConsumableArray(middlewares))];
	
	  // If Redux DevTools Extension is installed use it, otherwise use Redux compose
	  var composeEnhancers =  false ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : _redux.compose;
	
	  var store = (0, _redux.createStore)(rootReducer, composeEnhancers.apply(undefined, enhancers));
	  sagaMiddleware.run(rootSaga);
	
	  return store;
	}

/***/ },

/***/ 508:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(58);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.makeRestartable = makeRestartable;
	
	var _effects = __webpack_require__(51);
	
	var _reduxSaga = __webpack_require__(138);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function makeRestartable(saga) {
	  return _regenerator2.default.mark(function _callee2() {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            _context2.next = 2;
	            return (0, _effects.spawn)(_regenerator2.default.mark(function _callee() {
	              return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                  switch (_context.prev = _context.next) {
	                    case 0:
	                      if (false) {
	                        _context.next = 14;
	                        break;
	                      }
	
	                      _context.prev = 1;
	                      _context.next = 4;
	                      return (0, _effects.call)(saga);
	
	                    case 4:
	                      console.error('Unexpected root saga termination. The root sagas are supposed to be sagas that live during the whole app lifetime!', saga);
	                      _context.next = 10;
	                      break;
	
	                    case 7:
	                      _context.prev = 7;
	                      _context.t0 = _context['catch'](1);
	
	                      console.error('Saga error, the saga will be restarted', _context.t0);
	
	                    case 10:
	                      _context.next = 12;
	                      return (0, _reduxSaga.delay)(1000);
	
	                    case 12:
	                      _context.next = 0;
	                      break;
	
	                    case 14:
	                    case 'end':
	                      return _context.stop();
	                  }
	                }
	              }, _callee, this, [[1, 7]]);
	            }));
	
	          case 2:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, this);
	  });
	}

/***/ },

/***/ 509:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchThumbnail = exports.idToUrl = exports.tryExtractId = exports.THUMBNAIL_THROTTLE_MILLIS = exports.YOUTUBE_REGEX = undefined;
	
	var _fetch = __webpack_require__(32);
	
	var YOUTUBE_REGEX = exports.YOUTUBE_REGEX = /(?:youtube\.com\/\S*(?:(?:\/e(?:mbed))?\/|watch\/?\?(?:\S*?&?v=))|youtu\.be\/)([a-zA-Z0-9_-]*)/;
	var THUMBNAIL_THROTTLE_MILLIS = exports.THUMBNAIL_THROTTLE_MILLIS = 3000;
	
	var tryExtractId = exports.tryExtractId = function tryExtractId(value) {
	  var match = value.match(YOUTUBE_REGEX);
	
	  if (match && match[1]) {
	    return match[1];
	  }
	
	  return null;
	};
	
	var idToUrl = exports.idToUrl = function idToUrl(id) {
	  return id ? 'https://www.youtube.com/watch?v=' + id : '';
	};
	
	var fetchThumbnail = exports.fetchThumbnail = function fetchThumbnail(id) {
	  return (0, _fetch.fetchJson)('/youtube/videos/' + id).then(function (video) {
	    return {
	      video: video
	    };
	  });
	};

/***/ },

/***/ 842:
/***/ function(module, exports, __webpack_require__) {

	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(1637).enable();
	  window.Promise = __webpack_require__(1636);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(2053);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(17);


/***/ },

/***/ 870:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1079);
	
	__webpack_require__(1401);
	
	var _raven = __webpack_require__(1059);
	
	var _raven2 = _interopRequireDefault(_raven);
	
	var _semantic = __webpack_require__(1061);
	
	var _semantic2 = _interopRequireDefault(_semantic);
	
	var _router = __webpack_require__(1060);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _plugins = __webpack_require__(1053);
	
	var _plugins2 = _interopRequireDefault(_plugins);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Enabling Raven error capturing
	// Needed for redux-saga es6 generator support
	(0, _raven2.default)();
	
	// Enabling Semantic UI components
	
	
	// Import CSS reset and Global Styles
	(0, _semantic2.default)();
	
	// Loading plugins
	(0, _plugins2.default)();
	
	// Hooking router
	(0, _router2.default)();

/***/ },

/***/ 871:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.index = undefined;
	
	var _jquery = __webpack_require__(16);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _moment = __webpack_require__(134);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var index = exports.index = function index() {
	  var $form = (0, _jquery2.default)('form.search');
	
	  // Enabling calendar on search form
	  $form.find('.ui.calendar').calendarFr({
	    type: 'date',
	    parser: {
	      date: function date(text, settings) {
	        return (0, _moment2.default)(text, 'DD/MM/YYYY').toDate();
	      }
	    },
	    formatter: {
	      datetime: function datetime(date) {
	        if (!date) {
	          return '';
	        }
	
	        return (0, _moment2.default)(date).format('DD/MM/YYYY');
	      }
	    },
	    onChange: function onChange(date) {
	      $form.find('input[name="date"]').val((0, _moment2.default)(date).format('DD/MM/YYYY'));
	      $form.submit();
	    }
	  });
	};

/***/ },

/***/ 872:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.remove = exports.update = exports.save = exports.fetch = undefined;
	
	var _fetch = __webpack_require__(32);
	
	var _fetch2 = _interopRequireDefault(_fetch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fetch = exports.fetch = function fetch() {
	  return (0, _fetch.fetchJson)('/bucket/folders.json');
	};
	
	var save = exports.save = function save(name) {
	  return (0, _fetch.postJson)('/bucket/folders.json', {
	    name: name
	  });
	};
	
	var update = exports.update = function update(folder) {
	  return (0, _fetch.putJson)('/bucket/folders.json/' + folder.id, folder);
	};
	
	var remove = exports.remove = function remove(folderId) {
	  return (0, _fetch2.default)('/bucket/folders.json/' + folderId, {
	    method: 'DELETE'
	  });
	};

/***/ },

/***/ 873:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.folders = exports.folder = undefined;
	
	var _normalizr = __webpack_require__(201);
	
	var folder = exports.folder = new _normalizr.Schema('folders');
	var resource = new _normalizr.Schema('resources');
	
	folder.define({
	  resources: (0, _normalizr.arrayOf)(resource)
	});
	
	var folders = exports.folders = (0, _normalizr.arrayOf)(folder);

/***/ },

/***/ 874:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.crop = exports.upload = undefined;
	
	var _fetch = __webpack_require__(32);
	
	var _fetch2 = _interopRequireDefault(_fetch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var upload = exports.upload = function upload(folderId, file) {
	  var data = new FormData();
	  data.append('attachment', file);
	
	  return (0, _fetch2.default)('/bucket/folders.json/' + folderId + '/upload', {
	    method: 'POST',
	    body: data
	  }).then(function (res) {
	    return res.json();
	  });
	};
	
	var crop = exports.crop = function crop(folderId, resourceId, config) {
	  return (0, _fetch2.default)('/bucket/folders.json/' + folderId + '/crop/' + resourceId, {
	    method: 'POST',
	    headers: {
	      'Content-Type': 'application/json'
	    },
	    body: JSON.stringify(config)
	  }).then(function (res) {
	    return res.json();
	  });
	};

/***/ },

/***/ 875:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _App = __webpack_require__(882);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Root = function (_Component) {
	  _inherits(Root, _Component);
	
	  function Root() {
	    _classCallCheck(this, Root);
	
	    return _possibleConstructorReturn(this, (Root.__proto__ || Object.getPrototypeOf(Root)).apply(this, arguments));
	  }
	
	  _createClass(Root, [{
	    key: 'render',
	    value: function render() {
	      var store = this.props.store;
	
	      return _react2.default.createElement(
	        _reactRedux.Provider,
	        { store: store },
	        _react2.default.createElement(_App2.default, null)
	      );
	    }
	  }]);
	
	  return Root;
	}(_react.Component);
	
	exports.default = Root;

/***/ },

/***/ 876:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.index = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(38);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactHotLoader = __webpack_require__(699);
	
	var _store = __webpack_require__(903);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _Root = __webpack_require__(875);
	
	var _Root2 = _interopRequireDefault(_Root);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var index = exports.index = function index() {
	  var root = document.getElementById('root');
	
	  var store = (0, _store2.default)();
	  var render = function render(App) {
	    _reactDom2.default.render(_react2.default.createElement(
	      _reactHotLoader.AppContainer,
	      null,
	      _react2.default.createElement(App, { store: store })
	    ), root);
	  };
	
	  render(_Root2.default);
	
	  // Hot Module Replacement API
	  if (false) {
	    module.hot.accept('./containers/Root', function () {
	      var NextRoot = require('./containers/Root').default;
	      render(NextRoot);
	    });
	  }
	};

/***/ },

/***/ 877:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var isRunning = exports.isRunning = function isRunning(upload) {
	  return upload.state === 'processing' || upload.state === 'uploading';
	};

/***/ },

/***/ 878:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(58);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = root;
	
	var _effects = __webpack_require__(51);
	
	var _normalizr = __webpack_require__(201);
	
	var _folders = __webpack_require__(208);
	
	var ActionTypes = _interopRequireWildcard(_folders);
	
	var _folders2 = __webpack_require__(872);
	
	var Api = _interopRequireWildcard(_folders2);
	
	var _schema = __webpack_require__(873);
	
	var Schema = _interopRequireWildcard(_schema);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [fetchFolders, saveFolder, updateFolder, removeFolder, root].map(_regenerator2.default.mark);
	
	function fetchFolders() {
	  var response;
	  return _regenerator2.default.wrap(function fetchFolders$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.prev = 0;
	          _context.next = 3;
	          return (0, _effects.call)(Api.fetch);
	
	        case 3:
	          response = _context.sent;
	          _context.next = 6;
	          return (0, _effects.put)(ActionTypes.fetchFoldersSuccess((0, _normalizr.normalize)(response, Schema.folders)));
	
	        case 6:
	          _context.next = 12;
	          break;
	
	        case 8:
	          _context.prev = 8;
	          _context.t0 = _context['catch'](0);
	          _context.next = 12;
	          return (0, _effects.put)(ActionTypes.fetchFoldersFailure(_context.t0));
	
	        case 12:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this, [[0, 8]]);
	}
	
	function saveFolder(_ref) {
	  var name = _ref.name;
	  var response;
	  return _regenerator2.default.wrap(function saveFolder$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.call)(Api.save, name);
	
	        case 2:
	          response = _context2.sent;
	          _context2.next = 5;
	          return (0, _effects.put)(ActionTypes.saveFolderSuccess((0, _normalizr.normalize)(response, Schema.folder)));
	
	        case 5:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}
	
	function updateFolder(_ref2) {
	  var folder = _ref2.folder;
	  var response;
	  return _regenerator2.default.wrap(function updateFolder$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.call)(Api.update, folder);
	
	        case 2:
	          response = _context3.sent;
	          _context3.next = 5;
	          return (0, _effects.put)(ActionTypes.updateFolderSuccess((0, _normalizr.normalize)(response, Schema.folder)));
	
	        case 5:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}
	
	function removeFolder(_ref3) {
	  var folder = _ref3.folder;
	  return _regenerator2.default.wrap(function removeFolder$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return (0, _effects.call)(Api.remove, folder.id);
	
	        case 2:
	          _context4.next = 4;
	          return (0, _effects.put)(ActionTypes.removeFolderSuccess(folder.id));
	
	        case 4:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked[3], this);
	}
	
	function root() {
	  return _regenerator2.default.wrap(function root$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.next = 2;
	          return [(0, _effects.takeLatest)('FETCH_FOLDERS', fetchFolders), (0, _effects.takeEvery)('SAVE_FOLDER', saveFolder), (0, _effects.takeEvery)('UPDATE_FOLDER', updateFolder), (0, _effects.takeEvery)('REMOVE_FOLDER', removeFolder)];
	
	        case 2:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked[4], this);
	}

/***/ },

/***/ 879:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(58);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = root;
	
	var _effects = __webpack_require__(51);
	
	var _saga = __webpack_require__(508);
	
	var _folders = __webpack_require__(878);
	
	var _folders2 = _interopRequireDefault(_folders);
	
	var _uploads = __webpack_require__(881);
	
	var _uploads2 = _interopRequireDefault(_uploads);
	
	var _resources = __webpack_require__(880);
	
	var _resources2 = _interopRequireDefault(_resources);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [root].map(_regenerator2.default.mark);
	
	var rootSagas = [_folders2.default, _uploads2.default, _resources2.default].map(_saga.makeRestartable);
	
	function root() {
	  return _regenerator2.default.wrap(function root$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return rootSagas.map(function (saga) {
	            return (0, _effects.call)(saga);
	          });
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}

/***/ },

/***/ 880:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(58);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = root;
	
	var _reduxSaga = __webpack_require__(138);
	
	var _effects = __webpack_require__(51);
	
	var _resources = __webpack_require__(476);
	
	var Api = _interopRequireWildcard(_resources);
	
	var _resources2 = __webpack_require__(475);
	
	var ActionTypes = _interopRequireWildcard(_resources2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [updateResource, removeResource, root].map(_regenerator2.default.mark);
	
	function updateResource(_ref) {
	  var resource = _ref.resource;
	  return _regenerator2.default.wrap(function updateResource$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.call)(_reduxSaga.delay, 1000);
	
	        case 2:
	          _context.next = 4;
	          return (0, _effects.call)(Api.update, resource);
	
	        case 4:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	function removeResource(_ref2) {
	  var resource = _ref2.resource;
	  return _regenerator2.default.wrap(function removeResource$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.call)(Api.remove, resource.id);
	
	        case 2:
	          _context2.next = 4;
	          return (0, _effects.put)(ActionTypes.removeResourceSuccess(resource.id));
	
	        case 4:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}
	
	function root() {
	  return _regenerator2.default.wrap(function root$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return [(0, _effects.takeLatest)('UPDATE_RESOURCE', updateResource), (0, _effects.takeEvery)('REMOVE_RESOURCE', removeResource)];
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}

/***/ },

/***/ 881:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(58);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = root;
	
	var _reduxSaga = __webpack_require__(138);
	
	var _effects = __webpack_require__(51);
	
	var _uploads = __webpack_require__(171);
	
	var _constants = __webpack_require__(301);
	
	var _uploads2 = __webpack_require__(874);
	
	var Api = _interopRequireWildcard(_uploads2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [watchUploads, addPendingUpload, addPendingCrop, cancelPending, handleUpload, root].map(_regenerator2.default.mark);
	
	var INIT_BUFFER_SIZE = 20;
	
	// We don't fear overflow here, so using expanding buffer is not dangerous
	var createUploadChannel = function createUploadChannel() {
	  return (0, _reduxSaga.channel)(_reduxSaga.buffers.expanding(INIT_BUFFER_SIZE));
	};
	
	function watchUploads() {
	  var chan, i;
	  return _regenerator2.default.wrap(function watchUploads$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.call)(createUploadChannel);
	
	        case 2:
	          chan = _context.sent;
	          i = 0;
	
	        case 4:
	          if (!(i < _constants.MAX_CONCURRENT_UPLOADS)) {
	            _context.next = 10;
	            break;
	          }
	
	          _context.next = 7;
	          return (0, _effects.fork)(handleUpload, chan);
	
	        case 7:
	          i++;
	          _context.next = 4;
	          break;
	
	        case 10:
	          _context.next = 12;
	          return (0, _effects.takeEvery)(_uploads.UPLOAD_FILE, addPendingUpload, chan);
	
	        case 12:
	          _context.next = 14;
	          return (0, _effects.takeEvery)(_uploads.CROP_RESOURCE, addPendingCrop, chan);
	
	        case 14:
	          _context.next = 16;
	          return (0, _effects.takeLatest)(_uploads.CANCEL_PENDING, cancelPending, chan);
	
	        case 16:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	function addPendingUpload(chan, upload) {
	  return _regenerator2.default.wrap(function addPendingUpload$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.put)(chan, upload);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}
	
	function addPendingCrop(chan, crop) {
	  return _regenerator2.default.wrap(function addPendingCrop$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.put)(chan, crop);
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}
	
	function cancelPending(chan) {
	  return _regenerator2.default.wrap(function cancelPending$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return (0, _effects.flush)(chan);
	
	        case 2:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked[3], this);
	}
	
	function handleUpload(chan) {
	  var _ref, folder, upload, resource, crop, response;
	
	  return _regenerator2.default.wrap(function handleUpload$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          if (false) {
	            _context5.next = 31;
	            break;
	          }
	
	          _context5.next = 3;
	          return (0, _effects.take)(chan);
	
	        case 3:
	          _ref = _context5.sent;
	          folder = _ref.folder;
	          upload = _ref.upload;
	          resource = _ref.resource;
	          crop = _ref.crop;
	          _context5.prev = 8;
	          _context5.next = 11;
	          return (0, _effects.put)((0, _uploads.uploadingFile)(folder, upload));
	
	        case 11:
	          response = void 0;
	
	          if (!crop) {
	            _context5.next = 18;
	            break;
	          }
	
	          _context5.next = 15;
	          return (0, _effects.call)(Api.crop, folder.id, resource.id, crop);
	
	        case 15:
	          response = _context5.sent;
	          _context5.next = 21;
	          break;
	
	        case 18:
	          _context5.next = 20;
	          return (0, _effects.call)(Api.upload, folder.id, upload.file);
	
	        case 20:
	          response = _context5.sent;
	
	        case 21:
	          _context5.next = 23;
	          return (0, _effects.put)((0, _uploads.uploadFileSuccess)(folder, upload, response));
	
	        case 23:
	          _context5.next = 29;
	          break;
	
	        case 25:
	          _context5.prev = 25;
	          _context5.t0 = _context5['catch'](8);
	          _context5.next = 29;
	          return (0, _effects.put)((0, _uploads.uploadFileFailure)(folder, upload, _context5.t0));
	
	        case 29:
	          _context5.next = 0;
	          break;
	
	        case 31:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked[4], this, [[8, 25]]);
	}
	
	function root() {
	  return _regenerator2.default.wrap(function root$(_context6) {
	    while (1) {
	      switch (_context6.prev = _context6.next) {
	        case 0:
	          _context6.next = 2;
	          return [(0, _effects.fork)(watchUploads)];
	
	        case 2:
	        case 'end':
	          return _context6.stop();
	      }
	    }
	  }, _marked[5], this);
	}

/***/ },

/***/ 882:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(31);
	
	var _reactRedux = __webpack_require__(14);
	
	var _folders = __webpack_require__(172);
	
	var _folders2 = __webpack_require__(208);
	
	var FoldersActions = _interopRequireWildcard(_folders2);
	
	var _PageLoader = __webpack_require__(503);
	
	var _PageLoader2 = _interopRequireDefault(_PageLoader);
	
	var _IconHeader = __webpack_require__(502);
	
	var _IconHeader2 = _interopRequireDefault(_IconHeader);
	
	var _Folders = __webpack_require__(896);
	
	var _Folders2 = _interopRequireDefault(_Folders);
	
	var _Folder = __webpack_require__(891);
	
	var _Folder2 = _interopRequireDefault(_Folder);
	
	var _Upload = __webpack_require__(902);
	
	var _Upload2 = _interopRequireDefault(_Upload);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    isFetching: (0, _folders.getIsFetching)(state)
	  };
	};
	
	var App = function (_Component) {
	  _inherits(App, _Component);
	
	  function App() {
	    _classCallCheck(this, App);
	
	    return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
	  }
	
	  _createClass(App, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.fetchFolders();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var isFetching = this.props.isFetching;
	
	
	      if (isFetching) {
	        return _react2.default.createElement(_PageLoader2.default, null);
	      }
	
	      return _react2.default.createElement(
	        _reactRouterDom.BrowserRouter,
	        { basename: '/bucket' },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_IconHeader2.default, {
	            icon: 'photo',
	            circular: true,
	            title: 'Arborescence des ressources'
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: 'ui grid' },
	            _react2.default.createElement(
	              'div',
	              { className: 'twelve wide column' },
	              _react2.default.createElement(
	                _reactRouterDom.Switch,
	                null,
	                _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/', component: _Folders2.default }),
	                _react2.default.createElement(_reactRouterDom.Route, { path: '/folders/:id', component: _Folder2.default })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'four wide column' },
	              _react2.default.createElement(_Upload2.default, null)
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return App;
	}(_react.Component);
	
	App.propTypes = {
	  isFetching: __webpack_require__(1).PropTypes.bool.isRequired,
	  fetchFolders: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  fetchFolders: FoldersActions.fetchFolders
	})(App);

/***/ },

/***/ 883:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FolderForm = function (_Component) {
	  _inherits(FolderForm, _Component);
	
	  function FolderForm(props) {
	    _classCallCheck(this, FolderForm);
	
	    var _this = _possibleConstructorReturn(this, (FolderForm.__proto__ || Object.getPrototypeOf(FolderForm)).call(this, props));
	
	    _this.onNameChange = function (event) {
	      if (event.target instanceof HTMLInputElement) {
	        _this.setState({
	          name: event.target.value
	        });
	      }
	    };
	
	    _this.onFormSubmit = function (event) {
	      var _this$props = _this.props,
	          folder = _this$props.folder,
	          onChange = _this$props.onChange;
	      var name = _this.state.name;
	
	
	      event.preventDefault();
	
	      if (name && name.length > 0) {
	        onChange(Object.assign({}, folder, {
	          name: name
	        }));
	      }
	    };
	
	    _this.state = {
	      name: props.folder.name
	    };
	    return _this;
	  }
	
	  _createClass(FolderForm, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.folder !== this.props.folder) {
	        this.setState({
	          name: nextProps.folder.name
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var isUpdating = this.props.isUpdating;
	      var name = this.state.name;
	
	
	      return _react2.default.createElement(
	        _semanticUiReact.Segment,
	        { attached: 'top' },
	        _react2.default.createElement(
	          _semanticUiReact.Form,
	          { onSubmit: this.onFormSubmit },
	          _react2.default.createElement(
	            _semanticUiReact.Grid,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 12 },
	              _react2.default.createElement(
	                _semanticUiReact.Form.Field,
	                { inline: true },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  'Nom'
	                ),
	                _react2.default.createElement(_semanticUiReact.Input, {
	                  name: 'name',
	                  value: name,
	                  style: { width: '91%' },
	                  onChange: this.onNameChange
	                })
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 4 },
	              _react2.default.createElement(_semanticUiReact.Button, {
	                loading: isUpdating,
	                disabled: name.length === 0,
	                type: 'submit',
	                primary: true,
	                content: 'Enregistrer',
	                icon: 'save',
	                floated: 'right'
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return FolderForm;
	}(_react.Component);
	
	FolderForm.propTypes = {
	  folder: __webpack_require__(1).PropTypes.any.isRequired,
	  onChange: __webpack_require__(1).PropTypes.func.isRequired,
	  isUpdating: __webpack_require__(1).PropTypes.bool.isRequired
	};
	exports.default = FolderForm;

/***/ },

/***/ 884:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(31);
	
	var _semanticUiReact = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  input: {
	    width: '200px'
	  }
	};
	
	var FolderHeader = function FolderHeader(_ref) {
	  var folder = _ref.folder,
	      history = _ref.history,
	      onSearch = _ref.onSearch;
	
	  var search = function search(event) {
	    if (event.target instanceof HTMLInputElement) {
	      onSearch(event.target.value);
	    }
	  };
	
	  var goBack = function goBack() {
	    return history.goBack();
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'ui secondary menu segment actions' },
	    _react2.default.createElement(
	      _semanticUiReact.Menu.Item,
	      null,
	      _react2.default.createElement(_semanticUiReact.Button, {
	        onClick: goBack,
	        basic: true,
	        labelPosition: 'left',
	        icon: 'chevron circle left',
	        content: 'Retour \xE0 la liste'
	      })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Menu.Menu,
	      { position: 'right' },
	      _react2.default.createElement(
	        _semanticUiReact.Menu.Item,
	        null,
	        _react2.default.createElement(_semanticUiReact.Input, {
	          style: styles.input,
	          fluid: true,
	          onChange: search,
	          icon: 'search',
	          iconPosition: 'left',
	          placeholder: 'Recherche...'
	        })
	      )
	    )
	  );
	};
	
	FolderHeader.propTypes = {
	  folder: __webpack_require__(1).PropTypes.any.isRequired,
	  history: __webpack_require__(1).PropTypes.object.isRequired,
	  onSearch: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = (0, _reactRouterDom.withRouter)(FolderHeader);

/***/ },

/***/ 885:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ResourceItem = __webpack_require__(886);
	
	var _ResourceItem2 = _interopRequireDefault(_ResourceItem);
	
	var _constants = __webpack_require__(301);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _semanticUiReact = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getCardsNumberByCategory = function getCardsNumberByCategory(category) {
	  switch (category) {
	    case _constants.ResourceTypes.IMAGE:
	    case _constants.ResourceTypes.PDF:
	      return 'three';
	    case _constants.ResourceTypes.VIDEO:
	      return 'two';
	    default:
	      return 'three';
	  }
	};
	
	var getCardsClass = function getCardsClass(category) {
	  return (0, _classnames2.default)('ui cards', getCardsNumberByCategory(category));
	};
	
	var ResourceCategory = function ResourceCategory(_ref) {
	  var category = _ref.category,
	      resources = _ref.resources,
	      onUpdateResource = _ref.onUpdateResource,
	      onCropResource = _ref.onCropResource,
	      onRemoveResource = _ref.onRemoveResource,
	      isRemovingResource = _ref.isRemovingResource;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h2',
	      { className: 'ui header' },
	      (0, _constants.getResourceTypeLabelPlural)(category)
	    ),
	    _react2.default.createElement(_semanticUiReact.Divider, null),
	    _react2.default.createElement(
	      'div',
	      { className: getCardsClass(category) },
	      resources.map(function (r) {
	        return _react2.default.createElement(_ResourceItem2.default, {
	          key: r.id,
	          resource: r,
	          resources: resources,
	          onUpdate: onUpdateResource,
	          onCrop: onCropResource,
	          onRemove: onRemoveResource,
	          isRemoving: isRemovingResource
	        });
	      })
	    ),
	    _react2.default.createElement(_semanticUiReact.Divider, { hidden: true })
	  );
	};
	
	ResourceCategory.propTypes = {
	  category: __webpack_require__(1).PropTypes.any.isRequired,
	  resources: __webpack_require__(1).PropTypes.arrayOf(__webpack_require__(1).PropTypes.any).isRequired,
	  onUpdateResource: __webpack_require__(1).PropTypes.func.isRequired,
	  onCropResource: __webpack_require__(1).PropTypes.func.isRequired,
	  onRemoveResource: __webpack_require__(1).PropTypes.func.isRequired,
	  isRemovingResource: __webpack_require__(1).PropTypes.bool.isRequired
	};
	exports.default = ResourceCategory;

/***/ },

/***/ 886:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _Image = __webpack_require__(888);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Pdf = __webpack_require__(889);
	
	var _Pdf2 = _interopRequireDefault(_Pdf);
	
	var _Video = __webpack_require__(890);
	
	var _Video2 = _interopRequireDefault(_Video);
	
	var _constants = __webpack_require__(301);
	
	var _ConfirmDeleteButton = __webpack_require__(315);
	
	var _ConfirmDeleteButton2 = _interopRequireDefault(_ConfirmDeleteButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResourceItem = function ResourceItem(_ref) {
	  var resources = _ref.resources,
	      resource = _ref.resource,
	      onUpdate = _ref.onUpdate,
	      onRemove = _ref.onRemove,
	      isRemoving = _ref.isRemoving,
	      onCrop = _ref.onCrop;
	
	  var nameChanged = function nameChanged(_, _ref2) {
	    var value = _ref2.value;
	    return onUpdate(Object.assign({}, resource, {
	      name: value
	    }));
	  };
	
	  var remove = function remove() {
	    return onRemove(resource);
	  };
	
	  var renderContent = function renderContent() {
	    switch (resource.type.category) {
	      case _constants.ResourceTypes.IMAGE:
	        return _react2.default.createElement(_Image2.default, { resource: resource, resources: resources, onCrop: onCrop });
	      case _constants.ResourceTypes.PDF:
	        return _react2.default.createElement(_Pdf2.default, { resource: resource });
	      case _constants.ResourceTypes.VIDEO:
	        return _react2.default.createElement(_Video2.default, { resource: resource });
	      default:
	        console.warn('Unknown resource category ' + resource.type.category);
	        return null;
	    }
	  };
	
	  var deleteModalContent = '\n    \xCAtes-vous s\xFBre de vouloir supprimer cette ressource ?\n  ';
	
	  return _react2.default.createElement(
	    _semanticUiReact.Card,
	    null,
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      { extra: true },
	      _react2.default.createElement(_semanticUiReact.Input, { fluid: true, value: resource.name, onChange: nameChanged })
	    ),
	    renderContent(),
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      { extra: true },
	      _react2.default.createElement(_ConfirmDeleteButton2.default, {
	        content: 'Supprimer',
	        modalContent: deleteModalContent,
	        isLoading: isRemoving,
	        className: 'basic fluid red',
	        onConfirm: remove
	      })
	    )
	  );
	};
	
	ResourceItem.propTypes = {
	  resources: __webpack_require__(1).PropTypes.arrayOf(__webpack_require__(1).PropTypes.any).isRequired,
	  resource: __webpack_require__(1).PropTypes.any.isRequired,
	  onUpdate: __webpack_require__(1).PropTypes.func.isRequired,
	  onCrop: __webpack_require__(1).PropTypes.func.isRequired,
	  onRemove: __webpack_require__(1).PropTypes.func.isRequired,
	  isRemoving: __webpack_require__(1).PropTypes.bool.isRequired
	};
	exports.default = ResourceItem;

/***/ },

/***/ 887:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _ResourceCategory = __webpack_require__(885);
	
	var _ResourceCategory2 = _interopRequireDefault(_ResourceCategory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResourceList = function ResourceList(_ref) {
	  var resources = _ref.resources,
	      onUpdateResource = _ref.onUpdateResource,
	      onCropResource = _ref.onCropResource,
	      onRemoveResource = _ref.onRemoveResource,
	      isRemovingResource = _ref.isRemovingResource;
	
	  var renderContent = function renderContent() {
	    if (resources && resources.size) {
	      // Grouping resources  by category
	      return resources.groupBy(function (r) {
	        return r.type.category;
	      }).map(function (resources, category) {
	        return _react2.default.createElement(_ResourceCategory2.default, {
	          key: category,
	          category: category,
	          resources: resources.toArray(),
	          onUpdateResource: onUpdateResource,
	          onCropResource: onCropResource,
	          onRemoveResource: onRemoveResource,
	          isRemovingResource: isRemovingResource
	        });
	      }).toList();
	    }
	
	    return _react2.default.createElement(_semanticUiReact.Message, {
	      icon: 'info circle',
	      header: 'Aucune ressource associ\xE9e \xE0 ce dossier'
	    });
	  };
	
	  return _react2.default.createElement(
	    _semanticUiReact.Segment,
	    { attached: 'bottom' },
	    renderContent()
	  );
	};
	
	ResourceList.propTypes = {
	  resources: __webpack_require__(1).PropTypes.any.isRequired,
	  onUpdateResource: __webpack_require__(1).PropTypes.func.isRequired,
	  onCropResource: __webpack_require__(1).PropTypes.func.isRequired,
	  onRemoveResource: __webpack_require__(1).PropTypes.func.isRequired,
	  isRemovingResource: __webpack_require__(1).PropTypes.bool.isRequired
	};
	exports.default = ResourceList;

/***/ },

/***/ 888:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _ResourceDimmer = __webpack_require__(176);
	
	var _ResourceDimmer2 = _interopRequireDefault(_ResourceDimmer);
	
	var _ResourcesGallery = __webpack_require__(1074);
	
	var _ResourcesGallery2 = _interopRequireDefault(_ResourcesGallery);
	
	var _ImageCrop = __webpack_require__(174);
	
	var _ImageCrop2 = _interopRequireDefault(_ImageCrop);
	
	var _resources = __webpack_require__(114);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Image = function (_Component) {
	  _inherits(Image, _Component);
	
	  function Image(props) {
	    _classCallCheck(this, Image);
	
	    var _this = _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).call(this, props));
	
	    _this.showGallery = function () {
	      return _this.setState({ galleryOpen: true });
	    };
	
	    _this.hideGallery = function () {
	      return _this.setState({ galleryOpen: false });
	    };
	
	    _this.showCrop = function () {
	      return _this.setState({ cropOpen: true });
	    };
	
	    _this.hideCrop = function () {
	      return _this.setState({ cropOpen: false });
	    };
	
	    _this.onCropComplete = function (crop) {
	      var _this$props = _this.props,
	          resource = _this$props.resource,
	          onCrop = _this$props.onCrop;
	
	      onCrop(resource, crop);
	      _this.hideCrop();
	    };
	
	    _this.state = {
	      galleryOpen: false,
	      cropOpen: false
	    };
	    return _this;
	  }
	
	  _createClass(Image, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          resource = _props.resource,
	          resources = _props.resources;
	      var _state = this.state,
	          galleryOpen = _state.galleryOpen,
	          cropOpen = _state.cropOpen;
	
	
	      return _react2.default.createElement(
	        _ResourceDimmer2.default,
	        { resource: resource },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Button.Group,
	            { attached: 'top', basic: true, inverted: true, vertical: true },
	            _react2.default.createElement(_semanticUiReact.Button, { icon: 'play', content: 'Voir', onClick: this.showGallery }),
	            _react2.default.createElement(_semanticUiReact.Button, {
	              icon: 'crop',
	              content: 'Redimensionner',
	              onClick: this.showCrop
	            })
	          ),
	          _react2.default.createElement(_ImageCrop2.default, {
	            open: cropOpen,
	            image: (0, _resources.getImage)(resource, 'xhdpi_2x'),
	            onComplete: this.onCropComplete,
	            onClose: this.hideCrop
	          }),
	          _react2.default.createElement(_ResourcesGallery2.default, {
	            index: resources.indexOf(resource),
	            isOpen: galleryOpen,
	            resources: resources,
	            onClose: this.hideGallery
	          })
	        )
	      );
	    }
	  }]);
	
	  return Image;
	}(_react.Component);
	
	Image.propTypes = {
	  resources: __webpack_require__(1).PropTypes.arrayOf(__webpack_require__(1).PropTypes.any).isRequired,
	  resource: __webpack_require__(1).PropTypes.any.isRequired,
	  onCrop: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = Image;

/***/ },

/***/ 889:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ResourceDimmer = __webpack_require__(176);
	
	var _ResourceDimmer2 = _interopRequireDefault(_ResourceDimmer);
	
	var _semanticUiReact = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Pdf = function Pdf(_ref) {
	  var resource = _ref.resource;
	  return _react2.default.createElement(
	    _ResourceDimmer2.default,
	    { resource: resource },
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'a',
	        {
	          href: resource.url.original,
	          target: '_blank',
	          icon: 'file pdf outline',
	          className: 'ui labeled icon button'
	        },
	        _react2.default.createElement(_semanticUiReact.Icon, { name: 'file pdf outline' }),
	        'T\xE9l\xE9charger'
	      )
	    )
	  );
	};
	
	Pdf.propTypes = {
	  resource: __webpack_require__(1).PropTypes.any.isRequired
	};
	exports.default = Pdf;

/***/ },

/***/ 890:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ResourceVideo = __webpack_require__(1073);
	
	var _ResourceVideo2 = _interopRequireDefault(_ResourceVideo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Video = function Video(_ref) {
	  var resource = _ref.resource;
	  return _react2.default.createElement(
	    'div',
	    { className: 'content' },
	    _react2.default.createElement(_ResourceVideo2.default, { video: resource })
	  );
	};
	
	Video.propTypes = {
	  resource: __webpack_require__(1).PropTypes.any.isRequired
	};
	exports.default = Video;

/***/ },

/***/ 891:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _folders = __webpack_require__(172);
	
	var _resources = __webpack_require__(302);
	
	var _folders2 = __webpack_require__(208);
	
	var FoldersActions = _interopRequireWildcard(_folders2);
	
	var _resources2 = __webpack_require__(475);
	
	var ResourcesActions = _interopRequireWildcard(_resources2);
	
	var _uploads = __webpack_require__(171);
	
	var UploadActions = _interopRequireWildcard(_uploads);
	
	var _FolderHeader = __webpack_require__(884);
	
	var _FolderHeader2 = _interopRequireDefault(_FolderHeader);
	
	var _FolderForm = __webpack_require__(883);
	
	var _FolderForm2 = _interopRequireDefault(_FolderForm);
	
	var _ResourceList = __webpack_require__(887);
	
	var _ResourceList2 = _interopRequireDefault(_ResourceList);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, _ref) {
	  var match = _ref.match;
	  return {
	    folder: (0, _folders.getFolderById)(state, match.params.id),
	    isUpdating: (0, _folders.getIsUpdating)(state),
	    resources: (0, _resources.getResourcesByFolder)(state, match.params.id),
	    isRemovingResource: (0, _resources.getIsRemoving)(state)
	  };
	};
	
	var Folder = function Folder(_ref2) {
	  var folder = _ref2.folder,
	      resources = _ref2.resources,
	      updateFolder = _ref2.updateFolder,
	      isUpdating = _ref2.isUpdating,
	      filterResources = _ref2.filterResources,
	      updateResource = _ref2.updateResource,
	      cropResource = _ref2.cropResource,
	      removeResource = _ref2.removeResource,
	      isRemovingResource = _ref2.isRemovingResource;
	
	  if (folder) {
	    var onCropResource = function onCropResource(resource, crop) {
	      cropResource(folder, resource, crop);
	    };
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_FolderHeader2.default, { folder: folder, onSearch: filterResources }),
	      _react2.default.createElement(_FolderForm2.default, {
	        folder: folder,
	        isUpdating: isUpdating,
	        onChange: updateFolder
	      }),
	      _react2.default.createElement(_ResourceList2.default, {
	        resources: resources,
	        onUpdateResource: updateResource,
	        onCropResource: onCropResource,
	        onRemoveResource: removeResource,
	        isRemovingResource: isRemovingResource
	      })
	    );
	  }
	
	  return null;
	};
	
	Folder.propTypes = {
	  folder: __webpack_require__(1).PropTypes.any,
	  resources: __webpack_require__(1).PropTypes.any.isRequired,
	  updateFolder: __webpack_require__(1).PropTypes.func.isRequired,
	  isUpdating: __webpack_require__(1).PropTypes.bool.isRequired,
	  filterResources: __webpack_require__(1).PropTypes.func.isRequired,
	  updateResource: __webpack_require__(1).PropTypes.func.isRequired,
	  cropResource: __webpack_require__(1).PropTypes.func.isRequired,
	  removeResource: __webpack_require__(1).PropTypes.func.isRequired,
	  isRemovingResource: __webpack_require__(1).PropTypes.bool.isRequired
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  updateFolder: FoldersActions.updateFolder,
	  filterResources: ResourcesActions.filterResources,
	  updateResource: ResourcesActions.updateResource,
	  cropResource: UploadActions.cropResource,
	  removeResource: ResourcesActions.removeResource
	})(Folder);

/***/ },

/***/ 892:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UploadFileButton = __webpack_require__(895);
	
	var _UploadFileButton2 = _interopRequireDefault(_UploadFileButton);
	
	var _reactRouterDom = __webpack_require__(31);
	
	var _ConfirmDeleteButton = __webpack_require__(315);
	
	var _ConfirmDeleteButton2 = _interopRequireDefault(_ConfirmDeleteButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FolderItem = function FolderItem(_ref) {
	  var folder = _ref.folder,
	      resourcesCount = _ref.resourcesCount,
	      history = _ref.history,
	      onUpload = _ref.onUpload,
	      onRemove = _ref.onRemove,
	      isRemoving = _ref.isRemoving;
	
	  var uploadFiles = function uploadFiles(files) {
	    return onUpload(folder, files);
	  };
	  var navigateTo = function navigateTo() {
	    return history.push('folders/' + folder.id);
	  };
	  var remove = function remove() {
	    return onRemove(folder);
	  };
	
	  var deleteModalContent = '\n    \xCAtes-vous s\xFBr(e) de vouloir supprimer ce dossier\n    et ses ' + resourcesCount + ' ressource(s) ?\n  ';
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'ui card', onClick: navigateTo, style: { cursor: 'pointer' } },
	    _react2.default.createElement(
	      'div',
	      { className: 'content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'header' },
	        folder.name
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'two ui buttons' },
	        _react2.default.createElement(_UploadFileButton2.default, {
	          folder: folder,
	          onUpload: uploadFiles,
	          className: 'ui basic primary button'
	        }),
	        _react2.default.createElement(_ConfirmDeleteButton2.default, {
	          content: 'Supprimer',
	          modalContent: deleteModalContent,
	          className: 'basic red',
	          isLoading: isRemoving,
	          onConfirm: remove
	        })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'extra content' },
	      resourcesCount + ' Ressource(s)'
	    )
	  );
	};
	
	FolderItem.propTypes = {
	  folder: __webpack_require__(1).PropTypes.any.isRequired,
	  resourcesCount: __webpack_require__(1).PropTypes.number.isRequired,
	  history: __webpack_require__(1).PropTypes.object.isRequired,
	  onUpload: __webpack_require__(1).PropTypes.func.isRequired,
	  onRemove: __webpack_require__(1).PropTypes.func.isRequired,
	  isRemoving: __webpack_require__(1).PropTypes.bool.isRequired
	};
	exports.default = (0, _reactRouterDom.withRouter)(FolderItem);

/***/ },

/***/ 893:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FolderItem = __webpack_require__(892);
	
	var _FolderItem2 = _interopRequireDefault(_FolderItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FolderList = function FolderList(_ref) {
	  var folders = _ref.folders,
	      resourcesCountByFolder = _ref.resourcesCountByFolder,
	      onUploadFiles = _ref.onUploadFiles,
	      onRemove = _ref.onRemove,
	      isRemoving = _ref.isRemoving;
	
	  var resourcesCount = function resourcesCount(folder) {
	    return resourcesCountByFolder.get(folder) || 0;
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'ui three cards' },
	    folders.map(function (f) {
	      return _react2.default.createElement(_FolderItem2.default, {
	        key: f.id,
	        folder: f,
	        resourcesCount: resourcesCount(f.id),
	        onUpload: onUploadFiles,
	        onRemove: onRemove,
	        isRemoving: isRemoving
	      });
	    })
	  );
	};
	
	FolderList.propTypes = {
	  folders: __webpack_require__(1).PropTypes.any.isRequired,
	  resourcesCountByFolder: __webpack_require__(1).PropTypes.any.isRequired,
	  onUploadFiles: __webpack_require__(1).PropTypes.func.isRequired,
	  onRemove: __webpack_require__(1).PropTypes.func.isRequired,
	  isRemoving: __webpack_require__(1).PropTypes.bool.isRequired
	};
	exports.default = FolderList;

/***/ },

/***/ 894:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NewFolder = function (_Component) {
	  _inherits(NewFolder, _Component);
	
	  function NewFolder(props) {
	    _classCallCheck(this, NewFolder);
	
	    var _this = _possibleConstructorReturn(this, (NewFolder.__proto__ || Object.getPrototypeOf(NewFolder)).call(this, props));
	
	    _this.onChange = function (event) {
	      if (event.target instanceof HTMLInputElement) {
	        _this.setState({
	          name: event.target.value
	        });
	      }
	    };
	
	    _this.onSubmit = function () {
	      var name = _this.state.name;
	      var onSubmit = _this.props.onSubmit;
	
	
	      if (name) {
	        onSubmit(name);
	      }
	    };
	
	    _this.state = {
	      name: ''
	    };
	    return _this;
	  }
	
	  _createClass(NewFolder, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // Clearing component if submitted successfully
	      if (this.props.isSubmitting && !nextProps.isSubmitting) {
	        this.setState({
	          name: ''
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var isSubmitting = this.props.isSubmitting;
	      var name = this.state.name;
	
	
	      var buttonClass = (0, _classnames2.default)('ui right floated fluid primary labeled icon button', {
	        disabled: name.length < 1,
	        loading: isSubmitting
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ui fluid card' },
	        _react2.default.createElement(
	          'div',
	          { className: 'content' },
	          _react2.default.createElement(
	            'div',
	            { className: 'header' },
	            'Cr\xE9er un nouveau dossier'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'content' },
	          _react2.default.createElement(
	            'div',
	            { className: 'ui form' },
	            _react2.default.createElement(
	              'div',
	              { className: 'inline fields' },
	              _react2.default.createElement(
	                'div',
	                { className: 'twelve wide field' },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  'Nom'
	                ),
	                _react2.default.createElement('input', { type: 'text', value: name, onChange: this.onChange })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'four wide field' },
	                _react2.default.createElement(
	                  'button',
	                  { className: buttonClass, onClick: this.onSubmit },
	                  _react2.default.createElement('i', { className: 'add icon' }),
	                  'Ajouter'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return NewFolder;
	}(_react.Component);
	
	NewFolder.defaultProps = {
	  isSubmitting: false
	};
	NewFolder.propTypes = {
	  isSubmitting: __webpack_require__(1).PropTypes.bool.isRequired,
	  onSubmit: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = NewFolder;

/***/ },

/***/ 895:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(1894);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  input: {
	    display: 'none'
	  }
	};
	
	var UploadFileButton = function (_Component) {
	  _inherits(UploadFileButton, _Component);
	
	  function UploadFileButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, UploadFileButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UploadFileButton.__proto__ || Object.getPrototypeOf(UploadFileButton)).call.apply(_ref, [this].concat(args))), _this), _this.onSelectFile = function (event) {
	      event.stopPropagation();
	
	      _this.fileInput.click();
	    }, _this.onFileSelected = function (event) {
	      var onUpload = _this.props.onUpload;
	
	
	      if (event.target instanceof HTMLInputElement) {
	        var _files = event.target.files;
	        onUpload(_files);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(UploadFileButton, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var className = this.props.className;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: className, onClick: this.onSelectFile },
	        _react2.default.createElement('input', {
	          type: 'file',
	          name: 'upload',
	          multiple: true,
	          onChange: this.onFileSelected,
	          style: styles.input,
	          ref: function ref(input) {
	            _this2.fileInput = input;
	          }
	        }),
	        'Ajouter'
	      );
	    }
	  }]);
	
	  return UploadFileButton;
	}(_react.Component);
	
	UploadFileButton.propTypes = {
	  className: __webpack_require__(1).PropTypes.string.isRequired,
	  folder: __webpack_require__(1).PropTypes.any.isRequired,
	  onUpload: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = (0, _pure2.default)(UploadFileButton);

/***/ },

/***/ 896:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _folders = __webpack_require__(208);
	
	var FoldersActions = _interopRequireWildcard(_folders);
	
	var _uploads = __webpack_require__(171);
	
	var UploadsActions = _interopRequireWildcard(_uploads);
	
	var _folders2 = __webpack_require__(172);
	
	var _resources = __webpack_require__(302);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _FolderList = __webpack_require__(893);
	
	var _FolderList2 = _interopRequireDefault(_FolderList);
	
	var _NewFolder = __webpack_require__(894);
	
	var _NewFolder2 = _interopRequireDefault(_NewFolder);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    folders: (0, _folders2.getAllFolders)(state),
	    resourcesCountByFolder: (0, _resources.getCountByFolder)(state),
	    isSaving: (0, _folders2.getIsSaving)(state),
	    isRemoving: (0, _folders2.getIsRemoving)(state)
	  };
	};
	
	var Folders = function Folders(_ref) {
	  var folders = _ref.folders,
	      resourcesCountByFolder = _ref.resourcesCountByFolder,
	      removeFolder = _ref.removeFolder,
	      saveFolder = _ref.saveFolder,
	      isSaving = _ref.isSaving,
	      uploadFile = _ref.uploadFile,
	      isRemoving = _ref.isRemoving;
	
	  var renderContent = function renderContent() {
	    if (folders && folders.size) {
	      // TODO: Batch action calls
	      var uploadFiles = function uploadFiles(folder, files) {
	        return Array.prototype.forEach.call(files, function (f) {
	          return uploadFile(folder, f);
	        });
	      };
	
	      return _react2.default.createElement(_FolderList2.default, {
	        folders: folders,
	        resourcesCountByFolder: resourcesCountByFolder,
	        onUploadFiles: uploadFiles,
	        onRemove: removeFolder,
	        isRemoving: isRemoving
	      });
	    }
	
	    return _react2.default.createElement(_semanticUiReact.Message, { icon: 'info circle', header: 'Aucun dossier' });
	  };
	
	  return _react2.default.createElement(
	    _semanticUiReact.Segment,
	    null,
	    _react2.default.createElement(_NewFolder2.default, { onSubmit: saveFolder, isSubmitting: isSaving }),
	    _react2.default.createElement(_semanticUiReact.Divider, null),
	    renderContent()
	  );
	};
	
	Folders.propTypes = {
	  folders: __webpack_require__(1).PropTypes.any,
	  resourcesCountByFolder: __webpack_require__(1).PropTypes.any.isRequired,
	  saveFolder: __webpack_require__(1).PropTypes.func.isRequired,
	  removeFolder: __webpack_require__(1).PropTypes.func.isRequired,
	  isSaving: __webpack_require__(1).PropTypes.bool.isRequired,
	  isRemoving: __webpack_require__(1).PropTypes.bool.isRequired,
	  uploadFile: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  saveFolder: FoldersActions.saveFolder,
	  removeFolder: FoldersActions.removeFolder,
	  uploadFile: UploadsActions.uploadFile
	})(Folders);

/***/ },

/***/ 897:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PendingUploads = function PendingUploads(_ref) {
	  var count = _ref.count,
	      onCancel = _ref.onCancel;
	
	  if (count > 0) {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_semanticUiReact.Message, {
	        attached: true,
	        icon: 'hourglass start',
	        content: 'Actuellement ' + count + ' envoi(s) en attente'
	      }),
	      _react2.default.createElement(
	        'div',
	        {
	          className: 'ui bottom attached red tiny icon button',
	          onClick: onCancel
	        },
	        _react2.default.createElement('i', { className: 'close icon' }),
	        'Annuler les envois'
	      )
	    );
	  }
	
	  return null;
	};
	
	PendingUploads.propTypes = {
	  count: __webpack_require__(1).PropTypes.number.isRequired,
	  onCancel: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = PendingUploads;

/***/ },

/***/ 898:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UploadCounter = function UploadCounter(_ref) {
	  var count = _ref.count;
	  return _react2.default.createElement(
	    "div",
	    { className: "ui floating green circular label" },
	    count
	  );
	};
	
	UploadCounter.propTypes = {
	  count: __webpack_require__(1).PropTypes.number.isRequired
	};
	exports.default = UploadCounter;

/***/ },

/***/ 899:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UploadItemState = __webpack_require__(900);
	
	var _UploadItemState2 = _interopRequireDefault(_UploadItemState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  p: {
	    overflow: 'hidden'
	  }
	};
	
	var UploadItem = function UploadItem(_ref) {
	  var upload = _ref.upload;
	  return _react2.default.createElement(
	    'div',
	    { className: 'ui clearing segment' },
	    _react2.default.createElement(
	      'p',
	      { style: styles.p },
	      upload.name
	    ),
	    _react2.default.createElement(_UploadItemState2.default, { upload: upload })
	  );
	};
	
	UploadItem.propTypes = {
	  upload: __webpack_require__(1).PropTypes.any.isRequired
	};
	exports.default = UploadItem;

/***/ },

/***/ 900:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  loader: {
	    paddingTop: '0.8em',
	    paddingLeft: '0.3em'
	  }
	};
	
	var textFromState = function textFromState(state) {
	  switch (state) {
	    case 'uploading':
	      return 'Envoi';
	    case 'processing':
	      return 'Traitement';
	    default:
	      console.warn('Unknown upload state ' + state);
	      return '';
	  }
	};
	
	var errorContent = function errorContent(error) {
	  if (error && error.res) {
	    switch (error.res.status) {
	      case 408:
	      case 504:
	        return 'Problème réseau. Vérifiez votre connexion';
	      case 413:
	        return 'Fichier trop volumineux (> 150 Mo)';
	      case 502:
	      case 503:
	        return 'Serveur indisponible';
	      default:
	        return 'Une erreur technique est survenue';
	    }
	  }
	
	  return 'Une erreur serveur est survenue';
	};
	
	var UploadItemState = function UploadItemState(_ref) {
	  var upload = _ref.upload;
	
	  switch (upload.state) {
	    case 'uploading':
	    case 'processing':
	      return _react2.default.createElement(
	        'button',
	        { className: 'ui tiny right floated labeled icon button' },
	        _react2.default.createElement(
	          'i',
	          { className: 'icon', style: styles.loader },
	          _react2.default.createElement('i', { className: 'notched circle loading icon' })
	        ),
	        textFromState(upload.state)
	      );
	    case 'error':
	      return _react2.default.createElement(_semanticUiReact.Popup, {
	        trigger: _react2.default.createElement(_semanticUiReact.Button, {
	          icon: 'warning',
	          size: 'tiny',
	          inverted: true,
	          floated: 'right',
	          color: 'red'
	        }),
	        content: errorContent(upload.error),
	        positioning: 'left center'
	      });
	    default:
	      return null;
	  }
	};
	
	UploadItemState.propTypes = {
	  upload: __webpack_require__(1).PropTypes.any.isRequired
	};
	exports.default = UploadItemState;

/***/ },

/***/ 901:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UploadCounter = __webpack_require__(898);
	
	var _UploadCounter2 = _interopRequireDefault(_UploadCounter);
	
	var _UploadItem = __webpack_require__(899);
	
	var _UploadItem2 = _interopRequireDefault(_UploadItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UploadList = function UploadList(_ref) {
	  var uploads = _ref.uploads,
	      runningCount = _ref.runningCount;
	
	  var renderContent = function renderContent() {
	    if (uploads.size) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'ui stacked segments' },
	        uploads.map(function (u) {
	          return _react2.default.createElement(_UploadItem2.default, { key: u.token, upload: u });
	        })
	      );
	    }
	
	    return 'Aucun envoi en cours';
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'ui green segment' },
	    _react2.default.createElement(_UploadCounter2.default, { count: runningCount }),
	    renderContent()
	  );
	};
	
	UploadList.propTypes = {
	  uploads: __webpack_require__(1).PropTypes.any.isRequired,
	  runningCount: __webpack_require__(1).PropTypes.number.isRequired
	};
	exports.default = UploadList;

/***/ },

/***/ 902:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _uploads = __webpack_require__(478);
	
	var _uploads2 = __webpack_require__(171);
	
	var _UploadList = __webpack_require__(901);
	
	var _UploadList2 = _interopRequireDefault(_UploadList);
	
	var _PendingUploads = __webpack_require__(897);
	
	var _PendingUploads2 = _interopRequireDefault(_PendingUploads);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    running: (0, _uploads.getRunningUploads)(state),
	    pending: (0, _uploads.getPendingUploads)(state),
	    runningCount: (0, _uploads.getRunningCount)(state)
	  };
	};
	
	var Upload = function Upload(_ref) {
	  var running = _ref.running,
	      pending = _ref.pending,
	      runningCount = _ref.runningCount,
	      cancelPending = _ref.cancelPending;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_UploadList2.default, { uploads: running, runningCount: runningCount }),
	    _react2.default.createElement(_PendingUploads2.default, { count: pending.size, onCancel: cancelPending })
	  );
	};
	
	Upload.propTypes = {
	  running: __webpack_require__(1).PropTypes.any.isRequired,
	  pending: __webpack_require__(1).PropTypes.any.isRequired,
	  runningCount: __webpack_require__(1).PropTypes.number.isRequired,
	  cancelPending: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  cancelPending: _uploads2.cancelPending
	})(Upload);

/***/ },

/***/ 903:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _configureStore = __webpack_require__(507);
	
	var _configureStore2 = _interopRequireDefault(_configureStore);
	
	var _reducers = __webpack_require__(477);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _sagas = __webpack_require__(879);
	
	var _sagas2 = _interopRequireDefault(_sagas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  var store = (0, _configureStore2.default)(_reducers2.default, _sagas2.default);
	
	  // Make reducers hot reloadable, see http://mxs.is/googmo
	  if (false) {
	    module.hot.accept('./reducers', function () {
	      var nextRootReducer = require('./reducers').default;
	      store.replaceReducer(nextRootReducer);
	    });
	  }
	
	  return store;
	};

/***/ },

/***/ 904:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(31);
	
	var _reactRedux = __webpack_require__(14);
	
	var _actions = __webpack_require__(209);
	
	var Actions = _interopRequireWildcard(_actions);
	
	var _DiffusionCard = __webpack_require__(906);
	
	var _DiffusionCard2 = _interopRequireDefault(_DiffusionCard);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Edit = function (_Component) {
	  _inherits(Edit, _Component);
	
	  function Edit() {
	    _classCallCheck(this, Edit);
	
	    return _possibleConstructorReturn(this, (Edit.__proto__ || Object.getPrototypeOf(Edit)).apply(this, arguments));
	  }
	
	  _createClass(Edit, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.loadInitialDatas();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _reactRouterDom.HashRouter,
	        null,
	        _react2.default.createElement(_DiffusionCard2.default, null)
	      );
	    }
	  }]);
	
	  return Edit;
	}(_react.Component);
	
	Edit.propTypes = {
	  loadInitialDatas: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = (0, _reactRedux.connect)(undefined, {
	  loadInitialDatas: Actions.loadInitialDatas
	})(Edit);

/***/ },

/***/ 905:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.updatePostpone = updatePostpone;
	
	var _fetch = __webpack_require__(32);
	
	var _fetch2 = _interopRequireDefault(_fetch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function updatePostpone(id, date) {
	  return (0, _fetch2.default)('/campaign/' + id + '/postpone?date=' + date, {
	    method: 'PUT'
	  });
	}

/***/ },

/***/ 906:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _DiffusionList = __webpack_require__(307);
	
	var _DiffusionList2 = _interopRequireDefault(_DiffusionList);
	
	var _diffusion = __webpack_require__(303);
	
	var _diffusion2 = __webpack_require__(479);
	
	var DiffusionActions = _interopRequireWildcard(_diffusion2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    targets: (0, _diffusion.getTargets)(state)
	  };
	};
	
	var DiffusionCard = function DiffusionCard(_ref) {
	  var targets = _ref.targets,
	      updateTargets = _ref.updateTargets;
	  return _react2.default.createElement(_DiffusionList2.default, {
	    targets: targets,
	    onUpdate: updateTargets,
	    isEditable: true,
	    attached: true
	  });
	};
	
	DiffusionCard.propTypes = {
	  targets: __webpack_require__(1).PropTypes.arrayOf(__webpack_require__(1).PropTypes.any).isRequired,
	  updateTargets: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  updateTargets: DiffusionActions.updateTargets
	})(DiffusionCard);

/***/ },

/***/ 907:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.renderEdit = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(38);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRedux = __webpack_require__(14);
	
	var _redux = __webpack_require__(33);
	
	var _Edit = __webpack_require__(904);
	
	var _Edit2 = _interopRequireDefault(_Edit);
	
	var _reduxSaga = __webpack_require__(138);
	
	var _reduxSaga2 = _interopRequireDefault(_reduxSaga);
	
	var _middleware = __webpack_require__(314);
	
	var _middleware2 = _interopRequireDefault(_middleware);
	
	var _redux2 = __webpack_require__(322);
	
	var _reducers = __webpack_require__(481);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _sagas = __webpack_require__(910);
	
	var _sagas2 = _interopRequireDefault(_sagas);
	
	var _diffusion = __webpack_require__(303);
	
	var _jquery = __webpack_require__(16);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _fetch = __webpack_require__(32);
	
	var _toastr = __webpack_require__(81);
	
	var _loader = __webpack_require__(313);
	
	var _publish = __webpack_require__(909);
	
	var _publish2 = _interopRequireDefault(_publish);
	
	var _postpone = __webpack_require__(480);
	
	var _postpone2 = _interopRequireDefault(_postpone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var renderEdit = exports.renderEdit = function renderEdit(id) {
	  var sagaMiddleware = (0, _reduxSaga2.default)();
	  var ravenMiddleware = (0, _middleware2.default)();
	
	  var middleware = [sagaMiddleware, ravenMiddleware];
	
	  (0, _redux2.appendLoggerMiddlewareInDev)(middleware);
	
	  var store = (0, _redux.createStore)(_reducers2.default, _redux.applyMiddleware.apply(undefined, middleware));
	  sagaMiddleware.run(_sagas2.default);
	
	  // Rendering React UI
	  _reactDom2.default.render(_react2.default.createElement(
	    _reactRedux.Provider,
	    { store: store },
	    _react2.default.createElement(_Edit2.default, null)
	  ), document.getElementById('root'));
	
	  var $form = (0, _jquery2.default)('form');
	  $form.on('submit', function (evt) {
	    evt.preventDefault();
	
	    var $form = (0, _jquery2.default)(evt.currentTarget);
	
	    // Serializing form data
	    var data = new FormData($form[0]);
	
	    // Appending redux state
	    var state = store.getState();
	
	    var targets = (0, _diffusion.getTargets)(state).map(function (e) {
	      return {
	        role: e.role,
	        tags: e.tags
	      };
	    });
	    data.append('targets', JSON.stringify(targets));
	
	    return handleFormSubmit($form, data, function () {
	      // Storing flash in session for toast
	      (0, _toastr.storeSuccess)('Campagne de push mise à jour avec succès');
	
	      // Moving to list page
	      window.location.replace('/campaign');
	    });
	  });
	};
	
	function handleFormSubmit($form, data, successCallback) {
	  var handleFormErrors = function handleFormErrors(errors) {
	    // Clearing existing errors
	    $form.find('.field').removeClass('error');
	    $form.removeClass('error');
	    $form.find('.error.message').html('');
	
	    var formError = errors[0];
	    if (formError && formError.key) {
	      $form.find('input[name="' + formError.key + '"]').closest('.field').addClass('error');
	
	      $form.addClass('error');
	      $form.find('.error.message').append(formError.messages[0]);
	    }
	  };
	
	  var $submitButton = (0, _jquery2.default)(document.activeElement);
	
	  var postForm = function postForm(_ref) {
	    var push = _ref.push,
	        postpone = _ref.postpone;
	
	    var url = $submitButton.attr('formaction') || $form.attr('action');
	
	    // Append push to data
	    data.append('push', push);
	    data.append('postpone', postpone);
	
	    return (0, _fetch.post)(url, data).then(function (res) {
	      (0, _loader.hideFormLoader)($form);
	      successCallback(res);
	    }, function (err) {
	      (0, _loader.hideFormLoader)($form);
	
	      console.log('Error attempting to save campaign', err);
	      if (err.res.status === 400) {
	        err.res.json().then(function (json) {
	          return handleFormErrors(json);
	        });
	      } else {
	        (0, _toastr.error)('Une erreur est survenue pendant la sauvegarde de la campagne');
	      }
	    });
	  };
	
	  // Displaying push settings modal if needed
	  if ($submitButton.hasClass('publish')) {
	    (0, _publish2.default)(function (push) {
	      return postForm({ push: push });
	    });
	  } else if ($submitButton.hasClass('postpone')) {
	    (0, _postpone2.default)(function (postpone) {
	      return postForm({ postpone: postpone });
	    });
	  } else {
	    postForm({});
	  }
	
	  return false;
	}

/***/ },

/***/ 908:
[2057, 907, 480],

/***/ 909:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(16);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: Migrate to react based modal (like postpone one)
	exports.default = function (onSubmit) {
	  var $modal = (0, _jquery2.default)('#modal-publish-settings');
	
	  $modal.modal({
	    onVisible: function onVisible() {
	      $modal.find('.ui.checkbox').checkbox();
	    },
	    onApprove: function onApprove(element) {
	      var push = $modal.find('.ui.checkbox').hasClass('checked');
	      var $button = (0, _jquery2.default)(element);
	
	      $button.addClass('loading');
	      onSubmit(push).then(function (_) {
	        $button.removeClass('');
	        $modal.modal('hide');
	      });
	
	      return false;
	    }
	  }).modal('show');
	};

/***/ },

/***/ 910:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(58);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = root;
	
	var _effects = __webpack_require__(51);
	
	var _initialData = __webpack_require__(505);
	
	var _actions = __webpack_require__(209);
	
	var _reducers = __webpack_require__(481);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [loadInitialDatas, root].map(_regenerator2.default.mark);
	
	function loadInitialDatas() {
	  var isFetched, targets;
	  return _regenerator2.default.wrap(function loadInitialDatas$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_reducers.getIsFetched);
	
	        case 2:
	          isFetched = _context.sent;
	
	          if (isFetched) {
	            _context.next = 9;
	            break;
	          }
	
	          _context.next = 6;
	          return (0, _effects.call)(_initialData.getFromInitialData, 'targets', []);
	
	        case 6:
	          targets = _context.sent;
	          _context.next = 9;
	          return (0, _effects.put)({
	            type: _actions.INITIAL_DATA_LOAD_SUCCESS,
	            targets: targets
	          });
	
	        case 9:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	function root() {
	  return _regenerator2.default.wrap(function root$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return [(0, _effects.takeLatest)(_actions.INITIAL_DATA_LOAD, loadInitialDatas)];
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}

/***/ },

/***/ 911:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createContent = undefined;
	
	var _fetch = __webpack_require__(32);
	
	var _fetch2 = _interopRequireDefault(_fetch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createContent = exports.createContent = function createContent(pageId, platform) {
	  return (0, _fetch2.default)('/catalog/pages.json/' + pageId + '/content?platform=' + platform.code, {
	    headers: {
	      Accept: 'application/json'
	    },
	    method: 'POST'
	  }).then(function (res) {
	    return res.json();
	  });
	};

/***/ },

/***/ 912:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.deploy = exports.fetch = undefined;
	
	var _fetch = __webpack_require__(32);
	
	var _fetch2 = _interopRequireDefault(_fetch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fetch = exports.fetch = function fetch() {
	  return (0, _fetch.fetchJson)('/deployments.json');
	};
	
	var deploy = exports.deploy = function deploy() {
	  return (0, _fetch2.default)('/deployments.json', {
	    method: 'POST',
	    headers: {
	      Accept: 'application/json'
	    }
	  }).then(function (res) {
	    return res.json();
	  });
	};

/***/ },

/***/ 913:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchPlatforms = exports.fetchTemplates = exports.fetchSettings = undefined;
	
	var _fetch = __webpack_require__(32);
	
	var fetchSettings = exports.fetchSettings = function fetchSettings() {
	  return (0, _fetch.fetchJson)('/catalog/settings.json');
	};
	
	var fetchTemplates = exports.fetchTemplates = function fetchTemplates() {
	  return (0, _fetch.fetchJson)('/catalog/templates.json');
	};
	
	var fetchPlatforms = exports.fetchPlatforms = function fetchPlatforms() {
	  return (0, _fetch.fetchJson)('/catalog/platforms.json');
	};

/***/ },

/***/ 914:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _App = __webpack_require__(950);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Root = function (_Component) {
	  _inherits(Root, _Component);
	
	  function Root() {
	    _classCallCheck(this, Root);
	
	    return _possibleConstructorReturn(this, (Root.__proto__ || Object.getPrototypeOf(Root)).apply(this, arguments));
	  }
	
	  _createClass(Root, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          store = _props.store,
	          history = _props.history;
	
	      return _react2.default.createElement(
	        _reactRedux.Provider,
	        { store: store },
	        _react2.default.createElement(_App2.default, { history: history })
	      );
	    }
	  }]);
	
	  return Root;
	}(_react.Component);
	
	Root.propTypes = {
	  store: __webpack_require__(1).PropTypes.object.isRequired,
	  history: __webpack_require__(1).PropTypes.object.isRequired
	};
	exports.default = Root;

/***/ },

/***/ 915:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.index = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(38);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactHotLoader = __webpack_require__(699);
	
	var _store = __webpack_require__(987);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _history = __webpack_require__(1425);
	
	var _Root = __webpack_require__(914);
	
	var _Root2 = _interopRequireDefault(_Root);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var index = exports.index = function index() {
	  var root = document.getElementById('root');
	
	  var history = (0, _history.createBrowserHistory)({
	    basename: '/catalog'
	  });
	
	  var store = (0, _store2.default)(history);
	  var render = function render(App) {
	    _reactDom2.default.render(_react2.default.createElement(
	      _reactHotLoader.AppContainer,
	      null,
	      _react2.default.createElement(App, { store: store, history: history })
	    ), root);
	  };
	
	  render(_Root2.default);
	
	  // Hot Module Replacement API
	  if (false) {
	    module.hot.accept('./containers/Root', function () {
	      var NextRoot = require('./containers/Root').default;
	      render(NextRoot);
	    });
	  }
	};

/***/ },

/***/ 916:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App = __webpack_require__(308);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Edit = function Edit(_ref) {
	  var content = _ref.content,
	      onSerialize = _ref.onSerialize;
	
	  var serialize = function serialize(blocks) {
	    onSerialize(Object.assign({}, content, {
	      blocks: blocks
	    }));
	  };
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_App2.default, {
	      mode: 'draft',
	      blocks: content.blocks || [],
	      onUpdate: serialize,
	      locked: true
	    })
	  );
	};
	
	Edit.propTypes = {
	  content: __webpack_require__(1).PropTypes.any.isRequired,
	  onSerialize: __webpack_require__(1).PropTypes.func
	};
	exports.default = Edit;

/***/ },

/***/ 917:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Render = __webpack_require__(489);
	
	var _Render2 = _interopRequireDefault(_Render);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var View = function View(_ref) {
	  var content = _ref.content;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Render2.default, { blocks: content.blocks || [], locked: true })
	  );
	};
	
	View.propTypes = {
	  content: __webpack_require__(1).PropTypes.any.isRequired
	};
	exports.default = View;

/***/ },

/***/ 918:
[2058, 916, 917],

/***/ 919:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App = __webpack_require__(308);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _HeaderForm = __webpack_require__(921);
	
	var _HeaderForm2 = _interopRequireDefault(_HeaderForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Edit = function Edit(_ref) {
	  var content = _ref.content,
	      onSerialize = _ref.onSerialize;
	
	  var serialize = function serialize(blocks) {
	    onSerialize(Object.assign({}, content, {
	      blocks: blocks
	    }));
	  };
	
	  var headerChanged = function headerChanged(header) {
	    return onSerialize(Object.assign({}, content, header));
	  };
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_HeaderForm2.default, {
	      header: content,
	      strategy: content._imageResourceStrategy,
	      onUpdate: headerChanged
	    }),
	    _react2.default.createElement(_App2.default, {
	      mode: 'draft',
	      blocks: content.blocks || [],
	      onUpdate: serialize
	    })
	  );
	};
	
	Edit.propTypes = {
	  content: __webpack_require__(1).PropTypes.any.isRequired,
	  onSerialize: __webpack_require__(1).PropTypes.func
	};
	exports.default = Edit;

/***/ },

/***/ 920:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _OctoResourceImage = __webpack_require__(216);
	
	var _OctoResourceImage2 = _interopRequireDefault(_OctoResourceImage);
	
	var _Render = __webpack_require__(489);
	
	var _Render2 = _interopRequireDefault(_Render);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var headerTitle = function headerTitle(content) {
	  return content.title || content.shortTitle || 'Aucun titre';
	};
	
	var View = function View(_ref) {
	  var content = _ref.content;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _semanticUiReact.Card,
	      { centered: true },
	      _react2.default.createElement(_semanticUiReact.Card.Content, { header: headerTitle(content) }),
	      _react2.default.createElement(_OctoResourceImage2.default, {
	        strategy: content._imageResourceStrategy,
	        resource: content.image
	      })
	    ),
	    _react2.default.createElement(_semanticUiReact.Divider, null),
	    _react2.default.createElement(_Render2.default, { blocks: content.blocks || [] })
	  );
	};
	
	View.propTypes = {
	  content: __webpack_require__(1).PropTypes.any.isRequired
	};
	exports.default = View;

/***/ },

/***/ 921:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _OctoResourceCard = __webpack_require__(215);
	
	var _OctoResourceCard2 = _interopRequireDefault(_OctoResourceCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var HeaderForm = function HeaderForm(_ref) {
	  var header = _ref.header,
	      strategy = _ref.strategy,
	      onUpdate = _ref.onUpdate;
	
	  var inputChanged = function inputChanged(event) {
	    return onUpdate(Object.assign({}, header, _defineProperty({}, event.target.name, event.target.value)));
	  };
	
	  var imageUpdated = function imageUpdated(image) {
	    return onUpdate(Object.assign({}, header, {
	      image: image
	    }));
	  };
	
	  var imageDeleted = function imageDeleted() {
	    return onUpdate(Object.assign({}, header, {
	      image: undefined
	    }));
	  };
	
	  return _react2.default.createElement(
	    _semanticUiReact.Segment,
	    null,
	    _react2.default.createElement(
	      _semanticUiReact.Grid,
	      { columns: 2 },
	      _react2.default.createElement(
	        _semanticUiReact.Grid.Column,
	        { verticalAlign: 'middle' },
	        _react2.default.createElement(
	          _semanticUiReact.Form,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Form.Field,
	            null,
	            _react2.default.createElement(
	              'label',
	              null,
	              'Titre'
	            ),
	            _react2.default.createElement('input', {
	              name: 'title',
	              placeholder: 'Titre',
	              value: header.title || '',
	              onChange: inputChanged
	            })
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Form.Field,
	            null,
	            _react2.default.createElement(
	              'label',
	              null,
	              'Titre court'
	            ),
	            _react2.default.createElement('input', {
	              name: 'shortTitle',
	              placeholder: 'Titre court',
	              value: header.shortTitle || '',
	              onChange: inputChanged
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Grid.Column,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Header,
	          { as: 'h3', textAlign: 'center' },
	          'Image de titre'
	        ),
	        _react2.default.createElement(_OctoResourceCard2.default, {
	          resource: header.image,
	          strategy: strategy,
	          onUpdated: imageUpdated,
	          onDeleted: imageDeleted
	        })
	      )
	    )
	  );
	};
	
	HeaderForm.propTypes = {
	  header: __webpack_require__(1).PropTypes.any.isRequired,
	  strategy: __webpack_require__(1).PropTypes.any.isRequired,
	  onUpdate: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = HeaderForm;

/***/ },

/***/ 922:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getViewComponent = exports.getEditComponent = undefined;
	
	var _Edit = __webpack_require__(919);
	
	var _Edit2 = _interopRequireDefault(_Edit);
	
	var _View = __webpack_require__(920);
	
	var _View2 = _interopRequireDefault(_View);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	if (true) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_FlowHeader', {
	  value: __webpack_require__(1).PropTypes.shape({
	    title: __webpack_require__(1).PropTypes.string,
	    shortTitle: __webpack_require__(1).PropTypes.string,
	    image: __webpack_require__(1).PropTypes.any
	  })
	});
	var getEditComponent = exports.getEditComponent = function getEditComponent() {
	  return _Edit2.default;
	};
	var getViewComponent = exports.getViewComponent = function getViewComponent() {
	  return _View2.default;
	};

/***/ },

/***/ 923:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _NavigationLinks = __webpack_require__(928);
	
	var _NavigationLinks2 = _interopRequireDefault(_NavigationLinks);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var Edit = function Edit(_ref) {
	  var content = _ref.content,
	      onSerialize = _ref.onSerialize;
	
	  var linkAdded = function linkAdded(link) {
	    return onSerialize(Object.assign({}, content, {
	      items: [].concat(_toConsumableArray(content.items), [link])
	    }));
	  };
	
	  var linksUpdated = function linksUpdated(updated) {
	    return onSerialize(Object.assign({}, content, {
	      items: updated
	    }));
	  };
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_NavigationLinks2.default, {
	      links: content.items,
	      resourceStrategy: content.layout.strategy,
	      onAdd: linkAdded,
	      onUpdate: linksUpdated
	    })
	  );
	};
	
	Edit.propTypes = {
	  content: __webpack_require__(1).PropTypes.any.isRequired,
	  onSerialize: __webpack_require__(1).PropTypes.func
	};
	exports.default = Edit;

/***/ },

/***/ 924:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _ViewNavigationLinkItem = __webpack_require__(930);
	
	var _ViewNavigationLinkItem2 = _interopRequireDefault(_ViewNavigationLinkItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var View = function View(_ref) {
	  var content = _ref.content;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _semanticUiReact.Card.Group,
	      { itemsPerRow: 3 },
	      content.items.map(function (l) {
	        return _react2.default.createElement(_ViewNavigationLinkItem2.default, {
	          key: l.order,
	          link: l,
	          defaultResourceStrategy: content.layout.strategy
	        });
	      })
	    )
	  );
	};
	
	View.propTypes = {
	  content: __webpack_require__(1).PropTypes.any.isRequired
	};
	exports.default = View;

/***/ },

/***/ 925:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _OrderDropdown = __webpack_require__(1065);
	
	var _OrderDropdown2 = _interopRequireDefault(_OrderDropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationLinkButtons = function NavigationLinkButtons(_ref) {
	  var link = _ref.link,
	      linkCount = _ref.linkCount,
	      onOrderChange = _ref.onOrderChange,
	      onDelete = _ref.onDelete;
	
	  var changeLinkOrder = function changeLinkOrder(newOrder) {
	    return onOrderChange(link, newOrder);
	  };
	  var deleteLink = function deleteLink() {
	    return onDelete(link);
	  };
	
	  return _react2.default.createElement(
	    _semanticUiReact.Segment,
	    { basic: true },
	    _react2.default.createElement(_OrderDropdown2.default, {
	      value: link.order,
	      orderCount: linkCount,
	      onChange: changeLinkOrder
	    }),
	    _react2.default.createElement(_semanticUiReact.Button, {
	      onClick: deleteLink,
	      labelPosition: 'right',
	      icon: 'remove',
	      content: 'Supprimer',
	      color: 'red',
	      floated: 'right'
	    })
	  );
	};
	
	NavigationLinkButtons.propTypes = {
	  link: __webpack_require__(1).PropTypes.any.isRequired,
	  linkCount: __webpack_require__(1).PropTypes.number.isRequired,
	  onOrderChange: __webpack_require__(1).PropTypes.func.isRequired,
	  onDelete: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = NavigationLinkButtons;

/***/ },

/***/ 926:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(31);
	
	var _semanticUiReact = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationLinkForm = function NavigationLinkForm(_ref) {
	  var link = _ref.link,
	      onTitleChange = _ref.onTitleChange;
	
	  var onChange = function onChange(event) {
	    if (event.target instanceof HTMLInputElement) {
	      onTitleChange(event.target.value);
	    }
	  };
	
	  return _react2.default.createElement(
	    _semanticUiReact.Form,
	    null,
	    _react2.default.createElement(_semanticUiReact.Form.Input, { label: 'Titre', value: link.title, onChange: onChange }),
	    _react2.default.createElement(
	      _semanticUiReact.Form.Input,
	      {
	        iconPosition: 'left',
	        label: 'Liaison vers la page',
	        value: link.page.name,
	        readOnly: true,
	        action: true
	      },
	      _react2.default.createElement(_semanticUiReact.Icon, { name: 'chevron right' }),
	      _react2.default.createElement('input', null),
	      _react2.default.createElement(
	        _reactRouterDom.Link,
	        {
	          to: '/pages/' + link.page.id,
	          target: 'innoctopus',
	          className: 'ui button'
	        },
	        'Editer'
	      )
	    )
	  );
	};
	
	NavigationLinkForm.propTypes = {
	  link: __webpack_require__(1).PropTypes.any.isRequired,
	  onTitleChange: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = NavigationLinkForm;

/***/ },

/***/ 927:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _NavigationLinkForm = __webpack_require__(926);
	
	var _NavigationLinkForm2 = _interopRequireDefault(_NavigationLinkForm);
	
	var _NavigationLinkButtons = __webpack_require__(925);
	
	var _NavigationLinkButtons2 = _interopRequireDefault(_NavigationLinkButtons);
	
	var _OctoResourceCard = __webpack_require__(215);
	
	var _OctoResourceCard2 = _interopRequireDefault(_OctoResourceCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationLinkItem = function NavigationLinkItem(_ref) {
	  var link = _ref.link,
	      linkCount = _ref.linkCount,
	      defaultResourceStrategy = _ref.defaultResourceStrategy,
	      onUpdate = _ref.onUpdate,
	      onReorder = _ref.onReorder,
	      onDelete = _ref.onDelete;
	
	  var titleChanged = function titleChanged(title) {
	    return onUpdate(Object.assign({}, link, {
	      title: title
	    }));
	  };
	
	  var resourceUpdated = function resourceUpdated(resource) {
	    return onUpdate(Object.assign({}, link, {
	      image: resource
	    }));
	  };
	
	  var resourceDeleted = function resourceDeleted() {
	    return onUpdate(Object.assign({}, link, {
	      image: undefined
	    }));
	  };
	
	  return _react2.default.createElement(
	    _semanticUiReact.Segment,
	    { attached: true },
	    _react2.default.createElement(
	      _semanticUiReact.Grid,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Grid.Column,
	        { width: 6, verticalAlign: 'middle' },
	        _react2.default.createElement(_NavigationLinkForm2.default, { link: link, onTitleChange: titleChanged }),
	        _react2.default.createElement(_semanticUiReact.Divider, null),
	        _react2.default.createElement(_NavigationLinkButtons2.default, {
	          link: link,
	          linkCount: linkCount,
	          onOrderChange: onReorder,
	          onDelete: onDelete
	        })
	      ),
	      _react2.default.createElement(_semanticUiReact.Grid.Column, { width: 2 }),
	      _react2.default.createElement(
	        _semanticUiReact.Grid.Column,
	        { width: 8 },
	        _react2.default.createElement(_OctoResourceCard2.default, {
	          strategy: defaultResourceStrategy,
	          resource: link.image,
	          onUpdated: resourceUpdated,
	          onDeleted: resourceDeleted
	        })
	      )
	    )
	  );
	};
	
	NavigationLinkItem.propTypes = {
	  link: __webpack_require__(1).PropTypes.any.isRequired,
	  linkCount: __webpack_require__(1).PropTypes.number.isRequired,
	  defaultResourceStrategy: __webpack_require__(1).PropTypes.any.isRequired,
	  onUpdate: __webpack_require__(1).PropTypes.func.isRequired,
	  onReorder: __webpack_require__(1).PropTypes.func.isRequired,
	  onDelete: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = NavigationLinkItem;

/***/ },

/***/ 928:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutable = __webpack_require__(10);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _uuid = __webpack_require__(296);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _NavigationLinksHeader = __webpack_require__(929);
	
	var _NavigationLinksHeader2 = _interopRequireDefault(_NavigationLinksHeader);
	
	var _NavigationLinkItem = __webpack_require__(927);
	
	var _NavigationLinkItem2 = _interopRequireDefault(_NavigationLinkItem);
	
	var _ordering = __webpack_require__(320);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sortedLinks = function sortedLinks(links) {
	  return _immutable2.default.Seq(links).sortBy(function (l) {
	    return l.order;
	  }).toArray();
	};
	
	var updateLinks = function updateLinks(links) {
	  return function (updateFunction) {
	    return updateFunction(_immutable2.default.Map(links.map(function (l) {
	      return [l.order, l];
	    }))).toArray();
	  };
	};
	
	var mergeLinks = function mergeLinks(links, updated) {
	  return updateLinks(links)(function (map) {
	    return map.update(updated.order, function (l) {
	      return Object.assign({}, l, updated);
	    });
	  });
	};
	
	var removeLink = function removeLink(links, toDelete) {
	  return updateLinks(links)(function (map) {
	    return map.remove(toDelete.order);
	  });
	};
	
	var NavigationLinks = function NavigationLinks(_ref) {
	  var links = _ref.links,
	      resourceStrategy = _ref.resourceStrategy,
	      onAdd = _ref.onAdd,
	      onUpdate = _ref.onUpdate;
	
	  var renderContent = function renderContent() {
	    if (links.length) {
	      var updateLink = function updateLink(link) {
	        return onUpdate(mergeLinks(links, link));
	      };
	
	      var deleteLink = function deleteLink(link) {
	        var reordered = (0, _ordering.enforceElementsOrder)(removeLink(links, link));
	        onUpdate(reordered.toArray());
	      };
	
	      var reorderLinks = function reorderLinks(link, order) {
	        var reordered = (0, _ordering.reorderElements)(links, link, order);
	        onUpdate(reordered.toArray());
	      };
	
	      return sortedLinks(links).map(function (l) {
	        return _react2.default.createElement(_NavigationLinkItem2.default, {
	          key: l.order,
	          link: l,
	          linkCount: links.length,
	          defaultResourceStrategy: resourceStrategy,
	          onUpdate: updateLink,
	          onReorder: reorderLinks,
	          onDelete: deleteLink
	        });
	      });
	    }
	
	    return _react2.default.createElement(_semanticUiReact.Message, {
	      attached: 'bottom',
	      icon: 'blind',
	      header: 'Aucune liaison configur\xE9e pour cette page'
	    });
	  };
	
	  var addLink = function addLink(page) {
	    return onAdd({
	      id: (0, _uuid2.default)(),
	      order: links.length,
	      page: page,
	      pageId: page.id,
	      title: page.name
	    });
	  };
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_NavigationLinksHeader2.default, { onPageSelected: addLink }),
	    renderContent()
	  );
	};
	
	NavigationLinks.propTypes = {
	  links: __webpack_require__(1).PropTypes.arrayOf(__webpack_require__(1).PropTypes.any).isRequired,
	  resourceStrategy: __webpack_require__(1).PropTypes.any.isRequired,
	  onAdd: __webpack_require__(1).PropTypes.func.isRequired,
	  onUpdate: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = NavigationLinks;

/***/ },

/***/ 929:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _PageSelector = __webpack_require__(983);
	
	var _PageSelector2 = _interopRequireDefault(_PageSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LinksHeader = function (_Component) {
	  _inherits(LinksHeader, _Component);
	
	  function LinksHeader(props) {
	    _classCallCheck(this, LinksHeader);
	
	    var _this = _possibleConstructorReturn(this, (LinksHeader.__proto__ || Object.getPrototypeOf(LinksHeader)).call(this, props));
	
	    _this.showSelector = function () {
	      return _this.setState({ selectorVisible: true });
	    };
	
	    _this.hideSelector = function () {
	      return _this.setState({ selectorVisible: false });
	    };
	
	    _this.onPageSelected = function (page) {
	      _this.hideSelector();
	      _this.props.onPageSelected(page);
	    };
	
	    _this.state = {
	      selectorVisible: false
	    };
	    return _this;
	  }
	
	  _createClass(LinksHeader, [{
	    key: 'render',
	    value: function render() {
	      var selectorVisible = this.state.selectorVisible;
	
	
	      return _react2.default.createElement(
	        _semanticUiReact.Menu,
	        { borderless: true, attached: 'top' },
	        _react2.default.createElement(
	          _semanticUiReact.Menu.Item,
	          { header: true },
	          'Liaison(s)'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Menu.Item,
	          { position: 'right' },
	          _react2.default.createElement(_semanticUiReact.Button, {
	            onClick: this.showSelector,
	            content: 'Ajouter',
	            floated: 'right',
	            labelPosition: 'left',
	            icon: 'plus',
	            size: 'small'
	          })
	        ),
	        _react2.default.createElement(_PageSelector2.default, {
	          visible: selectorVisible,
	          onSelected: this.onPageSelected,
	          onCancel: this.hideSelector
	        })
	      );
	    }
	  }]);
	
	  return LinksHeader;
	}(_react.Component);
	
	LinksHeader.propTypes = {
	  onPageSelected: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = LinksHeader;

/***/ },

/***/ 930:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _reactRouterDom = __webpack_require__(31);
	
	var _OctoResourceImage = __webpack_require__(216);
	
	var _OctoResourceImage2 = _interopRequireDefault(_OctoResourceImage);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isBrokenLink = function isBrokenLink(link) {
	  return link.page.isArchived;
	};
	
	var isSecuredLink = function isSecuredLink(link) {
	  return link.page.securityContext === 'require';
	};
	
	var ItemLink = function ItemLink(_ref) {
	  var link = _ref.link;
	
	  var secured = isSecuredLink(link);
	
	  var linkClass = (0, _classnames2.default)('ui basic labeled fluid icon button', {
	    red: secured
	  });
	
	  var linkIcon = secured ? 'lock' : 'pointing right';
	
	  return _react2.default.createElement(
	    _reactRouterDom.Link,
	    { to: '/view/' + link.page.id, className: linkClass },
	    _react2.default.createElement(_semanticUiReact.Icon, { name: linkIcon }),
	    'Naviguer'
	  );
	};
	
	var ViewNavigationLinkItem = function ViewNavigationLinkItem(_ref2) {
	  var defaultResourceStrategy = _ref2.defaultResourceStrategy,
	      link = _ref2.link;
	  return _react2.default.createElement(
	    _semanticUiReact.Card,
	    null,
	    isBrokenLink(link) && _react2.default.createElement(_semanticUiReact.Popup, {
	      trigger: _react2.default.createElement(_semanticUiReact.Label, { corner: 'right', color: 'red', icon: 'warning' }),
	      content: 'Page archiv\xE9e'
	    }),
	    _react2.default.createElement(_semanticUiReact.Card.Content, { header: link.title }),
	    _react2.default.createElement(_OctoResourceImage2.default, {
	      strategy: defaultResourceStrategy,
	      resource: link.image
	    }),
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      { extra: true },
	      _react2.default.createElement(ItemLink, { link: link })
	    )
	  );
	};
	
	ViewNavigationLinkItem.propTypes = {
	  defaultResourceStrategy: __webpack_require__(1).PropTypes.any.isRequired,
	  link: __webpack_require__(1).PropTypes.any.isRequired
	};
	exports.default = ViewNavigationLinkItem;

/***/ },

/***/ 931:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getViewComponent = exports.getEditComponent = undefined;
	
	var _Edit = __webpack_require__(923);
	
	var _Edit2 = _interopRequireDefault(_Edit);
	
	var _View = __webpack_require__(924);
	
	var _View2 = _interopRequireDefault(_View);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	if (true) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_NavigationContentLink', {
	  value: __webpack_require__(1).PropTypes.shape({
	    order: __webpack_require__(1).PropTypes.number,
	    title: __webpack_require__(1).PropTypes.string,
	    page: __webpack_require__(1).PropTypes.any.isRequired,
	    image: __webpack_require__(1).PropTypes.any
	  })
	});
	if (true) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_NavigationContent', {
	  value: __webpack_require__(1).PropTypes.shape({
	    items: __webpack_require__(1).PropTypes.arrayOf(__webpack_require__(1).PropTypes.shape({
	      order: __webpack_require__(1).PropTypes.number,
	      title: __webpack_require__(1).PropTypes.string,
	      page: __webpack_require__(1).PropTypes.any.isRequired,
	      image: __webpack_require__(1).PropTypes.any
	    })).isRequired
	  })
	});
	var getEditComponent = exports.getEditComponent = function getEditComponent() {
	  return _Edit2.default;
	};
	var getViewComponent = exports.getViewComponent = function getViewComponent() {
	  return _View2.default;
	};

/***/ },

/***/ 932:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var View = function View() {
	  return _react2.default.createElement(_semanticUiReact.Message, {
	    icon: 'newspaper',
	    header: 'Actualit\xE9s',
	    content: 'Les actualit\xE9s sont g\xE9r\xE9es via le module d\xE9di\xE9 de gestion d\'actualit\xE9s'
	  });
	};
	
	exports.default = View;

/***/ },

/***/ 933:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getViewComponent = exports.getEditComponent = undefined;
	
	var _View = __webpack_require__(932);
	
	var _View2 = _interopRequireDefault(_View);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getEditComponent = exports.getEditComponent = function getEditComponent() {
	  return _View2.default;
	};
	
	var getViewComponent = exports.getViewComponent = function getViewComponent() {
	  return _View2.default;
	};

/***/ },

/***/ 934:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _ResourceCard = __webpack_require__(175);
	
	var _ResourceCard2 = _interopRequireDefault(_ResourceCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Edit = function Edit(_ref) {
	  var content = _ref.content,
	      onSerialize = _ref.onSerialize;
	
	  var resourceSelected = function resourceSelected(resource) {
	    return onSerialize(Object.assign({}, content, {
	      resourceId: resource.id,
	      resource: resource
	    }));
	  };
	
	  var resourceDeleted = function resourceDeleted() {
	    return onSerialize(Object.assign({}, content, {
	      resourceId: undefined,
	      resource: undefined
	    }));
	  };
	
	  return _react2.default.createElement(
	    _semanticUiReact.Segment,
	    null,
	    _react2.default.createElement(_semanticUiReact.Header, { textAlign: 'center', content: 'PDF' }),
	    _react2.default.createElement(_ResourceCard2.default, {
	      resourceType: 'pdf',
	      resource: content.resource,
	      onSelected: resourceSelected,
	      onDeleted: resourceDeleted
	    })
	  );
	};
	
	Edit.propTypes = {
	  content: __webpack_require__(1).PropTypes.any.isRequired,
	  onSerialize: __webpack_require__(1).PropTypes.func
	};
	exports.default = Edit;

/***/ },

/***/ 935:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _ResourceImage = __webpack_require__(99);
	
	var _ResourceImage2 = _interopRequireDefault(_ResourceImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var View = function View(_ref) {
	  var content = _ref.content;
	
	  if (content.resource) {
	    return _react2.default.createElement(
	      _semanticUiReact.Card,
	      { centered: true },
	      _react2.default.createElement(_ResourceImage2.default, { resource: content.resource }),
	      _react2.default.createElement(
	        _semanticUiReact.Card.Content,
	        { extra: true },
	        _react2.default.createElement(
	          'a',
	          {
	            href: content.resource.url.original,
	            target: '_blank',
	            icon: 'file pdf outline',
	            className: 'ui labeled fluid icon basic button'
	          },
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'file pdf outline' }),
	          'T\xE9l\xE9charger'
	        )
	      )
	    );
	  }
	
	  return _react2.default.createElement(_semanticUiReact.Message, { icon: 'info', header: 'Aucun PDF associ\xE9 \xE0 cette page' });
	};
	
	View.propTypes = {
	  content: __webpack_require__(1).PropTypes.any.isRequired
	};
	exports.default = View;

/***/ },

/***/ 936:
[2058, 934, 935],

/***/ 937:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DiffusionList = __webpack_require__(307);
	
	var _DiffusionList2 = _interopRequireDefault(_DiffusionList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DiffusionSecurity = function DiffusionSecurity(_ref) {
	  var security = _ref.security,
	      onUpdate = _ref.onUpdate;
	
	  var updateTargets = function updateTargets(targets) {
	    return onUpdate(Object.assign({}, security, {
	      targets: targets
	    }));
	  };
	
	  return _react2.default.createElement(_DiffusionList2.default, {
	    targets: security.targets,
	    onUpdate: updateTargets,
	    isEditable: true
	  });
	};
	
	DiffusionSecurity.propTypes = {
	  security: __webpack_require__(1).PropTypes.any.isRequired,
	  onUpdate: __webpack_require__(1).PropTypes.func
	};
	exports.default = DiffusionSecurity;

/***/ },

/***/ 938:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Edit = function Edit(_ref) {
	  var content = _ref.content,
	      onSerialize = _ref.onSerialize;
	
	  var onTitleChange = function onTitleChange(evt) {
	    if (evt.target instanceof HTMLInputElement) {
	      onSerialize(Object.assign({}, content, { title: evt.target.value }));
	    }
	  };
	
	  var onUrlChange = function onUrlChange(evt) {
	    if (evt.target instanceof HTMLInputElement) {
	      onSerialize(Object.assign({}, content, { url: evt.target.value }));
	    }
	  };
	
	  var onExternalChange = function onExternalChange(evt, data) {
	    if (evt.target instanceof HTMLElement) {
	      onSerialize(Object.assign({}, content, { external: data.checked }));
	    }
	  };
	
	  return _react2.default.createElement(
	    _semanticUiReact.Segment,
	    null,
	    _react2.default.createElement(
	      _semanticUiReact.Form,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Form.Field,
	        null,
	        _react2.default.createElement(
	          'label',
	          null,
	          'Titre'
	        ),
	        _react2.default.createElement('input', { value: content.title || '', onChange: onTitleChange })
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Form.Field,
	        null,
	        _react2.default.createElement(
	          'label',
	          null,
	          'Url'
	        ),
	        _react2.default.createElement('input', { value: content.url || '', onChange: onUrlChange })
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Form.Field,
	        null,
	        _react2.default.createElement(_semanticUiReact.Checkbox, {
	          label: 'Action externe',
	          checked: content.external,
	          onChange: onExternalChange
	        })
	      )
	    )
	  );
	};
	
	Edit.propTypes = {
	  content: __webpack_require__(1).PropTypes.any.isRequired,
	  onSerialize: __webpack_require__(1).PropTypes.func
	};
	exports.default = Edit;

/***/ },

/***/ 939:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var View = function View(_ref) {
	  var content = _ref.content;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _semanticUiReact.Grid,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Grid.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 'eight' },
	          content.title
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 'eight' },
	          content.external && 'Lien externe'
	        )
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Grid.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 'sixteen' },
	          content.url
	        )
	      )
	    )
	  );
	};
	
	View.propTypes = {
	  content: __webpack_require__(1).PropTypes.any.isRequired
	};
	exports.default = View;

/***/ },

/***/ 940:
[2058, 938, 939],

/***/ 941:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _ProgressiveImage = __webpack_require__(316);
	
	var _ProgressiveImage2 = _interopRequireDefault(_ProgressiveImage);
	
	var _imageLoader = __webpack_require__(379);
	
	var _imageLoader2 = _interopRequireDefault(_imageLoader);
	
	var _resources = __webpack_require__(114);
	
	var _youtube = __webpack_require__(509);
	
	var _throttle = __webpack_require__(406);
	
	var _throttle2 = _interopRequireDefault(_throttle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// TODO: Refactor to abstract it with Edito Youtube block (edito/plugins/youtube/Edit)
	// TODO: We should develop a HOC for this usage
	
	var contentToUrl = function contentToUrl(content) {
	  return content.youtubeId ? 'https://www.youtube.com/watch?v=' + content.youtubeId : '';
	};
	
	var Edit = function (_Component) {
	  _inherits(Edit, _Component);
	
	  function Edit(props) {
	    _classCallCheck(this, Edit);
	
	    var _this = _possibleConstructorReturn(this, (Edit.__proto__ || Object.getPrototypeOf(Edit)).call(this, props));
	
	    _this.getThumbnail = function (id) {
	      if (id) {
	        (0, _youtube.fetchThumbnail)(id).then(function (response) {
	          var video = response.video;
	
	          if (video) {
	            _this.setState({
	              currentThumbnail: video.thumbnail
	            });
	
	            _this.props.onSerialize(Object.assign({}, _this.props.content, {
	              thumbnail: video.thumbnail
	            }));
	          }
	        }, function (_) {
	          _this.setState({
	            error: true
	          });
	        });
	      }
	    };
	
	    _this.onUrlChanged = function (event) {
	      var _this$props = _this.props,
	          content = _this$props.content,
	          onSerialize = _this$props.onSerialize;
	
	
	      if (event.target instanceof HTMLInputElement) {
	        var _value = event.target.value;
	
	
	        var youtubeId = (0, _youtube.tryExtractId)(_value);
	        var isValid = youtubeId !== null;
	
	        _this.setState({
	          value: _value,
	          error: !isValid
	        });
	
	        if (isValid) {
	          _this.state.thumbnailThrottle(youtubeId);
	
	          onSerialize(Object.assign({}, content, {
	            youtubeId: youtubeId
	          }));
	        }
	      }
	    };
	
	    _this.state = {
	      error: false,
	      thumbnailThrottle: (0, _throttle2.default)(_this.getThumbnail, _youtube.THUMBNAIL_THROTTLE_MILLIS, { trailing: true })
	    };
	    return _this;
	  }
	
	  _createClass(Edit, [{
	    key: 'render',
	    value: function render() {
	      var content = this.props.content;
	      var _state = this.state,
	          value = _state.value,
	          error = _state.error;
	
	
	      var url = value || contentToUrl(content);
	      var thumbnail = this.state.currentThumbnail || content.thumbnail || _resources.getVideoPlaceholder;
	
	      return _react2.default.createElement(
	        _semanticUiReact.Segment,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Grid,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            { width: 4 },
	            _react2.default.createElement(
	              _ProgressiveImage2.default,
	              {
	                src: thumbnail,
	                crossOrigin: null,
	                placeholder: _imageLoader2.default
	              },
	              function (src) {
	                return _react2.default.createElement(_semanticUiReact.Image, { src: src });
	              }
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            { width: 12, verticalAlign: 'middle' },
	            _react2.default.createElement(
	              _semanticUiReact.Form,
	              null,
	              _react2.default.createElement(_semanticUiReact.Form.Input, {
	                value: url,
	                error: error,
	                label: 'Lien vid\xE9o Youtube',
	                placeholder: 'https://www.youtube.com/watch?v=',
	                onChange: this.onUrlChanged
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Edit;
	}(_react.Component);
	
	Edit.propTypes = {
	  content: __webpack_require__(1).PropTypes.any.isRequired,
	  onSerialize: __webpack_require__(1).PropTypes.func
	};
	exports.default = Edit;

/***/ },

/***/ 942:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var View = function View(_ref) {
	  var content = _ref.content;
	
	  if (content.youtubeId) {
	    return _react2.default.createElement(_semanticUiReact.Embed, {
	      id: content.youtubeId,
	      placeholder: content.thumbnail,
	      source: 'youtube'
	    });
	  }
	
	  return _react2.default.createElement(_semanticUiReact.Message, { icon: 'info', header: 'Aucune vid\xE9o sp\xE9cifi\xE9e' });
	};
	
	View.propTypes = {
	  content: __webpack_require__(1).PropTypes.any.isRequired
	};
	exports.default = View;

/***/ },

/***/ 943:
[2058, 941, 942],

/***/ 944:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(33);
	
	var _reduxForm = __webpack_require__(440);
	
	var _reactReduxToastr = __webpack_require__(280);
	
	var _reactRouterRedux = __webpack_require__(281);
	
	var _pages = __webpack_require__(72);
	
	var _pages2 = _interopRequireDefault(_pages);
	
	var _contents = __webpack_require__(173);
	
	var _contents2 = _interopRequireDefault(_contents);
	
	var _catalog = __webpack_require__(213);
	
	var _catalog2 = _interopRequireDefault(_catalog);
	
	var _platforms = __webpack_require__(140);
	
	var _platforms2 = _interopRequireDefault(_platforms);
	
	var _deployments = __webpack_require__(214);
	
	var _deployments2 = _interopRequireDefault(_deployments);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  form: _reduxForm.reducer,
	  toastr: _reactReduxToastr.reducer,
	  router: _reactRouterRedux.routerReducer,
	  pages: _pages2.default,
	  contents: _contents2.default,
	  catalog: _catalog2.default,
	  platforms: _platforms2.default,
	  deployments: _deployments2.default
	});

/***/ },

/***/ 945:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(58);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = root;
	
	var _effects = __webpack_require__(51);
	
	var _contents = __webpack_require__(210);
	
	var _platforms = __webpack_require__(212);
	
	var _contents2 = __webpack_require__(911);
	
	var Api = _interopRequireWildcard(_contents2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [createContent, root].map(_regenerator2.default.mark);
	
	function createContent(_ref) {
	  var page = _ref.page,
	      platform = _ref.platform;
	  var content;
	  return _regenerator2.default.wrap(function createContent$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.call)(Api.createContent, page.id, platform);
	
	        case 2:
	          content = _context.sent;
	          _context.next = 5;
	          return (0, _effects.put)({
	            type: _contents.CREATE_CONTENT_SUCCESS,
	            content: content
	          });
	
	        case 5:
	          _context.next = 7;
	          return (0, _effects.put)({
	            type: _platforms.CHANGE_EDITION_PLATFORM,
	            platform: platform
	          });
	
	        case 7:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	function root() {
	  return _regenerator2.default.wrap(function root$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return [(0, _effects.takeEvery)(_contents.CREATE_CONTENT, createContent)];
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}

/***/ },

/***/ 946:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(58);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = root;
	
	var _effects = __webpack_require__(51);
	
	var _reduxSaga = __webpack_require__(138);
	
	var _normalizr = __webpack_require__(201);
	
	var _schema = __webpack_require__(483);
	
	var Schema = _interopRequireWildcard(_schema);
	
	var _deployments = __webpack_require__(912);
	
	var Api = _interopRequireWildcard(_deployments);
	
	var _deployments2 = __webpack_require__(214);
	
	var _errors = __webpack_require__(178);
	
	var _deployments3 = __webpack_require__(211);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [fetchDeployments, deploy, root].map(_regenerator2.default.mark);
	
	function fetchDeployments() {
	  var isFetched, result;
	  return _regenerator2.default.wrap(function fetchDeployments$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_deployments2.getIsFetched);
	
	        case 2:
	          isFetched = _context.sent;
	
	          if (!isFetched) {
	            _context.next = 5;
	            break;
	          }
	
	          return _context.abrupt('return');
	
	        case 5:
	          _context.prev = 5;
	          _context.next = 8;
	          return (0, _effects.call)(Api.fetch);
	
	        case 8:
	          result = _context.sent;
	          _context.next = 11;
	          return (0, _effects.put)({
	            type: _deployments3.FETCH_DEPLOYMENTS_SUCCESS,
	            response: (0, _normalizr.normalize)(result, Schema.deployments)
	          });
	
	        case 11:
	          _context.next = 17;
	          break;
	
	        case 13:
	          _context.prev = 13;
	          _context.t0 = _context['catch'](5);
	          _context.next = 17;
	          return (0, _effects.put)({
	            type: _deployments3.FETCH_DEPLOYMENTS_FAILURE,
	            error: (0, _errors.displayJsonError)(_context.t0)
	          });
	
	        case 17:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this, [[5, 13]]);
	}
	
	function deploy() {
	  var result;
	  return _regenerator2.default.wrap(function deploy$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _reduxSaga.delay)(500);
	
	        case 2:
	          _context2.prev = 2;
	          _context2.next = 5;
	          return (0, _effects.call)(Api.deploy);
	
	        case 5:
	          result = _context2.sent;
	          _context2.next = 8;
	          return (0, _effects.put)({
	            type: _deployments3.DEPLOY_SUCCESS,
	            response: (0, _normalizr.normalize)(result, Schema.deployment)
	          });
	
	        case 8:
	          _context2.next = 14;
	          break;
	
	        case 10:
	          _context2.prev = 10;
	          _context2.t0 = _context2['catch'](2);
	          _context2.next = 14;
	          return (0, _effects.put)({
	            type: _deployments3.DEPLOY_FAILURE,
	            error: (0, _errors.displayJsonError)(_context2.t0)
	          });
	
	        case 14:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this, [[2, 10]]);
	}
	
	function root() {
	  return _regenerator2.default.wrap(function root$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return [(0, _effects.takeLatest)(_deployments3.FETCH_DEPLOYMENTS, fetchDeployments), (0, _effects.takeEvery)(_deployments3.DEPLOY, deploy)];
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}

/***/ },

/***/ 947:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(58);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _effects = __webpack_require__(51);
	
	var _reduxFormSubmitSaga = __webpack_require__(438);
	
	var _saga = __webpack_require__(508);
	
	var _pages = __webpack_require__(948);
	
	var _pages2 = _interopRequireDefault(_pages);
	
	var _pending = __webpack_require__(949);
	
	var _pending2 = _interopRequireDefault(_pending);
	
	var _contents = __webpack_require__(945);
	
	var _contents2 = _interopRequireDefault(_contents);
	
	var _deployments = __webpack_require__(946);
	
	var _deployments2 = _interopRequireDefault(_deployments);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [root].map(_regenerator2.default.mark);
	
	var rootSagas = [_pages2.default, _pending2.default, _contents2.default, _deployments2.default].map(_saga.makeRestartable);
	
	function root() {
	  return _regenerator2.default.wrap(function root$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return rootSagas.map(function (saga) {
	            return (0, _effects.call)(saga);
	          });
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	exports.default = (0, _reduxFormSubmitSaga.addFormSubmitSagaTo)(root);

/***/ },

/***/ 948:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(58);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = root;
	
	var _effects = __webpack_require__(51);
	
	var _normalizr = __webpack_require__(201);
	
	var _api = __webpack_require__(913);
	
	var CatalogApi = _interopRequireWildcard(_api);
	
	var _pages = __webpack_require__(482);
	
	var Api = _interopRequireWildcard(_pages);
	
	var _api2 = __webpack_require__(499);
	
	var UserApi = _interopRequireWildcard(_api2);
	
	var _schema = __webpack_require__(483);
	
	var Schema = _interopRequireWildcard(_schema);
	
	var _reactRouterRedux = __webpack_require__(281);
	
	var _reactReduxToastr = __webpack_require__(280);
	
	var _errors = __webpack_require__(178);
	
	var _pages2 = __webpack_require__(72);
	
	var _contents = __webpack_require__(173);
	
	var _pages3 = __webpack_require__(46);
	
	var _deployments = __webpack_require__(211);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [fetchPages, savePage, updatePage, archivePage, unarchivePage, root].map(_regenerator2.default.mark);
	
	function fetchPages() {
	  var _ref, _ref2, settings, roles, templates, platforms, pages;
	
	  return _regenerator2.default.wrap(function fetchPages$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.prev = 0;
	          _context.next = 3;
	          return [(0, _effects.call)(CatalogApi.fetchSettings), (0, _effects.call)(UserApi.fetchRoles), (0, _effects.call)(CatalogApi.fetchTemplates), (0, _effects.call)(CatalogApi.fetchPlatforms), (0, _effects.call)(Api.fetch)];
	
	        case 3:
	          _ref = _context.sent;
	          _ref2 = _slicedToArray(_ref, 5);
	          settings = _ref2[0];
	          roles = _ref2[1];
	          templates = _ref2[2];
	          platforms = _ref2[3];
	          pages = _ref2[4];
	          _context.next = 12;
	          return (0, _effects.put)({
	            type: _pages3.FETCH_PAGES_SUCCESS,
	            settings: settings,
	            roles: roles,
	            templates: templates,
	            platforms: platforms,
	            response: (0, _normalizr.normalize)(pages, Schema.pages)
	          });
	
	        case 12:
	          _context.next = 18;
	          break;
	
	        case 14:
	          _context.prev = 14;
	          _context.t0 = _context['catch'](0);
	          _context.next = 18;
	          return (0, _effects.put)({
	            type: _pages3.FETCH_PAGES_FAILURE,
	            error: _context.t0
	          });
	
	        case 18:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this, [[0, 14]]);
	}
	
	function savePage(_ref3) {
	  var payload = _ref3.payload;
	  var response;
	  return _regenerator2.default.wrap(function savePage$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.prev = 0;
	          _context2.next = 3;
	          return (0, _effects.call)(Api.save, payload);
	
	        case 3:
	          response = _context2.sent;
	          _context2.next = 6;
	          return (0, _effects.put)({
	            type: _pages3.SAVE_PAGE_SUCCESS,
	            response: (0, _normalizr.normalize)(response, Schema.page),
	            payload: response
	          });
	
	        case 6:
	          if (!payload.redirectOnCreate) {
	            _context2.next = 9;
	            break;
	          }
	
	          _context2.next = 9;
	          return (0, _effects.put)((0, _reactRouterRedux.replace)('/pages/' + response.id));
	
	        case 9:
	          _context2.next = 15;
	          break;
	
	        case 11:
	          _context2.prev = 11;
	          _context2.t0 = _context2['catch'](0);
	          _context2.next = 15;
	          return (0, _effects.put)({
	            type: _pages3.SAVE_PAGE_FAILURE,
	            payload: {
	              _error: (0, _errors.displayJsonError)(_context2.t0)
	            }
	          });
	
	        case 15:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this, [[0, 11]]);
	}
	
	function updatePage(_ref4) {
	  var page = _ref4.page;
	  var pendingPage, pendingContents, response;
	  return _regenerator2.default.wrap(function updatePage$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.prev = 0;
	          _context3.next = 3;
	          return (0, _effects.select)(_pages2.getPendingPageById, page.id);
	
	        case 3:
	          pendingPage = _context3.sent;
	          _context3.next = 6;
	          return (0, _effects.select)(_contents.getPendingContents, page.id);
	
	        case 6:
	          pendingContents = _context3.sent;
	          _context3.next = 9;
	          return (0, _effects.call)(Api.update, pendingPage, pendingContents);
	
	        case 9:
	          response = _context3.sent;
	          _context3.next = 12;
	          return (0, _effects.put)({
	            type: _pages3.UPDATE_PAGE_SUCCESS,
	            response: (0, _normalizr.normalize)(response, Schema.page)
	          });
	
	        case 12:
	          _context3.next = 20;
	          break;
	
	        case 14:
	          _context3.prev = 14;
	          _context3.t0 = _context3['catch'](0);
	          _context3.next = 18;
	          return (0, _effects.put)({
	            type: _pages3.UPDATE_PAGE_FAILURE,
	            error: _context3.t0
	          });
	
	        case 18:
	          _context3.next = 20;
	          return (0, _effects.put)(_reactReduxToastr.actions.add({
	            type: 'error',
	            title: 'Erreur',
	            message: 'Une erreur est survenue pendant la sauvegarde de la page',
	            options: {
	              timeOut: 3000,
	              showCloseButton: true
	            }
	          }));
	
	        case 20:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this, [[0, 14]]);
	}
	
	function archivePage(_ref5) {
	  var page = _ref5.page;
	  return _regenerator2.default.wrap(function archivePage$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return (0, _effects.call)(Api.archive, page.id);
	
	        case 2:
	          _context4.next = 4;
	          return (0, _effects.put)({
	            type: _pages3.FETCH_PAGES
	          });
	
	        case 4:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked[3], this);
	}
	
	function unarchivePage(_ref6) {
	  var page = _ref6.page;
	  return _regenerator2.default.wrap(function unarchivePage$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.next = 2;
	          return (0, _effects.call)(Api.unarchive, page.id);
	
	        case 2:
	          _context5.next = 4;
	          return (0, _effects.put)({
	            type: _pages3.FETCH_PAGES
	          });
	
	        case 4:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked[4], this);
	}
	
	function root() {
	  return _regenerator2.default.wrap(function root$(_context6) {
	    while (1) {
	      switch (_context6.prev = _context6.next) {
	        case 0:
	          _context6.next = 2;
	          return [(0, _effects.takeLatest)(_pages3.FETCH_PAGES, fetchPages), (0, _effects.takeEvery)(_deployments.DEPLOY_SUCCESS, fetchPages), // Fetch pages on deploy
	          (0, _effects.takeLatest)(_pages3.SAVE_PAGE_SUBMIT, savePage), (0, _effects.takeEvery)(_pages3.UPDATE_PAGE, updatePage), (0, _effects.takeEvery)(_pages3.ARCHIVE_PAGE, archivePage), (0, _effects.takeEvery)(_pages3.UNARCHIVE_PAGE, unarchivePage)];
	
	        case 2:
	        case 'end':
	          return _context6.stop();
	      }
	    }
	  }, _marked[5], this);
	}

/***/ },

/***/ 949:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(58);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = root;
	
	var _effects = __webpack_require__(51);
	
	var _reactReduxToastr = __webpack_require__(280);
	
	var _contents = __webpack_require__(210);
	
	var _pages = __webpack_require__(46);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [showPending, hidePending, root].map(_regenerator2.default.mark);
	
	function showPending() {
	  return _regenerator2.default.wrap(function showPending$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.put)(_reactReduxToastr.actions.add({
	            type: 'light',
	            title: 'Modification en cours',
	            message: 'Des modifications sont en cours sur cette page. N\'oubliez pas d\'enregistrer',
	            options: {
	              timeOut: 0,
	              showCloseButton: false,
	              icon: 'warning',
	              status: 'warning'
	            }
	          }));
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	function hidePending() {
	  return _regenerator2.default.wrap(function hidePending$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.put)(_reactReduxToastr.actions.removeByType('light'));
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}
	
	function root() {
	  return _regenerator2.default.wrap(function root$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return [(0, _effects.takeLatest)([_contents.SERIALIZE_CONTENT, _pages.SERIALIZE_PAGE], showPending), (0, _effects.takeLatest)([_pages.CANCEL_PENDING, _pages.UPDATE_PAGE], hidePending)];
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}

/***/ },

/***/ 950:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterRedux = __webpack_require__(281);
	
	var _reactRouterDom = __webpack_require__(31);
	
	var _reactRedux = __webpack_require__(14);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _Header = __webpack_require__(962);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Navigation = __webpack_require__(963);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	var _PageLoader = __webpack_require__(503);
	
	var _PageLoader2 = _interopRequireDefault(_PageLoader);
	
	var _reactReduxToastr = __webpack_require__(280);
	
	var _reactReduxToastr2 = _interopRequireDefault(_reactReduxToastr);
	
	var _pages = __webpack_require__(46);
	
	var PagesActions = _interopRequireWildcard(_pages);
	
	var _pages2 = __webpack_require__(72);
	
	var _deployments = __webpack_require__(214);
	
	var _catalog = __webpack_require__(213);
	
	var _platforms = __webpack_require__(140);
	
	var _Pages = __webpack_require__(980);
	
	var _Pages2 = _interopRequireDefault(_Pages);
	
	var _Create = __webpack_require__(964);
	
	var _Create2 = _interopRequireDefault(_Create);
	
	var _Edit = __webpack_require__(973);
	
	var _Edit2 = _interopRequireDefault(_Edit);
	
	var _Secure = __webpack_require__(975);
	
	var _Secure2 = _interopRequireDefault(_Secure);
	
	var _Catalog = __webpack_require__(956);
	
	var _Catalog2 = _interopRequireDefault(_Catalog);
	
	var _Deployments = __webpack_require__(961);
	
	var _Deployments2 = _interopRequireDefault(_Deployments);
	
	var _Archives = __webpack_require__(953);
	
	var _Archives2 = _interopRequireDefault(_Archives);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  container: {
	    height: '85%'
	  }
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    isFetching: (0, _pages2.getIsFetching)(state),
	    error: (0, _pages2.getError)(state) || (0, _deployments.getDeploymentError)(state),
	    templates: (0, _catalog.getTemplates)(state),
	    platforms: (0, _platforms.getPlatforms)(state)
	  };
	};
	
	var UNCONFIGURED_PLATFORM_MESSAGE = '\n  La plateforme n\'est actuellement pas configur\xE9e. Veuillez sp\xE9cifier au moins un template\n  et une plateforme cible.\n';
	
	var App = function (_Component) {
	  _inherits(App, _Component);
	
	  function App() {
	    _classCallCheck(this, App);
	
	    return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
	  }
	
	  _createClass(App, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.fetchPages();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          history = _props.history,
	          isFetching = _props.isFetching,
	          error = _props.error,
	          templates = _props.templates,
	          platforms = _props.platforms;
	
	
	      if (isFetching) {
	        return _react2.default.createElement(_PageLoader2.default, null);
	      }
	
	      if (error) {
	        return _react2.default.createElement(_semanticUiReact.Message, {
	          error: true,
	          header: 'Une erreur est survenue',
	          content: error.message || 'Veuillez nous excuser pour les désagréments occasionnés',
	          icon: 'bomb'
	        });
	      }
	
	      if (templates.length === 0 || platforms.length === 0) {
	        return _react2.default.createElement(_semanticUiReact.Message, {
	          header: 'Configuration',
	          content: UNCONFIGURED_PLATFORM_MESSAGE,
	          icon: 'warning'
	        });
	      }
	
	      return _react2.default.createElement(
	        _reactRouterRedux.ConnectedRouter,
	        { history: history },
	        _react2.default.createElement(
	          'div',
	          { style: styles.container },
	          _react2.default.createElement(_Header2.default, null),
	          _react2.default.createElement(_Navigation2.default, null),
	          _react2.default.createElement(
	            _reactRouterDom.Switch,
	            null,
	            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/', render: function render() {
	                return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/pages' });
	              } }),
	            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/pages', component: _Pages2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: '/pages/new', component: _Create2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/pages/:id', component: _Edit2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: '/pages/:id/secure', component: _Secure2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/view', component: _Catalog2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: '/view/:id', component: _Catalog2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: '/deployments', component: _Deployments2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: '/archives', component: _Archives2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, {
	              render: function render() {
	                return _react2.default.createElement(_semanticUiReact.Message, { icon: 'help', header: 'La page demand\xE9e n\'existe pas' });
	              }
	            })
	          ),
	          _react2.default.createElement(_reactReduxToastr2.default, {
	            timeOut: 2000,
	            newestOnTop: false,
	            preventDuplicates: true,
	            position: 'top-right',
	            transitionIn: 'fadeIn',
	            transitionOut: 'fadeOut'
	          })
	        )
	      );
	    }
	  }]);
	
	  return App;
	}(_react.Component);
	
	App.propTypes = {
	  history: __webpack_require__(1).PropTypes.object.isRequired,
	  isFetching: __webpack_require__(1).PropTypes.bool.isRequired,
	  error: __webpack_require__(1).PropTypes.any,
	  templates: __webpack_require__(1).PropTypes.arrayOf(__webpack_require__(1).PropTypes.any).isRequired,
	  platforms: __webpack_require__(1).PropTypes.arrayOf(__webpack_require__(1).PropTypes.any).isRequired,
	  fetchPages: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  fetchPages: PagesActions.fetchPages
	})(App);

/***/ },

/***/ 951:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(31);
	
	var _semanticUiReact = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ArchiveItem = function ArchiveItem(_ref) {
	  var archive = _ref.archive,
	      onUnarchive = _ref.onUnarchive;
	
	  var unarchive = function unarchive() {
	    return onUnarchive(archive);
	  };
	
	  return _react2.default.createElement(
	    _semanticUiReact.Table.Row,
	    null,
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Header,
	        { as: 'h3', textAlign: 'center' },
	        archive.name
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { textAlign: 'center' },
	      _react2.default.createElement(
	        _semanticUiReact.Label,
	        { color: 'green' },
	        archive.template.label
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { textAlign: 'center' },
	      _react2.default.createElement(
	        'div',
	        { className: 'ui tiny buttons' },
	        _react2.default.createElement(
	          _reactRouterDom.Link,
	          {
	            to: '/pages/' + archive.id,
	            target: 'innoctopus',
	            className: 'ui labeled icon button'
	          },
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'edit' }),
	          'Editer'
	        ),
	        _react2.default.createElement(_semanticUiReact.Button, {
	          onClick: unarchive,
	          color: 'green',
	          labelPosition: 'right',
	          content: 'R\xE9activer',
	          icon: 'recycle'
	        })
	      )
	    )
	  );
	};
	
	ArchiveItem.propTypes = {
	  archive: __webpack_require__(1).PropTypes.any.isRequired,
	  onUnarchive: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = ArchiveItem;

/***/ },

/***/ 952:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _ArchiveItem = __webpack_require__(951);
	
	var _ArchiveItem2 = _interopRequireDefault(_ArchiveItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ArchiveList = function ArchiveList(_ref) {
	  var archives = _ref.archives,
	      onUnarchive = _ref.onUnarchive;
	
	  if (archives && archives.size) {
	    return _react2.default.createElement(
	      _semanticUiReact.Segment,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Table,
	        { basic: 'very' },
	        _react2.default.createElement(
	          _semanticUiReact.Table.Header,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Table.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.HeaderCell,
	              { width: 8, textAlign: 'center' },
	              'Nom'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.HeaderCell,
	              { width: 4, textAlign: 'center' },
	              'Type'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.HeaderCell,
	              { width: 4, textAlign: 'center' },
	              'Actions'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Body,
	          null,
	          archives.map(function (a) {
	            return _react2.default.createElement(_ArchiveItem2.default, { key: a.id, archive: a, onUnarchive: onUnarchive });
	          })
	        )
	      )
	    );
	  }
	
	  return _react2.default.createElement(_semanticUiReact.Message, { icon: 'info circle', header: 'Aucune page archiv\xE9e' });
	};
	
	ArchiveList.propTypes = {
	  archives: __webpack_require__(1).PropTypes.any.isRequired,
	  onUnarchive: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = ArchiveList;

/***/ },

/***/ 953:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _pages = __webpack_require__(72);
	
	var _pages2 = __webpack_require__(46);
	
	var PagesActions = _interopRequireWildcard(_pages2);
	
	var _ArchiveList = __webpack_require__(952);
	
	var _ArchiveList2 = _interopRequireDefault(_ArchiveList);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    archives: (0, _pages.getArchivedPages)(state)
	  };
	};
	
	var Archives = function Archives(_ref) {
	  var archives = _ref.archives,
	      unarchive = _ref.unarchive;
	  return _react2.default.createElement(_ArchiveList2.default, { archives: archives, onUnarchive: unarchive });
	};
	
	Archives.propTypes = {
	  archives: __webpack_require__(1).PropTypes.any.isRequired,
	  unarchive: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  unarchive: PagesActions.unarchivePage
	})(Archives);

/***/ },

/***/ 954:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _platforms = __webpack_require__(140);
	
	var _PlatformSelector = __webpack_require__(487);
	
	var _PlatformSelector2 = _interopRequireDefault(_PlatformSelector);
	
	var _platforms2 = __webpack_require__(212);
	
	var PlatformActions = _interopRequireWildcard(_platforms2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    platform: (0, _platforms.getCatalogPlatform)(state),
	    platforms: (0, _platforms.getPlatforms)(state)
	  };
	};
	
	var CatalogMenu = function CatalogMenu(_ref) {
	  var platform = _ref.platform,
	      platforms = _ref.platforms,
	      changePlatform = _ref.changePlatform;
	  return _react2.default.createElement(
	    _semanticUiReact.Menu.Menu,
	    { position: 'right' },
	    _react2.default.createElement(
	      _semanticUiReact.Menu.Item,
	      null,
	      _react2.default.createElement(_PlatformSelector2.default, {
	        value: platform,
	        platforms: platforms,
	        onChange: changePlatform
	      })
	    )
	  );
	};
	
	CatalogMenu.propTypes = {
	  platform: __webpack_require__(1).PropTypes.any.isRequired,
	  platforms: __webpack_require__(1).PropTypes.arrayOf(__webpack_require__(1).PropTypes.any).isRequired,
	  changePlatform: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  changePlatform: PlatformActions.changeCatalogPlatform
	})(CatalogMenu);

/***/ },

/***/ 955:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(31);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _plugin = __webpack_require__(113);
	
	var _PageTemplateLabel = __webpack_require__(306);
	
	var _PageTemplateLabel2 = _interopRequireDefault(_PageTemplateLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  container: {
	    marginTop: '1rem'
	  }
	};
	
	var CatalogPageItem = function CatalogPageItem(_ref) {
	  var page = _ref.page,
	      content = _ref.content,
	      history = _ref.history;
	
	  var renderContent = function renderContent() {
	    var templateContent = (0, _plugin.getViewComponent)(page.template.code, content);
	    if (templateContent) {
	      return templateContent;
	    }
	
	    console.warn('Cannot render content as template type ' + page.template.code + ' is unknown.');
	    return null;
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.container },
	    _react2.default.createElement(
	      _semanticUiReact.Menu,
	      { attached: 'top', borderless: true },
	      !page.isRoot && _react2.default.createElement(
	        _semanticUiReact.Menu.Item,
	        null,
	        _react2.default.createElement(_semanticUiReact.Button, {
	          onClick: history.goBack,
	          labelPosition: 'left',
	          icon: 'chevron circle left',
	          content: 'Revenir'
	        })
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Menu.Item,
	        { header: true },
	        page.name
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Menu.Item,
	        null,
	        _react2.default.createElement(_PageTemplateLabel2.default, { page: page })
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Menu.Menu,
	        { position: 'right' },
	        _react2.default.createElement(
	          _semanticUiReact.Menu.Item,
	          null,
	          _react2.default.createElement(
	            _reactRouterDom.Link,
	            {
	              to: '/pages/' + page.id,
	              target: 'innoctopus',
	              className: 'ui labeled icon button'
	            },
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'edit' }),
	            'Editer'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Segment,
	      { attached: 'bottom' },
	      renderContent()
	    )
	  );
	};
	
	CatalogPageItem.propTypes = {
	  page: __webpack_require__(1).PropTypes.any.isRequired,
	  content: __webpack_require__(1).PropTypes.any.isRequired,
	  history: __webpack_require__(1).PropTypes.object.isRequired
	};
	exports.default = (0, _reactRouterDom.withRouter)(CatalogPageItem);

/***/ },

/***/ 956:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _pages = __webpack_require__(72);
	
	var _contents = __webpack_require__(173);
	
	var _platforms = __webpack_require__(140);
	
	var _CatalogPageItem = __webpack_require__(955);
	
	var _CatalogPageItem2 = _interopRequireDefault(_CatalogPageItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, _ref) {
	  var match = _ref.match;
	
	  var page = match.params.id ? (0, _pages.getPageById)(state, match.params.id) : (0, _pages.getRootPage)(state);
	
	  var content = page && (0, _contents.getContent)(state, page.id, (0, _platforms.getCatalogPlatform)(state));
	
	  return {
	    page: page,
	    content: content || {}
	  };
	};
	
	var Catalog = function Catalog(_ref2) {
	  var page = _ref2.page,
	      content = _ref2.content;
	
	  if (page) {
	    return _react2.default.createElement(_CatalogPageItem2.default, { page: page, content: content });
	  }
	
	  return _react2.default.createElement(_semanticUiReact.Message, {
	    icon: 'clone',
	    attached: true,
	    header: 'Aucune page dans le catalogue',
	    content: "Veuillez commencer à ajouter des pages dans l'onglet Mes Pages"
	  });
	};
	
	Catalog.propTypes = {
	  page: __webpack_require__(1).PropTypes.any,
	  content: __webpack_require__(1).PropTypes.any.isRequired
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Catalog);

/***/ },

/***/ 957:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var displayDate = function displayDate(deployment) {
	  var date = deployment.deployedAt.format('DD/MM/YYYY à HH:mm');
	  if (deployment.inProduction) {
	    return _react2.default.createElement(
	      _semanticUiReact.Header,
	      { as: 'h3' },
	      date
	    );
	  }
	
	  return date;
	};
	
	var displayUser = function displayUser(user) {
	  return user.email;
	};
	
	var DeploymentItem = function DeploymentItem(_ref) {
	  var deployment = _ref.deployment;
	  return _react2.default.createElement(
	    _semanticUiReact.Table.Row,
	    null,
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      deployment.inProduction && _react2.default.createElement(_semanticUiReact.Icon, { name: 'heartbeat', size: 'large', color: 'red', circular: true })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { textAlign: 'center' },
	      displayDate(deployment)
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { textAlign: 'center' },
	      displayUser(deployment.deployedBy)
	    )
	  );
	};
	
	DeploymentItem.propTypes = {
	  deployment: __webpack_require__(1).PropTypes.any.isRequired
	};
	exports.default = DeploymentItem;

/***/ },

/***/ 958:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _DeploymentItem = __webpack_require__(957);
	
	var _DeploymentItem2 = _interopRequireDefault(_DeploymentItem);
	
	var _DeployButton = __webpack_require__(484);
	
	var _DeployButton2 = _interopRequireDefault(_DeployButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeploymentList = function DeploymentList(_ref) {
	  var deployments = _ref.deployments,
	      onDeployed = _ref.onDeployed;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _semanticUiReact.Segment,
	      { color: 'red' },
	      _react2.default.createElement(
	        _semanticUiReact.Grid,
	        { centered: true, columns: 2 },
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { textAlign: 'center' },
	          _react2.default.createElement(_DeployButton2.default, {
	            onDeployed: onDeployed,
	            children: function children(onClick) {
	              return _react2.default.createElement(_semanticUiReact.Button, {
	                onClick: onClick,
	                icon: 'space shuttle',
	                color: 'red',
	                labelPosition: 'left',
	                size: 'big',
	                content: 'D\xE9ployer en production'
	              });
	            }
	          })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Segment,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Table,
	        { basic: 'very' },
	        _react2.default.createElement(
	          _semanticUiReact.Table.Header,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Table.Row,
	            null,
	            _react2.default.createElement(_semanticUiReact.Table.HeaderCell, { width: 2, textAlign: 'center' }),
	            _react2.default.createElement(
	              _semanticUiReact.Table.HeaderCell,
	              { width: 7, textAlign: 'center' },
	              'Date de d\xE9ploiement'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.HeaderCell,
	              { width: 7, textAlign: 'center' },
	              'Utilisateur'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Body,
	          null,
	          deployments.map(function (d) {
	            return _react2.default.createElement(_DeploymentItem2.default, { key: d.version, deployment: d });
	          })
	        )
	      )
	    )
	  );
	};
	
	DeploymentList.propTypes = {
	  deployments: __webpack_require__(1).PropTypes.arrayOf(__webpack_require__(1).PropTypes.any).isRequired,
	  onDeployed: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = DeploymentList;

/***/ },

/***/ 959:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  loader: {
	    minHeight: '140px'
	  }
	};
	
	var DeploymentLoader = function DeploymentLoader() {
	  return _react2.default.createElement(
	    _semanticUiReact.Segment,
	    { style: styles.loader },
	    _react2.default.createElement(
	      _semanticUiReact.Dimmer,
	      { active: true, inverted: true },
	      _react2.default.createElement(_semanticUiReact.Loader, {
	        indeterminate: true,
	        size: 'big',
	        content: 'D\xE9ploiement en production en cours...'
	      })
	    )
	  );
	};
	
	exports.default = DeploymentLoader;

/***/ },

/***/ 960:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _DeployButton = __webpack_require__(484);
	
	var _DeployButton2 = _interopRequireDefault(_DeployButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NoDeployments = function NoDeployments(_ref) {
	  var onDeployed = _ref.onDeployed;
	  return _react2.default.createElement(
	    _semanticUiReact.Segment,
	    null,
	    _react2.default.createElement(
	      _semanticUiReact.Grid,
	      { centered: true, columns: 2 },
	      _react2.default.createElement(
	        _semanticUiReact.Grid.Column,
	        { textAlign: 'center' },
	        _react2.default.createElement(_semanticUiReact.Message, {
	          attached: true,
	          header: 'Aucun d\xE9ploiement actuellement en production',
	          content: 'L\'application est pour le moment inaccessible aux utilisateurs mobiles'
	        }),
	        _react2.default.createElement(
	          _semanticUiReact.Segment,
	          { attached: 'bottom' },
	          _react2.default.createElement(_DeployButton2.default, {
	            onDeployed: onDeployed,
	            children: function children(onClick) {
	              return _react2.default.createElement(_semanticUiReact.Button, {
	                onClick: onClick,
	                icon: 'space shuttle',
	                color: 'red',
	                labelPosition: 'left',
	                size: 'big',
	                content: 'D\xE9ployer en production'
	              });
	            }
	          })
	        )
	      )
	    )
	  );
	};
	
	NoDeployments.propTypes = {
	  onDeployed: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = NoDeployments;

/***/ },

/***/ 961:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _deployments = __webpack_require__(214);
	
	var _deployments2 = __webpack_require__(211);
	
	var DeploymentsActions = _interopRequireWildcard(_deployments2);
	
	var _NoDeployments = __webpack_require__(960);
	
	var _NoDeployments2 = _interopRequireDefault(_NoDeployments);
	
	var _DeploymentLoader = __webpack_require__(959);
	
	var _DeploymentLoader2 = _interopRequireDefault(_DeploymentLoader);
	
	var _DeploymentList = __webpack_require__(958);
	
	var _DeploymentList2 = _interopRequireDefault(_DeploymentList);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  loader: {
	    minHeight: '140px'
	  }
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    isFetching: (0, _deployments.getIsFetching)(state),
	    isFetched: (0, _deployments.getIsFetched)(state),
	    isDeploying: (0, _deployments.getIsDeploying)(state),
	    deployments: (0, _deployments.getDeployments)(state)
	  };
	};
	
	var Deployments = function (_Component) {
	  _inherits(Deployments, _Component);
	
	  function Deployments() {
	    _classCallCheck(this, Deployments);
	
	    return _possibleConstructorReturn(this, (Deployments.__proto__ || Object.getPrototypeOf(Deployments)).apply(this, arguments));
	  }
	
	  _createClass(Deployments, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          isFetched = _props.isFetched,
	          fetchDeployments = _props.fetchDeployments;
	
	
	      if (!isFetched) {
	        fetchDeployments();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          isFetching = _props2.isFetching,
	          isFetched = _props2.isFetched,
	          isDeploying = _props2.isDeploying,
	          deployments = _props2.deployments,
	          deploy = _props2.deploy;
	
	
	      if (isFetching && !isFetched) {
	        return _react2.default.createElement(
	          _semanticUiReact.Segment,
	          { style: styles.loader },
	          _react2.default.createElement(
	            _semanticUiReact.Dimmer,
	            { active: true, inverted: true },
	            _react2.default.createElement(_semanticUiReact.Loader, { inverted: true, content: 'Chargement des d\xE9ploiements' })
	          )
	        );
	      }
	
	      if (isDeploying) {
	        return _react2.default.createElement(_DeploymentLoader2.default, null);
	      }
	
	      if (deployments.length === 0) {
	        return _react2.default.createElement(_NoDeployments2.default, { onDeployed: deploy });
	      }
	
	      return _react2.default.createElement(_DeploymentList2.default, { deployments: deployments, onDeployed: deploy });
	    }
	  }]);
	
	  return Deployments;
	}(_react.Component);
	
	Deployments.propTypes = {
	  isFetching: __webpack_require__(1).PropTypes.bool.isRequired,
	  isFetched: __webpack_require__(1).PropTypes.bool.isRequired,
	  isDeploying: __webpack_require__(1).PropTypes.bool.isRequired,
	  deployments: __webpack_require__(1).PropTypes.arrayOf(__webpack_require__(1).PropTypes.any).isRequired,
	  fetchDeployments: __webpack_require__(1).PropTypes.func.isRequired,
	  deploy: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps, DeploymentsActions)(Deployments);

/***/ },

/***/ 962:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _IconHeader = __webpack_require__(502);
	
	var _IconHeader2 = _interopRequireDefault(_IconHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header() {
	  return _react2.default.createElement(_IconHeader2.default, { icon: 'book', circular: true, title: 'Catalogue' });
	};
	
	exports.default = Header;

/***/ },

/***/ 963:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(31);
	
	var _Menu = __webpack_require__(976);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _Menu3 = __webpack_require__(954);
	
	var _Menu4 = _interopRequireDefault(_Menu3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Navigation = function Navigation() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'ui secondary pointing menu segment actions' },
	    _react2.default.createElement(
	      _reactRouterDom.NavLink,
	      { to: '/pages', activeClassName: 'active', className: 'item link' },
	      'Mes Pages'
	    ),
	    _react2.default.createElement(
	      _reactRouterDom.NavLink,
	      { to: '/view', activeClassName: 'active', className: 'item link' },
	      'Mon Application'
	    ),
	    _react2.default.createElement(
	      _reactRouterDom.NavLink,
	      { to: '/archives', activeClassName: 'active', className: 'item link' },
	      'Mes Archives'
	    ),
	    _react2.default.createElement(
	      _reactRouterDom.NavLink,
	      { to: '/deployments', activeClassName: 'active', className: 'item link' },
	      'Mes D\xE9ploiements'
	    ),
	    _react2.default.createElement(
	      _reactRouterDom.Switch,
	      null,
	      _react2.default.createElement(
	        _reactRouterDom.Route,
	        { exact: true, path: '/pages' },
	        _react2.default.createElement(_Menu2.default, null)
	      ),
	      _react2.default.createElement(
	        _reactRouterDom.Route,
	        { path: '/view' },
	        _react2.default.createElement(_Menu4.default, null)
	      )
	    )
	  );
	};
	
	exports.default = Navigation;

/***/ },

/***/ 964:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(31);
	
	var _reduxFormSubmitSaga = __webpack_require__(438);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _pages = __webpack_require__(46);
	
	var _CreatePageForm = __webpack_require__(485);
	
	var _CreatePageForm2 = _interopRequireDefault(_CreatePageForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var appendRedirectToFormData = function appendRedirectToFormData(data) {
	  return Object.assign({}, data, {
	    redirectOnCreate: true
	  });
	};
	
	var Create = function Create(_ref) {
	  var history = _ref.history,
	      save = _ref.save;
	
	  var cancel = function cancel(evt) {
	    evt.preventDefault();
	    history.goBack();
	  };
	
	  return _react2.default.createElement(
	    _CreatePageForm2.default,
	    {
	      onSubmit: (0, _reduxFormSubmitSaga.onSubmitActions)(_pages.SAVE_PAGE, appendRedirectToFormData)
	    },
	    function (_ref2) {
	      var fields = _ref2.fields,
	          submitting = _ref2.submitting,
	          pristine = _ref2.pristine;
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Segment,
	          null,
	          _react2.default.createElement(_semanticUiReact.Button, {
	            content: 'Retour \xE0 la liste',
	            disabled: submitting,
	            onClick: cancel,
	            basic: true,
	            icon: 'chevron circle left',
	            labelPosition: 'left'
	          }),
	          _react2.default.createElement(_semanticUiReact.Button, {
	            content: 'Enregistrer',
	            disabled: pristine,
	            loading: submitting,
	            primary: true,
	            floated: 'right',
	            icon: 'save',
	            labelPosition: 'left'
	          })
	        ),
	        _react2.default.createElement(_semanticUiReact.Segment, { children: fields })
	      );
	    }
	  );
	};
	
	Create.propTypes = {
	  history: __webpack_require__(1).PropTypes.object.isRequired
	};
	exports.default = (0, _reactRouterDom.withRouter)(Create);

/***/ },

/***/ 965:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getConfirmMessage = function getConfirmMessage() {
	  return _react2.default.createElement(
	    _semanticUiReact.Message,
	    { icon: true },
	    _react2.default.createElement(_semanticUiReact.Icon, { name: 'circle info' }),
	    _react2.default.createElement(
	      _semanticUiReact.Message.Content,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Message.Header,
	        null,
	        'Vous \xEAtes sur le point de modifier le layout de la page'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\n          Les redimensionnements effectu\xE9s sur les images seront perdus et\n          seront remplac\xE9s par les images originales.\n          '
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\xCAtes-vous s\xFBr(e) de vouloir modifier le layout ?'
	      )
	    )
	  );
	};
	
	var ConfirmLayoutChange = function ConfirmLayoutChange(_ref) {
	  var open = _ref.open,
	      loading = _ref.loading,
	      onConfirm = _ref.onConfirm,
	      onClose = _ref.onClose;
	
	  return _react2.default.createElement(
	    _semanticUiReact.Modal,
	    { open: open, onClose: onClose, closeIcon: true, size: 'small' },
	    _react2.default.createElement(_semanticUiReact.Header, { content: 'Modification de layout' }),
	    _react2.default.createElement(
	      _semanticUiReact.Modal.Content,
	      null,
	      getConfirmMessage()
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Modal.Actions,
	      null,
	      _react2.default.createElement(_semanticUiReact.Button, {
	        onClick: onClose,
	        labelPosition: 'left',
	        icon: 'close',
	        content: 'Annuler'
	      }),
	      _react2.default.createElement(_semanticUiReact.Button, {
	        onClick: onConfirm,
	        loading: loading,
	        positive: true,
	        labelPosition: 'right',
	        icon: 'check',
	        content: 'Confirmer'
	      })
	    )
	  );
	};
	
	ConfirmLayoutChange.propTypes = {
	  open: __webpack_require__(1).PropTypes.bool.isRequired,
	  loading: __webpack_require__(1).PropTypes.bool.isRequired,
	  onConfirm: __webpack_require__(1).PropTypes.func.isRequired,
	  onClose: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = ConfirmLayoutChange;

/***/ },

/***/ 966:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getConfirmMessage = function getConfirmMessage(platform) {
	  if (platform) {
	    return _react2.default.createElement(
	      _semanticUiReact.Message,
	      { icon: true },
	      _react2.default.createElement(_semanticUiReact.Icon, { name: 'circle info' }),
	      _react2.default.createElement(
	        _semanticUiReact.Message.Content,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Message.Header,
	          null,
	          'Vous \xEAtes sur le point de cr\xE9er la plateforme ' + platform.label + '.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          '\n            La plateforme par d\xE9fault ne sera plus utilis\xE9e sur cette page\n            et ses donn\xE9es seront remplac\xE9es par celles fournies \xE0 partir de maintenant.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          '\xCAtes-vous s\xFBr(e) de vouloir cr\xE9er la nouvelle plateforme ?'
	        )
	      )
	    );
	  }
	
	  return null;
	};
	
	var ConfirmPlatformChange = function ConfirmPlatformChange(_ref) {
	  var loading = _ref.loading,
	      platform = _ref.platform,
	      onConfirm = _ref.onConfirm,
	      onClose = _ref.onClose;
	
	  return _react2.default.createElement(
	    _semanticUiReact.Modal,
	    { open: !!platform, onClose: onClose, closeIcon: true, size: 'small' },
	    _react2.default.createElement(_semanticUiReact.Header, { content: 'Cr\xE9ation d\'une nouvelle plateforme' }),
	    _react2.default.createElement(
	      _semanticUiReact.Modal.Content,
	      null,
	      getConfirmMessage(platform)
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Modal.Actions,
	      null,
	      _react2.default.createElement(_semanticUiReact.Button, {
	        onClick: onClose,
	        labelPosition: 'left',
	        icon: 'close',
	        content: 'Annuler'
	      }),
	      _react2.default.createElement(_semanticUiReact.Button, {
	        onClick: onConfirm,
	        loading: loading,
	        positive: true,
	        labelPosition: 'right',
	        icon: 'check',
	        content: 'Confirmer'
	      })
	    )
	  );
	};
	
	ConfirmPlatformChange.propTypes = {
	  loading: __webpack_require__(1).PropTypes.bool.isRequired,
	  platform: __webpack_require__(1).PropTypes.any,
	  onConfirm: __webpack_require__(1).PropTypes.func.isRequired,
	  onClose: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = ConfirmPlatformChange;

/***/ },

/***/ 967:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _ConfirmLayoutChange = __webpack_require__(965);
	
	var _ConfirmLayoutChange2 = _interopRequireDefault(_ConfirmLayoutChange);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getLayoutsOptions = function getLayoutsOptions(layouts) {
	  return layouts.map(function (l) {
	    return {
	      value: l.code,
	      text: l.name
	    };
	  });
	};
	
	var LayoutsSelector = function (_Component) {
	  _inherits(LayoutsSelector, _Component);
	
	  function LayoutsSelector(props) {
	    _classCallCheck(this, LayoutsSelector);
	
	    var _this = _possibleConstructorReturn(this, (LayoutsSelector.__proto__ || Object.getPrototypeOf(LayoutsSelector)).call(this, props));
	
	    _this.layoutChanged = function (_, _ref) {
	      var value = _ref.value;
	      var content = _this.props.content;
	
	      var layout = content.layouts.find(function (l) {
	        return l.code === value;
	      });
	
	      if (layout && content.layout.code !== layout.code) {
	        _this.setState({ layout: layout });
	      }
	    };
	
	    _this.cancelChange = function () {
	      return _this.setState({ layout: undefined });
	    };
	
	    _this.confirmChange = function () {
	      var layout = _this.state.layout;
	
	      if (layout) {
	        _this.props.onChange(layout);
	      }
	    };
	
	    _this.state = {
	      isLoading: false
	    };
	    return _this;
	  }
	
	  _createClass(LayoutsSelector, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.isUpdating !== this.props.isUpdating && !nextProps.isUpdating) {
	        this.setState({
	          isLoading: false,
	          layout: undefined
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          content = _props.content,
	          hasUpdate = _props.hasUpdate,
	          isUpdating = _props.isUpdating;
	      var _state = this.state,
	          layout = _state.layout,
	          isLoading = _state.isLoading;
	
	
	      if (content && content.layouts && content.layouts.length) {
	        var currentLayout = layout ? layout.code : content.layout.code;
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_semanticUiReact.Form.Select, {
	            label: 'Mise en page',
	            disabled: hasUpdate || isUpdating,
	            value: currentLayout,
	            options: getLayoutsOptions(content.layouts),
	            onChange: this.layoutChanged
	          }),
	          _react2.default.createElement(_ConfirmLayoutChange2.default, {
	            open: !!layout,
	            loading: isLoading || isUpdating,
	            onClose: this.cancelChange,
	            onConfirm: this.confirmChange
	          })
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return LayoutsSelector;
	}(_react.Component);
	
	LayoutsSelector.propTypes = {
	  content: __webpack_require__(1).PropTypes.any,
	  hasUpdate: __webpack_require__(1).PropTypes.bool.isRequired,
	  isUpdating: __webpack_require__(1).PropTypes.bool.isRequired,
	  onChange: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = LayoutsSelector;

/***/ },

/***/ 968:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PageArchivedWarning = function PageArchivedWarning(_ref) {
	  var visible = _ref.visible;
	
	  if (visible) {
	    return _react2.default.createElement(_semanticUiReact.Message, {
	      error: true,
	      icon: 'warning circle',
	      header: 'Cette page est d\xE9sactiv\xE9e',
	      content: 'Vous pouvez la r\xE9activer via l\'onglet "Mes Archives"'
	    });
	  }
	
	  return null;
	};
	
	PageArchivedWarning.propTypes = {
	  visible: __webpack_require__(1).PropTypes.bool.isRequired
	};
	exports.default = PageArchivedWarning;

/***/ },

/***/ 969:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _LayoutsSelector = __webpack_require__(967);
	
	var _LayoutsSelector2 = _interopRequireDefault(_LayoutsSelector);
	
	var _constants = __webpack_require__(304);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PageForm = function PageForm(_ref) {
	  var page = _ref.page,
	      settings = _ref.settings,
	      content = _ref.content,
	      hasUpdate = _ref.hasUpdate,
	      isUpdating = _ref.isUpdating,
	      onChange = _ref.onChange,
	      onChangeLayout = _ref.onChangeLayout;
	
	  var nameChanged = function nameChanged(event) {
	    if (event.target instanceof HTMLInputElement) {
	      onChange(Object.assign({}, page, {
	        name: event.target.value
	      }));
	    }
	  };
	
	  var networkModeChanged = function networkModeChanged(_, _ref2) {
	    var value = _ref2.value;
	    return onChange(Object.assign({}, page, {
	      networkMode: value
	    }));
	  };
	
	  var securityContextChanged = function securityContextChanged(_, _ref3) {
	    var value = _ref3.value;
	    return onChange(Object.assign({}, page, {
	      securityContext: value
	    }));
	  };
	
	  return _react2.default.createElement(
	    _semanticUiReact.Segment,
	    null,
	    _react2.default.createElement(
	      _semanticUiReact.Form,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Form.Field,
	        null,
	        _react2.default.createElement(
	          'label',
	          null,
	          'Nom'
	        ),
	        _react2.default.createElement('input', { type: 'text', value: page.name, onChange: nameChanged })
	      ),
	      settings.canOverrideNetworkMode && _react2.default.createElement(_semanticUiReact.Form.Select, {
	        label: 'Connectivit\xE9',
	        value: page.networkMode || settings.defaultNetworkMode,
	        options: _constants.NETWORK_MODES,
	        onChange: networkModeChanged
	      }),
	      settings.canOverrideSecurityContext && _react2.default.createElement(_semanticUiReact.Form.Select, {
	        label: 'Contexte d\'authentification',
	        value: page.securityContext || settings.defaultSecurityContext || 'none',
	        options: _constants.SECURITY_CONTEXTS,
	        onChange: securityContextChanged
	      }),
	      _react2.default.createElement(_LayoutsSelector2.default, {
	        content: content,
	        hasUpdate: hasUpdate,
	        isUpdating: isUpdating,
	        onChange: onChangeLayout
	      })
	    )
	  );
	};
	
	PageForm.propTypes = {
	  page: __webpack_require__(1).PropTypes.any.isRequired,
	  settings: __webpack_require__(1).PropTypes.any.isRequired,
	  content: __webpack_require__(1).PropTypes.any,
	  hasUpdate: __webpack_require__(1).PropTypes.bool.isRequired,
	  isUpdating: __webpack_require__(1).PropTypes.bool.isRequired,
	  onChange: __webpack_require__(1).PropTypes.func.isRequired,
	  onChangeLayout: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = PageForm;

/***/ },

/***/ 970:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _reactRouterDom = __webpack_require__(31);
	
	var _PlatformSelector = __webpack_require__(487);
	
	var _PlatformSelector2 = _interopRequireDefault(_PlatformSelector);
	
	var _PageTemplateLabel = __webpack_require__(306);
	
	var _PageTemplateLabel2 = _interopRequireDefault(_PageTemplateLabel);
	
	var _SecurityButton = __webpack_require__(972);
	
	var _SecurityButton2 = _interopRequireDefault(_SecurityButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PageHeader = function PageHeader(_ref) {
	  var page = _ref.page,
	      platform = _ref.platform,
	      platforms = _ref.platforms,
	      isDisabled = _ref.isDisabled,
	      isUpdating = _ref.isUpdating,
	      onUpdate = _ref.onUpdate,
	      onChangePlatform = _ref.onChangePlatform;
	  return _react2.default.createElement(
	    _semanticUiReact.Menu,
	    null,
	    _react2.default.createElement(
	      _semanticUiReact.Menu.Item,
	      null,
	      _react2.default.createElement(
	        _reactRouterDom.Link,
	        { to: '/', className: 'ui basic labeled icon button' },
	        _react2.default.createElement('i', { className: 'chevron circle left icon' }),
	        'Retour \xE0 la liste'
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Menu.Item,
	      { className: 'borderless' },
	      _react2.default.createElement(_PageTemplateLabel2.default, { page: page })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Menu.Menu,
	      { position: 'right' },
	      !page.template.isLocked && _react2.default.createElement(
	        _semanticUiReact.Menu.Item,
	        { className: 'borderless' },
	        _react2.default.createElement(_SecurityButton2.default, { page: page })
	      ),
	      platforms.length > 1 && _react2.default.createElement(
	        _semanticUiReact.Menu.Item,
	        { className: 'borderless' },
	        _react2.default.createElement(_PlatformSelector2.default, {
	          value: platform,
	          platforms: platforms,
	          onChange: onChangePlatform
	        })
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Menu.Item,
	        null,
	        _react2.default.createElement(_semanticUiReact.Button, {
	          onClick: onUpdate,
	          loading: isUpdating,
	          disabled: isDisabled,
	          primary: true,
	          icon: 'save',
	          content: 'Enregistrer',
	          labelPosition: 'right'
	        })
	      )
	    )
	  );
	};
	
	PageHeader.propTypes = {
	  page: __webpack_require__(1).PropTypes.any.isRequired,
	  platform: __webpack_require__(1).PropTypes.any.isRequired,
	  platforms: __webpack_require__(1).PropTypes.arrayOf(__webpack_require__(1).PropTypes.any).isRequired,
	  isDisabled: __webpack_require__(1).PropTypes.bool.isRequired,
	  isUpdating: __webpack_require__(1).PropTypes.bool.isRequired,
	  onUpdate: __webpack_require__(1).PropTypes.func.isRequired,
	  onChangePlatform: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = PageHeader;

/***/ },

/***/ 971:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PageWarnings = function PageWarnings(_ref) {
	  var warnings = _ref.warnings;
	
	  if (warnings && warnings.length) {
	    return _react2.default.createElement(_semanticUiReact.Message, {
	      header: 'Avertissements',
	      icon: 'warning circle',
	      warning: true,
	      list: warnings
	    });
	  }
	
	  return null;
	};
	
	PageWarnings.propTypes = {
	  warnings: __webpack_require__(1).PropTypes.arrayOf(__webpack_require__(1).PropTypes.string).isRequired
	};
	exports.default = PageWarnings;

/***/ },

/***/ 972:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(31);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _plugin = __webpack_require__(113);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var buttonClass = function buttonClass(page) {
	  return (0, _classnames2.default)('ui icon button', {
	    red: (0, _plugin.isPageSecured)(page)
	  });
	};
	
	var iconName = function iconName(page) {
	  return (0, _plugin.isPageSecured)(page) ? 'lock' : 'unlock alternate';
	};
	
	var SecurityButton = function SecurityButton(_ref) {
	  var page = _ref.page;
	  return _react2.default.createElement(_semanticUiReact.Popup, {
	    trigger: _react2.default.createElement(
	      _reactRouterDom.Link,
	      { to: '/pages/' + page.id + '/secure', className: buttonClass(page) },
	      _react2.default.createElement(_semanticUiReact.Icon, { name: iconName(page) })
	    ),
	    content: 'S\xE9curisation de la page'
	  });
	};
	
	SecurityButton.propTypes = {
	  page: __webpack_require__(1).PropTypes.any.isRequired
	};
	exports.default = SecurityButton;

/***/ },

/***/ 973:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _compose = __webpack_require__(436);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _reactRedux = __webpack_require__(14);
	
	var _reactRouterDom = __webpack_require__(31);
	
	var _pages = __webpack_require__(46);
	
	var PagesActions = _interopRequireWildcard(_pages);
	
	var _contents = __webpack_require__(210);
	
	var ContentsActions = _interopRequireWildcard(_contents);
	
	var _platforms = __webpack_require__(212);
	
	var PlatformsActions = _interopRequireWildcard(_platforms);
	
	var _pages2 = __webpack_require__(72);
	
	var _contents2 = __webpack_require__(173);
	
	var _page = __webpack_require__(305);
	
	var _catalog = __webpack_require__(213);
	
	var _platforms2 = __webpack_require__(140);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _PageHeader = __webpack_require__(970);
	
	var _PageHeader2 = _interopRequireDefault(_PageHeader);
	
	var _PageForm = __webpack_require__(969);
	
	var _PageForm2 = _interopRequireDefault(_PageForm);
	
	var _PageWarnings = __webpack_require__(971);
	
	var _PageWarnings2 = _interopRequireDefault(_PageWarnings);
	
	var _ConfirmPlatformChange = __webpack_require__(966);
	
	var _ConfirmPlatformChange2 = _interopRequireDefault(_ConfirmPlatformChange);
	
	var _PageArchivedWarning = __webpack_require__(968);
	
	var _PageArchivedWarning2 = _interopRequireDefault(_PageArchivedWarning);
	
	var _PendingChangesPrompt = __webpack_require__(486);
	
	var _PendingChangesPrompt2 = _interopRequireDefault(_PendingChangesPrompt);
	
	var _plugin = __webpack_require__(113);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  container: {
	    marginTop: '1rem'
	  }
	};
	
	var mapStateToProps = function mapStateToProps(state, _ref) {
	  var id = _ref.match.params.id;
	  return {
	    page: (0, _pages2.getPageById)(state, id),
	    pendingPage: (0, _pages2.getPendingPageById)(state, id),
	    content: (0, _contents2.getCurrentContent)(state, id),
	    pendingContent: (0, _contents2.getPendingContent)(state, id),
	    pendingContents: (0, _contents2.getPendingContents)(state, id),
	    platform: (0, _platforms2.getEditionPlatform)(state),
	    platforms: (0, _platforms2.getPlatforms)(state),
	    settings: (0, _catalog.getSettings)(state),
	    hasUpdate: (0, _pages2.hasContentUpdate)(state, id),
	    isUpdating: (0, _pages2.getIsUpdating)(state),
	    isCreatingContent: (0, _contents2.getIsCreating)(state)
	  };
	};
	
	var Edit = function (_Component) {
	  _inherits(Edit, _Component);
	
	  function Edit(props) {
	    _classCallCheck(this, Edit);
	
	    var _this = _possibleConstructorReturn(this, (Edit.__proto__ || Object.getPrototypeOf(Edit)).call(this, props));
	
	    _this.changePlatform = function (platform) {
	      var _this$props = _this.props,
	          changePlatform = _this$props.changePlatform,
	          pendingContents = _this$props.pendingContents;
	
	      // Checking a pending content already exists for this platform, otherwise requesting confirmation
	
	      if (pendingContents.find(function (c) {
	        return c.platform === platform.code;
	      })) {
	        changePlatform(platform);
	      } else {
	        _this.setState({
	          needPlatformChangeConfirm: platform
	        });
	      }
	    };
	
	    _this.cancelChangePlatform = function () {
	      return _this.setState({ needPlatformChangeConfirm: undefined });
	    };
	
	    _this.confirmPlatformChange = function () {
	      var _this$props2 = _this.props,
	          page = _this$props2.page,
	          createContent = _this$props2.createContent;
	      var needPlatformChangeConfirm = _this.state.needPlatformChangeConfirm;
	
	      // Creating platform content remotely
	
	      createContent(page, needPlatformChangeConfirm);
	    };
	
	    _this.changeLayout = function (layout) {
	      var _this$props3 = _this.props,
	          page = _this$props3.page,
	          content = _this$props3.content,
	          serializeContent = _this$props3.serializeContent,
	          update = _this$props3.update;
	
	      // Serializing content with layout
	
	      serializeContent(Object.assign({}, content, {
	        layout: layout
	      }));
	
	      // The saving page
	      update(page);
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Edit, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var shouldHideModal = nextProps.isCreatingContent !== this.props.isCreatingContent && !nextProps.isCreatingContent;
	
	      // Checking content creation has finished to hide modal
	      if (shouldHideModal) {
	        this.setState({
	          needPlatformChangeConfirm: undefined
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _props = this.props,
	          page = _props.page,
	          content = _props.content,
	          hasUpdate = _props.hasUpdate,
	          cancelPending = _props.cancelPending;
	
	      // Don't forget to clear pending changes when leaving
	
	      if (hasUpdate) {
	        cancelPending(page, content);
	      }
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      var _props2 = this.props,
	          page = _props2.page,
	          pendingContent = _props2.pendingContent,
	          serializeContent = _props2.serializeContent;
	
	
	      var templateContent = (0, _plugin.getEditComponent)(page.template.code, pendingContent);
	      if (templateContent) {
	        return _react2.default.cloneElement(templateContent, {
	          onSerialize: serializeContent
	        });
	      }
	
	      console.warn('Cannot render content as template type ' + page.template.code + ' is unknown.');
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          page = _props3.page,
	          pendingPage = _props3.pendingPage,
	          pendingContent = _props3.pendingContent,
	          platform = _props3.platform,
	          platforms = _props3.platforms,
	          settings = _props3.settings,
	          hasUpdate = _props3.hasUpdate,
	          isUpdating = _props3.isUpdating,
	          isCreatingContent = _props3.isCreatingContent,
	          serialize = _props3.serialize,
	          update = _props3.update;
	      var needPlatformChangeConfirm = this.state.needPlatformChangeConfirm;
	
	
	      if (page) {
	        var updatePage = function updatePage() {
	          return update(page);
	        };
	
	        return _react2.default.createElement(
	          'div',
	          { style: styles.container },
	          _react2.default.createElement(_PageHeader2.default, {
	            page: page,
	            platform: platform,
	            platforms: platforms,
	            isDisabled: isCreatingContent || !hasUpdate,
	            isUpdating: isUpdating,
	            onUpdate: updatePage,
	            onChangePlatform: this.changePlatform
	          }),
	          _react2.default.createElement(_PageForm2.default, {
	            page: pendingPage,
	            content: pendingContent,
	            hasUpdate: hasUpdate,
	            isUpdating: isUpdating,
	            settings: settings,
	            onChange: serialize,
	            onChangeLayout: this.changeLayout
	          }),
	          _react2.default.createElement(_PageArchivedWarning2.default, { visible: page.isArchived }),
	          _react2.default.createElement(_PageWarnings2.default, { warnings: (0, _page.getPageWarnings)(page, pendingContent) }),
	          this.renderContent(),
	          _react2.default.createElement(_ConfirmPlatformChange2.default, {
	            loading: isCreatingContent,
	            platform: needPlatformChangeConfirm,
	            onConfirm: this.confirmPlatformChange,
	            onClose: this.cancelChangePlatform
	          }),
	          _react2.default.createElement(_PendingChangesPrompt2.default, { visible: hasUpdate })
	        );
	      }
	
	      return _react2.default.createElement(_semanticUiReact.Message, {
	        attached: 'bottom',
	        icon: 'help',
	        header: 'La page demand\xE9e n\'existe pas'
	      });
	    }
	  }]);
	
	  return Edit;
	}(_react.Component);
	
	Edit.propTypes = {
	  page: __webpack_require__(1).PropTypes.any,
	  pendingPage: __webpack_require__(1).PropTypes.any,
	  content: __webpack_require__(1).PropTypes.any,
	  pendingContent: __webpack_require__(1).PropTypes.any,
	  pendingContents: __webpack_require__(1).PropTypes.any.isRequired,
	  platform: __webpack_require__(1).PropTypes.any.isRequired,
	  platforms: __webpack_require__(1).PropTypes.arrayOf(__webpack_require__(1).PropTypes.any).isRequired,
	  settings: __webpack_require__(1).PropTypes.any.isRequired,
	  hasUpdate: __webpack_require__(1).PropTypes.bool.isRequired,
	  isUpdating: __webpack_require__(1).PropTypes.bool.isRequired,
	  isCreatingContent: __webpack_require__(1).PropTypes.bool.isRequired,
	  serialize: __webpack_require__(1).PropTypes.func.isRequired,
	  serializeContent: __webpack_require__(1).PropTypes.func.isRequired,
	  cancelPending: __webpack_require__(1).PropTypes.func.isRequired,
	  update: __webpack_require__(1).PropTypes.func.isRequired,
	  changePlatform: __webpack_require__(1).PropTypes.func.isRequired,
	  createContent: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = (0, _compose2.default)((0, _reactRedux.connect)(mapStateToProps, {
	  serialize: PagesActions.serializePage,
	  serializeContent: ContentsActions.serializeContent,
	  cancelPending: PagesActions.cancelPending,
	  update: PagesActions.updatePage,
	  changePlatform: PlatformsActions.changeEditionPlatform,
	  createContent: ContentsActions.createContent
	}), _reactRouterDom.withRouter)(Edit);

/***/ },

/***/ 974:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _reactRouterDom = __webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  menu: {
	    height: '66px'
	  }
	};
	
	var SecureHeader = function SecureHeader(_ref) {
	  var page = _ref.page,
	      hasUpdate = _ref.hasUpdate,
	      isUpdating = _ref.isUpdating,
	      onConfirm = _ref.onConfirm;
	  return _react2.default.createElement(
	    _semanticUiReact.Menu,
	    { style: styles.menu },
	    _react2.default.createElement(
	      _semanticUiReact.Menu.Item,
	      null,
	      _react2.default.createElement(
	        _reactRouterDom.Link,
	        { to: '/pages/' + page.id, className: 'ui labeled icon button' },
	        _react2.default.createElement('i', { className: 'chevron circle left icon' }),
	        'Retour \xE0 la page'
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Menu.Item,
	      { header: true, className: 'borderless' },
	      page.name
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Menu.Menu,
	      { position: 'right' },
	      _react2.default.createElement(
	        _semanticUiReact.Menu.Item,
	        null,
	        _react2.default.createElement(_semanticUiReact.Button, {
	          onClick: onConfirm,
	          loading: isUpdating,
	          disabled: !hasUpdate,
	          primary: true,
	          icon: 'save',
	          content: 'Enregistrer',
	          labelPosition: 'right'
	        })
	      )
	    )
	  );
	};
	
	SecureHeader.propTypes = {
	  page: __webpack_require__(1).PropTypes.any.isRequired,
	  hasUpdate: __webpack_require__(1).PropTypes.bool.isRequired,
	  isUpdating: __webpack_require__(1).PropTypes.bool.isRequired,
	  onConfirm: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = SecureHeader;

/***/ },

/***/ 975:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _compose = __webpack_require__(436);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _reactRedux = __webpack_require__(14);
	
	var _reactRouterDom = __webpack_require__(31);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _pages = __webpack_require__(72);
	
	var _pages2 = __webpack_require__(46);
	
	var PagesActions = _interopRequireWildcard(_pages2);
	
	var _plugin = __webpack_require__(113);
	
	var _SecureHeader = __webpack_require__(974);
	
	var _SecureHeader2 = _interopRequireDefault(_SecureHeader);
	
	var _PendingChangesPrompt = __webpack_require__(486);
	
	var _PendingChangesPrompt2 = _interopRequireDefault(_PendingChangesPrompt);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  container: {
	    marginTop: '1rem'
	  }
	};
	
	var mapStateToProps = function mapStateToProps(state, _ref) {
	  var id = _ref.match.params.id;
	  return {
	    page: (0, _pages.getPageById)(state, id),
	    pendingPage: (0, _pages.getPendingPageById)(state, id),
	    isUpdating: (0, _pages.getIsUpdating)(state),
	    hasUpdate: (0, _pages.hasContentUpdate)(state, id)
	  };
	};
	
	var Secure = function (_Component) {
	  _inherits(Secure, _Component);
	
	  function Secure() {
	    _classCallCheck(this, Secure);
	
	    return _possibleConstructorReturn(this, (Secure.__proto__ || Object.getPrototypeOf(Secure)).apply(this, arguments));
	  }
	
	  _createClass(Secure, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _props = this.props,
	          page = _props.page,
	          hasUpdate = _props.hasUpdate,
	          cancelPending = _props.cancelPending;
	
	      // Don't forget to clear pending changes when leaving
	
	      if (hasUpdate) {
	        cancelPending(page);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          page = _props2.page,
	          pendingPage = _props2.pendingPage,
	          isUpdating = _props2.isUpdating,
	          hasUpdate = _props2.hasUpdate,
	          serialize = _props2.serialize,
	          update = _props2.update;
	
	
	      if (page) {
	        var serializeSecurity = function serializeSecurity(security) {
	          return serialize(Object.assign({}, pendingPage, {
	            security: security
	          }));
	        };
	
	        var renderContent = function renderContent() {
	          var component = (0, _plugin.getSecurityComponent)(pendingPage);
	          if (component) {
	            return _react2.default.cloneElement(component, {
	              onUpdate: serializeSecurity
	            });
	          }
	
	          return _react2.default.createElement(_semanticUiReact.Message, {
	            icon: 'info',
	            header: 'Aucun contexte de s\xE9curit\xE9',
	            content: 'Le contexte de s\xE9curit\xE9 n\'est pas configurable sur cette page'
	          });
	        };
	
	        var confirm = function confirm() {
	          return update(page);
	        };
	
	        return _react2.default.createElement(
	          'div',
	          { style: styles.container },
	          _react2.default.createElement(_SecureHeader2.default, {
	            page: page,
	            hasUpdate: hasUpdate,
	            isUpdating: isUpdating,
	            onConfirm: confirm
	          }),
	          renderContent(),
	          _react2.default.createElement(_PendingChangesPrompt2.default, { visible: hasUpdate })
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return Secure;
	}(_react.Component);
	
	Secure.propTypes = {
	  page: __webpack_require__(1).PropTypes.any,
	  pendingPage: __webpack_require__(1).PropTypes.any,
	  isUpdating: __webpack_require__(1).PropTypes.bool.isRequired,
	  hasUpdate: __webpack_require__(1).PropTypes.bool.isRequired,
	  serialize: __webpack_require__(1).PropTypes.func.isRequired,
	  cancelPending: __webpack_require__(1).PropTypes.func.isRequired,
	  update: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = (0, _compose2.default)((0, _reactRedux.connect)(mapStateToProps, {
	  serialize: PagesActions.serializePage,
	  update: PagesActions.updatePage,
	  cancelPending: PagesActions.cancelPending
	}), _reactRouterDom.withRouter)(Secure);

/***/ },

/***/ 976:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _reactRouterDom = __webpack_require__(31);
	
	var _pages = __webpack_require__(46);
	
	var PageActions = _interopRequireWildcard(_pages);
	
	var _pages2 = __webpack_require__(72);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    currentFilter: (0, _pages2.getFilter)(state),
	    pages: (0, _pages2.getAllPages)(state)
	  };
	};
	
	var PagesMenu = function PagesMenu(_ref) {
	  var currentFilter = _ref.currentFilter,
	      pages = _ref.pages,
	      onFilter = _ref.onFilter;
	
	  var filter = function filter(event) {
	    onFilter(event.target.value);
	  };
	
	  return _react2.default.createElement(
	    _semanticUiReact.Menu.Menu,
	    { position: 'right' },
	    _react2.default.createElement(
	      _semanticUiReact.Menu.Item,
	      { className: 'borderless' },
	      _react2.default.createElement(
	        _semanticUiReact.Form,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Form.Field,
	          null,
	          _react2.default.createElement(_semanticUiReact.Input, {
	            placeholder: 'Rechercher...',
	            icon: 'search',
	            iconPosition: 'left',
	            value: currentFilter,
	            onChange: filter
	          })
	        )
	      )
	    ),
	    (pages.size > 0 || currentFilter.length > 0) && _react2.default.createElement(
	      _semanticUiReact.Menu.Item,
	      null,
	      _react2.default.createElement(
	        _reactRouterDom.Link,
	        { to: '/pages/new', className: 'ui primary labeled icon button' },
	        _react2.default.createElement(_semanticUiReact.Icon, { name: 'add' }),
	        'Ajouter'
	      )
	    )
	  );
	};
	
	PagesMenu.propTypes = {
	  currentFilter: __webpack_require__(1).PropTypes.string.isRequired,
	  pages: __webpack_require__(1).PropTypes.any.isRequired,
	  onFilter: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  onFilter: PageActions.filterPages
	})(PagesMenu);

/***/ },

/***/ 977:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _reactRouterDom = __webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NoPages = function NoPages() {
	  return _react2.default.createElement(
	    _semanticUiReact.Segment,
	    null,
	    _react2.default.createElement(
	      _semanticUiReact.Grid,
	      { centered: true, columns: 3 },
	      _react2.default.createElement(
	        _semanticUiReact.Grid.Column,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Message,
	          { icon: true, attached: true },
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'home' }),
	          _react2.default.createElement(
	            _semanticUiReact.Message.Content,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Message.Header,
	              null,
	              'Aucune page d\'accueil dans le catalogue'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Segment,
	          { attached: 'bottom' },
	          _react2.default.createElement(
	            _reactRouterDom.Link,
	            {
	              to: { pathname: '/pages/new', query: { root: true } },
	              className: 'ui fluid primary button'
	            },
	            'Cr\xE9er une page d\'accueil'
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = NoPages;

/***/ },

/***/ 978:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NoResult = function NoResult() {
	  return _react2.default.createElement(_semanticUiReact.Message, {
	    icon: 'unlinkify',
	    header: 'Aucun r\xE9sultat',
	    content: 'Aucune page ne correspond aux crit\xE8res de votre recherche'
	  });
	};
	
	exports.default = NoResult;

/***/ },

/***/ 979:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _reactVirtualized = __webpack_require__(1867);
	
	var _reactRouterDom = __webpack_require__(31);
	
	var _plugin = __webpack_require__(113);
	
	var _page = __webpack_require__(305);
	
	var _ConfirmDeleteButton = __webpack_require__(315);
	
	var _ConfirmDeleteButton2 = _interopRequireDefault(_ConfirmDeleteButton);
	
	var _PageTemplateLabel = __webpack_require__(306);
	
	var _PageTemplateLabel2 = _interopRequireDefault(_PageTemplateLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ROW_HEIGHT = 55;
	var HEADER_HEIGHT = 40;
	
	// TODO: Allow grouping them in virtual folders
	var PageList = function PageList(_ref) {
	  var pages = _ref.pages,
	      history = _ref.history,
	      onArchivePage = _ref.onArchivePage;
	
	  var modalDeleteContent = '\n    \xCAtes-vous s\xFBr(e) de vouloir d\xE9sactiver cette page ?\n    Elle disparaitra de l\'arborescence mais restera disponible via l\'onglet "Mes Archives"\n  ';
	
	  var navigateToPage = function navigateToPage(_ref2) {
	    var rowData = _ref2.rowData;
	    return history.push('/pages/' + rowData.id);
	  };
	
	  var getRow = function getRow(_ref3) {
	    var index = _ref3.index;
	    return pages.get(index);
	  };
	
	  var computeListHeight = function computeListHeight(rowCount, rowHeight, height) {
	    return Math.min((rowCount + 1) * rowHeight + 15, height);
	  };
	
	  var renderRootColumn = function renderRootColumn(_ref4) {
	    var cellData = _ref4.cellData;
	    return cellData && _react2.default.createElement(_semanticUiReact.Icon, { name: 'home', size: 'large', circular: true });
	  };
	
	  var renderSecurityColumn = function renderSecurityColumn(_ref5) {
	    var rowData = _ref5.rowData;
	
	    if ((0, _plugin.isPageSecured)(rowData)) {
	      return _react2.default.createElement(
	        _semanticUiReact.Label,
	        { color: 'red' },
	        'Activ\xE9e'
	      );
	    }
	    return _react2.default.createElement(
	      _semanticUiReact.Label,
	      null,
	      'Inactive'
	    );
	  };
	
	  var renderTemplateColumn = function renderTemplateColumn(_ref6) {
	    var rowData = _ref6.rowData;
	    return _react2.default.createElement(_PageTemplateLabel2.default, { page: rowData });
	  };
	  var renderNameColumn = function renderNameColumn(_ref7) {
	    var cellData = _ref7.cellData;
	    return _react2.default.createElement(
	      _semanticUiReact.Header,
	      { as: 'h3', textAlign: 'center' },
	      cellData
	    );
	  };
	  var getRowStyle = function getRowStyle(_ref8) {
	    var index = _ref8.index;
	    return index + 1 < pages.size && { borderBottom: '1px solid rgba(0,0,0,.1)' };
	  };
	
	  var renderActionsColumn = function renderActionsColumn(_ref9) {
	    var rowData = _ref9.rowData;
	
	    var archive = function archive() {
	      return onArchivePage(rowData);
	    };
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'ui tiny buttons' },
	      !(0, _page.isPageLocked)(rowData) && _react2.default.createElement(_ConfirmDeleteButton2.default, {
	        content: 'Archiver',
	        icon: _react2.default.createElement(_semanticUiReact.Icon, { name: 'archive' }),
	        className: 'red right labeled icon',
	        modalTitle: 'D\xE9sactivation',
	        modalContent: modalDeleteContent,
	        onConfirm: archive
	      })
	    );
	  };
	
	  var catalogPageListColumns = function catalogPageListColumns(width) {
	    var columnWidth = function columnWidth(_columnWidth) {
	      return width / 16 * _columnWidth;
	    };
	
	    return [_react2.default.createElement(_reactVirtualized.Column, {
	      key: 'root',
	      dataKey: 'isRoot',
	      width: columnWidth(1),
	      headerClassName: 'centered',
	      cellRenderer: renderRootColumn,
	      style: { textAlign: 'center' }
	    }), _react2.default.createElement(_reactVirtualized.Column, {
	      key: 'name',
	      label: 'Nom',
	      dataKey: 'name',
	      width: columnWidth(6),
	      headerClassName: 'centered',
	      cellRenderer: renderNameColumn,
	      style: { textAlign: 'center' }
	    }), _react2.default.createElement(_reactVirtualized.Column, {
	      key: 'security',
	      label: 'Securit\xE9',
	      dataKey: 'security',
	      width: columnWidth(3),
	      headerClassName: 'centered',
	      cellRenderer: renderSecurityColumn,
	      style: { textAlign: 'center' }
	    }), _react2.default.createElement(_reactVirtualized.Column, {
	      key: 'template',
	      label: 'Type',
	      dataKey: 'template',
	      width: columnWidth(3),
	      headerClassName: 'centered',
	      cellRenderer: renderTemplateColumn,
	      style: { textAlign: 'center' }
	    }), _react2.default.createElement(_reactVirtualized.Column, {
	      key: 'act',
	      label: 'Actions',
	      dataKey: 'actions',
	      width: columnWidth(4),
	      headerClassName: 'centered',
	      cellRenderer: renderActionsColumn,
	      style: { textAlign: 'center' }
	    })];
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: { height: '100%' } },
	    _react2.default.createElement(
	      _reactVirtualized.AutoSizer,
	      null,
	      function (_ref10) {
	        var width = _ref10.width,
	            height = _ref10.height;
	        return _react2.default.createElement(
	          _semanticUiReact.Segment,
	          {
	            style: {
	              width: width,
	              height: computeListHeight(pages.size, ROW_HEIGHT, height)
	            }
	          },
	          _react2.default.createElement(
	            _reactVirtualized.AutoSizer,
	            null,
	            function (segmentDimentions) {
	              return _react2.default.createElement(
	                _reactVirtualized.Table,
	                {
	                  ref: 'Table',
	                  width: segmentDimentions.width,
	                  height: computeListHeight(pages.size, ROW_HEIGHT, segmentDimentions.height),
	                  rowHeight: ROW_HEIGHT,
	                  headerHeight: HEADER_HEIGHT,
	                  rowCount: pages.size,
	                  rowGetter: getRow,
	                  onRowClick: navigateToPage,
	                  headerStyle: { textAlign: 'center' },
	                  rowStyle: getRowStyle
	                },
	                catalogPageListColumns(segmentDimentions.width)
	              );
	            }
	          )
	        );
	      }
	    )
	  );
	};
	
	PageList.propTypes = {
	  pages: __webpack_require__(1).PropTypes.any.isRequired,
	  history: __webpack_require__(1).PropTypes.object.isRequired,
	  onArchivePage: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = (0, _reactRouterDom.withRouter)(PageList);

/***/ },

/***/ 980:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _pages = __webpack_require__(46);
	
	var PagesActions = _interopRequireWildcard(_pages);
	
	var _pages2 = __webpack_require__(72);
	
	var _PageList = __webpack_require__(979);
	
	var _PageList2 = _interopRequireDefault(_PageList);
	
	var _NoPages = __webpack_require__(977);
	
	var _NoPages2 = _interopRequireDefault(_NoPages);
	
	var _NoResult = __webpack_require__(978);
	
	var _NoResult2 = _interopRequireDefault(_NoResult);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    pages: (0, _pages2.getAllPages)(state),
	    currentFilter: (0, _pages2.getFilter)(state)
	  };
	};
	
	var hasRootPages = function hasRootPages(pages) {
	  return pages && pages.filter(function (p) {
	    return p.isRoot;
	  }).size > 0;
	};
	var isFiltering = function isFiltering(filter) {
	  return filter && filter.length > 0;
	};
	
	var Pages = function Pages(_ref) {
	  var pages = _ref.pages,
	      currentFilter = _ref.currentFilter,
	      archivePage = _ref.archivePage;
	
	  if (isFiltering(currentFilter) && pages.size === 0) {
	    return _react2.default.createElement(_NoResult2.default, null);
	  }
	
	  if (hasRootPages(pages) || isFiltering(currentFilter)) {
	    return _react2.default.createElement(_PageList2.default, {
	      pages: pages,
	      filter: currentFilter,
	      onArchivePage: archivePage
	    });
	  }
	
	  return _react2.default.createElement(_NoPages2.default, null);
	};
	
	Pages.propTypes = {
	  pages: __webpack_require__(1).PropTypes.any.isRequired,
	  currentFilter: __webpack_require__(1).PropTypes.string,
	  archivePage: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  archivePage: PagesActions.archivePage
	})(Pages);

/***/ },

/***/ 981:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _reduxFormSubmitSaga = __webpack_require__(438);
	
	var _pages = __webpack_require__(46);
	
	var _CreatePageForm = __webpack_require__(485);
	
	var _CreatePageForm2 = _interopRequireDefault(_CreatePageForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  content: {
	    display: 'block',
	    width: '100%',
	    fontSize: '1em',
	    lineHeight: '1.4',
	    padding: '1.5rem',
	    background: '#fff'
	  },
	  actions: {
	    background: '#f9fafb',
	    padding: '1rem 1rem',
	    borderTop: '1px solid rgba(34,36,38,.15)',
	    textAlign: 'right',
	    borderBottomLeftRadius: '.28571429rem',
	    borderBottomRightRadius: '.28571429rem'
	  },
	  submit: {
	    marginLeft: '.75em',
	    marginBottom: '1rem'
	  }
	}; /* flow */
	
	var CreatePageModal = function CreatePageModal(_ref) {
	  var visible = _ref.visible,
	      onClose = _ref.onClose,
	      onSelected = _ref.onSelected,
	      onSwitchMode = _ref.onSwitchMode;
	
	  var submit = function submit(values, dispatch) {
	    return (0, _reduxFormSubmitSaga.onSubmitActions)(_pages.SAVE_PAGE)(values, dispatch).then(onSelected);
	  };
	
	  return _react2.default.createElement(
	    _semanticUiReact.Modal,
	    { open: visible, onClose: onClose, closeIcon: true },
	    _react2.default.createElement(
	      _semanticUiReact.Modal.Header,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Grid,
	        { columns: 2 },
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Header,
	            null,
	            'Cr\xE9ation de page'
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          null,
	          _react2.default.createElement(_semanticUiReact.Button, {
	            onClick: onSwitchMode,
	            floated: 'right',
	            labelPosition: 'left',
	            icon: 'close',
	            content: 'Annuler la cr\xE9ation'
	          })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _CreatePageForm2.default,
	      { onSubmit: submit },
	      function (_ref2) {
	        var fields = _ref2.fields,
	            submitting = _ref2.submitting,
	            pristine = _ref2.pristine;
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Modal.Content,
	            { style: styles.content },
	            fields
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Modal.Actions,
	            { style: styles.actions },
	            _react2.default.createElement(_semanticUiReact.Button, {
	              style: styles.submit,
	              content: 'Enregistrer et s\xE9lectionner',
	              disabled: pristine,
	              loading: submitting,
	              primary: true,
	              floated: 'right',
	              icon: 'save',
	              labelPosition: 'left'
	            })
	          )
	        );
	      }
	    )
	  );
	};
	
	CreatePageModal.propTypes = {
	  visible: __webpack_require__(1).PropTypes.bool.isRequired,
	  onSelected: __webpack_require__(1).PropTypes.func.isRequired,
	  onSwitchMode: __webpack_require__(1).PropTypes.func.isRequired,
	  onClose: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = CreatePageModal;

/***/ },

/***/ 982:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _constants = __webpack_require__(304);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NetworkModeSelector = function NetworkModeSelector(_ref) {
	  var canOverride = _ref.canOverride,
	      input = _ref.input,
	      _ref$meta = _ref.meta,
	      touched = _ref$meta.touched,
	      error = _ref$meta.error,
	      label = _ref.label;
	
	  var modeChanged = function modeChanged(_, _ref2) {
	    var value = _ref2.value;
	    return input.onChange(value);
	  };
	
	  if (canOverride) {
	    return _react2.default.createElement(_semanticUiReact.Form.Select, Object.assign({}, input, {
	      error: touched && error,
	      label: label,
	      onChange: modeChanged,
	      options: _constants.NETWORK_MODES,
	      placeholder: 'S\xE9lectionnez un mode de connectivit\xE9'
	    }));
	  }
	
	  return null;
	};
	
	NetworkModeSelector.propTypes = {
	  canOverride: __webpack_require__(1).PropTypes.bool.isRequired,
	  input: __webpack_require__(1).PropTypes.object.isRequired,
	  meta: __webpack_require__(1).PropTypes.object.isRequired,
	  label: __webpack_require__(1).PropTypes.any.isRequired
	};
	exports.default = NetworkModeSelector;

/***/ },

/***/ 983:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _pages = __webpack_require__(72);
	
	var _SelectPageModal = __webpack_require__(985);
	
	var _SelectPageModal2 = _interopRequireDefault(_SelectPageModal);
	
	var _CreatePageModal = __webpack_require__(981);
	
	var _CreatePageModal2 = _interopRequireDefault(_CreatePageModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    pages: (0, _pages.getAllPages)(state)
	  };
	};
	
	var PageSelector = function (_Component) {
	  _inherits(PageSelector, _Component);
	
	  function PageSelector(props) {
	    _classCallCheck(this, PageSelector);
	
	    var _this = _possibleConstructorReturn(this, (PageSelector.__proto__ || Object.getPrototypeOf(PageSelector)).call(this, props));
	
	    _this.toggleAddMode = function () {
	      return _this.setState(function (state) {
	        return { addMode: !state.addMode };
	      });
	    };
	
	    _this.close = function () {
	      _this.setState({
	        addMode: false
	      }, _this.props.onCancel);
	    };
	
	    _this.state = {
	      addMode: false
	    };
	    return _this;
	  }
	
	  _createClass(PageSelector, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          visible = _props.visible,
	          pages = _props.pages,
	          onSelected = _props.onSelected;
	      var addMode = this.state.addMode;
	
	
	      if (addMode) {
	        return _react2.default.createElement(_CreatePageModal2.default, {
	          visible: visible,
	          onClose: this.close,
	          onSelected: onSelected,
	          onSwitchMode: this.toggleAddMode
	        });
	      } else {
	        return _react2.default.createElement(_SelectPageModal2.default, {
	          visible: visible,
	          pages: pages,
	          onClose: this.close,
	          onSelected: onSelected,
	          onSwitchMode: this.toggleAddMode
	        });
	      }
	    }
	  }]);
	
	  return PageSelector;
	}(_react.Component);
	
	PageSelector.propTypes = {
	  visible: __webpack_require__(1).PropTypes.bool.isRequired,
	  pages: __webpack_require__(1).PropTypes.any.isRequired,
	  onSelected: __webpack_require__(1).PropTypes.func.isRequired,
	  onCancel: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(PageSelector);

/***/ },

/***/ 984:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _constants = __webpack_require__(304);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SecurityContextSelector = function SecurityContextSelector(_ref) {
	  var canOverride = _ref.canOverride,
	      input = _ref.input,
	      _ref$meta = _ref.meta,
	      touched = _ref$meta.touched,
	      error = _ref$meta.error,
	      label = _ref.label;
	
	  var contextChanged = function contextChanged(_, _ref2) {
	    var value = _ref2.value;
	    return input.onChange(value);
	  };
	
	  if (canOverride) {
	    return _react2.default.createElement(_semanticUiReact.Form.Select, Object.assign({}, input, {
	      error: touched && error,
	      label: label,
	      onChange: contextChanged,
	      options: _constants.SECURITY_CONTEXTS,
	      placeholder: 'S\xE9lectionnez un contexte d\'authentification'
	    }));
	  }
	
	  return null;
	};
	
	SecurityContextSelector.propTypes = {
	  canOverride: __webpack_require__(1).PropTypes.bool.isRequired,
	  input: __webpack_require__(1).PropTypes.object.isRequired,
	  meta: __webpack_require__(1).PropTypes.object.isRequired,
	  label: __webpack_require__(1).PropTypes.any.isRequired
	};
	exports.default = SecurityContextSelector;

/***/ },

/***/ 985:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _reactVirtualizedSelect = __webpack_require__(716);
	
	var _reactVirtualizedSelect2 = _interopRequireDefault(_reactVirtualizedSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pagesToOptions = function pagesToOptions(pages) {
	  return pages.filter(function (p) {
	    return !p.template.isLocked;
	  }).map(function (p) {
	    return {
	      label: p.name,
	      value: p.id
	    };
	  }).toArray();
	};
	
	var SelectPageModal = function SelectPageModal(_ref) {
	  var visible = _ref.visible,
	      pages = _ref.pages,
	      onClose = _ref.onClose,
	      onSwitchMode = _ref.onSwitchMode,
	      onSelected = _ref.onSelected;
	
	  var options = pagesToOptions(pages);
	
	  var selectPage = function selectPage(_ref2) {
	    var value = _ref2.value;
	    return onSelected(pages.find(function (p) {
	      return p.id === value;
	    }));
	  };
	
	  return _react2.default.createElement(
	    _semanticUiReact.Modal,
	    { open: visible, onClose: onClose, closeIcon: true },
	    _react2.default.createElement(
	      _semanticUiReact.Modal.Header,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Grid,
	        { columns: 2 },
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Header,
	            null,
	            'S\xE9lection de page'
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          null,
	          _react2.default.createElement(_semanticUiReact.Button, {
	            onClick: onSwitchMode,
	            floated: 'right',
	            primary: true,
	            labelPosition: 'left',
	            icon: 'add',
	            content: 'Cr\xE9er une page'
	          })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Modal.Content,
	      null,
	      options.length > 0 && _react2.default.createElement(_reactVirtualizedSelect2.default, {
	        options: options,
	        placeholder: 'S\xE9lectionnez une page',
	        noResultsText: 'Aucune page ne correspond aux crit\xE8res de recherche',
	        onChange: selectPage
	      }),
	      options.length === 0 && _react2.default.createElement(_semanticUiReact.Message, {
	        icon: 'info',
	        content: 'Aucune page disponible. Veuillez en cr\xE9er au moins une'
	      })
	    )
	  );
	};
	
	SelectPageModal.propTypes = {
	  visible: __webpack_require__(1).PropTypes.bool.isRequired,
	  pages: __webpack_require__(1).PropTypes.any.isRequired,
	  onSelected: __webpack_require__(1).PropTypes.func.isRequired,
	  onSwitchMode: __webpack_require__(1).PropTypes.func.isRequired,
	  onClose: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = SelectPageModal;

/***/ },

/***/ 986:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var templateValues = function templateValues(templates) {
	  return templates.map(function (t) {
	    return {
	      value: t.code,
	      text: t.label
	    };
	  });
	};
	
	var TemplateSelector = function TemplateSelector(_ref) {
	  var templates = _ref.templates,
	      input = _ref.input,
	      _ref$meta = _ref.meta,
	      touched = _ref$meta.touched,
	      error = _ref$meta.error,
	      label = _ref.label;
	
	  var templateChanged = function templateChanged(_, _ref2) {
	    var value = _ref2.value;
	    return input.onChange(value);
	  };
	
	  return _react2.default.createElement(_semanticUiReact.Form.Select, Object.assign({}, input, {
	    error: touched && !!error,
	    label: label,
	    onChange: templateChanged,
	    options: templateValues(templates),
	    placeholder: 'S\xE9lectionnez un type'
	  }));
	};
	
	TemplateSelector.propTypes = {
	  templates: __webpack_require__(1).PropTypes.arrayOf(__webpack_require__(1).PropTypes.any).isRequired,
	  input: __webpack_require__(1).PropTypes.object.isRequired,
	  meta: __webpack_require__(1).PropTypes.object.isRequired,
	  label: __webpack_require__(1).PropTypes.any.isRequired
	};
	exports.default = TemplateSelector;

/***/ },

/***/ 987:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _configureStore = __webpack_require__(507);
	
	var _configureStore2 = _interopRequireDefault(_configureStore);
	
	var _reactRouterRedux = __webpack_require__(281);
	
	var _reducers = __webpack_require__(944);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _sagas = __webpack_require__(947);
	
	var _sagas2 = _interopRequireDefault(_sagas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (history) {
	  var store = (0, _configureStore2.default)(_reducers2.default, _sagas2.default, [(0, _reactRouterRedux.routerMiddleware)(history)]);
	
	  // Make reducers hot reloadable, see http://mxs.is/googmo
	  if (false) {
	    module.hot.accept('./reducers', function () {
	      var nextRootReducer = require('./reducers').default;
	      store.replaceReducer(nextRootReducer);
	    });
	  }
	
	  return store;
	};

/***/ },

/***/ 988:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchTags = exports.getFilteredUsers = undefined;
	
	var _fetch = __webpack_require__(32);
	
	var getFilteredUsers = exports.getFilteredUsers = function getFilteredUsers(role, tags) {
	  return (0, _fetch.postJson)('/users/diffusion.json', {
	    role: role === 'none' ? null : role,
	    tags: tags
	  });
	};
	
	var fetchTags = exports.fetchTags = function fetchTags() {
	  return (0, _fetch.fetchJson)('/users/tags.json');
	};

/***/ },

/***/ 989:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _DiffusionModal = __webpack_require__(992);
	
	var _DiffusionModal2 = _interopRequireDefault(_DiffusionModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AddTargetButton = function (_Component) {
	  _inherits(AddTargetButton, _Component);
	
	  function AddTargetButton(props) {
	    _classCallCheck(this, AddTargetButton);
	
	    var _this = _possibleConstructorReturn(this, (AddTargetButton.__proto__ || Object.getPrototypeOf(AddTargetButton)).call(this, props));
	
	    _this.onShowModal = function () {
	      return _this.setState({ isModalOpened: true });
	    };
	
	    _this.onCloseModal = function () {
	      return _this.setState({ isModalOpened: false });
	    };
	
	    _this.onSelected = function (target) {
	      _this.props.onTargetAdded(target);
	      _this.onCloseModal();
	    };
	
	    _this.state = {
	      isModalOpened: false
	    };
	    return _this;
	  }
	
	  _createClass(AddTargetButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          isFetching = _props.isFetching,
	          roles = _props.roles;
	      var isModalOpened = this.state.isModalOpened;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_semanticUiReact.Button, {
	          onClick: this.onShowModal,
	          type: 'button',
	          icon: 'add user',
	          loading: isFetching,
	          labelPosition: 'right',
	          content: 'Ajouter'
	        }),
	        _react2.default.createElement(_DiffusionModal2.default, {
	          isOpened: isModalOpened,
	          title: 'Ajout de destinataires',
	          roles: roles,
	          onClose: this.onCloseModal,
	          onSelected: this.onSelected
	        })
	      );
	    }
	  }]);
	
	  return AddTargetButton;
	}(_react.Component);
	
	AddTargetButton.propTypes = {
	  isFetching: __webpack_require__(1).PropTypes.bool.isRequired,
	  roles: __webpack_require__(1).PropTypes.arrayOf(__webpack_require__(1).PropTypes.any).isRequired,
	  onTargetAdded: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = AddTargetButton;

/***/ },

/***/ 990:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var DEFAULT_ITEM = {
	  value: 'none',
	  text: 'Tous'
	};
	
	var Choices = function Choices(_ref) {
	  var items = _ref.items,
	      value = _ref.value,
	      name = _ref.name,
	      onChange = _ref.onChange,
	      placeholder = _ref.placeholder,
	      label = _ref.label,
	      loading = _ref.loading,
	      multiple = _ref.multiple;
	
	  var selectionChanged = function selectionChanged(_, _ref2) {
	    var value = _ref2.value;
	    return onChange(value);
	  };
	
	  var withDefaultItem = multiple ? items : [DEFAULT_ITEM].concat(_toConsumableArray(items));
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'ui field' },
	    _react2.default.createElement(
	      'label',
	      null,
	      label
	    ),
	    _react2.default.createElement(_semanticUiReact.Dropdown, {
	      value: value,
	      fluid: true,
	      selection: true,
	      search: true,
	      loading: loading,
	      name: name,
	      placeholder: placeholder,
	      noResultsMessage: 'Aucun tag correspondant',
	      multiple: multiple,
	      options: withDefaultItem,
	      onChange: selectionChanged
	    })
	  );
	};
	
	Choices.propTypes = {
	  name: __webpack_require__(1).PropTypes.string,
	  value: __webpack_require__(1).PropTypes.oneOfType([__webpack_require__(1).PropTypes.string, __webpack_require__(1).PropTypes.arrayOf(__webpack_require__(1).PropTypes.string)]),
	  label: __webpack_require__(1).PropTypes.string.isRequired,
	  placeholder: __webpack_require__(1).PropTypes.string,
	  items: __webpack_require__(1).PropTypes.arrayOf(__webpack_require__(1).PropTypes.object).isRequired,
	  loading: __webpack_require__(1).PropTypes.bool,
	  multiple: __webpack_require__(1).PropTypes.bool,
	  onChange: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = Choices;

/***/ },

/***/ 991:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _AddTargetButton = __webpack_require__(989);
	
	var _AddTargetButton2 = _interopRequireDefault(_AddTargetButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  buttons: {
	    clear: {
	      height: '36px'
	    }
	  }
	};
	
	var DiffusionHeader = function DiffusionHeader(_ref) {
	  var isFetching = _ref.isFetching,
	      isEditable = _ref.isEditable,
	      roles = _ref.roles,
	      onClear = _ref.onClear,
	      onAdd = _ref.onAdd,
	      attached = _ref.attached;
	
	  return _react2.default.createElement(
	    _semanticUiReact.Menu,
	    { size: 'small', attached: attached || 'top' },
	    _react2.default.createElement(
	      _semanticUiReact.Menu.Item,
	      { header: true, className: 'borderless' },
	      'Liste de diffusion'
	    ),
	    isEditable && _react2.default.createElement(
	      _semanticUiReact.Menu.Menu,
	      { position: 'right' },
	      _react2.default.createElement(
	        _semanticUiReact.Menu.Item,
	        null,
	        _react2.default.createElement(_semanticUiReact.Button, {
	          style: styles.buttons.clear,
	          loading: isFetching,
	          type: 'button',
	          icon: 'recycle',
	          content: 'Vider',
	          labelPosition: 'left',
	          onClick: onClear
	        })
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Menu.Item,
	        null,
	        _react2.default.createElement(_AddTargetButton2.default, {
	          isFetching: isFetching,
	          roles: roles,
	          onTargetAdded: onAdd
	        })
	      )
	    )
	  );
	};
	
	DiffusionHeader.propTypes = {
	  isFetching: __webpack_require__(1).PropTypes.bool.isRequired,
	  isEditable: __webpack_require__(1).PropTypes.bool.isRequired,
	  roles: __webpack_require__(1).PropTypes.arrayOf(__webpack_require__(1).PropTypes.any).isRequired,
	  onClear: __webpack_require__(1).PropTypes.func.isRequired,
	  onAdd: __webpack_require__(1).PropTypes.func.isRequired,
	  attached: __webpack_require__(1).PropTypes.bool
	};
	exports.default = DiffusionHeader;

/***/ },

/***/ 992:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _Choices = __webpack_require__(990);
	
	var _Choices2 = _interopRequireDefault(_Choices);
	
	var _TargetUsersCounter = __webpack_require__(995);
	
	var _TargetUsersCounter2 = _interopRequireDefault(_TargetUsersCounter);
	
	var _index = __webpack_require__(988);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DiffusionModal = function (_React$Component) {
	  _inherits(DiffusionModal, _React$Component);
	
	  function DiffusionModal(props) {
	    _classCallCheck(this, DiffusionModal);
	
	    var _this = _possibleConstructorReturn(this, (DiffusionModal.__proto__ || Object.getPrototypeOf(DiffusionModal)).call(this, props));
	
	    _this.onClose = function () {
	      // Clearing current state
	      _this.setState({
	        isFetching: false,
	        selectedRole: 'none',
	        selectedTags: [],
	        users: []
	      }, _this.props.onClose);
	    };
	
	    _this.refreshUsersSelection = function () {
	      var _this$state = _this.state,
	          selectedRole = _this$state.selectedRole,
	          selectedTags = _this$state.selectedTags;
	
	
	      (0, _index.getFilteredUsers)(selectedRole, selectedTags).then(function (users) {
	        return _this.setState({ users: users });
	      });
	    };
	
	    _this.onTagsChanged = function (selectedTags) {
	      _this.setState({
	        selectedTags: selectedTags
	      }, _this.refreshUsersSelection);
	    };
	
	    _this.onRoleChanged = function (selectedRole) {
	      _this.setState({
	        selectedRole: selectedRole
	      }, _this.refreshUsersSelection);
	    };
	
	    _this.onValidate = function () {
	      var _this$state2 = _this.state,
	          selectedRole = _this$state2.selectedRole,
	          selectedTags = _this$state2.selectedTags;
	
	
	      var target = {
	        role: selectedRole === 'none' ? null : selectedRole,
	        tags: selectedTags
	      };
	
	      _this.props.onSelected(target);
	      _this.onClose();
	    };
	
	    _this.state = {
	      isFetching: false,
	      users: [],
	      tags: [],
	      selectedRole: 'none',
	      selectedTags: []
	    };
	    return _this;
	  }
	
	  _createClass(DiffusionModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      // Avoid loading tags multiple times
	      if (this.state.tags.length) return;
	
	      this.setState({ isFetching: true });
	
	      (0, _index.fetchTags)().then(function (tags) {
	        _this2.setState({
	          isFetching: false,
	          tags: tags
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          title = _props.title,
	          roles = _props.roles,
	          isOpened = _props.isOpened;
	      var _state = this.state,
	          isFetching = _state.isFetching,
	          users = _state.users,
	          tags = _state.tags,
	          selectedRole = _state.selectedRole,
	          selectedTags = _state.selectedTags;
	
	
	      var tagsChoices = tags.map(function (t) {
	        return {
	          text: t,
	          value: t
	        };
	      });
	
	      var roleChoices = roles.map(function (r) {
	        return {
	          text: r.label,
	          value: r.code
	        };
	      });
	
	      return _react2.default.createElement(
	        _semanticUiReact.Modal,
	        { open: isOpened, closeIcon: true, onClose: this.onClose },
	        _react2.default.createElement(
	          _semanticUiReact.Modal.Header,
	          null,
	          title
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Modal.Content,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Form,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'ui two fields' },
	              _react2.default.createElement(_Choices2.default, {
	                value: selectedRole,
	                name: 'role',
	                placeholder: 'R\xF4le',
	                label: 'R\xF4le',
	                items: roleChoices,
	                onChange: this.onRoleChanged
	              })
	            ),
	            _react2.default.createElement(_Choices2.default, {
	              value: selectedTags,
	              name: 'tags',
	              placeholder: 'Tags',
	              label: 'Tags',
	              loading: isFetching,
	              items: tagsChoices,
	              onChange: this.onTagsChanged,
	              multiple: true
	            })
	          ),
	          _react2.default.createElement(_TargetUsersCounter2.default, { users: users })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Modal.Actions,
	          null,
	          _react2.default.createElement(_semanticUiReact.Button, {
	            onClick: this.onClose,
	            icon: 'close',
	            labelPosition: 'left',
	            content: 'Annuler'
	          }),
	          _react2.default.createElement(_semanticUiReact.Button, {
	            onClick: this.onValidate,
	            primary: true,
	            icon: 'check',
	            labelPosition: 'right',
	            content: 'Valider'
	          })
	        )
	      );
	    }
	  }]);
	
	  return DiffusionModal;
	}(_react2.default.Component);
	
	DiffusionModal.propTypes = {
	  title: __webpack_require__(1).PropTypes.string.isRequired,
	  isOpened: __webpack_require__(1).PropTypes.bool.isRequired,
	  roles: __webpack_require__(1).PropTypes.arrayOf(__webpack_require__(1).PropTypes.any).isRequired,
	  onSelected: __webpack_require__(1).PropTypes.func.isRequired,
	  onClose: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = DiffusionModal;

/***/ },

/***/ 993:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TargetRole(_ref) {
	  var target = _ref.target,
	      roles = _ref.roles;
	
	  var role = roles.find(function (r) {
	    return r.code === target.role;
	  });
	  if (role) {
	    return _react2.default.createElement(
	      _semanticUiReact.Label,
	      { color: 'green' },
	      role.label
	    );
	  } else {
	    return _react2.default.createElement(
	      _semanticUiReact.Label,
	      null,
	      'Tous les r\xF4les'
	    );
	  }
	}
	
	function TargetTags(_ref2) {
	  var target = _ref2.target;
	
	  if (target.tags && target.tags.length) {
	    return _react2.default.createElement(
	      'span',
	      null,
	      target.tags.map(function (t) {
	        return _react2.default.createElement(
	          _semanticUiReact.Label,
	          { key: t },
	          t
	        );
	      })
	    );
	  }
	
	  return _react2.default.createElement(
	    _semanticUiReact.Label,
	    null,
	    'Tous les tags'
	  );
	}
	
	var DiffusionTarget = function DiffusionTarget(_ref3) {
	  var target = _ref3.target,
	      onDelete = _ref3.onDelete,
	      isEditable = _ref3.isEditable,
	      roles = _ref3.roles;
	
	  var remove = function remove() {
	    return onDelete(target);
	  };
	
	  return _react2.default.createElement(
	    _semanticUiReact.Table.Row,
	    null,
	    isEditable && _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { collapsing: true },
	      _react2.default.createElement(_semanticUiReact.Button, {
	        type: 'button',
	        size: 'tiny',
	        color: 'red',
	        icon: 'remove',
	        onClick: remove
	      })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { textAlign: 'center' },
	      _react2.default.createElement(TargetRole, { target: target, roles: roles })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { textAlign: 'center' },
	      _react2.default.createElement(TargetTags, { target: target })
	    )
	  );
	};
	
	DiffusionTarget.propTypes = {
	  target: __webpack_require__(1).PropTypes.any.isRequired,
	  isEditable: __webpack_require__(1).PropTypes.bool.isRequired,
	  roles: __webpack_require__(1).PropTypes.arrayOf(__webpack_require__(1).PropTypes.any).isRequired,
	  onDelete: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = DiffusionTarget;

/***/ },

/***/ 994:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _DiffusionTarget = __webpack_require__(993);
	
	var _DiffusionTarget2 = _interopRequireDefault(_DiffusionTarget);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DiffusionTargets = function DiffusionTargets(_ref) {
	  var isEditable = _ref.isEditable,
	      targets = _ref.targets,
	      roles = _ref.roles,
	      attached = _ref.attached,
	      onDelete = _ref.onDelete;
	
	  if (targets && targets.length) {
	    return _react2.default.createElement(
	      _semanticUiReact.Segment,
	      { attached: attached || 'bottom' },
	      _react2.default.createElement(
	        _semanticUiReact.Table,
	        { basic: 'very' },
	        _react2.default.createElement(
	          _semanticUiReact.Table.Header,
	          { fullWidth: true },
	          _react2.default.createElement(
	            _semanticUiReact.Table.Row,
	            null,
	            isEditable && _react2.default.createElement(_semanticUiReact.Table.HeaderCell, null),
	            _react2.default.createElement(
	              _semanticUiReact.Table.HeaderCell,
	              { width: 6, textAlign: 'center' },
	              'Profil'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.HeaderCell,
	              { width: 10, textAlign: 'center' },
	              'Tags'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Body,
	          null,
	          targets.map(function (t) {
	            return _react2.default.createElement(_DiffusionTarget2.default, {
	              key: targets.indexOf(t),
	              target: t,
	              roles: roles,
	              isEditable: isEditable,
	              onDelete: onDelete
	            });
	          })
	        )
	      )
	    );
	  }
	
	  return _react2.default.createElement(
	    _semanticUiReact.Segment,
	    { attached: attached || 'bottom' },
	    _react2.default.createElement(_semanticUiReact.Message, { icon: 'info', header: 'Liste de diffusion vide. Visible \xE0 tous.' })
	  );
	};
	
	DiffusionTargets.propTypes = {
	  isEditable: __webpack_require__(1).PropTypes.bool.isRequired,
	  targets: __webpack_require__(1).PropTypes.arrayOf(__webpack_require__(1).PropTypes.any).isRequired,
	  roles: __webpack_require__(1).PropTypes.arrayOf(__webpack_require__(1).PropTypes.any).isRequired,
	  onDelete: __webpack_require__(1).PropTypes.func.isRequired,
	  attached: __webpack_require__(1).PropTypes.bool
	};
	exports.default = DiffusionTargets;

/***/ },

/***/ 995:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TargetUsersCounter = function TargetUsersCounter(_ref) {
	  var users = _ref.users;
	
	  var count = users.length;
	
	  return _react2.default.createElement(
	    _semanticUiReact.Segment,
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'header' },
	      'Destinataires:',
	      _react2.default.createElement(
	        'em',
	        null,
	        ' ',
	        count,
	        ' s\xE9lectionn\xE9(s)'
	      )
	    )
	  );
	};
	
	TargetUsersCounter.propTypes = {
	  users: __webpack_require__(1).PropTypes.arrayOf(__webpack_require__(1).PropTypes.any).isRequired
	};
	exports.default = TargetUsersCounter;

/***/ },

/***/ 996:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _BlockTypeCard = __webpack_require__(1000);
	
	var _BlockTypeCard2 = _interopRequireDefault(_BlockTypeCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AddBlockButton = function (_Component) {
	  _inherits(AddBlockButton, _Component);
	
	  function AddBlockButton(props) {
	    _classCallCheck(this, AddBlockButton);
	
	    var _this = _possibleConstructorReturn(this, (AddBlockButton.__proto__ || Object.getPrototypeOf(AddBlockButton)).call(this, props));
	
	    _this.showModal = function () {
	      return _this.setState({ displayModal: true });
	    };
	
	    _this.hideModal = function () {
	      return _this.setState({ displayModal: false });
	    };
	
	    _this.addBlock = function (type) {
	      _this.props.onAdd(type);
	      _this.hideModal();
	    };
	
	    _this.state = {
	      displayModal: false
	    };
	    return _this;
	  }
	
	  _createClass(AddBlockButton, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var templates = this.props.templates;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Modal,
	          { basic: true, open: this.state.displayModal, onClose: this.hideModal },
	          _react2.default.createElement(_semanticUiReact.Header, { content: 'Ajouter un contenu' }),
	          _react2.default.createElement(
	            _semanticUiReact.Card.Group,
	            { itemsPerRow: 3 },
	            templates.map(function (bt) {
	              return _react2.default.createElement(_BlockTypeCard2.default, {
	                key: bt.code,
	                template: bt,
	                onSelect: _this2.addBlock
	              });
	            })
	          )
	        ),
	        _react2.default.createElement(_semanticUiReact.Button, {
	          type: 'button',
	          onClick: this.showModal,
	          icon: 'add',
	          content: 'Ajouter',
	          labelPosition: 'right'
	        })
	      );
	    }
	  }]);
	
	  return AddBlockButton;
	}(_react.Component);
	
	AddBlockButton.propTypes = {
	  templates: __webpack_require__(1).PropTypes.arrayOf(__webpack_require__(1).PropTypes.any).isRequired,
	  onAdd: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = AddBlockButton;

/***/ },

/***/ 997:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ViewBlockItem = __webpack_require__(1004);
	
	var _ViewBlockItem2 = _interopRequireDefault(_ViewBlockItem);
	
	var _EditBlockItem = __webpack_require__(1002);
	
	var _EditBlockItem2 = _interopRequireDefault(_EditBlockItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapBlockToMode = function mapBlockToMode(block) {
	  return block.isNew ? 'edit' : 'view';
	};
	
	var BlockItem = function (_Component) {
	  _inherits(BlockItem, _Component);
	
	  function BlockItem(props) {
	    _classCallCheck(this, BlockItem);
	
	    var _this = _possibleConstructorReturn(this, (BlockItem.__proto__ || Object.getPrototypeOf(BlockItem)).call(this, props));
	
	    _this.onSwitchMode = function () {
	      return _this.setState(function (prevState, props) {
	        return {
	          displayMode: prevState.displayMode === 'view' ? 'edit' : 'view'
	        };
	      });
	    };
	
	    _this.onSaveBlock = function (block) {
	      _this.props.onUpdate(Object.assign({}, block, {
	        isNew: undefined
	      }));
	      _this.onSwitchMode();
	    };
	
	    _this.state = {
	      displayMode: mapBlockToMode(props.block)
	    };
	    return _this;
	  }
	
	  _createClass(BlockItem, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.block !== this.props.block) {
	        this.setState({
	          displayMode: mapBlockToMode(nextProps.block)
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          mode = _props.mode,
	          templates = _props.templates,
	          block = _props.block,
	          blocks = _props.blocks,
	          onOrderChanged = _props.onOrderChanged,
	          onDelete = _props.onDelete,
	          locked = _props.locked;
	      var displayMode = this.state.displayMode;
	
	
	      var changeOrder = function changeOrder(order) {
	        return onOrderChanged(block, order);
	      };
	      var remove = function remove() {
	        return onDelete(block);
	      };
	
	      switch (displayMode) {
	        case 'view':
	          return _react2.default.createElement(_ViewBlockItem2.default, {
	            templates: templates,
	            block: block,
	            blocks: blocks,
	            onEdit: this.onSwitchMode,
	            onOrderChanged: changeOrder,
	            onDelete: remove,
	            locked: locked
	          });
	        case 'edit':
	          return _react2.default.createElement(_EditBlockItem2.default, {
	            mode: mode,
	            block: block,
	            onSave: this.onSaveBlock,
	            onCancel: this.onSwitchMode
	          });
	        default:
	          console.warn('Unknown block mode ' + displayMode + '. Cannot render');
	          return null;
	      }
	    }
	  }]);
	
	  return BlockItem;
	}(_react.Component);
	
	BlockItem.propTypes = {
	  mode: __webpack_require__(1).PropTypes.any.isRequired,
	  templates: __webpack_require__(1).PropTypes.arrayOf(__webpack_require__(1).PropTypes.any).isRequired,
	  block: __webpack_require__(1).PropTypes.any.isRequired,
	  blocks: __webpack_require__(1).PropTypes.any.isRequired,
	  onUpdate: __webpack_require__(1).PropTypes.func.isRequired,
	  onOrderChanged: __webpack_require__(1).PropTypes.func.isRequired,
	  onDelete: __webpack_require__(1).PropTypes.func.isRequired,
	  locked: __webpack_require__(1).PropTypes.bool
	};
	exports.default = BlockItem;

/***/ },

/***/ 998:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _BlockTemplateImage = __webpack_require__(491);
	
	var _BlockTemplateImage2 = _interopRequireDefault(_BlockTemplateImage);
	
	var _plugin = __webpack_require__(309);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BlockListRender = function BlockListRender(_ref) {
	  var templates = _ref.templates,
	      blocks = _ref.blocks;
	
	  var renderContent = function renderContent(block) {
	    var component = (0, _plugin.getRenderComponent)(block);
	    if (component === null) {
	      console.warn('Unknown render block type ' + block.template + '. Cannot render');
	    }
	
	    return component;
	  };
	
	  if (blocks && blocks.length) {
	    return _react2.default.createElement(
	      _semanticUiReact.Item.Group,
	      { divided: true },
	      blocks.map(function (block) {
	        return _react2.default.createElement(
	          _semanticUiReact.Item,
	          { key: block.id },
	          _react2.default.createElement(_BlockTemplateImage2.default, { templates: templates, block: block }),
	          _react2.default.createElement(
	            'div',
	            { className: 'ui middle aligned content' },
	            renderContent(block)
	          )
	        );
	      })
	    );
	  }
	
	  return _react2.default.createElement(_semanticUiReact.Message, { icon: 'info', header: 'Aucun contenu \xE9ditorial' });
	};
	
	BlockListRender.propTypes = {
	  templates: __webpack_require__(1).PropTypes.arrayOf(__webpack_require__(1).PropTypes.any).isRequired,
	  blocks: __webpack_require__(1).PropTypes.arrayOf(__webpack_require__(1).PropTypes.any).isRequired
	};
	exports.default = BlockListRender;

/***/ },

/***/ 999:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  buttons: {
	    margin: 'auto'
	  }
	};
	
	var BlockOrderButtons = function BlockOrderButtons(_ref) {
	  var canOrderUp = _ref.canOrderUp,
	      canOrderDown = _ref.canOrderDown,
	      onOrderUp = _ref.onOrderUp,
	      onOrderDown = _ref.onOrderDown;
	  return _react2.default.createElement(
	    _semanticUiReact.Button.Group,
	    { vertical: true, style: styles.buttons },
	    _react2.default.createElement(_semanticUiReact.Button, {
	      type: 'button',
	      onClick: onOrderUp,
	      disabled: !canOrderUp,
	      compact: true,
	      icon: 'chevron up'
	    }),
	    _react2.default.createElement(_semanticUiReact.Button, {
	      type: 'button',
	      onClick: onOrderDown,
	      disabled: !canOrderDown,
	      compact: true,
	      icon: 'chevron down'
	    })
	  );
	};
	
	BlockOrderButtons.propTypes = {
	  canOrderUp: __webpack_require__(1).PropTypes.bool.isRequired,
	  canOrderDown: __webpack_require__(1).PropTypes.bool.isRequired,
	  onOrderUp: __webpack_require__(1).PropTypes.func.isRequired,
	  onOrderDown: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = BlockOrderButtons;

/***/ },

/***/ 1000:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _constants = __webpack_require__(141);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BlockTypeCard = function BlockTypeCard(_ref) {
	  var template = _ref.template,
	      onSelect = _ref.onSelect;
	
	  var select = function select() {
	    return onSelect(template.code);
	  };
	
	  return _react2.default.createElement(
	    _semanticUiReact.Card,
	    { raised: true, centered: true, color: 'blue', onClick: select },
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      _react2.default.createElement(
	        'h2',
	        { className: 'ui center aligned icon header' },
	        _react2.default.createElement(_semanticUiReact.Icon, { name: template.icon || _constants.DEFAULT_BLOCK_ICON }),
	        template.label
	      )
	    )
	  );
	};
	
	BlockTypeCard.propTypes = {
	  template: __webpack_require__(1).PropTypes.any.isRequired,
	  onSelect: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = BlockTypeCard;

/***/ },

/***/ 1001:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _AddBlockButton = __webpack_require__(996);
	
	var _AddBlockButton2 = _interopRequireDefault(_AddBlockButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BlocksHeader = function BlocksHeader(_ref) {
	  var templates = _ref.templates,
	      attached = _ref.attached,
	      onAdd = _ref.onAdd,
	      locked = _ref.locked;
	
	  return _react2.default.createElement(
	    _semanticUiReact.Menu,
	    { size: 'small', attached: attached || 'top' },
	    _react2.default.createElement(
	      _semanticUiReact.Menu.Item,
	      { header: true, className: 'borderless' },
	      'Contenus \xE9ditoriaux'
	    ),
	    !locked && _react2.default.createElement(
	      _semanticUiReact.Menu.Menu,
	      { position: 'right' },
	      _react2.default.createElement(
	        _semanticUiReact.Menu.Item,
	        null,
	        _react2.default.createElement(_AddBlockButton2.default, { templates: templates, onAdd: onAdd })
	      )
	    )
	  );
	};
	
	BlocksHeader.propTypes = {
	  templates: __webpack_require__(1).PropTypes.arrayOf(__webpack_require__(1).PropTypes.any).isRequired,
	  onAdd: __webpack_require__(1).PropTypes.func.isRequired,
	  attached: __webpack_require__(1).PropTypes.bool,
	  locked: __webpack_require__(1).PropTypes.bool
	};
	exports.default = BlocksHeader;

/***/ },

/***/ 1002:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(38);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _plugin = __webpack_require__(309);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EditBlockItem = function (_Component) {
	  _inherits(EditBlockItem, _Component);
	
	  function EditBlockItem(props) {
	    _classCallCheck(this, EditBlockItem);
	
	    var _this = _possibleConstructorReturn(this, (EditBlockItem.__proto__ || Object.getPrototypeOf(EditBlockItem)).call(this, props));
	
	    _this.serializeContent = function (diff) {
	      _this.setState({
	        diff: diff
	      });
	    };
	
	    _this.onCanSubmitChanged = function (value) {
	      _this.setState({ canSubmit: value });
	    };
	
	    _this.state = {
	      canSubmit: true,
	      diff: props.block
	    };
	    return _this;
	  }
	
	  _createClass(EditBlockItem, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.block !== this.props.block) {
	        this.setState({
	          diff: nextProps.block
	        });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.state.diff.isNew) {
	        var element = _reactDom2.default.findDOMNode(this.item);
	
	        // TODO: timeout to remove if children does not mutate their state (or does not have one) when they mount
	        // Here timeout is set because some children use ProgressiveImage Component
	        setTimeout(function () {
	          element.scrollIntoView({ block: 'end' });
	        }, 200);
	      }
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      var mode = this.props.mode;
	      var diff = this.state.diff;
	
	
	      var content = (0, _plugin.getEditComponent)(diff);
	      if (content === null) {
	        console.warn('Unknown edit block type ' + diff.template + '. Cannot render');
	        return null;
	      }
	
	      return _react2.default.cloneElement(content, {
	        mode: mode,
	        onCanSubmitChanged: this.onCanSubmitChanged,
	        onSerialize: this.serializeContent
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          onSave = _props.onSave,
	          onCancel = _props.onCancel;
	      var _state = this.state,
	          diff = _state.diff,
	          canSubmit = _state.canSubmit;
	
	
	      var save = function save() {
	        return onSave(diff);
	      };
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'ui item',
	          ref: function ref(_ref) {
	            _this2.item = _ref;
	          }
	        },
	        _react2.default.createElement(
	          _semanticUiReact.Item.Content,
	          null,
	          this.renderContent(),
	          _react2.default.createElement(
	            _semanticUiReact.Item.Extra,
	            null,
	            _react2.default.createElement(_semanticUiReact.Button, {
	              type: 'button',
	              onClick: save,
	              disabled: !canSubmit,
	              primary: true,
	              floated: 'right',
	              icon: 'check',
	              content: 'Valider',
	              labelPosition: 'right'
	            }),
	            _react2.default.createElement(_semanticUiReact.Button, {
	              type: 'button',
	              onClick: onCancel,
	              icon: 'chevron left',
	              labelPosition: 'left',
	              content: 'Annuler',
	              floated: 'right'
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return EditBlockItem;
	}(_react.Component);
	
	EditBlockItem.propTypes = {
	  mode: __webpack_require__(1).PropTypes.any.isRequired,
	  block: __webpack_require__(1).PropTypes.any.isRequired,
	  onSave: __webpack_require__(1).PropTypes.func.isRequired,
	  onCancel: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = EditBlockItem;

/***/ },

/***/ 1003:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutable = __webpack_require__(10);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _BlocksHeader = __webpack_require__(1001);
	
	var _BlocksHeader2 = _interopRequireDefault(_BlocksHeader);
	
	var _BlockItem = __webpack_require__(997);
	
	var _BlockItem2 = _interopRequireDefault(_BlockItem);
	
	var _ordering = __webpack_require__(320);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var updateBlocks = function updateBlocks(blocks) {
	  return function (updateFunction) {
	    return updateFunction(_immutable2.default.Map(blocks.map(function (b) {
	      return [b.order, b];
	    })).toList());
	  };
	};
	
	var mergeBlocks = function mergeBlocks(blocks, updated) {
	  return updateBlocks(blocks)(function (map) {
	    return map.update(updated.order, function (b) {
	      return Object.assign({}, b, updated);
	    });
	  });
	};
	
	var removeBlock = function removeBlock(blocks, toDelete) {
	  return updateBlocks(blocks)(function (map) {
	    return map.remove(toDelete.order);
	  });
	};
	
	var EditorBlocks = function EditorBlocks(_ref) {
	  var mode = _ref.mode,
	      templates = _ref.templates,
	      blocks = _ref.blocks,
	      onAdd = _ref.onAdd,
	      onUpdate = _ref.onUpdate,
	      attached = _ref.attached,
	      locked = _ref.locked;
	
	  var renderContents = function renderContents() {
	    if (blocks && blocks.size) {
	      var updateBlock = function updateBlock(block) {
	        return onUpdate(mergeBlocks(blocks, block));
	      };
	
	      var reorderBlocks = function reorderBlocks(block, order) {
	        var reordered = (0, _ordering.reorderElements)(blocks, block, order);
	        onUpdate(reordered);
	      };
	
	      var deleteBlock = function deleteBlock(block) {
	        var reordered = (0, _ordering.enforceElementsOrder)(removeBlock(blocks, block));
	        onUpdate(reordered);
	      };
	
	      return _react2.default.createElement(
	        _semanticUiReact.Item.Group,
	        { divided: true },
	        blocks.map(function (b) {
	          return _react2.default.createElement(_BlockItem2.default, {
	            key: b.id,
	            mode: mode,
	            templates: templates,
	            block: b,
	            blocks: blocks,
	            onUpdate: updateBlock,
	            onOrderChanged: reorderBlocks,
	            onDelete: deleteBlock,
	            locked: locked
	          });
	        })
	      );
	    }
	
	    return _react2.default.createElement(_semanticUiReact.Message, { icon: 'info', header: 'Aucun contenu \xE9ditorial' });
	  };
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_BlocksHeader2.default, {
	      templates: templates,
	      onAdd: onAdd,
	      attached: attached,
	      locked: locked
	    }),
	    _react2.default.createElement(
	      _semanticUiReact.Segment,
	      { attached: attached || 'bottom' },
	      renderContents()
	    )
	  );
	};
	
	EditorBlocks.propTypes = {
	  mode: __webpack_require__(1).PropTypes.any.isRequired,
	  templates: __webpack_require__(1).PropTypes.arrayOf(__webpack_require__(1).PropTypes.any).isRequired,
	  blocks: __webpack_require__(1).PropTypes.any.isRequired,
	  onAdd: __webpack_require__(1).PropTypes.func.isRequired,
	  onUpdate: __webpack_require__(1).PropTypes.func.isRequired,
	  attached: __webpack_require__(1).PropTypes.bool,
	  locked: __webpack_require__(1).PropTypes.bool
	};
	exports.default = EditorBlocks;

/***/ },

/***/ 1004:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _BlockTemplateImage = __webpack_require__(491);
	
	var _BlockTemplateImage2 = _interopRequireDefault(_BlockTemplateImage);
	
	var _BlockOrderButtons = __webpack_require__(999);
	
	var _BlockOrderButtons2 = _interopRequireDefault(_BlockOrderButtons);
	
	var _plugin = __webpack_require__(309);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  action: {
	    marginLeft: '1.5em',
	    display: 'flex'
	  }
	};
	
	var ViewBlockItem = function (_Component) {
	  _inherits(ViewBlockItem, _Component);
	
	  function ViewBlockItem(props) {
	    _classCallCheck(this, ViewBlockItem);
	
	    var _this = _possibleConstructorReturn(this, (ViewBlockItem.__proto__ || Object.getPrototypeOf(ViewBlockItem)).call(this, props));
	
	    _this.onShowDimmer = function () {
	      return _this.setState({ dimmerActive: true });
	    };
	
	    _this.onHideDimmer = function () {
	      return _this.setState({ dimmerActive: false });
	    };
	
	    _this.state = {
	      dimmerActive: false
	    };
	    return _this;
	  }
	
	  _createClass(ViewBlockItem, [{
	    key: 'renderContent',
	    value: function renderContent() {
	      var block = this.props.block;
	
	
	      var content = (0, _plugin.getViewComponent)(block);
	      if (content === null) {
	        console.warn('Unknown view block type ' + block.template + '. Cannot render');
	      }
	
	      return content;
	    }
	  }, {
	    key: 'renderDimmerContent',
	    value: function renderDimmerContent() {
	      var _props = this.props,
	          onEdit = _props.onEdit,
	          onDelete = _props.onDelete,
	          locked = _props.locked;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_semanticUiReact.Button, {
	          type: 'button',
	          onClick: onEdit,
	          icon: 'edit',
	          labelPosition: 'right',
	          content: 'Modifier'
	        }),
	        !locked && _react2.default.createElement(_semanticUiReact.Button, {
	          type: 'button',
	          onClick: onDelete,
	          icon: 'close',
	          color: 'red',
	          labelPosition: 'right',
	          content: 'Supprimer'
	        })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          templates = _props2.templates,
	          block = _props2.block,
	          blocks = _props2.blocks,
	          onOrderChanged = _props2.onOrderChanged;
	      var dimmerActive = this.state.dimmerActive;
	
	
	      var canOrderUp = block.order > 0;
	      var canOrderDown = block.order < blocks.size - 1;
	      var orderUp = function orderUp() {
	        return onOrderChanged(block.order - 1);
	      };
	      var orderDown = function orderDown() {
	        return onOrderChanged(block.order + 1);
	      };
	
	      return _react2.default.createElement(
	        _semanticUiReact.Item,
	        null,
	        _react2.default.createElement(_BlockTemplateImage2.default, { templates: templates, block: block }),
	        _react2.default.createElement(
	          _semanticUiReact.Dimmer.Dimmable,
	          {
	            className: 'ui middle aligned content',
	            dimmed: dimmerActive,
	            onMouseEnter: this.onShowDimmer,
	            onMouseLeave: this.onHideDimmer
	          },
	          _react2.default.createElement(
	            _semanticUiReact.Dimmer,
	            { active: dimmerActive, inverted: true },
	            this.renderDimmerContent()
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'content' },
	            this.renderContent()
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ui small action', style: styles.action },
	          _react2.default.createElement(_BlockOrderButtons2.default, {
	            canOrderUp: canOrderUp,
	            canOrderDown: canOrderDown,
	            onOrderUp: orderUp,
	            onOrderDown: orderDown
	          })
	        )
	      );
	    }
	  }]);
	
	  return ViewBlockItem;
	}(_react.Component);
	
	ViewBlockItem.propTypes = {
	  templates: __webpack_require__(1).PropTypes.arrayOf(__webpack_require__(1).PropTypes.any).isRequired,
	  block: __webpack_require__(1).PropTypes.any.isRequired,
	  blocks: __webpack_require__(1).PropTypes.any.isRequired,
	  onEdit: __webpack_require__(1).PropTypes.func.isRequired,
	  onOrderChanged: __webpack_require__(1).PropTypes.func.isRequired,
	  onDelete: __webpack_require__(1).PropTypes.func.isRequired,
	  locked: __webpack_require__(1).PropTypes.bool
	};
	exports.default = ViewBlockItem;

/***/ },

/***/ 1005:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _toastr = __webpack_require__(81);
	
	var _RadioMenu = __webpack_require__(317);
	
	var _RadioMenu2 = _interopRequireDefault(_RadioMenu);
	
	var _constants = __webpack_require__(492);
	
	var _places = __webpack_require__(1624);
	
	var _places2 = _interopRequireDefault(_places);
	
	var _RichTextItem = __webpack_require__(177);
	
	var _RichTextItem2 = _interopRequireDefault(_RichTextItem);
	
	var _RichTextCounter = __webpack_require__(319);
	
	var _RichTextCounter2 = _interopRequireDefault(_RichTextCounter);
	
	var _draftJs = __webpack_require__(86);
	
	var _richtext = __webpack_require__(115);
	
	var _index = __webpack_require__(141);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	/* global google */
	/* global navigator */
	
	var mapBlockContentToEditorState = function mapBlockContentToEditorState(block) {
	  return block.content ? (0, _richtext.htmlToState)(block.content) : _draftJs.EditorState.createEmpty(_richtext.linkDecorator);
	};
	
	var Edit = function (_Component) {
	  _inherits(Edit, _Component);
	
	  function Edit(props) {
	    _classCallCheck(this, Edit);
	
	    var _this = _possibleConstructorReturn(this, (Edit.__proto__ || Object.getPrototypeOf(Edit)).call(this, props));
	
	    _this.onAddressChange = function (evt) {
	      if (evt.target instanceof HTMLInputElement) {
	        var _block = _this.state.block;
	
	        _this.setState({ block: Object.assign({}, _block, { address: evt.target.value }) });
	      }
	    };
	
	    _this.onAddressClear = function (evt) {
	      var marker = _this.state.marker;
	      var block = _this.props.block;
	
	
	      marker && marker.setMap(null);
	
	      _this.setState({
	        block: Object.assign({}, block, { address: undefined, lat: undefined, lng: undefined })
	      });
	    };
	
	    _this.onTitleChange = function (evt) {
	      if (evt.target instanceof HTMLInputElement) {
	        var _block2 = _this.props.block;
	
	        _this.props.onSerialize(Object.assign({}, _block2, { text: evt.target.value }));
	      }
	    };
	
	    _this.onLatChange = function (evt) {
	      if (evt.target instanceof HTMLInputElement) {
	        var _block3 = _this.state.block;
	
	        _this.props.onSerialize(Object.assign({}, _block3, { lat: evt.target.value }));
	      }
	    };
	
	    _this.onLngChange = function (evt) {
	      if (evt.target instanceof HTMLInputElement) {
	        var _block4 = _this.props.block;
	
	        _this.props.onSerialize(Object.assign({}, _block4, { lng: evt.target.value }));
	      }
	    };
	
	    _this.toggleAddress = function (evt) {
	      evt.preventDefault();
	
	      if (evt.target instanceof HTMLButtonElement) {
	        var _this$props = _this.props,
	            _block5 = _this$props.block,
	            _onSerialize = _this$props.onSerialize;
	
	        _onSerialize(Object.assign({}, _block5, { type: _constants.ADDRESS_MAP_BLOCKTYPE }));
	      }
	    };
	
	    _this.toggleDestination = function (evt) {
	      evt.preventDefault();
	
	      if (evt.target instanceof HTMLButtonElement) {
	        var _this$props2 = _this.props,
	            _block6 = _this$props2.block,
	            _onSerialize2 = _this$props2.onSerialize;
	
	        _onSerialize2(Object.assign({}, _block6, { type: _constants.DESTINATION_MAP_BLOCKTYPE }));
	      }
	    };
	
	    _this.onAddressSelect = function (suggestion) {
	      var _this$state = _this.state,
	          map = _this$state.map,
	          marker = _this$state.marker;
	      var block = _this.props.block;
	
	
	      map.setCenter(suggestion.latlng);
	
	      var newMarker = void 0;
	      // Setting marker to new Location
	      if (marker) {
	        marker.setPosition(suggestion.latlng);
	      } else {
	        newMarker = new google.maps.Marker({
	          position: suggestion.latlng,
	          map: map
	        });
	      }
	
	      _this.setState({
	        marker: marker || newMarker,
	        block: Object.assign({}, block, {
	          address: suggestion.value,
	          lat: suggestion.latlng.lat,
	          lng: suggestion.latlng.lng
	        })
	      });
	    };
	
	    _this.onMapClick = function (evt) {
	      var _this$state2 = _this.state,
	          map = _this$state2.map,
	          marker = _this$state2.marker,
	          block = _this$state2.block;
	
	
	      marker && marker.setMap(null);
	
	      if (map) {
	        var newMarker = new google.maps.Marker({
	          position: evt.latLng,
	          animation: google.maps.Animation.DROP,
	          map: map
	        });
	
	        map.setCenter(evt.latLng);
	        _this.setState({
	          marker: newMarker,
	          block: Object.assign({}, block, {
	            lat: evt.latLng.lat(),
	            lng: evt.latLng.lng()
	          })
	        });
	
	        _this.handleReverseGeocode();
	      }
	    };
	
	    _this.onMapShowChange = function (event, data) {
	      var _this$props3 = _this.props,
	          block = _this$props3.block,
	          onSerialize = _this$props3.onSerialize;
	
	
	      onSerialize(Object.assign({}, block, { showMap: data.checked }));
	    };
	
	    _this.initMap = function () {
	      var block = _this.state.block;
	
	
	      var mapCenterLat = block.lat || 46.248250;
	      var mapCenterLng = block.lng || 0.878906;
	
	      setTimeout(function () {
	        var placeInput = (0, _places2.default)({
	          container: _this.addressInput
	        });
	
	        placeInput.on('change', function (evt) {
	          evt.suggestion && _this.onAddressSelect(evt.suggestion);
	        });
	
	        placeInput.on('clear', function (evt) {
	          _this.onAddressClear();
	        });
	
	        if (_this.map) {
	          var map = new google.maps.Map(_this.map, {
	            center: { lat: mapCenterLat, lng: mapCenterLng },
	            zoom: block.zoomLevel || 11,
	            zoomControl: true,
	            mapTypeControl: false,
	            scaleControl: false,
	            streetViewControl: false,
	            rotateControl: false
	          });
	
	          var marker = void 0;
	
	          if (block.lat && block.lng) {
	            marker = new google.maps.Marker({
	              position: { lat: block.lat, lng: block.lng },
	              map: map
	            });
	          }
	
	          map.addListener('click', _this.onMapClick);
	          map.addListener('zoom_changed', function (evt) {
	            _this.setState({ block: Object.assign({}, block, { zoomLevel: map.getZoom() }) });
	          });
	
	          _this.setState({ map: map, marker: marker });
	        }
	      }, 100);
	      // TODO: find a way to initialize map without timeout (onMount and onOpen Modal callbacks doesn't seem to work)
	    };
	
	    _this.serializeAsHtml = function (editorState) {
	      var _this$props4 = _this.props,
	          block = _this$props4.block,
	          onSerialize = _this$props4.onSerialize,
	          onCanSubmitChanged = _this$props4.onCanSubmitChanged;
	
	
	      _this.setState({
	        editor: editorState
	      });
	
	      onSerialize(Object.assign({}, block, {
	        content: (0, _richtext.stateToHTML)(editorState.getCurrentContent())
	      }));
	
	      onCanSubmitChanged(!((0, _richtext.getCharCount)(editorState) > _index.MAP_CHARACTER_LIMIT));
	    };
	
	    _this.handleReverseGeocode = function () {
	      var _this$state3 = _this.state,
	          geocoder = _this$state3.geocoder,
	          block = _this$state3.block;
	
	
	      if (geocoder && block.lat && block.lng) {
	        geocoder.geocode({ location: { lat: block.lat, lng: block.lng } }, function (results, status) {
	          if (status === google.maps.GeocoderStatus.OK) {
	            _this.setState({
	              block: Object.assign({}, block, {
	                address: results[0].formatted_address
	              })
	            });
	          }
	        });
	      }
	    };
	
	    _this.initWithMyPosition = function (evt) {
	      var geocoder = _this.state.geocoder;
	
	
	      if (navigator.geolocation) {
	        navigator.geolocation.getCurrentPosition(function (success) {
	          var _this$props5 = _this.props,
	              block = _this$props5.block,
	              onSerialize = _this$props5.onSerialize;
	
	
	          if (geocoder && success.coords.latitude && success.coords.longitude) {
	            geocoder.geocode({
	              location: {
	                lat: success.coords.latitude,
	                lng: success.coords.longitude
	              }
	            }, function (results, status) {
	              if (status === google.maps.GeocoderStatus.OK) {
	                onSerialize(Object.assign({}, block, {
	                  address: results[0].formatted_address,
	                  lat: success.coords.latitude,
	                  lng: success.coords.longitude
	                }));
	              }
	            });
	          } else {
	            (0, _toastr.error)('Erreur de géolocalisation');
	          }
	        }, function (failure) {
	          switch (failure.code) {
	            case 1:
	              (0, _toastr.error)("Access refusé par l'utilisateur");
	              break;
	            case 2:
	              (0, _toastr.error)('Service de géolocalisation indisponible');
	              break;
	            case 3:
	              (0, _toastr.error)('Requête expirée');
	              break;
	            default:
	              (0, _toastr.error)('Erreur inconnue');
	              break;
	          }
	        });
	      } else {
	        (0, _toastr.error)('Geolocation is not supported by this browser');
	      }
	    };
	
	    _this.validateModal = function (evt) {
	      if (evt.target instanceof HTMLButtonElement) {
	        var _block7 = _this.state.block;
	
	
	        _this.handleClose();
	        _this.props.onSerialize(_block7);
	      }
	    };
	
	    _this.handleClose = function () {
	      _this.setState({ openModal: false, block: undefined });
	    };
	
	    _this.state = {
	      editor: mapBlockContentToEditorState(props.block)
	    };
	    return _this;
	  }
	
	  _createClass(Edit, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          onSerialize = _props.onSerialize,
	          block = _props.block;
	
	      this.setState({ geocoder: new google.maps.Geocoder() });
	
	      if (!block.type) {
	        onSerialize(Object.assign({}, block, { type: _constants.DEFAULT_MAP_BLOCKTYPE }));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          openModal = _state.openModal,
	          editor = _state.editor;
	      var block = this.props.block;
	
	      var menuDescriptor = [{
	        value: _constants.ADDRESS_MAP_BLOCKTYPE,
	        handler: this.toggleAddress,
	        label: 'Adresse'
	      }, {
	        value: _constants.DESTINATION_MAP_BLOCKTYPE,
	        handler: this.toggleDestination,
	        label: 'Destination'
	      }];
	      var defaultLabel = block.type === _constants.ADDRESS_MAP_BLOCKTYPE ? 'Adresse' : 'Destination';
	      var handleOpen = function handleOpen() {
	        _this2.setState({ openModal: true, block: _this2.props.block });
	      };
	
	      var renderModal = function renderModal() {
	        var block = _this2.state.block;
	
	
	        var addressValue = block ? block.address : '';
	        var latValue = block && block.lat;
	        var lngValue = block && block.lng;
	
	        return _react2.default.createElement(
	          _semanticUiReact.Modal,
	          {
	            closeIcon: true,
	            open: openModal,
	            onClose: _this2.handleClose,
	            onMount: _this2.initMap
	          },
	          _react2.default.createElement(
	            _semanticUiReact.Modal.Header,
	            null,
	            'Mise \xE0 jour: ',
	            defaultLabel
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Modal.Content,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Modal.Description,
	              { style: { height: '550px' } },
	              _react2.default.createElement(
	                _semanticUiReact.Form,
	                null,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'field' },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    'Adresse'
	                  ),
	                  _react2.default.createElement('input', {
	                    ref: function ref(_ref) {
	                      return _this2.addressInput = _ref;
	                    },
	                    type: 'text',
	                    name: 'address',
	                    value: addressValue || '',
	                    onChange: _this2.onAddressChange
	                  })
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Form.Group,
	                  { label: 'Coordonn\xE9es GPS', widths: 'equal', inline: true },
	                  _react2.default.createElement(_semanticUiReact.Form.Input, {
	                    label: 'Latitude',
	                    value: latValue || '',
	                    name: 'lat',
	                    onChange: _this2.onLatChange,
	                    disabled: true
	                  }),
	                  _react2.default.createElement(_semanticUiReact.Form.Input, {
	                    label: 'Longitude',
	                    value: lngValue || '',
	                    name: 'lng',
	                    onChange: _this2.onLngChange,
	                    disabled: true
	                  })
	                )
	              ),
	              _react2.default.createElement('div', {
	                ref: function ref(_ref2) {
	                  return _this2.map = _ref2;
	                },
	                style: { height: '75%', marginBottom: '5%' }
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Modal.Actions,
	            null,
	            _react2.default.createElement(_semanticUiReact.Button, {
	              icon: 'check',
	              content: 'Valider',
	              primary: true,
	              onClick: _this2.validateModal
	            })
	          )
	        );
	      };
	
	      return _react2.default.createElement(
	        _semanticUiReact.Item.Content,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Grid,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 'sixteen' },
	              _react2.default.createElement(
	                'div',
	                { className: 'ui form' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'field' },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    'Titre'
	                  ),
	                  _react2.default.createElement('input', {
	                    type: 'text',
	                    value: block.text || '',
	                    onChange: this.onTitleChange
	                  })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Row,
	            { verticalAlign: 'middle' },
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 'four' },
	              _react2.default.createElement(_RadioMenu2.default, {
	                label: 'Type de tuile',
	                currentValue: block.type,
	                menuDesc: menuDescriptor
	              })
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 'four' },
	              _react2.default.createElement(_semanticUiReact.Checkbox, {
	                checked: block.showMap || false,
	                onChange: this.onMapShowChange,
	                label: 'Afficher la carte'
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 'sixteen' },
	              _react2.default.createElement(
	                'div',
	                { className: 'ui form' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'field' },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    defaultLabel
	                  ),
	                  _react2.default.createElement('textarea', {
	                    className: 'disabled',
	                    value: block.address || '',
	                    rows: '1',
	                    readOnly: true
	                  })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 'five' },
	              _react2.default.createElement(
	                _semanticUiReact.Button.Group,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Button,
	                  { type: 'button', attached: 'left', onClick: handleOpen },
	                  'Mettre \xE0 jour'
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Button,
	                  {
	                    type: 'button',
	                    attached: 'right',
	                    onClick: this.initWithMyPosition
	                  },
	                  'Utiliser ma position'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 'sixteen' },
	              _react2.default.createElement(
	                'div',
	                { className: 'ui form' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'field' },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    'Informations suppl\xE9mentaires'
	                  ),
	                  _react2.default.createElement(_RichTextItem2.default, {
	                    parentState: editor,
	                    onChange: this.serializeAsHtml,
	                    withTextBlocks: true,
	                    withInlineBasics: true,
	                    withLinks: true,
	                    withColors: true
	                  }),
	                  _react2.default.createElement(_RichTextCounter2.default, {
	                    editorState: editor,
	                    charLimit: _index.MAP_CHARACTER_LIMIT,
	                    chars: true
	                  })
	                )
	              )
	            )
	          )
	        ),
	        renderModal()
	      );
	    }
	  }]);
	
	  return Edit;
	}(_react.Component);
	
	Edit.propTypes = {
	  block: __webpack_require__(1).PropTypes.any.isRequired,
	  onSerialize: __webpack_require__(1).PropTypes.func,
	  onCanSubmitChanged: __webpack_require__(1).PropTypes.func
	};
	exports.default = Edit;

/***/ },

/***/ 1006:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _constants = __webpack_require__(492);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	/* global google */
	
	var View = function (_Component) {
	  _inherits(View, _Component);
	
	  function View() {
	    _classCallCheck(this, View);
	
	    return _possibleConstructorReturn(this, (View.__proto__ || Object.getPrototypeOf(View)).apply(this, arguments));
	  }
	
	  _createClass(View, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var block = this.props.block;
	      var order = block.order;
	
	
	      if (document.getElementById('map_view_' + order)) {
	        var map = new google.maps.Map(document.getElementById('map_view_' + order), {
	          center: { lat: block.lat, lng: block.lng },
	          zoom: block.zoomLevel || 11,
	          zoomControl: false,
	          mapTypeControl: false,
	          scaleControl: false,
	          streetViewControl: false,
	          rotateControl: false,
	          draggable: false,
	          keyboardShortcuts: false,
	          scrollwheel: false
	        });
	
	        new google.maps.Marker({
	          position: { lat: block.lat, lng: block.lng },
	          map: map
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var block = this.props.block;
	      var order = block.order;
	
	      var label = block.type === _constants.ADDRESS_MAP_BLOCKTYPE ? 'Adresse' : 'Destination';
	      var mapAttachment = block.address ? 'bottom' : false;
	
	      if (block.lat && block.lng) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Segment,
	            { attached: 'top' },
	            _react2.default.createElement(
	              _semanticUiReact.Label,
	              { attached: 'top right' },
	              label
	            ),
	            block.address
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Segment,
	            { attached: mapAttachment },
	            _react2.default.createElement('div', {
	              id: 'map_view_' + order,
	              className: 'ui item content',
	              style: { height: '400px', width: '100%' }
	            })
	          )
	        );
	      }
	
	      return _react2.default.createElement(_semanticUiReact.Message, { icon: 'info', header: 'Aucune ' + label + ' sp\xE9cifi\xE9e' });
	    }
	  }]);
	
	  return View;
	}(_react.Component);
	
	View.propTypes = {
	  block: __webpack_require__(1).PropTypes.any
	};
	exports.default = View;

/***/ },

/***/ 1007:
[2059, 1005, 1006],

/***/ 1008:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _RadioMenu = __webpack_require__(317);
	
	var _RadioMenu2 = _interopRequireDefault(_RadioMenu);
	
	var _constants = __webpack_require__(493);
	
	var _RichTextItem = __webpack_require__(177);
	
	var _RichTextItem2 = _interopRequireDefault(_RichTextItem);
	
	var _RichTextCounter = __webpack_require__(319);
	
	var _RichTextCounter2 = _interopRequireDefault(_RichTextCounter);
	
	var _draftJs = __webpack_require__(86);
	
	var _richtext = __webpack_require__(115);
	
	var _index = __webpack_require__(141);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapBlockContentToEditorState = function mapBlockContentToEditorState(block) {
	  return block.content ? (0, _richtext.htmlToState)(block.content) : _draftJs.EditorState.createEmpty(_richtext.linkDecorator);
	};
	
	var Edit = function (_Component) {
	  _inherits(Edit, _Component);
	
	  function Edit(props) {
	    _classCallCheck(this, Edit);
	
	    var _this = _possibleConstructorReturn(this, (Edit.__proto__ || Object.getPrototypeOf(Edit)).call(this, props));
	
	    _this.validateContact = function (target, type) {
	      var editor = _this.state.editor;
	
	
	      switch (type) {
	        case _constants.MAIL_CONTACT_BLOCKTYPE:
	          return target && _constants.MAIL_VALIDATION.test(target) && !((0, _richtext.getCharCount)(editor) > _index.CONTACT_CHARACTER_LIMIT);
	        case _constants.PHONE_CONTACT_BLOCKTYPE:
	          return target && true && !((0, _richtext.getCharCount)(editor) > _index.CONTACT_CHARACTER_LIMIT);
	        default:
	          return false;
	      }
	    };
	
	    _this.onReceiptChange = function (evt) {
	      var _this$props = _this.props,
	          onSerialize = _this$props.onSerialize,
	          onCanSubmitChanged = _this$props.onCanSubmitChanged,
	          block = _this$props.block;
	
	
	      if (evt.target instanceof HTMLInputElement) {
	        onSerialize(Object.assign({}, block, { target: evt.target.value }));
	        onCanSubmitChanged(_this.validateContact(evt.target.value, block.type));
	      }
	    };
	
	    _this.onOverlayChange = function (evt) {
	      var _this$props2 = _this.props,
	          onSerialize = _this$props2.onSerialize,
	          block = _this$props2.block;
	
	
	      if (evt.target instanceof HTMLInputElement) {
	        onSerialize(Object.assign({}, block, { text: evt.target.value }));
	      }
	    };
	
	    _this.toggleMail = function (evt) {
	      var _this$props3 = _this.props,
	          onSerialize = _this$props3.onSerialize,
	          block = _this$props3.block,
	          onCanSubmitChanged = _this$props3.onCanSubmitChanged;
	
	      evt.preventDefault();
	
	      onSerialize(Object.assign({}, block, { type: _constants.MAIL_CONTACT_BLOCKTYPE }));
	      onCanSubmitChanged(_this.validateContact(block.target, _constants.MAIL_CONTACT_BLOCKTYPE));
	    };
	
	    _this.togglePhone = function (evt) {
	      var _this$props4 = _this.props,
	          onSerialize = _this$props4.onSerialize,
	          block = _this$props4.block,
	          onCanSubmitChanged = _this$props4.onCanSubmitChanged;
	
	      evt.preventDefault();
	
	      onSerialize(Object.assign({}, block, { type: _constants.PHONE_CONTACT_BLOCKTYPE }));
	      onCanSubmitChanged(_this.validateContact(block.target, _constants.PHONE_CONTACT_BLOCKTYPE));
	    };
	
	    _this.serializeAsHtml = function (editorState) {
	      var _this$props5 = _this.props,
	          block = _this$props5.block,
	          onSerialize = _this$props5.onSerialize,
	          onCanSubmitChanged = _this$props5.onCanSubmitChanged;
	
	
	      _this.setState({
	        editor: editorState
	      });
	
	      onSerialize(Object.assign({}, block, {
	        content: (0, _richtext.stateToHTML)(editorState.getCurrentContent())
	      }));
	
	      onCanSubmitChanged(_this.validateContact(block.target, block.type));
	    };
	
	    _this.state = {
	      editor: mapBlockContentToEditorState(props.block)
	    };
	    return _this;
	  }
	
	  _createClass(Edit, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          onSerialize = _props.onSerialize,
	          block = _props.block,
	          onCanSubmitChanged = _props.onCanSubmitChanged;
	
	      if (!block.type) {
	        onSerialize(Object.assign({}, block, { type: _constants.DEFAULT_CONTACT_BLOCKTYPE }));
	      }
	
	      if (!block.target) {
	        onCanSubmitChanged(false);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var block = this.props.block;
	      var editor = this.state.editor;
	
	
	      var typeLabel = block.type === _constants.MAIL_CONTACT_BLOCKTYPE ? 'Mail' : 'Téléphonique';
	      var inputType = block.type === _constants.MAIL_CONTACT_BLOCKTYPE ? 'email' : 'tel';
	
	      var menuDescriptor = [{
	        value: _constants.MAIL_CONTACT_BLOCKTYPE,
	        handler: this.toggleMail,
	        label: 'Email'
	      }, {
	        value: _constants.PHONE_CONTACT_BLOCKTYPE,
	        handler: this.togglePhone,
	        label: 'Téléphone'
	      }];
	
	      return _react2.default.createElement(
	        _semanticUiReact.Form,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Form.Field,
	          null,
	          _react2.default.createElement(
	            'label',
	            null,
	            'Type de destinataire'
	          ),
	          _react2.default.createElement(_RadioMenu2.default, { currentValue: block.type, menuDesc: menuDescriptor })
	        ),
	        _react2.default.createElement(_semanticUiReact.Form.Input, {
	          label: 'Destinataire ' + typeLabel,
	          defaultValue: block.target,
	          onChange: this.onReceiptChange,
	          type: inputType,
	          required: true
	        }),
	        _react2.default.createElement(
	          _semanticUiReact.Form.Field,
	          null,
	          _react2.default.createElement(
	            'label',
	            null,
	            'Description'
	          ),
	          _react2.default.createElement(_semanticUiReact.Form.Input, {
	            defaultValue: block.text,
	            onChange: this.onOverlayChange
	          })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Form.Field,
	          null,
	          _react2.default.createElement(
	            'label',
	            null,
	            'Informations suppl\xE9mentaires'
	          ),
	          _react2.default.createElement(_RichTextItem2.default, {
	            parentState: editor,
	            onChange: this.serializeAsHtml,
	            withTextBlocks: true,
	            withInlineBasics: true,
	            withLinks: true,
	            withColors: true
	          }),
	          _react2.default.createElement(_RichTextCounter2.default, {
	            editorState: editor,
	            charLimit: _index.CONTACT_CHARACTER_LIMIT,
	            chars: true
	          })
	        )
	      );
	    }
	  }]);
	
	  return Edit;
	}(_react.Component);
	
	Edit.propTypes = {
	  block: __webpack_require__(1).PropTypes.any.isRequired,
	  onSerialize: __webpack_require__(1).PropTypes.func,
	  onCanSubmitChanged: __webpack_require__(1).PropTypes.func
	};
	exports.default = Edit;

/***/ },

/***/ 1009:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _RichTextItem = __webpack_require__(177);
	
	var _RichTextItem2 = _interopRequireDefault(_RichTextItem);
	
	var _draftJs = __webpack_require__(86);
	
	var _richtext = __webpack_require__(115);
	
	var _constants = __webpack_require__(493);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var View = function View(_ref) {
	  var block = _ref.block;
	
	  var targetIcon = block.type === _constants.MAIL_CONTACT_BLOCKTYPE ? 'mail square' : 'phone square';
	  var blockLabel = block.type === _constants.MAIL_CONTACT_BLOCKTYPE ? 'Contact par email' : 'Contact par téléphone';
	
	  var stateFromBlockContent = block.content ? (0, _richtext.htmlToState)(block.content) : _draftJs.EditorState.createEmpty(_richtext.linkDecorator);
	
	  if (block.target) {
	    return _react2.default.createElement(
	      _semanticUiReact.Segment,
	      { padded: true },
	      _react2.default.createElement(
	        _semanticUiReact.Label,
	        { attached: 'top' },
	        blockLabel
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Grid,
	        { padded: true },
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Row,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Header,
	            null,
	            _react2.default.createElement(_semanticUiReact.Icon, { name: targetIcon }),
	            block.target
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Row,
	          null,
	          block.text && 'Titre: ' + block.text
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Row,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            { width: 'sixteen' },
	            block.content && _react2.default.createElement(_RichTextItem2.default, { parentState: stateFromBlockContent, readOnly: true })
	          )
	        )
	      )
	    );
	  }
	
	  return _react2.default.createElement(_semanticUiReact.Message, { icon: 'info', header: 'Aucun contact sp\xE9cifi\xE9' });
	};
	
	View.propTypes = {
	  block: __webpack_require__(1).PropTypes.any.isRequired
	};
	exports.default = View;

/***/ },

/***/ 1010:
[2059, 1008, 1009],

/***/ 1011:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutable = __webpack_require__(10);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _uuid = __webpack_require__(296);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _GalleryImageSelector = __webpack_require__(1013);
	
	var _GalleryImageSelector2 = _interopRequireDefault(_GalleryImageSelector);
	
	var _GalleryImage = __webpack_require__(1012);
	
	var _GalleryImage2 = _interopRequireDefault(_GalleryImage);
	
	var _ordering = __webpack_require__(320);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var updateImages = function updateImages(images) {
	  return function (updateFunction) {
	    return updateFunction(_immutable2.default.Map(images.map(function (i) {
	      return [i.order, i];
	    })).toList());
	  };
	};
	
	var mergeImages = function mergeImages(images, updated) {
	  return updateImages(images)(function (map) {
	    return map.update(updated.order, function (i) {
	      return Object.assign({}, i, updated);
	    });
	  });
	};
	
	var removeImage = function removeImage(images, toDelete) {
	  return updateImages(images)(function (map) {
	    return map.remove(toDelete.order);
	  });
	};
	
	var Edit = function Edit(_ref) {
	  var block = _ref.block,
	      onSerialize = _ref.onSerialize;
	
	  var updateImages = function updateImages(images) {
	    return onSerialize(Object.assign({}, block, {
	      images: images
	    }));
	  };
	
	  var imageSelected = function imageSelected(resource) {
	    var images = block.images || [];
	    var newImage = {
	      id: (0, _uuid2.default)(),
	      order: images.length,
	      blockId: block.id,
	      resource: resource
	    };
	
	    updateImages([].concat(_toConsumableArray(images), [newImage]));
	  };
	
	  var imageUpdated = function imageUpdated(updated) {
	    var newImages = mergeImages(block.images, updated);
	    updateImages(newImages.toArray());
	  };
	
	  var imageDeleted = function imageDeleted(image) {
	    var newImages = (0, _ordering.enforceElementsOrder)(removeImage(block.images, image));
	    updateImages(newImages.toArray());
	  };
	
	  if (block.images && block.images.length) {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_GalleryImageSelector2.default, { onSelected: imageSelected }),
	      _react2.default.createElement(
	        _semanticUiReact.Card.Group,
	        { itemsPerRow: 4 },
	        block.images.map(function (i) {
	          return _react2.default.createElement(_GalleryImage2.default, {
	            key: i.order,
	            image: i,
	            onUpdate: imageUpdated,
	            onDelete: imageDeleted
	          });
	        })
	      )
	    );
	  }
	
	  return _react2.default.createElement(_GalleryImageSelector2.default, { onSelected: imageSelected });
	};
	
	Edit.propTypes = {
	  block: __webpack_require__(1).PropTypes.any.isRequired,
	  onSerialize: __webpack_require__(1).PropTypes.func
	};
	exports.default = Edit;

/***/ },

/***/ 1012:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _ResourceDimmer = __webpack_require__(176);
	
	var _ResourceDimmer2 = _interopRequireDefault(_ResourceDimmer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  input: {
	    margin: '8px'
	  }
	};
	
	var GalleryImage = function GalleryImage(_ref) {
	  var image = _ref.image,
	      onUpdate = _ref.onUpdate,
	      onDelete = _ref.onDelete;
	
	  var update = function update(event) {
	    if (event.target instanceof HTMLInputElement) {
	      onUpdate(Object.assign({}, image, {
	        title: event.target.value
	      }));
	    }
	  };
	
	  var remove = function remove() {
	    return onDelete(image);
	  };
	
	  return _react2.default.createElement(
	    _semanticUiReact.Card,
	    { key: image.order },
	    _react2.default.createElement(
	      _ResourceDimmer2.default,
	      { resource: image.resource && image.resource.source },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_semanticUiReact.Button, {
	          onClick: remove,
	          icon: 'close',
	          color: 'red',
	          content: 'Supprimer',
	          labelPosition: 'right'
	        })
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      { extra: true },
	      _react2.default.createElement(_semanticUiReact.Input, {
	        value: image.title || '',
	        onChange: update,
	        fluid: true,
	        placeholder: 'Titre',
	        style: styles.input
	      })
	    )
	  );
	};
	
	GalleryImage.propTypes = {
	  image: __webpack_require__(1).PropTypes.any.isRequired,
	  onUpdate: __webpack_require__(1).PropTypes.func.isRequired,
	  onDelete: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = GalleryImage;

/***/ },

/***/ 1013:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _index = __webpack_require__(318);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _ResourceImage = __webpack_require__(99);
	
	var _ResourceImage2 = _interopRequireDefault(_ResourceImage);
	
	var _resources = __webpack_require__(488);
	
	var ResourceService = _interopRequireWildcard(_resources);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  card: {
	    maxWidth: '220px'
	  }
	};
	
	var GalleryImageSelector = function (_Component) {
	  _inherits(GalleryImageSelector, _Component);
	
	  function GalleryImageSelector(props) {
	    _classCallCheck(this, GalleryImageSelector);
	
	    var _this = _possibleConstructorReturn(this, (GalleryImageSelector.__proto__ || Object.getPrototypeOf(GalleryImageSelector)).call(this, props));
	
	    _this.onShowSelector = function () {
	      return _this.setState({ selectorOpen: true });
	    };
	
	    _this.onHideSelector = function () {
	      return _this.setState({ selectorOpen: false });
	    };
	
	    _this.onResourceSelected = function (resource) {
	      _this.setState({
	        selectorOpen: false
	      });
	
	      _this.props.onSelected(ResourceService.createTemplateResource(resource));
	    };
	
	    _this.state = {
	      selectorOpen: false
	    };
	    return _this;
	  }
	
	  _createClass(GalleryImageSelector, [{
	    key: 'render',
	    value: function render() {
	      var selectorOpen = this.state.selectorOpen;
	
	
	      var content = _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Button,
	          {
	            type: 'button',
	            primary: true,
	            icon: true,
	            labelPosition: 'right',
	            onClick: this.onShowSelector
	          },
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'image' }),
	          'S\xE9lectionner'
	        )
	      );
	
	      return _react2.default.createElement(
	        _semanticUiReact.Card,
	        { centered: true, style: styles.card },
	        _react2.default.createElement(_semanticUiReact.Dimmer.Dimmable, {
	          as: _ResourceImage2.default,
	          dimmed: true,
	          dimmer: { active: true, content: content },
	          dimmerProps: { inverted: true }
	        }),
	        _react2.default.createElement(_index2.default, {
	          open: selectorOpen,
	          resourceType: 'image',
	          onResourceSelected: this.onResourceSelected,
	          onClose: this.onHideSelector
	        })
	      );
	    }
	  }]);
	
	  return GalleryImageSelector;
	}(_react.Component);
	
	GalleryImageSelector.propTypes = {
	  onSelected: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = GalleryImageSelector;

/***/ },

/***/ 1014:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _OctoResourceImage = __webpack_require__(216);
	
	var _OctoResourceImage2 = _interopRequireDefault(_OctoResourceImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var View = function View(_ref) {
	  var block = _ref.block;
	
	  if (block.images && block.images.length) {
	    return _react2.default.createElement(
	      _semanticUiReact.Card.Group,
	      { itemsPerRow: 4 },
	      block.images.map(function (i) {
	        return _react2.default.createElement(
	          _semanticUiReact.Card,
	          { key: i.order },
	          _react2.default.createElement(_OctoResourceImage2.default, { resource: i.resource })
	        );
	      })
	    );
	  }
	
	  return _react2.default.createElement(_semanticUiReact.Message, { icon: 'info', header: 'Aucune image dans la gallerie' });
	};
	
	View.propTypes = {
	  block: __webpack_require__(1).PropTypes.any.isRequired
	};
	exports.default = View;

/***/ },

/***/ 1015:
[2059, 1011, 1014],

/***/ 1016:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _OctoResourceCard = __webpack_require__(215);
	
	var _OctoResourceCard2 = _interopRequireDefault(_OctoResourceCard);
	
	var _resources = __webpack_require__(488);
	
	var ResourceServices = _interopRequireWildcard(_resources);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEFAULT_ASPECT = 16 / 9;
	var DEFAULT_MODE = 'crop';
	
	var Edit = function (_Component) {
	  _inherits(Edit, _Component);
	
	  function Edit() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Edit);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Edit.__proto__ || Object.getPrototypeOf(Edit)).call.apply(_ref, [this].concat(args))), _this), _this.changeMode = function (mode) {
	      return function () {
	        return _this.serializeBlock(Object.assign({}, _this.props.block, {
	          mode: mode
	        }));
	      };
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Edit, [{
	    key: 'serializeBlock',
	    value: function serializeBlock(block) {
	      this.props.onSerialize(Object.assign({
	        mode: DEFAULT_MODE
	      }, block));
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      var _this2 = this;
	
	      var block = this.props.block;
	
	
	      var imageUpdated = function imageUpdated(image) {
	        return _this2.serializeBlock(Object.assign({}, block, {
	          image: image
	        }));
	      };
	
	      var imageProcessed = function imageProcessed(url) {
	        return _this2.serializeBlock(Object.assign({}, block, {
	          image: Object.assign({}, block.image, {
	            raw: url
	          })
	        }));
	      };
	
	      var imageDeleted = function imageDeleted(image) {
	        return _this2.serializeBlock(Object.assign({}, block, {
	          image: undefined
	        }));
	      };
	
	      if (!block.mode || block.mode === 'crop') {
	        var strategy = block._cropImageStrategy || ResourceServices.createServerDrivenStrategy({
	          aspect: DEFAULT_ASPECT
	        });
	
	        return _react2.default.createElement(_OctoResourceCard2.default, {
	          strategy: strategy,
	          resource: block.image,
	          onUpdated: imageUpdated,
	          onProcessed: imageProcessed,
	          onDeleted: imageDeleted
	        });
	      } else {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_OctoResourceCard2.default, {
	            resource: block.image,
	            onUpdated: imageUpdated,
	            onDeleted: imageDeleted
	          }),
	          _react2.default.createElement(
	            _semanticUiReact.Grid,
	            { columns: 2, textAlign: 'center' },
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Button.Group,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Button,
	                  {
	                    onClick: this.changeMode('standard'),
	                    active: block.mode === 'standard'
	                  },
	                  'Standard'
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Button,
	                  {
	                    onClick: this.changeMode('limitless'),
	                    active: block.mode === 'limitless'
	                  },
	                  'Sans limite'
	                )
	              )
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var block = this.props.block;
	
	
	      var buttonsDisabled = !!block.image;
	
	      var captionChanged = function captionChanged(event) {
	        return _this3.serializeBlock(Object.assign({}, block, {
	          caption: event.target.value
	        }));
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Grid,
	          { columns: 2, textAlign: 'center' },
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Button.Group,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Button,
	                {
	                  onClick: this.changeMode('standard'),
	                  disabled: buttonsDisabled,
	                  active: block.mode && block.mode !== 'crop'
	                },
	                'Image enti\xE8re'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Button,
	                {
	                  onClick: this.changeMode('crop'),
	                  disabled: buttonsDisabled,
	                  active: !block.mode || block.mode === 'crop'
	                },
	                'Image recoup\xE9e'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_semanticUiReact.Divider, null),
	        _react2.default.createElement(
	          _semanticUiReact.Form,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Form.Field,
	            null,
	            _react2.default.createElement(
	              'label',
	              null,
	              'L\xE9gende'
	            ),
	            _react2.default.createElement('input', {
	              placeholder: 'L\xE9gende',
	              value: block.caption || '',
	              onChange: captionChanged
	            })
	          )
	        ),
	        _react2.default.createElement(_semanticUiReact.Divider, null),
	        this.renderContent()
	      );
	    }
	  }]);
	
	  return Edit;
	}(_react.Component);
	
	Edit.propTypes = {
	  block: __webpack_require__(1).PropTypes.any.isRequired,
	  onSerialize: __webpack_require__(1).PropTypes.func
	};
	exports.default = Edit;

/***/ },

/***/ 1017:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _OctoResourceImage = __webpack_require__(216);
	
	var _OctoResourceImage2 = _interopRequireDefault(_OctoResourceImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var View = function View(_ref) {
	  var block = _ref.block,
	      onSerialize = _ref.onSerialize;
	
	  if (block.image) {
	    return _react2.default.createElement(
	      _semanticUiReact.Grid,
	      { columns: 2, textAlign: 'center' },
	      _react2.default.createElement(
	        _semanticUiReact.Grid.Column,
	        null,
	        _react2.default.createElement(_semanticUiReact.Header, { as: 'h3', content: block.caption }),
	        _react2.default.createElement(_OctoResourceImage2.default, {
	          strategy: block.image.strategy,
	          resource: block.image
	        })
	      )
	    );
	  }
	
	  return _react2.default.createElement(_semanticUiReact.Message, { icon: 'info', header: 'Aucune image sp\xE9cifi\xE9e' });
	};
	
	View.propTypes = {
	  block: __webpack_require__(1).PropTypes.any.isRequired
	};
	exports.default = View;

/***/ },

/***/ 1018:
[2059, 1016, 1017],

/***/ 1019:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _RadioMenu = __webpack_require__(317);
	
	var _RadioMenu2 = _interopRequireDefault(_RadioMenu);
	
	var _constants = __webpack_require__(1021);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Edit = function (_Component) {
	  _inherits(Edit, _Component);
	
	  function Edit() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Edit);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Edit.__proto__ || Object.getPrototypeOf(Edit)).call.apply(_ref, [this].concat(args))), _this), _this.handleUrlChange = function (evt) {
	      if (evt.target instanceof HTMLInputElement) {
	        var _this$props = _this.props,
	            _block = _this$props.block,
	            _onSerialize = _this$props.onSerialize,
	            _onCanSubmitChanged = _this$props.onCanSubmitChanged;
	
	
	        var validUrl = !evt.target.value.match(/^[a-zA-Z]+:\/\//) ? 'http://' + evt.target.value : evt.target.value;
	
	        _onSerialize(Object.assign({}, _block, { url: validUrl }));
	        _onCanSubmitChanged(validUrl && true);
	      }
	    }, _this.handleTitleChange = function (evt) {
	      if (evt.target instanceof HTMLInputElement) {
	        var _this$props2 = _this.props,
	            _block2 = _this$props2.block,
	            _onSerialize2 = _this$props2.onSerialize;
	
	
	        _onSerialize2(Object.assign({}, _block2, { content: evt.target.value }));
	      }
	    }, _this.toggleInApp = function (evt) {
	      evt.preventDefault();
	      if (evt.target instanceof HTMLButtonElement) {
	        var _this$props3 = _this.props,
	            _block3 = _this$props3.block,
	            _onSerialize3 = _this$props3.onSerialize;
	
	
	        _onSerialize3(Object.assign({}, _block3, { action: _constants.INAPP_ACTION }));
	      }
	    }, _this.toggleNavigator = function (evt) {
	      evt.preventDefault();
	      if (evt.target instanceof HTMLButtonElement) {
	        var _this$props4 = _this.props,
	            _block4 = _this$props4.block,
	            _onSerialize4 = _this$props4.onSerialize;
	
	
	        _onSerialize4(Object.assign({}, _block4, { action: _constants.NAVIGATOR_ACTION }));
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Edit, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          block = _props.block,
	          onSerialize = _props.onSerialize,
	          onCanSubmitChanged = _props.onCanSubmitChanged;
	
	
	      if (!block.action) {
	        onSerialize(Object.assign({}, block, { action: _constants.DEFAULT_ACTION_TYPE }));
	      }
	      onCanSubmitChanged(block.url && true);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var block = this.props.block;
	
	
	      var menuDescriptor = [{ value: _constants.INAPP_ACTION, handler: this.toggleInApp, label: 'InApp' }, {
	        value: _constants.NAVIGATOR_ACTION,
	        handler: this.toggleNavigator,
	        label: 'Navigateur'
	      }];
	
	      return _react2.default.createElement(
	        _semanticUiReact.Form,
	        null,
	        _react2.default.createElement(_semanticUiReact.Form.Input, {
	          label: 'Destination',
	          defaultValue: block.url,
	          onChange: this.handleUrlChange,
	          required: true
	        }),
	        _react2.default.createElement(
	          _semanticUiReact.Form.Field,
	          null,
	          _react2.default.createElement(
	            'label',
	            null,
	            'Titre'
	          ),
	          _react2.default.createElement(_semanticUiReact.Form.Input, {
	            defaultValue: block.content,
	            onChange: this.handleTitleChange
	          })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Form.Field,
	          null,
	          _react2.default.createElement(
	            'label',
	            null,
	            'Type d\'action'
	          ),
	          _react2.default.createElement(_RadioMenu2.default, { currentValue: block.action, menuDesc: menuDescriptor })
	        )
	      );
	    }
	  }]);
	
	  return Edit;
	}(_react.Component);
	
	Edit.propTypes = {
	  block: __webpack_require__(1).PropTypes.any.isRequired,
	  onSerialize: __webpack_require__(1).PropTypes.func,
	  onCanSubmitChanged: __webpack_require__(1).PropTypes.func
	};
	exports.default = Edit;

/***/ },

/***/ 1020:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var View = function View(_ref) {
	  var block = _ref.block;
	
	  if (block.url) {
	    return _react2.default.createElement(
	      _semanticUiReact.Segment,
	      { padded: true },
	      _react2.default.createElement(
	        _semanticUiReact.Grid,
	        { padded: true },
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Row,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Header,
	            null,
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'linkify' }),
	            block.url
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Row,
	          null,
	          block.content
	        )
	      )
	    );
	  }
	
	  return _react2.default.createElement(_semanticUiReact.Message, { icon: 'info', header: 'Aucun lien sp\xE9cifi\xE9' });
	};
	
	View.propTypes = {
	  block: __webpack_require__(1).PropTypes.any.isRequired
	};
	exports.default = View;

/***/ },

/***/ 1021:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var DEFAULT_ACTION_TYPE = exports.DEFAULT_ACTION_TYPE = 'inapp';
	var INAPP_ACTION = exports.INAPP_ACTION = 'inapp';
	var NAVIGATOR_ACTION = exports.NAVIGATOR_ACTION = 'navigator';

/***/ },

/***/ 1022:
[2059, 1019, 1020],

/***/ 1023:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _pages = __webpack_require__(482);
	
	var PagesApi = _interopRequireWildcard(_pages);
	
	var _reactVirtualizedSelect = __webpack_require__(716);
	
	var _reactVirtualizedSelect2 = _interopRequireDefault(_reactVirtualizedSelect);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  content: {
	    minHeight: '120px'
	  }
	};
	
	var pagesToOptions = function pagesToOptions(pages) {
	  return pages.map(function (p) {
	    return {
	      label: p.name,
	      value: p.id
	    };
	  });
	};
	
	var Edit = function (_Component) {
	  _inherits(Edit, _Component);
	
	  function Edit(props) {
	    _classCallCheck(this, Edit);
	
	    var _this = _possibleConstructorReturn(this, (Edit.__proto__ || Object.getPrototypeOf(Edit)).call(this, props));
	
	    _this.state = {
	      isFetching: false,
	      pages: []
	    };
	    return _this;
	  }
	
	  _createClass(Edit, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.setState({
	        isFetching: true
	      }, function () {
	        return _this2.props.onCanSubmitChanged(false);
	      });
	
	      PagesApi.fetchLight(this.props.mode).then(function (pages) {
	        return _this2.setState({
	          isFetching: false,
	          pages: pages
	        }, function () {
	          return _this2.props.onCanSubmitChanged(true);
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          block = _props.block,
	          onSerialize = _props.onSerialize;
	      var _state = this.state,
	          isFetching = _state.isFetching,
	          pages = _state.pages;
	
	
	      var pageSelected = function pageSelected(page) {
	        return onSerialize(Object.assign({}, block, {
	          pageId: page.value,
	          page: {
	            id: page.value,
	            name: page.label
	          }
	        }));
	      };
	
	      var titleChanged = function titleChanged(event) {
	        return onSerialize(Object.assign({}, block, {
	          title: event.target.value
	        }));
	      };
	
	      if (isFetching) {
	        return _react2.default.createElement(
	          _semanticUiReact.Segment,
	          { style: styles.content },
	          _react2.default.createElement(
	            _semanticUiReact.Dimmer,
	            { active: true, inverted: true },
	            _react2.default.createElement(_semanticUiReact.Loader, { inverted: true, content: 'Chargement des pages' })
	          )
	        );
	      }
	
	      var getTitleOrDefault = function getTitleOrDefault() {
	        if (typeof block.title !== 'undefined') {
	          return block.title;
	        }
	
	        return block.page && block.page.name || '';
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.content },
	        _react2.default.createElement(_semanticUiReact.Message, {
	          info: true,
	          content: 'S\xE9lectionnez une page parmi la liste ci-dessous'
	        }),
	        _react2.default.createElement(
	          _semanticUiReact.Form,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Form.Field,
	            null,
	            _react2.default.createElement(
	              'label',
	              null,
	              'Page cible'
	            ),
	            _react2.default.createElement(_reactVirtualizedSelect2.default, {
	              value: block.pageId,
	              options: pagesToOptions(pages),
	              placeholder: 'S\xE9lectionnez une page',
	              noResultsText: 'Aucune page ne correspond aux crit\xE8res de recherche',
	              onChange: pageSelected
	            })
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Form.Field,
	            null,
	            _react2.default.createElement(
	              'label',
	              null,
	              'Libell\xE9 du lien'
	            ),
	            _react2.default.createElement('input', {
	              value: getTitleOrDefault(),
	              onChange: titleChanged,
	              placeholder: 'Libell\xE9 du lien'
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Edit;
	}(_react.Component);
	
	Edit.propTypes = {
	  mode: __webpack_require__(1).PropTypes.any.isRequired,
	  block: __webpack_require__(1).PropTypes.any.isRequired,
	  onSerialize: __webpack_require__(1).PropTypes.func,
	  onCanSubmitChanged: __webpack_require__(1).PropTypes.func
	};
	exports.default = Edit;

/***/ },

/***/ 1024:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(31);
	
	var _semanticUiReact = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Render = function Render(_ref) {
	  var block = _ref.block;
	
	  if (block.page) {
	    return _react2.default.createElement(
	      _semanticUiReact.Form,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Form.Input,
	        {
	          iconPosition: 'left',
	          label: 'Liaison vers la page',
	          defaultValue: block.page.name,
	          readOnly: true,
	          action: true
	        },
	        _react2.default.createElement(_semanticUiReact.Icon, { name: 'chevron right' }),
	        _react2.default.createElement('input', null),
	        _react2.default.createElement(
	          _reactRouterDom.Link,
	          {
	            to: 'pages/' + block.page.id,
	            target: 'innoctopus',
	            className: 'ui button'
	          },
	          'Editer'
	        )
	      )
	    );
	  }
	
	  return _react2.default.createElement(_semanticUiReact.Message, { icon: 'info', header: 'Aucune page sp\xE9cifi\xE9e' });
	};
	
	Render.propTypes = {
	  block: __webpack_require__(1).PropTypes.any.isRequired
	};
	exports.default = Render;

/***/ },

/***/ 1025:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var View = function View(_ref) {
	  var block = _ref.block;
	
	  if (block.page) {
	    return _react2.default.createElement(
	      _semanticUiReact.Form,
	      null,
	      _react2.default.createElement(_semanticUiReact.Form.Input, {
	        label: 'Titre',
	        value: block.title || block.page && block.page.name,
	        readOnly: true
	      }),
	      _react2.default.createElement(
	        _semanticUiReact.Form.Input,
	        {
	          iconPosition: 'left',
	          label: 'Liaison vers la page',
	          defaultValue: block.page.name,
	          readOnly: true
	        },
	        _react2.default.createElement(_semanticUiReact.Icon, { name: 'chevron right' }),
	        _react2.default.createElement('input', null)
	      )
	    );
	  }
	
	  return _react2.default.createElement(_semanticUiReact.Message, { icon: 'info', header: 'Aucune page sp\xE9cifi\xE9e' });
	};
	
	View.propTypes = {
	  block: __webpack_require__(1).PropTypes.any.isRequired
	};
	exports.default = View;

/***/ },

/***/ 1026:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getRenderComponent = exports.getViewComponent = exports.getEditComponent = undefined;
	
	var _Edit = __webpack_require__(1023);
	
	var _Edit2 = _interopRequireDefault(_Edit);
	
	var _View = __webpack_require__(1025);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _Render = __webpack_require__(1024);
	
	var _Render2 = _interopRequireDefault(_Render);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getEditComponent = exports.getEditComponent = function getEditComponent() {
	  return _Edit2.default;
	};
	
	var getViewComponent = exports.getViewComponent = function getViewComponent() {
	  return _View2.default;
	};
	var getRenderComponent = exports.getRenderComponent = function getRenderComponent() {
	  return _Render2.default;
	};

/***/ },

/***/ 1027:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _RichTextItem = __webpack_require__(177);
	
	var _RichTextItem2 = _interopRequireDefault(_RichTextItem);
	
	var _RichTextCounter = __webpack_require__(319);
	
	var _RichTextCounter2 = _interopRequireDefault(_RichTextCounter);
	
	var _draftJs = __webpack_require__(86);
	
	var _richtext = __webpack_require__(115);
	
	var _index = __webpack_require__(141);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapBlockContentToEditorState = function mapBlockContentToEditorState(block) {
	  return block.content ? (0, _richtext.htmlToState)(block.content) : _draftJs.EditorState.createEmpty(_richtext.linkDecorator);
	};
	
	var Edit = function (_Component) {
	  _inherits(Edit, _Component);
	
	  function Edit(props) {
	    _classCallCheck(this, Edit);
	
	    var _this = _possibleConstructorReturn(this, (Edit.__proto__ || Object.getPrototypeOf(Edit)).call(this, props));
	
	    _this.serializeAsHtml = function (editorState) {
	      var _this$props = _this.props,
	          block = _this$props.block,
	          onSerialize = _this$props.onSerialize,
	          onCanSubmitChanged = _this$props.onCanSubmitChanged;
	
	
	      _this.setState({
	        editor: editorState
	      });
	
	      onSerialize(Object.assign({}, block, {
	        content: (0, _richtext.stateToHTML)(editorState.getCurrentContent())
	      }));
	      onCanSubmitChanged(!((0, _richtext.getCharCount)(editorState) > _index.TEXT_CHARACTER_LIMIT));
	    };
	
	    _this.state = {
	      editor: mapBlockContentToEditorState(props.block)
	    };
	    return _this;
	  }
	
	  _createClass(Edit, [{
	    key: 'render',
	    value: function render() {
	      var editor = this.state.editor;
	
	
	      return _react2.default.createElement(
	        _semanticUiReact.Item.Content,
	        null,
	        _react2.default.createElement(_RichTextItem2.default, {
	          parentState: editor,
	          onChange: this.serializeAsHtml,
	          withTextBlocks: true,
	          withInlineBasics: true,
	          withLinks: true,
	          withColors: true
	        }),
	        _react2.default.createElement(_RichTextCounter2.default, { editorState: editor, chars: true })
	      );
	    }
	  }]);
	
	  return Edit;
	}(_react.Component);
	
	Edit.propTypes = {
	  block: __webpack_require__(1).PropTypes.any.isRequired,
	  onSerialize: __webpack_require__(1).PropTypes.func,
	  onCanSubmitChanged: __webpack_require__(1).PropTypes.func
	};
	exports.default = Edit;

/***/ },

/***/ 1028:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Render = function Render(_ref) {
	  var block = _ref.block;
	
	  function createMarkup() {
	    return { __html: block.content };
	  }
	
	  if (block.content) {
	    return _react2.default.createElement('div', { dangerouslySetInnerHTML: createMarkup() });
	  }
	
	  return _react2.default.createElement(_semanticUiReact.Message, { icon: 'info', header: 'Aucun contenu sp\xE9cifi\xE9' });
	};
	
	Render.propTypes = {
	  block: __webpack_require__(1).PropTypes.any.isRequired
	};
	exports.default = Render;

/***/ },

/***/ 1029:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _RichTextItem = __webpack_require__(177);
	
	var _RichTextItem2 = _interopRequireDefault(_RichTextItem);
	
	var _draftJs = __webpack_require__(86);
	
	var _richtext = __webpack_require__(115);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var View = function View(_ref) {
	  var block = _ref.block;
	
	  var stateFromBlockContent = block.content ? (0, _richtext.htmlToState)(block.content) : _draftJs.EditorState.createEmpty(_richtext.linkDecorator);
	
	  if ((0, _richtext.getCharCount)(stateFromBlockContent)) {
	    return _react2.default.createElement(_RichTextItem2.default, { parentState: stateFromBlockContent, readOnly: true });
	  }
	
	  return _react2.default.createElement(_semanticUiReact.Message, { icon: 'info', header: 'Element texte vide' });
	};
	
	View.propTypes = {
	  block: __webpack_require__(1).PropTypes.any.isRequired
	};
	exports.default = View;

/***/ },

/***/ 1030:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getRenderComponent = exports.getViewComponent = exports.getEditComponent = undefined;
	
	var _Render = __webpack_require__(1028);
	
	var _Render2 = _interopRequireDefault(_Render);
	
	var _Edit = __webpack_require__(1027);
	
	var _Edit2 = _interopRequireDefault(_Edit);
	
	var _View = __webpack_require__(1029);
	
	var _View2 = _interopRequireDefault(_View);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getEditComponent = exports.getEditComponent = function getEditComponent() {
	  return _Edit2.default;
	};
	
	var getViewComponent = exports.getViewComponent = function getViewComponent() {
	  return _View2.default;
	};
	var getRenderComponent = exports.getRenderComponent = function getRenderComponent() {
	  return _Render2.default;
	};

/***/ },

/***/ 1031:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Edit = function (_Component) {
	  _inherits(Edit, _Component);
	
	  function Edit() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Edit);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Edit.__proto__ || Object.getPrototypeOf(Edit)).call.apply(_ref, [this].concat(args))), _this), _this.toggleHeaderButton = function (level) {
	      _this.props.onCanSubmitChanged(_this.props.block.content);
	      _this.props.onSerialize(Object.assign({}, _this.props.block, {
	        level: level
	      }));
	    }, _this.toggleH1 = function () {
	      _this.toggleHeaderButton('h1');
	    }, _this.toggleH2 = function () {
	      _this.toggleHeaderButton('h2');
	    }, _this.toggleH3 = function () {
	      _this.toggleHeaderButton('h3');
	    }, _this.onInputChange = function (event) {
	      if (event.target instanceof HTMLInputElement) {
	        var _value = event.target.value;
	
	
	        _this.props.onCanSubmitChanged(_value && _value.length);
	
	        _this.props.onSerialize(Object.assign({}, _this.props.block, {
	          content: _value
	        }));
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Edit, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          onCanSubmitChanged = _props.onCanSubmitChanged,
	          block = _props.block;
	
	      onCanSubmitChanged(block.content);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var block = this.props.block;
	
	
	      return _react2.default.createElement(
	        _semanticUiReact.Item.Content,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Button.Group,
	          { style: { marginBottom: '10px' } },
	          _react2.default.createElement(
	            _semanticUiReact.Button,
	            {
	              type: 'button',
	              onClick: this.toggleH1,
	              active: !block.level || block.level === 'h1'
	            },
	            'Titre 1'
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Button,
	            {
	              type: 'button',
	              onClick: this.toggleH2,
	              active: block.level === 'h2'
	            },
	            'Titre 2'
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Button,
	            {
	              type: 'button',
	              onClick: this.toggleH3,
	              active: block.level === 'h3'
	            },
	            'Titre 3'
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Form,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Form.Field,
	            null,
	            _react2.default.createElement(
	              'label',
	              null,
	              'Titre'
	            ),
	            _react2.default.createElement(_semanticUiReact.Input, {
	              fluid: true,
	              placeholder: 'Titre',
	              defaultValue: block.content,
	              onChange: this.onInputChange
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Edit;
	}(_react.Component);
	
	Edit.propTypes = {
	  block: __webpack_require__(1).PropTypes.any.isRequired,
	  onSerialize: __webpack_require__(1).PropTypes.func,
	  onCanSubmitChanged: __webpack_require__(1).PropTypes.func
	};
	exports.default = Edit;

/***/ },

/***/ 1032:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var View = function View(_ref) {
	  var block = _ref.block;
	
	  if (block.content) {
	    return _react2.default.createElement(
	      _semanticUiReact.Header,
	      { as: block.level || 'h1', textAlign: 'center' },
	      block.content
	    );
	  }
	
	  return _react2.default.createElement(_semanticUiReact.Message, { icon: 'info', header: 'Aucun titre sp\xE9cifi\xE9' });
	};
	
	View.propTypes = {
	  block: __webpack_require__(1).PropTypes.any.isRequired
	};
	exports.default = View;

/***/ },

/***/ 1033:
[2059, 1031, 1032],

/***/ 1034:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _ProgressiveImage = __webpack_require__(316);
	
	var _ProgressiveImage2 = _interopRequireDefault(_ProgressiveImage);
	
	var _resources = __webpack_require__(114);
	
	var _imageLoader = __webpack_require__(379);
	
	var _imageLoader2 = _interopRequireDefault(_imageLoader);
	
	var _throttle = __webpack_require__(406);
	
	var _throttle2 = _interopRequireDefault(_throttle);
	
	var _youtube = __webpack_require__(509);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var blockToUrl = function blockToUrl(block) {
	  return block.youtubeId ? 'https://www.youtube.com/watch?v=' + block.youtubeId : '';
	};
	
	var Edit = function (_Component) {
	  _inherits(Edit, _Component);
	
	  function Edit(props) {
	    _classCallCheck(this, Edit);
	
	    var _this = _possibleConstructorReturn(this, (Edit.__proto__ || Object.getPrototypeOf(Edit)).call(this, props));
	
	    _this.getThumbnail = function (id) {
	      var canSubmit = function canSubmit(value) {
	        return _this.props.onCanSubmitChanged(value);
	      };
	
	      if (id) {
	        canSubmit(false);
	        (0, _youtube.fetchThumbnail)(id).then(function (response) {
	          var video = response.video;
	
	          if (video) {
	            _this.setState({
	              currentThumbnail: video.thumbnail
	            });
	
	            _this.props.onSerialize(Object.assign({}, _this.props.block, {
	              thumbnail: video.thumbnail
	            }));
	
	            canSubmit(true);
	          }
	        }, function (_) {
	          _this.setState({
	            error: true
	          });
	        });
	      }
	    };
	
	    _this.onUrlChanged = function (event) {
	      var _this$props = _this.props,
	          block = _this$props.block,
	          onSerialize = _this$props.onSerialize;
	
	
	      if (event.target instanceof HTMLInputElement) {
	        var _value = event.target.value;
	
	
	        var youtubeId = (0, _youtube.tryExtractId)(_value);
	        var isValid = youtubeId !== null;
	
	        _this.setState({
	          value: _value,
	          error: !isValid
	        });
	
	        _this.props.onCanSubmitChanged(false);
	
	        if (isValid) {
	          _this.state.thumbnailThrottle(youtubeId);
	
	          onSerialize(Object.assign({}, block, {
	            youtubeId: youtubeId
	          }));
	        }
	      }
	    };
	
	    _this.state = {
	      error: false,
	      thumbnailThrottle: (0, _throttle2.default)(_this.getThumbnail, _youtube.THUMBNAIL_THROTTLE_MILLIS, { trailing: true })
	    };
	    return _this;
	  }
	
	  _createClass(Edit, [{
	    key: 'render',
	    value: function render() {
	      var block = this.props.block;
	      var _state = this.state,
	          value = _state.value,
	          error = _state.error;
	
	
	      var url = value || blockToUrl(block);
	      var thumbnail = this.state.currentThumbnail || block.thumbnail || _resources.getVideoPlaceholder;
	
	      return _react2.default.createElement(
	        _semanticUiReact.Grid,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 4 },
	          _react2.default.createElement(
	            _ProgressiveImage2.default,
	            {
	              src: thumbnail,
	              crossOrigin: null,
	              placeholder: _imageLoader2.default
	            },
	            function (src) {
	              return _react2.default.createElement(_semanticUiReact.Image, { src: src });
	            }
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 12, verticalAlign: 'middle' },
	          _react2.default.createElement(
	            _semanticUiReact.Form,
	            null,
	            _react2.default.createElement(_semanticUiReact.Form.Input, {
	              error: error,
	              label: 'Lien vid\xE9o Youtube',
	              placeholder: 'https://www.youtube.com/watch?v=',
	              value: url,
	              onChange: this.onUrlChanged
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Edit;
	}(_react.Component);
	
	Edit.propTypes = {
	  block: __webpack_require__(1).PropTypes.any.isRequired,
	  onSerialize: __webpack_require__(1).PropTypes.func,
	  onCanSubmitChanged: __webpack_require__(1).PropTypes.func
	};
	exports.default = Edit;

/***/ },

/***/ 1035:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _resources = __webpack_require__(114);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var View = function View(_ref) {
	  var block = _ref.block;
	
	  if (block.youtubeId && block.youtubeId.length) {
	    return _react2.default.createElement(_semanticUiReact.Embed, {
	      id: block.youtubeId,
	      placeholder: block.thumbnail || _resources.getVideoPlaceholder,
	      source: 'youtube'
	    });
	  }
	
	  return _react2.default.createElement(_semanticUiReact.Message, { icon: 'info', header: 'Aucune vid\xE9o sp\xE9cifi\xE9e' });
	};
	
	View.propTypes = {
	  block: __webpack_require__(1).PropTypes.any.isRequired
	};
	exports.default = View;

/***/ },

/***/ 1036:
[2059, 1034, 1035],

/***/ 1037:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(31);
	
	var _reactRedux = __webpack_require__(14);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _actions = __webpack_require__(142);
	
	var NewsActions = _interopRequireWildcard(_actions);
	
	var _ImagesCard = __webpack_require__(1041);
	
	var _ImagesCard2 = _interopRequireDefault(_ImagesCard);
	
	var _EditoCard = __webpack_require__(1040);
	
	var _EditoCard2 = _interopRequireDefault(_EditoCard);
	
	var _DiffusionCard = __webpack_require__(1039);
	
	var _DiffusionCard2 = _interopRequireDefault(_DiffusionCard);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Edit = function (_Component) {
	  _inherits(Edit, _Component);
	
	  function Edit() {
	    _classCallCheck(this, Edit);
	
	    return _possibleConstructorReturn(this, (Edit.__proto__ || Object.getPrototypeOf(Edit)).apply(this, arguments));
	  }
	
	  _createClass(Edit, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      console.log('MOUNT');
	      this.props.loadInitialDatas();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      console.log(this.props);
	      return _react2.default.createElement(
	        _reactRouterDom.HashRouter,
	        null,
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Segment,
	            { attached: true },
	            _react2.default.createElement(
	              _semanticUiReact.Menu,
	              { secondary: true },
	              _react2.default.createElement(
	                _reactRouterDom.NavLink,
	                {
	                  exact: true,
	                  to: '/images',
	                  activeClassName: 'active',
	                  className: 'item'
	                },
	                'Images'
	              ),
	              _react2.default.createElement(
	                _reactRouterDom.NavLink,
	                {
	                  exact: true,
	                  to: '/edito',
	                  activeClassName: 'active',
	                  className: 'item'
	                },
	                'Contenu \xE9ditorial'
	              ),
	              _react2.default.createElement(
	                _reactRouterDom.NavLink,
	                {
	                  exact: true,
	                  to: '/diffusion',
	                  activeClassName: 'active',
	                  className: 'item'
	                },
	                'Diffusion'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactRouterDom.Switch,
	            null,
	            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/', render: function render() {
	                return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/images' });
	              } }),
	            _react2.default.createElement(
	              _reactRouterDom.Route,
	              { exact: true, path: '/images' },
	              _react2.default.createElement(_ImagesCard2.default, null)
	            ),
	            _react2.default.createElement(
	              _reactRouterDom.Route,
	              { exact: true, path: '/edito' },
	              _react2.default.createElement(_EditoCard2.default, null)
	            ),
	            _react2.default.createElement(
	              _reactRouterDom.Route,
	              { exact: true, path: '/diffusion' },
	              _react2.default.createElement(_DiffusionCard2.default, null)
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Edit;
	}(_react.Component);
	
	Edit.propTypes = {
	  loadInitialDatas: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return state;
	}, {
	  loadInitialDatas: NewsActions.loadInitialDatas
	})(Edit);

/***/ },

/***/ 1038:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.updatePostpone = updatePostpone;
	
	var _fetch = __webpack_require__(32);
	
	var _fetch2 = _interopRequireDefault(_fetch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function updatePostpone(id, date) {
	  return (0, _fetch2.default)('/news/' + id + '/postpone?date=' + date, {
	    method: 'PUT'
	  });
	}

/***/ },

/***/ 1039:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _DiffusionList = __webpack_require__(307);
	
	var _DiffusionList2 = _interopRequireDefault(_DiffusionList);
	
	var _diffusion = __webpack_require__(310);
	
	var _diffusion2 = __webpack_require__(494);
	
	var DiffusionActions = _interopRequireWildcard(_diffusion2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    targets: (0, _diffusion.getTargets)(state)
	  };
	};
	
	var DiffusionCard = function DiffusionCard(_ref) {
	  var targets = _ref.targets,
	      updateTargets = _ref.updateTargets;
	  return _react2.default.createElement(_DiffusionList2.default, {
	    targets: targets,
	    onUpdate: updateTargets,
	    isEditable: true,
	    attached: true
	  });
	};
	
	DiffusionCard.propTypes = {
	  targets: __webpack_require__(1).PropTypes.arrayOf(__webpack_require__(1).PropTypes.any).isRequired,
	  updateTargets: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  updateTargets: DiffusionActions.updateTargets
	})(DiffusionCard);

/***/ },

/***/ 1040:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _edito = __webpack_require__(311);
	
	var _App = __webpack_require__(308);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _edito2 = __webpack_require__(495);
	
	var EditoActions = _interopRequireWildcard(_edito2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    blocks: (0, _edito.getBlocks)(state)
	  };
	};
	
	var EditoCard = function EditoCard(_ref) {
	  var blocks = _ref.blocks,
	      updateBlocks = _ref.updateBlocks;
	  return _react2.default.createElement(_App2.default, {
	    mode: 'production',
	    blocks: blocks,
	    onUpdate: updateBlocks,
	    attached: true
	  });
	};
	
	EditoCard.propTypes = {
	  blocks: __webpack_require__(1).PropTypes.arrayOf(__webpack_require__(1).PropTypes.any).isRequired,
	  updateBlocks: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  updateBlocks: EditoActions.updateBlocks
	})(EditoCard);

/***/ },

/***/ 1041:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(14);
	
	var _images = __webpack_require__(312);
	
	var _images2 = __webpack_require__(496);
	
	var ImagesActions = _interopRequireWildcard(_images2);
	
	var _OctoResourceCard = __webpack_require__(215);
	
	var _OctoResourceCard2 = _interopRequireDefault(_OctoResourceCard);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    imageStrategy: (0, _images.getImageStrategy)(state),
	    image: (0, _images.getImage)(state),
	    catchImageStrategy: (0, _images.getCatchImageStrategy)(state),
	    catchImage: (0, _images.getCatchImage)(state)
	  };
	};
	
	var ImagesCard = function ImagesCard(_ref) {
	  var imageStrategy = _ref.imageStrategy,
	      image = _ref.image,
	      catchImageStrategy = _ref.catchImageStrategy,
	      catchImage = _ref.catchImage,
	      updateImage = _ref.updateImage,
	      deleteImage = _ref.deleteImage,
	      updateCatchImage = _ref.updateCatchImage,
	      deleteCatchImage = _ref.deleteCatchImage;
	
	  if (imageStrategy) {
	    return _react2.default.createElement(
	      _semanticUiReact.Segment,
	      { attached: true },
	      _react2.default.createElement(
	        _semanticUiReact.Header,
	        { textAlign: 'center' },
	        'Image titre'
	      ),
	      _react2.default.createElement(_OctoResourceCard2.default, {
	        strategy: imageStrategy,
	        resource: image,
	        onUpdated: updateImage,
	        onDeleted: deleteImage
	      }),
	      _react2.default.createElement(_semanticUiReact.Divider, null),
	      _react2.default.createElement(
	        _semanticUiReact.Header,
	        { textAlign: 'center' },
	        'Image d\'accroche'
	      ),
	      _react2.default.createElement(_OctoResourceCard2.default, {
	        strategy: catchImageStrategy,
	        resource: catchImage,
	        onUpdated: updateCatchImage,
	        onDeleted: deleteCatchImage
	      })
	    );
	  }
	
	  return null;
	};
	
	ImagesCard.propTypes = {
	  imageStrategy: __webpack_require__(1).PropTypes.any,
	  image: __webpack_require__(1).PropTypes.any,
	  catchImageStrategy: __webpack_require__(1).PropTypes.any,
	  catchImage: __webpack_require__(1).PropTypes.any,
	  updateImage: __webpack_require__(1).PropTypes.func.isRequired,
	  updateCatchImage: __webpack_require__(1).PropTypes.func.isRequired,
	  deleteImage: __webpack_require__(1).PropTypes.func.isRequired,
	  deleteCatchImage: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  updateImage: ImagesActions.updateImage,
	  updateCatchImage: ImagesActions.updateCatchImage,
	  deleteImage: ImagesActions.deleteImage,
	  deleteCatchImage: ImagesActions.deleteCatchImage
	})(ImagesCard);

/***/ },

/***/ 1042:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.renderEdit = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(38);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRedux = __webpack_require__(14);
	
	var _redux = __webpack_require__(33);
	
	var _Edit = __webpack_require__(1037);
	
	var _Edit2 = _interopRequireDefault(_Edit);
	
	var _reduxSaga = __webpack_require__(138);
	
	var _reduxSaga2 = _interopRequireDefault(_reduxSaga);
	
	var _middleware = __webpack_require__(314);
	
	var _middleware2 = _interopRequireDefault(_middleware);
	
	var _redux2 = __webpack_require__(322);
	
	var _reducers = __webpack_require__(498);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _sagas = __webpack_require__(1045);
	
	var _sagas2 = _interopRequireDefault(_sagas);
	
	var _edito = __webpack_require__(311);
	
	var _diffusion = __webpack_require__(310);
	
	var _images = __webpack_require__(312);
	
	var _jquery = __webpack_require__(16);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _fetch = __webpack_require__(32);
	
	var _json = __webpack_require__(506);
	
	var _toastr = __webpack_require__(81);
	
	var _loader = __webpack_require__(313);
	
	var _publish = __webpack_require__(1044);
	
	var _publish2 = _interopRequireDefault(_publish);
	
	var _postpone = __webpack_require__(497);
	
	var _postpone2 = _interopRequireDefault(_postpone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var renderEdit = exports.renderEdit = function renderEdit(id) {
	  var sagaMiddleware = (0, _reduxSaga2.default)();
	  var ravenMiddleware = (0, _middleware2.default)();
	
	  var middleware = [sagaMiddleware, ravenMiddleware];
	
	  (0, _redux2.appendLoggerMiddlewareInDev)(middleware);
	
	  var store = (0, _redux.createStore)(_reducers2.default, _redux.applyMiddleware.apply(undefined, middleware));
	  sagaMiddleware.run(_sagas2.default);
	
	  // Rendering React UI
	  _reactDom2.default.render(_react2.default.createElement(
	    _reactRedux.Provider,
	    { store: store },
	    _react2.default.createElement(_Edit2.default, null)
	  ), document.getElementById('root'));
	
	  var $form = (0, _jquery2.default)('form');
	  $form.on('submit', function (evt) {
	    evt.preventDefault();
	
	    var $form = (0, _jquery2.default)(evt.currentTarget);
	
	    // Serializing form data
	    var data = new FormData($form[0]);
	
	    // Appending redux state
	    var state = store.getState();
	
	    var image = (0, _images.getImage)(state);
	    if (image) {
	      data.append('image', JSON.stringify(image));
	    }
	
	    var catchImage = (0, _images.getCatchImage)(state);
	    if (catchImage) {
	      data.append('catchImage', JSON.stringify(catchImage));
	    }
	
	    var blocks = (0, _edito.getBlocks)(state);
	    data.append('blocks', JSON.stringify(blocks, _json.purify));
	
	    var targets = (0, _diffusion.getTargets)(state).map(function (e) {
	      return {
	        role: e.role,
	        tags: e.tags
	      };
	    });
	    data.append('targets', JSON.stringify(targets));
	
	    return handleFormSubmit($form, data, function () {
	      // Storing flash in session for toast
	      (0, _toastr.storeSuccess)('Actualité mise à jour avec succès');
	
	      // Moving to list page
	      window.location.replace('/news');
	    });
	  });
	};
	
	function handleFormSubmit($form, data, successCallback) {
	  var handleFormErrors = function handleFormErrors(errors) {
	    // Clearing existing errors
	    $form.find('.field').removeClass('error');
	
	    var formError = errors[0];
	    if (formError && formError.key) {
	      $form.find('input[name="' + formError.key + '"]').closest('.field').addClass('error');
	    }
	  };
	
	  var $submitButton = (0, _jquery2.default)(document.activeElement);
	  var postForm = function postForm(_ref) {
	    var push = _ref.push,
	        postpone = _ref.postpone;
	
	    var url = $submitButton.attr('formaction') || $form.attr('action');
	
	    // Append push to data
	    data.append('push', push);
	    data.append('postpone', postpone);
	
	    return (0, _fetch.post)(url, data).then(function (res) {
	      (0, _loader.hideFormLoader)($form);
	      successCallback(res);
	    }, function (err) {
	      (0, _loader.hideFormLoader)($form);
	
	      console.log('Error attempting to save news', err);
	      if (err.res.status === 400) {
	        err.res.json().then(function (json) {
	          return handleFormErrors(json);
	        });
	      } else {
	        (0, _toastr.error)('Une erreur est survenue pendant la sauvegarde de l\'actualit\xE9');
	      }
	    });
	  };
	
	  // Displaying push settings modal if needed
	  if ($submitButton.hasClass('publish')) {
	    (0, _publish2.default)(function (push) {
	      return postForm({ push: push });
	    });
	  } else if ($submitButton.hasClass('postpone')) {
	    (0, _postpone2.default)(function (postpone) {
	      return postForm({ postpone: postpone });
	    });
	  } else {
	    postForm({});
	  }
	
	  return false;
	}

/***/ },

/***/ 1043:
[2057, 1042, 497],

/***/ 1044:
909,

/***/ 1045:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(58);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = root;
	
	var _effects = __webpack_require__(51);
	
	var _initialData = __webpack_require__(505);
	
	var _actions = __webpack_require__(142);
	
	var _reducers = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [loadInitialDatas, root].map(_regenerator2.default.mark);
	
	function loadInitialDatas() {
	  var isFetched, strategy, image, catchStrategy, catchImage, blocks, targets;
	  return _regenerator2.default.wrap(function loadInitialDatas$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_reducers.getIsFetched);
	
	        case 2:
	          isFetched = _context.sent;
	
	          if (isFetched) {
	            _context.next = 24;
	            break;
	          }
	
	          _context.next = 6;
	          return (0, _effects.call)(_initialData.getFromInitialData, 'strategy', null);
	
	        case 6:
	          strategy = _context.sent;
	          _context.next = 9;
	          return (0, _effects.call)(_initialData.getFromInitialData, 'image', null);
	
	        case 9:
	          image = _context.sent;
	          _context.next = 12;
	          return (0, _effects.call)(_initialData.getFromInitialData, 'catchStrategy', null);
	
	        case 12:
	          catchStrategy = _context.sent;
	          _context.next = 15;
	          return (0, _effects.call)(_initialData.getFromInitialData, 'catchImage', null);
	
	        case 15:
	          catchImage = _context.sent;
	          _context.next = 18;
	          return (0, _effects.call)(_initialData.getFromInitialData, 'blocks', []);
	
	        case 18:
	          blocks = _context.sent;
	          _context.next = 21;
	          return (0, _effects.call)(_initialData.getFromInitialData, 'targets', []);
	
	        case 21:
	          targets = _context.sent;
	          _context.next = 24;
	          return (0, _effects.put)({
	            type: _actions.INITIAL_DATA_LOAD_SUCCESS,
	            targets: targets,
	            blocks: blocks,
	            strategy: strategy,
	            image: image,
	            catchStrategy: catchStrategy,
	            catchImage: catchImage
	          });
	
	        case 24:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	function root() {
	  return _regenerator2.default.wrap(function root$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return [(0, _effects.takeLatest)(_actions.INITIAL_DATA_LOAD, loadInitialDatas)];
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}

/***/ },

/***/ 1046:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(16);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _errors = __webpack_require__(178);
	
	var _fetch = __webpack_require__(32);
	
	var _fetch2 = _interopRequireDefault(_fetch);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AcceptAccountRequestModal = function (_Component) {
	  _inherits(AcceptAccountRequestModal, _Component);
	
	  function AcceptAccountRequestModal(props) {
	    _classCallCheck(this, AcceptAccountRequestModal);
	
	    var _this = _possibleConstructorReturn(this, (AcceptAccountRequestModal.__proto__ || Object.getPrototypeOf(AcceptAccountRequestModal)).call(this, props));
	
	    _this.setForm = function (ref) {
	      _this.form = ref;
	
	      // Enabling tags dropdown
	      (0, _jquery2.default)(ref).find('.dropdown.tags').dropdown({
	        allowAdditions: true
	      });
	    };
	
	    _this.onAccept = function () {
	      var _this$props = _this.props,
	          id = _this$props.id,
	          onAccepted = _this$props.onAccepted;
	
	
	      if (_this.form) {
	        var data = new FormData(_this.form);
	
	        _this.setState({
	          isAccepting: true
	        });
	
	        (0, _fetch.post)('/accounts/requests/' + id + '/accept', data).then(onAccepted).catch(function (error) {
	          if (error.res.text) {
	            return error.res.text().then(function (text) {
	              return _this.setState({
	                isAccepting: false,
	                error: '',
	                form: {
	                  __html: text
	                }
	              });
	            });
	          } else {
	            _this.setState({
	              isAccepting: false,
	              error: (0, _errors.displayError)(error)
	            });
	          }
	        });
	      }
	    };
	
	    _this.state = {
	      isAccepting: false
	    };
	    return _this;
	  }
	
	  _createClass(AcceptAccountRequestModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var id = this.props.id;
	
	
	      (0, _fetch2.default)('/accounts/requests/' + id + '/new').then(function (res) {
	        return res.text();
	      }).then(function (text) {
	        return _this2.setState({
	          form: {
	            __html: text
	          }
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          open = _props.open,
	          onClose = _props.onClose;
	      var _state = this.state,
	          form = _state.form,
	          isAccepting = _state.isAccepting,
	          error = _state.error;
	
	
	      var formClass = (0, _classnames2.default)('ui form', {
	        error: error !== undefined
	      });
	
	      return _react2.default.createElement(
	        _semanticUiReact.Modal,
	        { closeIcon: true, size: 'small', open: open, onClose: onClose },
	        _react2.default.createElement(
	          _semanticUiReact.Modal.Header,
	          null,
	          'Cr\xE9ation de compte'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Modal.Content,
	          null,
	          form && _react2.default.createElement(
	            'form',
	            { className: formClass, ref: this.setForm },
	            error && error.length && _react2.default.createElement(
	              'div',
	              { className: 'ui error message' },
	              _react2.default.createElement(
	                'p',
	                null,
	                error
	              )
	            ),
	            _react2.default.createElement('div', { dangerouslySetInnerHTML: form })
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Modal.Actions,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Button,
	            { onClick: onClose },
	            'Annuler'
	          ),
	          _react2.default.createElement(_semanticUiReact.Button, {
	            loading: isAccepting,
	            onClick: this.onAccept,
	            primary: true,
	            icon: 'save',
	            labelPosition: 'right',
	            content: 'Cr\xE9er le compte'
	          })
	        )
	      );
	    }
	  }]);
	
	  return AcceptAccountRequestModal;
	}(_react.Component);
	
	AcceptAccountRequestModal.propTypes = {
	  open: __webpack_require__(1).PropTypes.bool.isRequired,
	  id: __webpack_require__(1).PropTypes.string.isRequired,
	  url: __webpack_require__(1).PropTypes.string.isRequired,
	  onClose: __webpack_require__(1).PropTypes.func.isRequired,
	  onAccepted: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = AcceptAccountRequestModal;

/***/ },

/***/ 1047:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.index = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(16);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fetch = __webpack_require__(32);
	
	var _fetch2 = _interopRequireDefault(_fetch);
	
	var _redirect = __webpack_require__(321);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _AcceptAccountRequestModal = __webpack_require__(1046);
	
	var _AcceptAccountRequestModal2 = _interopRequireDefault(_AcceptAccountRequestModal);
	
	var _modals = __webpack_require__(217);
	
	var _errors = __webpack_require__(178);
	
	var _toastr = __webpack_require__(81);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var index = exports.index = function index() {
	  (0, _jquery2.default)('table tr .decline.button').on('click', onDecline);
	  (0, _jquery2.default)('table tr .accept.button').on('click', onAccept);
	};
	
	function onDecline(event) {
	  var $button = (0, _jquery2.default)(event.currentTarget);
	  var url = $button.attr('data-url');
	
	  if (url && url.length) {
	    (0, _modals.mountComponent)(_react2.default.createElement(DeclineModal, { url: url, onClose: _modals.unmountCurrentComponent }));
	  } else {
	    console.warn('Decline button must have a `data-url` attribute but none specified');
	  }
	}
	
	function declineConfirmed() {
	  (0, _modals.unmountCurrentComponent)();
	
	  // Storing success notification
	  (0, _toastr.storeSuccess)('Demande déclinée avec succès');
	
	  // Reloading page
	  window.location.reload(true);
	}
	
	function onAccept(event) {
	  var $button = (0, _jquery2.default)(event.currentTarget);
	
	  var id = $button.closest('tr').attr('data-id');
	  var url = $button.attr('data-url');
	
	  if (url && url.length) {
	    (0, _modals.mountComponent)(_react2.default.createElement(_AcceptAccountRequestModal2.default, {
	      open: true,
	      id: id,
	      url: url,
	      onClose: _modals.unmountCurrentComponent,
	      onAccepted: acceptConfirmed
	    }));
	  } else {
	    console.warn('Accept button must have a `data-url` attribute but none specified');
	  }
	}
	
	function acceptConfirmed(response) {
	  (0, _modals.unmountCurrentComponent)();
	
	  // Storing success notification
	  (0, _toastr.storeSuccess)('Compte utilisateur créé avec succès');
	
	  (0, _redirect.redirectToResponse)(response);
	}
	
	var DeclineModal = function (_Component) {
	  _inherits(DeclineModal, _Component);
	
	  function DeclineModal(props) {
	    _classCallCheck(this, DeclineModal);
	
	    var _this = _possibleConstructorReturn(this, (DeclineModal.__proto__ || Object.getPrototypeOf(DeclineModal)).call(this, props));
	
	    _this.onDecline = function () {
	      var url = _this.props.url;
	
	
	      _this.setState({
	        isDeclining: true
	      });
	
	      (0, _fetch2.default)(url, { method: 'POST' }).then(declineConfirmed, _fetch.handleFetchError).catch(function (error) {
	        return _this.setState({
	          isDeclining: false,
	          error: (0, _errors.displayError)(error)
	        });
	      });
	    };
	
	    _this.state = {
	      isDeclining: false
	    };
	    return _this;
	  }
	
	  _createClass(DeclineModal, [{
	    key: 'render',
	    value: function render() {
	      var onClose = this.props.onClose;
	      var _state = this.state,
	          isDeclining = _state.isDeclining,
	          error = _state.error;
	
	
	      return _react2.default.createElement(
	        _semanticUiReact.Modal,
	        { closeIcon: true, size: 'small', open: true, onClose: onClose },
	        _react2.default.createElement(
	          _semanticUiReact.Modal.Header,
	          null,
	          'D\xE9clinaison de la demande'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Modal.Content,
	          null,
	          error && _react2.default.createElement(_semanticUiReact.Message, { error: true, content: error }),
	          _react2.default.createElement(
	            'p',
	            null,
	            '\n              \xCAtes-vous s\xFBr(e) de vouloir d\xE9cliner cette demande ? Elle\n              sera d\xE9finitivement supprim\xE9e de cette liste.\n            '
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Modal.Actions,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Button,
	            { onClick: onClose },
	            'Non'
	          ),
	          _react2.default.createElement(_semanticUiReact.Button, {
	            disabled: !!error,
	            onClick: this.onDecline,
	            loading: isDeclining,
	            negative: true,
	            icon: 'thumbs down',
	            labelPosition: 'right',
	            content: 'Oui'
	          })
	        )
	      );
	    }
	  }]);

	  return DeclineModal;
	}(_react.Component);

	DeclineModal.propTypes = {
	  url: __webpack_require__(1).PropTypes.string.isRequired,
	  onClose: __webpack_require__(1).PropTypes.func.isRequired
	};

/***/ },

/***/ 1048:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.index = undefined;
	
	var _jquery = __webpack_require__(16);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var index = exports.index = function index(ctx) {
	  var modal = (0, _jquery2.default)('#techModal');
	  var createButton = (0, _jquery2.default)('#createButton');
	  var validationButton = modal.find('.ui.button');
	
	  createButton.on('click', function (evt) {
	    evt.preventDefault();
	    modal.modal('show');
	  });
	
	  validationButton.on('click', function (evt) {
	    evt.preventDefault();
	
	    var techId = (0, _jquery2.default)('#techId').val();
	    var newUrl = (0, _jquery2.default)('#techModal').attr('data-url');
	    if (techId && newUrl) {
	      window.location.href = newUrl.replace('-1', techId);
	    }
	  });
	};

/***/ },

/***/ 1049:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(16);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _moment = __webpack_require__(134);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(1957);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  _jquery2.default.fn.calendarFr = function (params) {
	    return _jquery2.default.fn.calendar.call(this, Object.assign({
	      firstDayOfWeek: 1,
	      text: {
	        days: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
	        months: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Décembre']
	      },
	      formatter: Object.assign({
	        hourHeader: function hourHeader(date) {
	          return (0, _moment2.default)(date).format('dddd DD');
	        },
	        datetime: function datetime(date) {
	          if (!date) {
	            return '';
	          }
	
	          return (0, _moment2.default)(date).format('dddd DD MMMM YYYY à HH:mm');
	        },
	        time: function time(date) {
	          return (0, _moment2.default)(date).format('HH:mm');
	        }
	      }, params.formatter)
	    }, params));
	  };
	};
	
	// SUI calendar doesn't do a proper module export, so we need to shim it

/***/ },

/***/ 1050:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(16);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fetch = __webpack_require__(32);
	
	var _fetch2 = _interopRequireDefault(_fetch);
	
	var _errors = __webpack_require__(178);
	
	var _modals = __webpack_require__(217);
	
	var _toastr = __webpack_require__(81);
	
	var _DeleteModal = __webpack_require__(500);
	
	var _DeleteModal2 = _interopRequireDefault(_DeleteModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	exports.default = function () {
	  (0, _jquery2.default)('.button.delete').on('click', confirmDelete);
	};
	
	function confirmDelete(event) {
	  var $button = (0, _jquery2.default)(event.currentTarget);
	
	  var url = $button.attr('data-url');
	  var content = $button.attr('data-content');
	  var method = $button.attr('data-method') || 'DELETE';
	
	  if (url && content) {
	    showModal(url, method, content);
	  } else {
	    console.warn('Trying to confirm deletion without required data attributes (url, content)');
	  }
	}
	
	function deleteConfirmed() {
	  (0, _modals.unmountCurrentComponent)();
	
	  // Storing success notification
	  (0, _toastr.storeSuccess)('Suppression effectuée avec succès');
	
	  // Reloading page
	  window.location.reload(true);
	}
	
	var ModalWrapper = function (_Component) {
	  _inherits(ModalWrapper, _Component);
	
	  function ModalWrapper(props) {
	    _classCallCheck(this, ModalWrapper);
	
	    var _this = _possibleConstructorReturn(this, (ModalWrapper.__proto__ || Object.getPrototypeOf(ModalWrapper)).call(this, props));
	
	    _this.onDelete = function () {
	      var _this$props = _this.props,
	          url = _this$props.url,
	          method = _this$props.method;
	
	
	      _this.setState({
	        isDeleting: true
	      });
	
	      (0, _fetch2.default)(url, { method: method }).then(deleteConfirmed, _fetch.handleFetchError).catch(function (error) {
	        _this.setState({
	          isDeleting: false,
	          error: (0, _errors.displayJsonError)(error)
	        });
	      });
	    };
	
	    _this.state = {
	      isDeleting: false
	    };
	    return _this;
	  }
	
	  _createClass(ModalWrapper, [{
	    key: 'render',
	    value: function render() {
	      var content = this.props.content;
	      var _state = this.state,
	          isDeleting = _state.isDeleting,
	          error = _state.error;
	
	
	      return _react2.default.createElement(_DeleteModal2.default, {
	        open: true,
	        loading: isDeleting,
	        error: error,
	        content: content,
	        onConfirm: this.onDelete,
	        onClose: _modals.unmountCurrentComponent
	      });
	    }
	  }]);
	
	  return ModalWrapper;
	}(_react.Component);
	
	ModalWrapper.propTypes = {
	  url: __webpack_require__(1).PropTypes.string.isRequired,
	  method: __webpack_require__(1).PropTypes.string.isRequired,
	  content: __webpack_require__(1).PropTypes.string.isRequired
	};
	
	
	function showModal(url, method, content) {
	  (0, _modals.mountComponent)(_react2.default.createElement(ModalWrapper, { url: url, method: method, content: content }));
	}

/***/ },

/***/ 1051:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(664);
	
	var _moment = __webpack_require__(134);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  _moment2.default.updateLocale('fr', {
	    months: 'Janvier_Février_Mars_Avril_Mai_Juin_Juillet_Août_Septembre_Octobre_Novembre_Décembre'.split('_'),
	    weekdays: 'Dimanche_Lundi_Mardi_Mercredi_Jeudi_Vendredi_Samedi'.split('_')
	  });
	};

/***/ },

/***/ 1052:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(16);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  var $window = (0, _jquery2.default)(window);
	  $window.on('scroll', function (e) {
	    if ((0, _jquery2.default)(e.target).scrollTop() >= 105) {
	      (0, _jquery2.default)('body').addClass('fixed');
	    } else {
	      (0, _jquery2.default)('body').removeClass('fixed');
	    }
	  });
	};

/***/ },

/***/ 1053:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loader = __webpack_require__(313);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _toastr = __webpack_require__(81);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var _tableRow = __webpack_require__(1057);
	
	var _tableRow2 = _interopRequireDefault(_tableRow);
	
	var _confirmDelete = __webpack_require__(1050);
	
	var _confirmDelete2 = _interopRequireDefault(_confirmDelete);
	
	var _tags = __webpack_require__(1058);
	
	var _tags2 = _interopRequireDefault(_tags);
	
	var _resources = __webpack_require__(1055);
	
	var _resources2 = _interopRequireDefault(_resources);
	
	var _search = __webpack_require__(1056);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _orderer = __webpack_require__(1054);
	
	var _orderer2 = _interopRequireDefault(_orderer);
	
	var _fixedActions = __webpack_require__(1052);
	
	var _fixedActions2 = _interopRequireDefault(_fixedActions);
	
	var _date = __webpack_require__(1051);
	
	var _date2 = _interopRequireDefault(_date);
	
	var _calendar = __webpack_require__(1049);
	
	var _calendar2 = _interopRequireDefault(_calendar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  [_loader2.default, _toastr2.default, _tableRow2.default, _confirmDelete2.default, _orderer2.default, _tags2.default, _fixedActions2.default, _resources2.default, _search2.default, _calendar2.default, _date2.default].map(function (plugin) {
	    return plugin.call(undefined);
	  });
	};

/***/ },

/***/ 1054:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(16);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _urijs = __webpack_require__(2045);
	
	var _urijs2 = _interopRequireDefault(_urijs);
	
	var _fetch = __webpack_require__(32);
	
	var _fetch2 = _interopRequireDefault(_fetch);
	
	var _toastr = __webpack_require__(81);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  (0, _jquery2.default)('.ordering.dropdown').dropdown({
	    onChange: onOrderChange
	  });
	};
	
	function onOrderChange(value, _, element) {
	  var $element = (0, _jquery2.default)(element).closest('.ordering');
	
	  var url = $element.attr('data-url');
	  if (url && url.length) {
	    var orderUrl = (0, _urijs2.default)(url).setSearch({ order: value }).toString();
	
	    // Changing order async then refreshing
	    $element.addClass('loading');
	    (0, _fetch2.default)(orderUrl, {
	      method: 'POST'
	    }).then(function (_) {
	      (0, _toastr.storeSuccess)('Ordre mis à jour avec succès');
	      window.location.reload(true);
	    });
	  } else {
	    console.warn('Trying to reorder an element without required data attribute (url)');
	  }
	}

/***/ },

/***/ 1055:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(16);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(38);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _InputResourceCard = __webpack_require__(1064);
	
	var _InputResourceCard2 = _interopRequireDefault(_InputResourceCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  var $resources = (0, _jquery2.default)('.resource');
	  $resources.each(function (_, element) {
	    var $element = (0, _jquery2.default)(element);
	
	    var name = $element.attr('data-name');
	    var title = $element.attr('data-title');
	    var value = $element.attr('data-id');
	    var type = $element.attr('data-type');
	    var thumbnail = $element.attr('data-thumbnail');
	
	    _reactDom2.default.render(_react2.default.createElement(_InputResourceCard2.default, {
	      name: name,
	      title: title,
	      value: value,
	      resourceType: type,
	      thumbnail: thumbnail
	    }), element);
	  });
	};

/***/ },

/***/ 1056:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(16);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  var $form = (0, _jquery2.default)('form.search');
	
	  // Enabling dropdown
	  $form.find('.ui.dropdown').dropdown({
	    onChange: function onChange() {
	      return $form.submit();
	    }
	  });
	};

/***/ },

/***/ 1057:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(16);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DISABLE_CLICK_CLASS = 'disable-row-click';
	
	exports.default = function () {
	  (0, _jquery2.default)('.ui.table.selectable').each(function (_, element) {
	    var $table = (0, _jquery2.default)(element);
	    var $rows = $table.find('tr[data-url]');
	
	    $rows.css('cursor', 'pointer');
	    $rows.find('td.' + DISABLE_CLICK_CLASS).css('cursor', 'default');
	
	    // Add click event
	    $rows.on('click', function (event) {
	      if (notClickable(event)) {
	        return;
	      }
	
	      var $row = (0, _jquery2.default)(event.currentTarget);
	      var url = $row.attr('data-url');
	      if (url && url.length) {
	        // Redirecting to target page
	        window.location.assign(url);
	      }
	    });
	  });
	};
	
	function notClickable(event) {
	  var $target = (0, _jquery2.default)(event.target);
	
	  return event.target.localName === 'a' || event.target.localName === 'button' || event.target.localName === 'i' || $target.hasClass(DISABLE_CLICK_CLASS) || $target.closest('td').hasClass(DISABLE_CLICK_CLASS);
	}

/***/ },

/***/ 1058:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(16);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  var $dropdown = (0, _jquery2.default)('input[name=tags]').closest('.dropdown');
	
	  $dropdown.dropdown({
	    allowAdditions: true,
	    direction: 'upward'
	  });
	  $dropdown.on('keypress', function (evt) {
	    if (evt.keyCode === 13) {
	      evt.preventDefault();
	    }
	  });
	};

/***/ },

/***/ 1059:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ravenJs = __webpack_require__(669);
	
	var _ravenJs2 = _interopRequireDefault(_ravenJs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  if (("production") === 'production' && !!window.__SENTRY__) {
	    var _window$__SENTRY__ = window.__SENTRY__,
	        dsn = _window$__SENTRY__.dsn,
	        release = _window$__SENTRY__.release,
	        environment = _window$__SENTRY__.environment;
	
	
	    console.log('Configuring Raven for release: ' + release + ' on environment: ' + environment);
	
	    try {
	      _ravenJs2.default.config(dsn, {
	        release: release,
	        environment: environment
	      }).install();
	
	      handlePromiseRejection();
	    } catch (error) {
	      console.warn('Invalid Sentry DSN provided: ' + dsn);
	    }
	  }
	};
	
	function handlePromiseRejection() {
	  window.onunhandledrejection = function (evt) {
	    _ravenJs2.default.captureException(evt.reason, {
	      level: 'warning'
	    });
	  };
	}

/***/ },

/***/ 1060:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hook;
	
	var _page = __webpack_require__(1619);
	
	var _page2 = _interopRequireDefault(_page);
	
	var _bucket = __webpack_require__(876);
	
	var Bucket = _interopRequireWildcard(_bucket);
	
	var _catalog = __webpack_require__(915);
	
	var Catalog = _interopRequireWildcard(_catalog);
	
	var _news = __webpack_require__(1043);
	
	var News = _interopRequireWildcard(_news);
	
	var _requests = __webpack_require__(1047);
	
	var AccountRequests = _interopRequireWildcard(_requests);
	
	var _events = __webpack_require__(871);
	
	var AdminEvents = _interopRequireWildcard(_events);
	
	var _campaign = __webpack_require__(908);
	
	var Campaign = _interopRequireWildcard(_campaign);
	
	var _workers = __webpack_require__(1048);
	
	var Worker = _interopRequireWildcard(_workers);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hook() {
	  // Bucket
	  (0, _page2.default)('/bucket', Bucket.index);
	  (0, _page2.default)('/bucket/*', Bucket.index);
	
	  // Catalog
	  (0, _page2.default)('/catalog', Catalog.index);
	  (0, _page2.default)('/catalog/*', Catalog.index);
	
	  // News
	  (0, _page2.default)('/news/:id', News.index);
	
	  // Accounts
	  (0, _page2.default)('/accounts/requests', AccountRequests.index);
	
	  // Admin
	  (0, _page2.default)('/admin/events', AdminEvents.index);
	
	  // Campaign
	  (0, _page2.default)('/campaign/:id', Campaign.index);
	
	  (0, _page2.default)('/customers/:id/workers', Worker.index);
	
	  _page2.default.start({
	    click: false,
	    popstate: false
	  });
	}

/***/ },

/***/ 1061:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(16);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  _jquery2.default.fn.transition = __webpack_require__(2038);
	  _jquery2.default.fn.dimmer = __webpack_require__(1959);
	  _jquery2.default.fn.modal = __webpack_require__(1961);
	  _jquery2.default.fn.checkbox = __webpack_require__(1958);
	  _jquery2.default.fn.dropdown = __webpack_require__(1960);
	  _jquery2.default.fn.popup = __webpack_require__(1962);
	
	  // Enabling dropdowns app wide
	  (0, _jquery2.default)('.ui.dropdown').dropdown();
	};

/***/ },

/***/ 1062:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _ResourceCard = __webpack_require__(175);
	
	var _ResourceCard2 = _interopRequireDefault(_ResourceCard);
	
	var _resources = __webpack_require__(504);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClientDrivenResourceCard = function (_Component) {
	  _inherits(ClientDrivenResourceCard, _Component);
	
	  function ClientDrivenResourceCard() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ClientDrivenResourceCard);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ClientDrivenResourceCard.__proto__ || Object.getPrototypeOf(ClientDrivenResourceCard)).call.apply(_ref, [this].concat(args))), _this), _this.onHorizontalAlignChanged = function (_, _ref2) {
	      var horizontalAlign = _ref2.value;
	      return _this.props.onChanged(horizontalAlign, _this.props.verticalAlign, _this.props.parallaxEnabled);
	    }, _this.onVerticalAlignChanged = function (_, _ref3) {
	      var verticalAlign = _ref3.value;
	      return _this.props.onChanged(_this.props.horizontalAlign, verticalAlign, _this.props.parallaxEnabled);
	    }, _this.onParallaxChanged = function (_, _ref4) {
	      var parallaxEnabled = _ref4.checked;
	      return _this.props.onChanged(_this.props.horizontalAlign, _this.props.verticalAlign, parallaxEnabled);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ClientDrivenResourceCard, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          resource = _props.resource,
	          horizontalAlign = _props.horizontalAlign,
	          verticalAlign = _props.verticalAlign,
	          parallaxEnabled = _props.parallaxEnabled,
	          onSelected = _props.onSelected,
	          onDeleted = _props.onDeleted;
	
	
	      var fieldDisabled = !resource;
	
	      return _react2.default.createElement(
	        _semanticUiReact.Grid,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Row,
	          { columns: 2, divided: true },
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Header,
	              { as: 'h3', textAlign: 'center' },
	              'Image Cible'
	            ),
	            _react2.default.createElement(_ResourceCard2.default, {
	              resourceType: 'image',
	              resource: resource,
	              onSelected: onSelected,
	              onDeleted: onDeleted
	            })
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Header,
	              { as: 'h3', textAlign: 'center' },
	              'Configuration'
	            ),
	            _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	            _react2.default.createElement(
	              _semanticUiReact.Form,
	              null,
	              _react2.default.createElement(_semanticUiReact.Form.Select, {
	                disabled: fieldDisabled,
	                value: horizontalAlign,
	                onChange: this.onHorizontalAlignChanged,
	                label: 'Alignement horizontal',
	                name: 'horizontalAlign',
	                options: _resources.HORIZONTAL_ALIGNS
	              }),
	              _react2.default.createElement(_semanticUiReact.Form.Select, {
	                disabled: fieldDisabled,
	                value: verticalAlign,
	                onChange: this.onVerticalAlignChanged,
	                label: 'Alignement vertical',
	                name: 'verticalAlign',
	                options: _resources.VERTICAL_ALIGNS
	              }),
	              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
	                disabled: fieldDisabled,
	                checked: parallaxEnabled,
	                onChange: this.onParallaxChanged,
	                name: 'parallax',
	                label: 'Parallax activ\xE9e'
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ClientDrivenResourceCard;
	}(_react.Component);
	
	ClientDrivenResourceCard.propTypes = {
	  resource: __webpack_require__(1).PropTypes.any,
	  horizontalAlign: __webpack_require__(1).PropTypes.any.isRequired,
	  verticalAlign: __webpack_require__(1).PropTypes.any.isRequired,
	  parallaxEnabled: __webpack_require__(1).PropTypes.bool.isRequired,
	  onSelected: __webpack_require__(1).PropTypes.func.isRequired,
	  onChanged: __webpack_require__(1).PropTypes.func.isRequired,
	  onDeleted: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = ClientDrivenResourceCard;

/***/ },

/***/ 1063:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _reactColor = __webpack_require__(409);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEFAULT_COLOR = '#FFFFFF';
	
	var styles = {
	  content: {
	    margin: '0 auto',
	    width: '35%'
	  }
	};
	
	// TODO: display loader while loading image (see onImageLoaded props from ReactCrop)
	
	var ImageExpand = function (_Component) {
	  _inherits(ImageExpand, _Component);
	
	  function ImageExpand(props) {
	    _classCallCheck(this, ImageExpand);
	
	    var _this = _possibleConstructorReturn(this, (ImageExpand.__proto__ || Object.getPrototypeOf(ImageExpand)).call(this, props));
	
	    _this.onColorChanged = function (value) {
	      return _this.setState({ color: value });
	    };
	
	    _this.onConfirm = function () {
	      return _this.props.onUpdate(_this.state.color.hex);
	    };
	
	    _this.state = {
	      color: props.color || DEFAULT_COLOR
	    };
	    return _this;
	  }
	
	  _createClass(ImageExpand, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.color !== this.props.color) {
	        this.setState({
	          color: nextProps.color
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          open = _props.open,
	          onClose = _props.onClose;
	      var color = this.state.color;
	
	
	      return _react2.default.createElement(
	        _semanticUiReact.Modal,
	        { closeIcon: true, open: open, onClose: onClose, size: 'small' },
	        _react2.default.createElement(
	          _semanticUiReact.Modal.Header,
	          null,
	          'Elargissement de l\'image'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Modal.Content,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Message,
	            { info: true },
	            'Choisissez une couleur de remplissage \xE0 utiliser lors de l\'\xE9largissement avec pr\xE9servation du ratio'
	          ),
	          _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	          _react2.default.createElement(
	            'div',
	            { style: styles.content },
	            _react2.default.createElement(_reactColor.ChromePicker, {
	              color: color,
	              disableAlpha: true,
	              onChangeComplete: this.onColorChanged
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Modal.Actions,
	          null,
	          _react2.default.createElement(_semanticUiReact.Button, {
	            type: 'button',
	            onClick: this.onConfirm,
	            positive: true,
	            icon: 'checkmark',
	            labelPosition: 'right',
	            content: 'Valider'
	          })
	        )
	      );
	    }
	  }]);
	
	  return ImageExpand;
	}(_react.Component);
	
	ImageExpand.propTypes = {
	  open: __webpack_require__(1).PropTypes.bool.isRequired,
	  color: __webpack_require__(1).PropTypes.string,
	  onUpdate: __webpack_require__(1).PropTypes.func.isRequired,
	  onClose: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = ImageExpand;

/***/ },

/***/ 1064:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _ResourceImage = __webpack_require__(99);
	
	var _ResourceImage2 = _interopRequireDefault(_ResourceImage);
	
	var _index = __webpack_require__(318);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapPropsToResource = function mapPropsToResource(props) {
	  return {
	    type: {
	      category: props.resourceType
	    },
	    url: {
	      web: props.thumbnail
	    }
	  };
	};
	
	var InputResourceCard = function (_Component) {
	  _inherits(InputResourceCard, _Component);
	
	  function InputResourceCard(props) {
	    _classCallCheck(this, InputResourceCard);
	
	    var _this = _possibleConstructorReturn(this, (InputResourceCard.__proto__ || Object.getPrototypeOf(InputResourceCard)).call(this, props));
	
	    _this.onShowSelector = function (event) {
	      event.preventDefault();
	      _this.setState({ selectorOpen: true });
	    };
	
	    _this.onHideSelector = function () {
	      return _this.setState({ selectorOpen: false });
	    };
	
	    _this.onResourceSelected = function (resource) {
	      // Updating current image
	      _this.setState({
	        selectorOpen: false,
	        resource: resource,
	        value: resource.id
	      });
	    };
	
	    _this.onRemoveResource = function (event) {
	      event.preventDefault();
	
	      _this.setState({
	        resource: undefined,
	        value: undefined
	      });
	    };
	
	    _this.state = {
	      selectorOpen: false,
	      value: props.value,
	      resource: mapPropsToResource(props)
	    };
	    return _this;
	  }
	
	  _createClass(InputResourceCard, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.value !== this.props.value) {
	        this.setState({
	          value: nextProps.value,
	          resource: mapPropsToResource(nextProps)
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          name = _props.name,
	          title = _props.title,
	          resourceType = _props.resourceType;
	      var _state = this.state,
	          selectorOpen = _state.selectorOpen,
	          value = _state.value,
	          resource = _state.resource;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Header,
	          { as: 'h3', textAlign: 'center' },
	          title
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Card,
	          { centered: true },
	          _react2.default.createElement('input', { type: 'hidden', name: name + '_id', defaultValue: value || '' }),
	          _react2.default.createElement(_ResourceImage2.default, { resource: resource }),
	          _react2.default.createElement(
	            _semanticUiReact.Card.Content,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'ui two buttons' },
	              _react2.default.createElement(
	                _semanticUiReact.Button,
	                {
	                  type: 'button',
	                  basic: true,
	                  color: 'green',
	                  onClick: this.onShowSelector
	                },
	                'Modifier'
	              ),
	              resource && _react2.default.createElement(
	                _semanticUiReact.Button,
	                {
	                  type: 'button',
	                  basic: true,
	                  color: 'red',
	                  onClick: this.onRemoveResource
	                },
	                'Supprimer'
	              )
	            )
	          ),
	          _react2.default.createElement(_index2.default, {
	            open: selectorOpen,
	            resourceType: resourceType,
	            onResourceSelected: this.onResourceSelected,
	            onClose: this.onHideSelector
	          })
	        )
	      );
	    }
	  }]);
	
	  return InputResourceCard;
	}(_react.Component);
	
	InputResourceCard.propTypes = {
	  name: __webpack_require__(1).PropTypes.string.isRequired,
	  title: __webpack_require__(1).PropTypes.string.isRequired,
	  value: __webpack_require__(1).PropTypes.string,
	  thumbnail: __webpack_require__(1).PropTypes.string,
	  resourceType: __webpack_require__(1).PropTypes.any.isRequired
	};
	exports.default = InputResourceCard;

/***/ },

/***/ 1065:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _range = __webpack_require__(1599);
	
	var _range2 = _interopRequireDefault(_range);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getAvailableOrders = function getAvailableOrders(orderCount) {
	  return (0, _range2.default)(1, orderCount + 1).map(function (o) {
	    return {
	      text: o,
	      value: o
	    };
	  });
	};
	
	var OrderDropdown = function OrderDropdown(_ref) {
	  var value = _ref.value,
	      orderCount = _ref.orderCount,
	      onChange = _ref.onChange;
	
	  var changeOrder = function changeOrder(_, _ref2) {
	    var newValue = _ref2.value;
	
	    var newOrder = newValue - 1;
	    if (newOrder !== value) {
	      onChange(newOrder);
	    }
	  };
	
	  return _react2.default.createElement(_semanticUiReact.Dropdown, {
	    style: { zIndex: 100 },
	    compact: true,
	    selection: true,
	    value: value + 1,
	    options: getAvailableOrders(orderCount),
	    onChange: changeOrder
	  });
	};
	
	OrderDropdown.propTypes = {
	  value: __webpack_require__(1).PropTypes.number.isRequired,
	  orderCount: __webpack_require__(1).PropTypes.number.isRequired,
	  onChange: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = OrderDropdown;

/***/ },

/***/ 1066:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RawImage = function RawImage(_ref) {
	  var raw = _ref.raw,
	      className = _ref.className,
	      alt = _ref.alt;
	
	  var imageClass = (0, _classnames2.default)('ui image', className);
	
	  return _react2.default.createElement(
	    'div',
	    { className: imageClass, style: { overflow: 'visible' } },
	    _react2.default.createElement('img', { src: raw, crossOrigin: 'Anonymous', alt: 'Rendu' })
	  );
	};
	
	RawImage.propTypes = {
	  raw: __webpack_require__(1).PropTypes.string.isRequired,
	  className: __webpack_require__(1).PropTypes.string
	};
	exports.default = RawImage;

/***/ },

/***/ 1067:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchFolders = exports.fetchResources = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _fetch = __webpack_require__(32);
	
	var _fetch2 = _interopRequireDefault(_fetch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fetchResources = exports.fetchResources = function fetchResources(page, resourceType, folder, filter) {
	  var url = '/bucket/resources.json?page=' + page + '&resource_type=' + resourceType;
	  if (folder) {
	    url += '&folder=' + folder;
	  }
	  if (filter) {
	    url += '&filter=' + filter;
	  }
	
	  return (0, _fetch2.default)(url, {
	    headers: {
	      Accept: 'application/json',
	      'Content-Type': 'application/json'
	    }
	  }).then(function (res) {
	    // TODO: Use a regex
	    var contentRange = res.headers.get('Content-Range');
	
	    var total = contentRange.split('/')[1];
	
	    var _contentRange$split$ = contentRange.split('/')[0].split('-'),
	        _contentRange$split$2 = _slicedToArray(_contentRange$split$, 2),
	        offset = _contentRange$split$2[0],
	        limit = _contentRange$split$2[1];
	
	    return res.json().then(function (resources) {
	      return {
	        resources: resources,
	        total: total,
	        offset: offset,
	        limit: limit
	      };
	    });
	  });
	};
	
	var fetchFolders = exports.fetchFolders = function fetchFolders() {
	  return (0, _fetch.fetchJson)('/bucket/folders.json');
	};

/***/ },

/***/ 1068:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapFoldersToOptions = function mapFoldersToOptions(folders) {
	  return folders.map(function (f) {
	    return {
	      value: f.id,
	      text: f.name
	    };
	  }).toArray();
	};
	
	var FoldersFilter = function FoldersFilter(_ref) {
	  var value = _ref.value,
	      folders = _ref.folders,
	      onChange = _ref.onChange;
	
	  var changeFolder = function changeFolder(_, _ref2) {
	    var value = _ref2.value;
	    return onChange(value);
	  };
	
	  return _react2.default.createElement(_semanticUiReact.Dropdown, {
	    value: value,
	    selection: true,
	    placeholder: 'Dossier',
	    options: mapFoldersToOptions(folders),
	    onChange: changeFolder
	  });
	};
	
	FoldersFilter.propTypes = {
	  value: __webpack_require__(1).PropTypes.number,
	  folders: __webpack_require__(1).PropTypes.any.isRequired,
	  onChange: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = FoldersFilter;

/***/ },

/***/ 1069:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _ResourceImage = __webpack_require__(99);
	
	var _ResourceImage2 = _interopRequireDefault(_ResourceImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResourceItem = function ResourceItem(_ref) {
	  var resource = _ref.resource,
	      onSelect = _ref.onSelect;
	
	  var selectResource = function selectResource() {
	    return onSelect(resource);
	  };
	
	  return _react2.default.createElement(
	    _semanticUiReact.Card,
	    null,
	    _react2.default.createElement(_ResourceImage2.default, { resource: resource }),
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      resource.name
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Button,
	      { type: 'button', icon: true, attached: 'bottom', onClick: selectResource },
	      _react2.default.createElement(_semanticUiReact.Icon, { name: 'mouse pointer' }),
	      'S\xE9lectionner'
	    )
	  );
	};
	
	ResourceItem.propTypes = {
	  resource: __webpack_require__(1).PropTypes.any.isRequired,
	  onSelect: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = ResourceItem;

/***/ },

/***/ 1070:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _ResourcesPager = __webpack_require__(1072);
	
	var _ResourcesPager2 = _interopRequireDefault(_ResourcesPager);
	
	var _FoldersFilter = __webpack_require__(1068);
	
	var _FoldersFilter2 = _interopRequireDefault(_FoldersFilter);
	
	var _reactDebounceInput = __webpack_require__(1695);
	
	var _reactDebounceInput2 = _interopRequireDefault(_reactDebounceInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResourcesHeader = function ResourcesHeader(_ref) {
	  var folders = _ref.folders,
	      hasPreviousPage = _ref.hasPreviousPage,
	      hasNextPage = _ref.hasNextPage,
	      onPreviousPage = _ref.onPreviousPage,
	      onNextPage = _ref.onNextPage,
	      currentFolder = _ref.currentFolder,
	      onFolderChange = _ref.onFolderChange,
	      currentFilter = _ref.currentFilter,
	      onFilterChange = _ref.onFilterChange;
	
	  var changeFilter = function changeFilter(event) {
	    if (event.target instanceof HTMLInputElement) {
	      onFilterChange(event.target.value);
	    } else {
	      onFilterChange('');
	    }
	  };
	
	  return _react2.default.createElement(
	    _semanticUiReact.Menu,
	    null,
	    _react2.default.createElement(
	      _semanticUiReact.Menu.Item,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'ui icon input' },
	        _react2.default.createElement(_reactDebounceInput2.default, {
	          autoFocus: true,
	          minLength: 2,
	          debounceTimeout: 600,
	          value: currentFilter,
	          onChange: changeFilter,
	          placeholder: 'Recherche...'
	        }),
	        _react2.default.createElement(_semanticUiReact.Icon, { name: 'search' })
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Menu.Item,
	      null,
	      _react2.default.createElement(_FoldersFilter2.default, {
	        value: currentFolder,
	        folders: folders,
	        onChange: onFolderChange
	      })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Menu.Menu,
	      { position: 'right' },
	      _react2.default.createElement(
	        _semanticUiReact.Menu.Item,
	        null,
	        _react2.default.createElement(_ResourcesPager2.default, {
	          hasPrevious: hasPreviousPage,
	          hasNext: hasNextPage,
	          onPrevious: onPreviousPage,
	          onNext: onNextPage
	        })
	      )
	    )
	  );
	};
	
	ResourcesHeader.propTypes = {
	  folders: __webpack_require__(1).PropTypes.any.isRequired,
	  hasPreviousPage: __webpack_require__(1).PropTypes.bool.isRequired,
	  hasNextPage: __webpack_require__(1).PropTypes.bool.isRequired,
	  onPreviousPage: __webpack_require__(1).PropTypes.func.isRequired,
	  onNextPage: __webpack_require__(1).PropTypes.func.isRequired,
	  currentFolder: __webpack_require__(1).PropTypes.number,
	  onFolderChange: __webpack_require__(1).PropTypes.func.isRequired,
	  currentFilter: __webpack_require__(1).PropTypes.string.isRequired,
	  onFilterChange: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = ResourcesHeader;

/***/ },

/***/ 1071:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _ResourceItem = __webpack_require__(1069);
	
	var _ResourceItem2 = _interopRequireDefault(_ResourceItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResourcesPage = function ResourcesPage(_ref) {
	  var resources = _ref.resources,
	      onSelect = _ref.onSelect;
	
	  if (resources && resources.size) {
	    return _react2.default.createElement(
	      _semanticUiReact.Card.Group,
	      { itemsPerRow: 6 },
	      resources.map(function (r) {
	        return _react2.default.createElement(_ResourceItem2.default, { key: r.id, resource: r, onSelect: onSelect });
	      })
	    );
	  }
	
	  return _react2.default.createElement(_semanticUiReact.Message, {
	    icon: 'info',
	    header: 'Aucune ressource ne correspond aux crit\xE8res demand\xE9s'
	  });
	};
	
	ResourcesPage.propTypes = {
	  resources: __webpack_require__(1).PropTypes.any.isRequired,
	  onSelect: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = ResourcesPage;

/***/ },

/***/ 1072:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResourcesPages = function ResourcesPages(_ref) {
	  var hasPrevious = _ref.hasPrevious,
	      hasNext = _ref.hasNext,
	      onPrevious = _ref.onPrevious,
	      onNext = _ref.onNext;
	  return _react2.default.createElement(
	    _semanticUiReact.Menu,
	    { pagination: true },
	    _react2.default.createElement(
	      _semanticUiReact.Menu.Item,
	      {
	        as: _semanticUiReact.Button,
	        type: 'button',
	        disabled: !hasPrevious,
	        onClick: onPrevious
	      },
	      _react2.default.createElement(_semanticUiReact.Icon, { name: 'chevron left' })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Menu.Item,
	      { as: _semanticUiReact.Button, type: 'button', disabled: !hasNext, onClick: onNext },
	      _react2.default.createElement(_semanticUiReact.Icon, { name: 'chevron right' })
	    )
	  );
	};
	
	ResourcesPages.propTypes = {
	  hasPrevious: __webpack_require__(1).PropTypes.bool.isRequired,
	  hasNext: __webpack_require__(1).PropTypes.bool.isRequired,
	  onPrevious: __webpack_require__(1).PropTypes.func.isRequired,
	  onNext: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = ResourcesPages;

/***/ },

/***/ 1073:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var videoStyles = {
	  objectFit: 'contain',
	  maxWidth: '100%',
	  maxHeight: '100%'
	};
	
	var ResourceVideo = function ResourceVideo(_ref) {
	  var video = _ref.video;
	  return _react2.default.createElement(
	    'video',
	    { controls: true, style: videoStyles },
	    _react2.default.createElement('source', { src: video.url.original })
	  );
	};
	
	ResourceVideo.propTypes = {
	  video: __webpack_require__(1).PropTypes.any.isRequired
	};
	exports.default = ResourceVideo;

/***/ },

/***/ 1074:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImageLightbox = __webpack_require__(1761);
	
	var _reactImageLightbox2 = _interopRequireDefault(_reactImageLightbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapResourcesToUrl = function mapResourcesToUrl(resources) {
	  return resources.map(function (r) {
	    return r.url.xhdpi_2x;
	  }).filter(function (url) {
	    return url && url.length;
	  }).map(function (url) {
	    return url + '?' + new Date().toString();
	  });
	}; // Appending date to url to avoid CORS issues
	
	var ResourcesGallery = function (_Component) {
	  _inherits(ResourcesGallery, _Component);
	
	  function ResourcesGallery(props) {
	    _classCallCheck(this, ResourcesGallery);
	
	    var _this = _possibleConstructorReturn(this, (ResourcesGallery.__proto__ || Object.getPrototypeOf(ResourcesGallery)).call(this, props));
	
	    _this.movePrev = function () {
	      var resources = _this.props.resources;
	
	      _this.setState({
	        photoIndex: (_this.state.photoIndex + resources.length - 1) % resources.length
	      });
	    };
	
	    _this.moveNext = function () {
	      var resources = _this.props.resources;
	
	      _this.setState({
	        photoIndex: (_this.state.photoIndex + 1) % resources.length
	      });
	    };
	
	    _this.state = {
	      photoIndex: props.index || 0
	    };
	    return _this;
	  }
	
	  _createClass(ResourcesGallery, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.index !== this.props.index) {
	        this.setState({
	          photoIndex: nextProps.index
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          isOpen = _props.isOpen,
	          resources = _props.resources,
	          onClose = _props.onClose;
	      var photoIndex = this.state.photoIndex;
	
	
	      if (isOpen) {
	        var images = mapResourcesToUrl(resources);
	
	        return _react2.default.createElement(_reactImageLightbox2.default, {
	          mainSrc: images[photoIndex],
	          prevSrc: images[(photoIndex + images.length - 1) % images.length],
	          nextSrc: images[(photoIndex + 1) % images.length],
	          onMovePrevRequest: this.movePrev,
	          onMoveNextRequest: this.moveNext,
	          onCloseRequest: onClose
	        });
	      }
	
	      return null;
	    }
	  }]);
	
	  return ResourcesGallery;
	}(_react.Component);
	
	ResourcesGallery.propTypes = {
	  resources: __webpack_require__(1).PropTypes.arrayOf(__webpack_require__(1).PropTypes.any).isRequired,
	  isOpen: __webpack_require__(1).PropTypes.bool.isRequired,
	  index: __webpack_require__(1).PropTypes.number,
	  onClose: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = ResourcesGallery;

/***/ },

/***/ 1075:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StyleButton = function StyleButton(_ref) {
	  var onToggle = _ref.onToggle,
	      active = _ref.active,
	      label = _ref.label,
	      styleEffect = _ref.styleEffect,
	      displayStyle = _ref.displayStyle;
	
	  var onLocalToggle = function onLocalToggle(e) {
	    e.preventDefault();
	    onToggle(styleEffect);
	  };
	
	  var buttonClass = (0, _classnames2.default)('ui icon button', {
	    active: active
	  });
	
	  if (displayStyle) {
	    return _react2.default.createElement(_semanticUiReact.Button, {
	      type: 'button',
	      className: buttonClass,
	      onMouseDown: onLocalToggle,
	      style: { textAlign: 'center' },
	      icon: displayStyle
	    });
	  }
	
	  return _react2.default.createElement(
	    _semanticUiReact.Button,
	    { type: 'button', className: buttonClass, onMouseDown: onLocalToggle },
	    label
	  );
	};
	
	StyleButton.propTypes = {
	  onToggle: __webpack_require__(1).PropTypes.func.isRequired,
	  active: __webpack_require__(1).PropTypes.bool.isRequired,
	  label: __webpack_require__(1).PropTypes.string.isRequired,
	  styleEffect: __webpack_require__(1).PropTypes.string.isRequired,
	  displayStyle: __webpack_require__(1).PropTypes.string
	};
	exports.default = StyleButton;

/***/ },

/***/ 1076:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(5);
	
	var _reactMeasure = __webpack_require__(1764);
	
	var _reactMeasure2 = _interopRequireDefault(_reactMeasure);
	
	var _ResourceCard = __webpack_require__(175);
	
	var _ResourceCard2 = _interopRequireDefault(_ResourceCard);
	
	var _ResourceImage = __webpack_require__(99);
	
	var _ResourceImage2 = _interopRequireDefault(_ResourceImage);
	
	var _ResourceDimmer = __webpack_require__(176);
	
	var _ResourceDimmer2 = _interopRequireDefault(_ResourceDimmer);
	
	var _ImageCrop = __webpack_require__(174);
	
	var _ImageCrop2 = _interopRequireDefault(_ImageCrop);
	
	var _ImageExpand = __webpack_require__(1063);
	
	var _ImageExpand2 = _interopRequireDefault(_ImageExpand);
	
	var _resources = __webpack_require__(476);
	
	var ResourceApi = _interopRequireWildcard(_resources);
	
	var _resources2 = __webpack_require__(114);
	
	var _blob = __webpack_require__(1077);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	/* eslint jsx-a11y/img-has-alt: "off" */
	
	var babelPluginFlowReactPropTypes_proptype_CropConfig = __webpack_require__(174).babelPluginFlowReactPropTypes_proptype_CropConfig || __webpack_require__(1).PropTypes.any;
	
	var styles = {
	  result: {
	    display: 'flex',
	    flexDirection: 'column',
	    justifyContent: 'center',
	    height: '90%'
	  }
	};
	
	var ServerDrivenResourceCard = function (_Component) {
	  _inherits(ServerDrivenResourceCard, _Component);
	
	  function ServerDrivenResourceCard(props) {
	    _classCallCheck(this, ServerDrivenResourceCard);
	
	    var _this = _possibleConstructorReturn(this, (ServerDrivenResourceCard.__proto__ || Object.getPrototypeOf(ServerDrivenResourceCard)).call(this, props));
	
	    _this.onShowCrop = function () {
	      return _this.setState({ cropOpen: true });
	    };
	
	    _this.onHideCrop = function () {
	      return _this.setState({ cropOpen: false });
	    };
	
	    _this.onShowExpand = function () {
	      return _this.setState({ expandOpen: true });
	    };
	
	    _this.onHideExpand = function () {
	      return _this.setState({ expandOpen: false });
	    };
	
	    _this.onImageMeasured = function (dimensions) {
	      _this.setState({
	        imageDimensions: dimensions
	      });
	    };
	
	    _this.onResourceSelected = function (resource) {
	      _this.props.onDeleted();
	      _this.props.onSelected(resource);
	    };
	
	    _this.onResourceDeleted = function () {
	      _this.props.onDeleted();
	
	      _this.setState({
	        isRendering: false,
	        renderingError: undefined,
	        renderingResult: undefined
	      });
	    };
	
	    _this.onResourceCrop = function (crop) {
	      var resource = _this.props.resource;
	
	      if (!resource) {
	        console.warn('Trying to crop image without source');
	        return;
	      }
	
	      _this.setState({
	        cropOpen: false
	      }, function () {
	        return _this.processAndNotifyConfigChanged(crop, function () {
	          return ResourceApi.crop(resource.id, crop);
	        });
	      });
	    };
	
	    _this.onResourceExpand = function (color) {
	      var _this$props = _this.props,
	          resource = _this$props.resource,
	          config = _this$props.config;
	
	      if (resource && config && config.aspect) {
	        _this.setState({
	          expandOpen: false
	        }, function () {
	          var crop = {
	            aspect: config.aspect,
	            color: color
	          };
	
	          _this.processAndNotifyConfigChanged(crop, function () {
	            return ResourceApi.expand(resource.id, crop);
	          });
	        });
	      } else {
	        console.warn('Trying to expand image without source or aspect');
	      }
	    };
	
	    _this.state = {
	      cropOpen: false,
	      expandOpen: false,
	      isRendering: false,
	      imageDimensions: {}
	    };
	    return _this;
	  }
	
	  _createClass(ServerDrivenResourceCard, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.resource !== nextProps.resource) {
	        // Reset rendering when resource changed
	        this.setState({
	          isRendering: false,
	          renderingResult: undefined,
	          imageDimensions: {}
	        });
	      }
	    }
	  }, {
	    key: 'processAndNotifyConfigChanged',
	    value: function processAndNotifyConfigChanged(crop, process) {
	      this.props.onConfigChanged(crop);
	
	      // Processing async
	      this.processResource(process);
	    }
	  }, {
	    key: 'processResource',
	    value: function processResource(fetch) {
	      var _this2 = this;
	
	      var onImageProcessed = this.props.onImageProcessed;
	
	
	      this.setState({
	        isRendering: true,
	        renderingResult: undefined
	      });
	
	      // Performing croping server side
	      return fetch().then(_blob.blobToURL).then(function (url) {
	        _this2.setState({
	          isRendering: false,
	          renderingResult: url
	        });
	
	        if (onImageProcessed) {
	          onImageProcessed(url);
	        }
	      }).catch(function (error) {
	        _this2.setState({
	          renderingError: error
	        });
	      });
	    }
	  }, {
	    key: 'renderProcessingContent',
	    value: function renderProcessingContent() {
	      var _props = this.props,
	          resource = _props.resource,
	          output = _props.output,
	          raw = _props.raw;
	      var _state = this.state,
	          isRendering = _state.isRendering,
	          renderingError = _state.renderingError,
	          renderingResult = _state.renderingResult,
	          imageDimensions = _state.imageDimensions;
	
	
	      if (renderingError) {
	        return _react2.default.createElement(_semanticUiReact.Message, {
	          error: true,
	          content: 'Une erreur est survenue pendant la g\xE9n\xE9ration du rendu'
	        });
	      }
	
	      if (renderingResult || raw) {
	        var cropStyle = {
	          maxHeight: imageDimensions.height
	        };
	
	        return _react2.default.createElement(
	          'div',
	          { style: styles.result },
	          _react2.default.createElement(
	            'div',
	            { className: 'ui centered image' },
	            _react2.default.createElement('img', { src: renderingResult || raw, style: cropStyle })
	          )
	        );
	      }
	
	      if (isRendering) {
	        return _react2.default.createElement(
	          _semanticUiReact.Segment,
	          { style: { minHeight: '80px' } },
	          _react2.default.createElement(
	            _semanticUiReact.Dimmer,
	            { active: true },
	            _react2.default.createElement(
	              _semanticUiReact.Loader,
	              { size: 'small' },
	              'G\xE9n\xE9ration du rendu'
	            )
	          )
	        );
	      }
	
	      if (output) {
	        return _react2.default.createElement(_ResourceImage2.default, { resource: output });
	      }
	
	      var messageContent = resource ? 'Veuillez redimensionner la ressource pour générer le rendu' : 'Veuillez sélectionnez une ressource';
	
	      return _react2.default.createElement(_semanticUiReact.Message, { content: messageContent });
	    }
	  }, {
	    key: 'renderOperationSelector',
	    value: function renderOperationSelector() {
	      var _props2 = this.props,
	          resource = _props2.resource,
	          config = _props2.config;
	      var _state2 = this.state,
	          cropOpen = _state2.cropOpen,
	          expandOpen = _state2.expandOpen;
	
	
	      if (resource) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_ImageCrop2.default, {
	            open: cropOpen,
	            onClose: this.onHideCrop,
	            config: config,
	            image: (0, _resources2.getImage)(resource, 'xhdpi_2x'),
	            onComplete: this.onResourceCrop
	          }),
	          _react2.default.createElement(_ImageExpand2.default, {
	            open: expandOpen,
	            color: config && config.color,
	            onClose: this.onHideExpand,
	            onUpdate: this.onResourceExpand
	          })
	        );
	      }
	
	      return null;
	    }
	
	    // TODO: Expand operation is not available when aspect is not set
	
	  }, {
	    key: 'renderDimmer',
	    value: function renderDimmer() {
	      var _props3 = this.props,
	          resource = _props3.resource,
	          config = _props3.config;
	
	      var crop = (!config || !config.color) && _react2.default.createElement(
	        _semanticUiReact.Button,
	        {
	          type: 'button',
	          icon: true,
	          labelPosition: 'right',
	          onClick: this.onShowCrop
	        },
	        _react2.default.createElement(_semanticUiReact.Icon, { name: 'crop' }),
	        'Redimensionner'
	      );
	
	      var expand = config && config.aspect && !config.width && _react2.default.createElement(
	        _semanticUiReact.Button,
	        {
	          type: 'button',
	          icon: true,
	          labelPosition: 'right',
	          onClick: this.onShowExpand
	        },
	        _react2.default.createElement(_semanticUiReact.Icon, { name: 'maximize' }),
	        'Elargir'
	      );
	
	      return _react2.default.createElement(
	        _ResourceDimmer2.default,
	        { resource: resource },
	        _react2.default.createElement(
	          _semanticUiReact.Button.Group,
	          { vertical: true, basic: true, inverted: true },
	          crop,
	          expand
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var resource = this.props.resource;
	
	
	      return _react2.default.createElement(
	        _semanticUiReact.Grid,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Row,
	          { columns: 2, divided: true },
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Header,
	              { as: 'h3', textAlign: 'center' },
	              'Image originale'
	            ),
	            _react2.default.createElement(
	              _reactMeasure2.default,
	              { includeMargin: false, onMeasure: this.onImageMeasured },
	              _react2.default.createElement(
	                _ResourceCard2.default,
	                {
	                  resourceType: 'image',
	                  resource: resource,
	                  onSelected: this.onResourceSelected,
	                  onDeleted: this.onResourceDeleted
	                },
	                this.renderDimmer()
	              )
	            ),
	            this.renderOperationSelector()
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            { textAlign: 'center' },
	            _react2.default.createElement(
	              _semanticUiReact.Header,
	              { as: 'h3', textAlign: 'center' },
	              'Rendu'
	            ),
	            this.renderProcessingContent()
	          )
	        )
	      );
	    }
	  }]);
	
	  return ServerDrivenResourceCard;
	}(_react.Component);
	
	ServerDrivenResourceCard.propTypes = {
	  resource: __webpack_require__(1).PropTypes.any,
	  config: babelPluginFlowReactPropTypes_proptype_CropConfig,
	  output: __webpack_require__(1).PropTypes.any,
	  raw: __webpack_require__(1).PropTypes.string,
	  onSelected: __webpack_require__(1).PropTypes.func.isRequired,
	  onConfigChanged: __webpack_require__(1).PropTypes.func.isRequired,
	  onImageProcessed: __webpack_require__(1).PropTypes.func,
	  onDeleted: __webpack_require__(1).PropTypes.func.isRequired
	};
	exports.default = ServerDrivenResourceCard;

/***/ },

/***/ 1077:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var blobToURL = exports.blobToURL = function blobToURL(blob) {
	  return new Promise(function (resolve, reject) {
	    try {
	      var reader = new FileReader();
	      reader.onload = function () {
	        resolve(reader.result);
	      };
	
	      reader.readAsDataURL(blob);
	    } catch (error) {
	      reject(error);
	    }
	  });
	};

/***/ },

/***/ 1078:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var storeInSession = exports.storeInSession = function storeInSession(key, value) {
	  return window.sessionStorage.setItem(key, value);
	};
	
	var getFromSession = exports.getFromSession = function getFromSession(key) {
	  return window.sessionStorage.getItem(key);
	};
	
	var deleteFromSession = exports.deleteFromSession = function deleteFromSession(key) {
	  return window.sessionStorage.removeItem(key);
	};
	
	var scopeWithKey = exports.scopeWithKey = function scopeWithKey(key, scopeThunk) {
	  var value = getFromSession(key);
	  if (value) {
	    try {
	      scopeThunk(value);
	    } catch (error) {
	      console.warn('Error attempting to execute scoped session storage action', error);
	    } finally {
	      deleteFromSession(key);
	    }
	  }
	};

/***/ },

/***/ 1401:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 1614:
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./fr": 664
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1614;


/***/ },

/***/ 2046:
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },

/***/ 2047:
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },

/***/ 2054:
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./flow/minimal/index.js": 918,
		"./flow/simple/index.js": 922,
		"./nav/simple/index.js": 931,
		"./news/simple/index.js": 933,
		"./pdf/index.js": 936,
		"./web/index.js": 940,
		"./youtube/index.js": 943
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 2054;


/***/ },

/***/ 2055:
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./address/index.js": 1007,
		"./contact/index.js": 1010,
		"./gallery/index.js": 1015,
		"./image/index.js": 1018,
		"./link/index.js": 1022,
		"./page/index.js": 1026,
		"./text/index.js": 1030,
		"./title/index.js": 1033,
		"./youtube/index.js": 1036
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 2055;


/***/ },

/***/ 2056:
/***/ function(module, exports) {

	/* (ignored) */

/***/ },

/***/ 2057:
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.index = undefined;
	
	var _form = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _postpone = __webpack_require__(__webpack_module_template_argument_1__);
	
	var index = exports.index = function index(ctx) {
	  var id = ctx.params.id;
	  if (id && !Number.isNaN(parseInt(id, 10))) {
	    // Bind form handling
	    (0, _form.renderEdit)(id);
	
	    // Enable postpone behavior
	    (0, _postpone.bindInteractions)(id);
	  }
	};

/***/ },

/***/ 2058:
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getViewComponent = exports.getEditComponent = undefined;
	
	var _Edit = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Edit2 = _interopRequireDefault(_Edit);
	
	var _View = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _View2 = _interopRequireDefault(_View);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getEditComponent = exports.getEditComponent = function getEditComponent() {
	  return _Edit2.default;
	};
	var getViewComponent = exports.getViewComponent = function getViewComponent() {
	  return _View2.default;
	};

/***/ },

/***/ 2059:
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getRenderComponent = exports.getViewComponent = exports.getEditComponent = undefined;
	
	var _Edit = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Edit2 = _interopRequireDefault(_Edit);
	
	var _View = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _View2 = _interopRequireDefault(_View);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getEditComponent = exports.getEditComponent = function getEditComponent() {
	  return _Edit2.default;
	};
	var getViewComponent = exports.getViewComponent = function getViewComponent() {
	  return _View2.default;
	};
	var getRenderComponent = exports.getRenderComponent = function getRenderComponent() {
	  return _View2.default;
	};

/***/ }

});


// WEBPACK FOOTER //
// main.95188c51.js